// Copyright 2021 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
(function(global, factory) { /* global define, require, module */

    /* AMD */ if (typeof define === 'function' && define.amd)
        define(["protobufjs/minimal"], factory);

    /* CommonJS */ else if (typeof require === 'function' && typeof module === 'object' && module && module.exports)
        module.exports = factory(require("google-gax").protobufMinimal);

})(this, function($protobuf) {
    "use strict";

    // Common aliases
    var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
    
    // Exported root namespace
    var $root = $protobuf.roots._google_cloud_translate_protos || ($protobuf.roots._google_cloud_translate_protos = {});
    
    $root.google = (function() {
    
        /**
         * Namespace google.
         * @exports google
         * @namespace
         */
        var google = {};
    
        google.cloud = (function() {
    
            /**
             * Namespace cloud.
             * @memberof google
             * @namespace
             */
            var cloud = {};
    
            cloud.translation = (function() {
    
                /**
                 * Namespace translation.
                 * @memberof google.cloud
                 * @namespace
                 */
                var translation = {};
    
                translation.v3 = (function() {
    
                    /**
                     * Namespace v3.
                     * @memberof google.cloud.translation
                     * @namespace
                     */
                    var v3 = {};
    
                    v3.TranslationService = (function() {
    
                        /**
                         * Constructs a new TranslationService service.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a TranslationService
                         * @extends $protobuf.rpc.Service
                         * @constructor
                         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                         */
                        function TranslationService(rpcImpl, requestDelimited, responseDelimited) {
                            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                        }
    
                        (TranslationService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = TranslationService;
    
                        /**
                         * Creates new TranslationService service using the specified rpc implementation.
                         * @function create
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @static
                         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                         * @returns {TranslationService} RPC service. Useful where requests and/or responses are streamed.
                         */
                        TranslationService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                            return new this(rpcImpl, requestDelimited, responseDelimited);
                        };
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3.TranslationService#translateText}.
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @typedef TranslateTextCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3.TranslateTextResponse} [response] TranslateTextResponse
                         */
    
                        /**
                         * Calls TranslateText.
                         * @function translateText
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.ITranslateTextRequest} request TranslateTextRequest message or plain object
                         * @param {google.cloud.translation.v3.TranslationService.TranslateTextCallback} callback Node-style callback called with the error, if any, and TranslateTextResponse
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.translateText = function translateText(request, callback) {
                            return this.rpcCall(translateText, $root.google.cloud.translation.v3.TranslateTextRequest, $root.google.cloud.translation.v3.TranslateTextResponse, request, callback);
                        }, "name", { value: "TranslateText" });
    
                        /**
                         * Calls TranslateText.
                         * @function translateText
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.ITranslateTextRequest} request TranslateTextRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3.TranslateTextResponse>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3.TranslationService#detectLanguage}.
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @typedef DetectLanguageCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3.DetectLanguageResponse} [response] DetectLanguageResponse
                         */
    
                        /**
                         * Calls DetectLanguage.
                         * @function detectLanguage
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IDetectLanguageRequest} request DetectLanguageRequest message or plain object
                         * @param {google.cloud.translation.v3.TranslationService.DetectLanguageCallback} callback Node-style callback called with the error, if any, and DetectLanguageResponse
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.detectLanguage = function detectLanguage(request, callback) {
                            return this.rpcCall(detectLanguage, $root.google.cloud.translation.v3.DetectLanguageRequest, $root.google.cloud.translation.v3.DetectLanguageResponse, request, callback);
                        }, "name", { value: "DetectLanguage" });
    
                        /**
                         * Calls DetectLanguage.
                         * @function detectLanguage
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IDetectLanguageRequest} request DetectLanguageRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3.DetectLanguageResponse>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3.TranslationService#getSupportedLanguages}.
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @typedef GetSupportedLanguagesCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3.SupportedLanguages} [response] SupportedLanguages
                         */
    
                        /**
                         * Calls GetSupportedLanguages.
                         * @function getSupportedLanguages
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IGetSupportedLanguagesRequest} request GetSupportedLanguagesRequest message or plain object
                         * @param {google.cloud.translation.v3.TranslationService.GetSupportedLanguagesCallback} callback Node-style callback called with the error, if any, and SupportedLanguages
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.getSupportedLanguages = function getSupportedLanguages(request, callback) {
                            return this.rpcCall(getSupportedLanguages, $root.google.cloud.translation.v3.GetSupportedLanguagesRequest, $root.google.cloud.translation.v3.SupportedLanguages, request, callback);
                        }, "name", { value: "GetSupportedLanguages" });
    
                        /**
                         * Calls GetSupportedLanguages.
                         * @function getSupportedLanguages
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IGetSupportedLanguagesRequest} request GetSupportedLanguagesRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3.SupportedLanguages>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3.TranslationService#translateDocument}.
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @typedef TranslateDocumentCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3.TranslateDocumentResponse} [response] TranslateDocumentResponse
                         */
    
                        /**
                         * Calls TranslateDocument.
                         * @function translateDocument
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.ITranslateDocumentRequest} request TranslateDocumentRequest message or plain object
                         * @param {google.cloud.translation.v3.TranslationService.TranslateDocumentCallback} callback Node-style callback called with the error, if any, and TranslateDocumentResponse
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.translateDocument = function translateDocument(request, callback) {
                            return this.rpcCall(translateDocument, $root.google.cloud.translation.v3.TranslateDocumentRequest, $root.google.cloud.translation.v3.TranslateDocumentResponse, request, callback);
                        }, "name", { value: "TranslateDocument" });
    
                        /**
                         * Calls TranslateDocument.
                         * @function translateDocument
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.ITranslateDocumentRequest} request TranslateDocumentRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3.TranslateDocumentResponse>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3.TranslationService#batchTranslateText}.
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @typedef BatchTranslateTextCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.longrunning.Operation} [response] Operation
                         */
    
                        /**
                         * Calls BatchTranslateText.
                         * @function batchTranslateText
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IBatchTranslateTextRequest} request BatchTranslateTextRequest message or plain object
                         * @param {google.cloud.translation.v3.TranslationService.BatchTranslateTextCallback} callback Node-style callback called with the error, if any, and Operation
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.batchTranslateText = function batchTranslateText(request, callback) {
                            return this.rpcCall(batchTranslateText, $root.google.cloud.translation.v3.BatchTranslateTextRequest, $root.google.longrunning.Operation, request, callback);
                        }, "name", { value: "BatchTranslateText" });
    
                        /**
                         * Calls BatchTranslateText.
                         * @function batchTranslateText
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IBatchTranslateTextRequest} request BatchTranslateTextRequest message or plain object
                         * @returns {Promise<google.longrunning.Operation>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3.TranslationService#batchTranslateDocument}.
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @typedef BatchTranslateDocumentCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.longrunning.Operation} [response] Operation
                         */
    
                        /**
                         * Calls BatchTranslateDocument.
                         * @function batchTranslateDocument
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentRequest} request BatchTranslateDocumentRequest message or plain object
                         * @param {google.cloud.translation.v3.TranslationService.BatchTranslateDocumentCallback} callback Node-style callback called with the error, if any, and Operation
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.batchTranslateDocument = function batchTranslateDocument(request, callback) {
                            return this.rpcCall(batchTranslateDocument, $root.google.cloud.translation.v3.BatchTranslateDocumentRequest, $root.google.longrunning.Operation, request, callback);
                        }, "name", { value: "BatchTranslateDocument" });
    
                        /**
                         * Calls BatchTranslateDocument.
                         * @function batchTranslateDocument
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentRequest} request BatchTranslateDocumentRequest message or plain object
                         * @returns {Promise<google.longrunning.Operation>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3.TranslationService#createGlossary}.
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @typedef CreateGlossaryCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.longrunning.Operation} [response] Operation
                         */
    
                        /**
                         * Calls CreateGlossary.
                         * @function createGlossary
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.ICreateGlossaryRequest} request CreateGlossaryRequest message or plain object
                         * @param {google.cloud.translation.v3.TranslationService.CreateGlossaryCallback} callback Node-style callback called with the error, if any, and Operation
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.createGlossary = function createGlossary(request, callback) {
                            return this.rpcCall(createGlossary, $root.google.cloud.translation.v3.CreateGlossaryRequest, $root.google.longrunning.Operation, request, callback);
                        }, "name", { value: "CreateGlossary" });
    
                        /**
                         * Calls CreateGlossary.
                         * @function createGlossary
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.ICreateGlossaryRequest} request CreateGlossaryRequest message or plain object
                         * @returns {Promise<google.longrunning.Operation>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3.TranslationService#listGlossaries}.
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @typedef ListGlossariesCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3.ListGlossariesResponse} [response] ListGlossariesResponse
                         */
    
                        /**
                         * Calls ListGlossaries.
                         * @function listGlossaries
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IListGlossariesRequest} request ListGlossariesRequest message or plain object
                         * @param {google.cloud.translation.v3.TranslationService.ListGlossariesCallback} callback Node-style callback called with the error, if any, and ListGlossariesResponse
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.listGlossaries = function listGlossaries(request, callback) {
                            return this.rpcCall(listGlossaries, $root.google.cloud.translation.v3.ListGlossariesRequest, $root.google.cloud.translation.v3.ListGlossariesResponse, request, callback);
                        }, "name", { value: "ListGlossaries" });
    
                        /**
                         * Calls ListGlossaries.
                         * @function listGlossaries
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IListGlossariesRequest} request ListGlossariesRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3.ListGlossariesResponse>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3.TranslationService#getGlossary}.
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @typedef GetGlossaryCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3.Glossary} [response] Glossary
                         */
    
                        /**
                         * Calls GetGlossary.
                         * @function getGlossary
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IGetGlossaryRequest} request GetGlossaryRequest message or plain object
                         * @param {google.cloud.translation.v3.TranslationService.GetGlossaryCallback} callback Node-style callback called with the error, if any, and Glossary
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.getGlossary = function getGlossary(request, callback) {
                            return this.rpcCall(getGlossary, $root.google.cloud.translation.v3.GetGlossaryRequest, $root.google.cloud.translation.v3.Glossary, request, callback);
                        }, "name", { value: "GetGlossary" });
    
                        /**
                         * Calls GetGlossary.
                         * @function getGlossary
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IGetGlossaryRequest} request GetGlossaryRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3.Glossary>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3.TranslationService#deleteGlossary}.
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @typedef DeleteGlossaryCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.longrunning.Operation} [response] Operation
                         */
    
                        /**
                         * Calls DeleteGlossary.
                         * @function deleteGlossary
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IDeleteGlossaryRequest} request DeleteGlossaryRequest message or plain object
                         * @param {google.cloud.translation.v3.TranslationService.DeleteGlossaryCallback} callback Node-style callback called with the error, if any, and Operation
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.deleteGlossary = function deleteGlossary(request, callback) {
                            return this.rpcCall(deleteGlossary, $root.google.cloud.translation.v3.DeleteGlossaryRequest, $root.google.longrunning.Operation, request, callback);
                        }, "name", { value: "DeleteGlossary" });
    
                        /**
                         * Calls DeleteGlossary.
                         * @function deleteGlossary
                         * @memberof google.cloud.translation.v3.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3.IDeleteGlossaryRequest} request DeleteGlossaryRequest message or plain object
                         * @returns {Promise<google.longrunning.Operation>} Promise
                         * @variation 2
                         */
    
                        return TranslationService;
                    })();
    
                    v3.TranslateTextGlossaryConfig = (function() {
    
                        /**
                         * Properties of a TranslateTextGlossaryConfig.
                         * @memberof google.cloud.translation.v3
                         * @interface ITranslateTextGlossaryConfig
                         * @property {string|null} [glossary] TranslateTextGlossaryConfig glossary
                         * @property {boolean|null} [ignoreCase] TranslateTextGlossaryConfig ignoreCase
                         */
    
                        /**
                         * Constructs a new TranslateTextGlossaryConfig.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a TranslateTextGlossaryConfig.
                         * @implements ITranslateTextGlossaryConfig
                         * @constructor
                         * @param {google.cloud.translation.v3.ITranslateTextGlossaryConfig=} [properties] Properties to set
                         */
                        function TranslateTextGlossaryConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TranslateTextGlossaryConfig glossary.
                         * @member {string} glossary
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @instance
                         */
                        TranslateTextGlossaryConfig.prototype.glossary = "";
    
                        /**
                         * TranslateTextGlossaryConfig ignoreCase.
                         * @member {boolean} ignoreCase
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @instance
                         */
                        TranslateTextGlossaryConfig.prototype.ignoreCase = false;
    
                        /**
                         * Creates a new TranslateTextGlossaryConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateTextGlossaryConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.TranslateTextGlossaryConfig} TranslateTextGlossaryConfig instance
                         */
                        TranslateTextGlossaryConfig.create = function create(properties) {
                            return new TranslateTextGlossaryConfig(properties);
                        };
    
                        /**
                         * Encodes the specified TranslateTextGlossaryConfig message. Does not implicitly {@link google.cloud.translation.v3.TranslateTextGlossaryConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateTextGlossaryConfig} message TranslateTextGlossaryConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextGlossaryConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.glossary != null && Object.hasOwnProperty.call(message, "glossary"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.glossary);
                            if (message.ignoreCase != null && Object.hasOwnProperty.call(message, "ignoreCase"))
                                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.ignoreCase);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TranslateTextGlossaryConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3.TranslateTextGlossaryConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateTextGlossaryConfig} message TranslateTextGlossaryConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextGlossaryConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TranslateTextGlossaryConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.TranslateTextGlossaryConfig} TranslateTextGlossaryConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextGlossaryConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.TranslateTextGlossaryConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.glossary = reader.string();
                                    break;
                                case 2:
                                    message.ignoreCase = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TranslateTextGlossaryConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.TranslateTextGlossaryConfig} TranslateTextGlossaryConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextGlossaryConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TranslateTextGlossaryConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TranslateTextGlossaryConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.glossary != null && message.hasOwnProperty("glossary"))
                                if (!$util.isString(message.glossary))
                                    return "glossary: string expected";
                            if (message.ignoreCase != null && message.hasOwnProperty("ignoreCase"))
                                if (typeof message.ignoreCase !== "boolean")
                                    return "ignoreCase: boolean expected";
                            return null;
                        };
    
                        /**
                         * Creates a TranslateTextGlossaryConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.TranslateTextGlossaryConfig} TranslateTextGlossaryConfig
                         */
                        TranslateTextGlossaryConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.TranslateTextGlossaryConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3.TranslateTextGlossaryConfig();
                            if (object.glossary != null)
                                message.glossary = String(object.glossary);
                            if (object.ignoreCase != null)
                                message.ignoreCase = Boolean(object.ignoreCase);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TranslateTextGlossaryConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @static
                         * @param {google.cloud.translation.v3.TranslateTextGlossaryConfig} message TranslateTextGlossaryConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TranslateTextGlossaryConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.glossary = "";
                                object.ignoreCase = false;
                            }
                            if (message.glossary != null && message.hasOwnProperty("glossary"))
                                object.glossary = message.glossary;
                            if (message.ignoreCase != null && message.hasOwnProperty("ignoreCase"))
                                object.ignoreCase = message.ignoreCase;
                            return object;
                        };
    
                        /**
                         * Converts this TranslateTextGlossaryConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.TranslateTextGlossaryConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TranslateTextGlossaryConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TranslateTextGlossaryConfig;
                    })();
    
                    v3.TranslateTextRequest = (function() {
    
                        /**
                         * Properties of a TranslateTextRequest.
                         * @memberof google.cloud.translation.v3
                         * @interface ITranslateTextRequest
                         * @property {Array.<string>|null} [contents] TranslateTextRequest contents
                         * @property {string|null} [mimeType] TranslateTextRequest mimeType
                         * @property {string|null} [sourceLanguageCode] TranslateTextRequest sourceLanguageCode
                         * @property {string|null} [targetLanguageCode] TranslateTextRequest targetLanguageCode
                         * @property {string|null} [parent] TranslateTextRequest parent
                         * @property {string|null} [model] TranslateTextRequest model
                         * @property {google.cloud.translation.v3.ITranslateTextGlossaryConfig|null} [glossaryConfig] TranslateTextRequest glossaryConfig
                         * @property {Object.<string,string>|null} [labels] TranslateTextRequest labels
                         */
    
                        /**
                         * Constructs a new TranslateTextRequest.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a TranslateTextRequest.
                         * @implements ITranslateTextRequest
                         * @constructor
                         * @param {google.cloud.translation.v3.ITranslateTextRequest=} [properties] Properties to set
                         */
                        function TranslateTextRequest(properties) {
                            this.contents = [];
                            this.labels = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TranslateTextRequest contents.
                         * @member {Array.<string>} contents
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.contents = $util.emptyArray;
    
                        /**
                         * TranslateTextRequest mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.mimeType = "";
    
                        /**
                         * TranslateTextRequest sourceLanguageCode.
                         * @member {string} sourceLanguageCode
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.sourceLanguageCode = "";
    
                        /**
                         * TranslateTextRequest targetLanguageCode.
                         * @member {string} targetLanguageCode
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.targetLanguageCode = "";
    
                        /**
                         * TranslateTextRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.parent = "";
    
                        /**
                         * TranslateTextRequest model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.model = "";
    
                        /**
                         * TranslateTextRequest glossaryConfig.
                         * @member {google.cloud.translation.v3.ITranslateTextGlossaryConfig|null|undefined} glossaryConfig
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.glossaryConfig = null;
    
                        /**
                         * TranslateTextRequest labels.
                         * @member {Object.<string,string>} labels
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.labels = $util.emptyObject;
    
                        /**
                         * Creates a new TranslateTextRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateTextRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.TranslateTextRequest} TranslateTextRequest instance
                         */
                        TranslateTextRequest.create = function create(properties) {
                            return new TranslateTextRequest(properties);
                        };
    
                        /**
                         * Encodes the specified TranslateTextRequest message. Does not implicitly {@link google.cloud.translation.v3.TranslateTextRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateTextRequest} message TranslateTextRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.contents != null && message.contents.length)
                                for (var i = 0; i < message.contents.length; ++i)
                                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.contents[i]);
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.mimeType);
                            if (message.sourceLanguageCode != null && Object.hasOwnProperty.call(message, "sourceLanguageCode"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.sourceLanguageCode);
                            if (message.targetLanguageCode != null && Object.hasOwnProperty.call(message, "targetLanguageCode"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.targetLanguageCode);
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.model);
                            if (message.glossaryConfig != null && Object.hasOwnProperty.call(message, "glossaryConfig"))
                                $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.encode(message.glossaryConfig, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 8, wireType 2 =*/66).string(message.parent);
                            if (message.labels != null && Object.hasOwnProperty.call(message, "labels"))
                                for (var keys = Object.keys(message.labels), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 10, wireType 2 =*/82).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.labels[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TranslateTextRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3.TranslateTextRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateTextRequest} message TranslateTextRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TranslateTextRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.TranslateTextRequest} TranslateTextRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.TranslateTextRequest(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.contents && message.contents.length))
                                        message.contents = [];
                                    message.contents.push(reader.string());
                                    break;
                                case 3:
                                    message.mimeType = reader.string();
                                    break;
                                case 4:
                                    message.sourceLanguageCode = reader.string();
                                    break;
                                case 5:
                                    message.targetLanguageCode = reader.string();
                                    break;
                                case 8:
                                    message.parent = reader.string();
                                    break;
                                case 6:
                                    message.model = reader.string();
                                    break;
                                case 7:
                                    message.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                    break;
                                case 10:
                                    if (message.labels === $util.emptyObject)
                                        message.labels = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.labels[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TranslateTextRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.TranslateTextRequest} TranslateTextRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TranslateTextRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TranslateTextRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.contents != null && message.hasOwnProperty("contents")) {
                                if (!Array.isArray(message.contents))
                                    return "contents: array expected";
                                for (var i = 0; i < message.contents.length; ++i)
                                    if (!$util.isString(message.contents[i]))
                                        return "contents: string[] expected";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                if (!$util.isString(message.sourceLanguageCode))
                                    return "sourceLanguageCode: string expected";
                            if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                if (!$util.isString(message.targetLanguageCode))
                                    return "targetLanguageCode: string expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig")) {
                                var error = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.verify(message.glossaryConfig);
                                if (error)
                                    return "glossaryConfig." + error;
                            }
                            if (message.labels != null && message.hasOwnProperty("labels")) {
                                if (!$util.isObject(message.labels))
                                    return "labels: object expected";
                                var key = Object.keys(message.labels);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.labels[key[i]]))
                                        return "labels: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a TranslateTextRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.TranslateTextRequest} TranslateTextRequest
                         */
                        TranslateTextRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.TranslateTextRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3.TranslateTextRequest();
                            if (object.contents) {
                                if (!Array.isArray(object.contents))
                                    throw TypeError(".google.cloud.translation.v3.TranslateTextRequest.contents: array expected");
                                message.contents = [];
                                for (var i = 0; i < object.contents.length; ++i)
                                    message.contents[i] = String(object.contents[i]);
                            }
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            if (object.sourceLanguageCode != null)
                                message.sourceLanguageCode = String(object.sourceLanguageCode);
                            if (object.targetLanguageCode != null)
                                message.targetLanguageCode = String(object.targetLanguageCode);
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.model != null)
                                message.model = String(object.model);
                            if (object.glossaryConfig != null) {
                                if (typeof object.glossaryConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3.TranslateTextRequest.glossaryConfig: object expected");
                                message.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.fromObject(object.glossaryConfig);
                            }
                            if (object.labels) {
                                if (typeof object.labels !== "object")
                                    throw TypeError(".google.cloud.translation.v3.TranslateTextRequest.labels: object expected");
                                message.labels = {};
                                for (var keys = Object.keys(object.labels), i = 0; i < keys.length; ++i)
                                    message.labels[keys[i]] = String(object.labels[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TranslateTextRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3.TranslateTextRequest} message TranslateTextRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TranslateTextRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.contents = [];
                            if (options.objects || options.defaults)
                                object.labels = {};
                            if (options.defaults) {
                                object.mimeType = "";
                                object.sourceLanguageCode = "";
                                object.targetLanguageCode = "";
                                object.model = "";
                                object.glossaryConfig = null;
                                object.parent = "";
                            }
                            if (message.contents && message.contents.length) {
                                object.contents = [];
                                for (var j = 0; j < message.contents.length; ++j)
                                    object.contents[j] = message.contents[j];
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                object.sourceLanguageCode = message.sourceLanguageCode;
                            if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                object.targetLanguageCode = message.targetLanguageCode;
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig"))
                                object.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.toObject(message.glossaryConfig, options);
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            var keys2;
                            if (message.labels && (keys2 = Object.keys(message.labels)).length) {
                                object.labels = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.labels[keys2[j]] = message.labels[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this TranslateTextRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.TranslateTextRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TranslateTextRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TranslateTextRequest;
                    })();
    
                    v3.TranslateTextResponse = (function() {
    
                        /**
                         * Properties of a TranslateTextResponse.
                         * @memberof google.cloud.translation.v3
                         * @interface ITranslateTextResponse
                         * @property {Array.<google.cloud.translation.v3.ITranslation>|null} [translations] TranslateTextResponse translations
                         * @property {Array.<google.cloud.translation.v3.ITranslation>|null} [glossaryTranslations] TranslateTextResponse glossaryTranslations
                         */
    
                        /**
                         * Constructs a new TranslateTextResponse.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a TranslateTextResponse.
                         * @implements ITranslateTextResponse
                         * @constructor
                         * @param {google.cloud.translation.v3.ITranslateTextResponse=} [properties] Properties to set
                         */
                        function TranslateTextResponse(properties) {
                            this.translations = [];
                            this.glossaryTranslations = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TranslateTextResponse translations.
                         * @member {Array.<google.cloud.translation.v3.ITranslation>} translations
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @instance
                         */
                        TranslateTextResponse.prototype.translations = $util.emptyArray;
    
                        /**
                         * TranslateTextResponse glossaryTranslations.
                         * @member {Array.<google.cloud.translation.v3.ITranslation>} glossaryTranslations
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @instance
                         */
                        TranslateTextResponse.prototype.glossaryTranslations = $util.emptyArray;
    
                        /**
                         * Creates a new TranslateTextResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateTextResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.TranslateTextResponse} TranslateTextResponse instance
                         */
                        TranslateTextResponse.create = function create(properties) {
                            return new TranslateTextResponse(properties);
                        };
    
                        /**
                         * Encodes the specified TranslateTextResponse message. Does not implicitly {@link google.cloud.translation.v3.TranslateTextResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateTextResponse} message TranslateTextResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.translations != null && message.translations.length)
                                for (var i = 0; i < message.translations.length; ++i)
                                    $root.google.cloud.translation.v3.Translation.encode(message.translations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.glossaryTranslations != null && message.glossaryTranslations.length)
                                for (var i = 0; i < message.glossaryTranslations.length; ++i)
                                    $root.google.cloud.translation.v3.Translation.encode(message.glossaryTranslations[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TranslateTextResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3.TranslateTextResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateTextResponse} message TranslateTextResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TranslateTextResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.TranslateTextResponse} TranslateTextResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.TranslateTextResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.translations && message.translations.length))
                                        message.translations = [];
                                    message.translations.push($root.google.cloud.translation.v3.Translation.decode(reader, reader.uint32()));
                                    break;
                                case 3:
                                    if (!(message.glossaryTranslations && message.glossaryTranslations.length))
                                        message.glossaryTranslations = [];
                                    message.glossaryTranslations.push($root.google.cloud.translation.v3.Translation.decode(reader, reader.uint32()));
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TranslateTextResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.TranslateTextResponse} TranslateTextResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TranslateTextResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TranslateTextResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.translations != null && message.hasOwnProperty("translations")) {
                                if (!Array.isArray(message.translations))
                                    return "translations: array expected";
                                for (var i = 0; i < message.translations.length; ++i) {
                                    var error = $root.google.cloud.translation.v3.Translation.verify(message.translations[i]);
                                    if (error)
                                        return "translations." + error;
                                }
                            }
                            if (message.glossaryTranslations != null && message.hasOwnProperty("glossaryTranslations")) {
                                if (!Array.isArray(message.glossaryTranslations))
                                    return "glossaryTranslations: array expected";
                                for (var i = 0; i < message.glossaryTranslations.length; ++i) {
                                    var error = $root.google.cloud.translation.v3.Translation.verify(message.glossaryTranslations[i]);
                                    if (error)
                                        return "glossaryTranslations." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a TranslateTextResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.TranslateTextResponse} TranslateTextResponse
                         */
                        TranslateTextResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.TranslateTextResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3.TranslateTextResponse();
                            if (object.translations) {
                                if (!Array.isArray(object.translations))
                                    throw TypeError(".google.cloud.translation.v3.TranslateTextResponse.translations: array expected");
                                message.translations = [];
                                for (var i = 0; i < object.translations.length; ++i) {
                                    if (typeof object.translations[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3.TranslateTextResponse.translations: object expected");
                                    message.translations[i] = $root.google.cloud.translation.v3.Translation.fromObject(object.translations[i]);
                                }
                            }
                            if (object.glossaryTranslations) {
                                if (!Array.isArray(object.glossaryTranslations))
                                    throw TypeError(".google.cloud.translation.v3.TranslateTextResponse.glossaryTranslations: array expected");
                                message.glossaryTranslations = [];
                                for (var i = 0; i < object.glossaryTranslations.length; ++i) {
                                    if (typeof object.glossaryTranslations[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3.TranslateTextResponse.glossaryTranslations: object expected");
                                    message.glossaryTranslations[i] = $root.google.cloud.translation.v3.Translation.fromObject(object.glossaryTranslations[i]);
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TranslateTextResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @static
                         * @param {google.cloud.translation.v3.TranslateTextResponse} message TranslateTextResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TranslateTextResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.translations = [];
                                object.glossaryTranslations = [];
                            }
                            if (message.translations && message.translations.length) {
                                object.translations = [];
                                for (var j = 0; j < message.translations.length; ++j)
                                    object.translations[j] = $root.google.cloud.translation.v3.Translation.toObject(message.translations[j], options);
                            }
                            if (message.glossaryTranslations && message.glossaryTranslations.length) {
                                object.glossaryTranslations = [];
                                for (var j = 0; j < message.glossaryTranslations.length; ++j)
                                    object.glossaryTranslations[j] = $root.google.cloud.translation.v3.Translation.toObject(message.glossaryTranslations[j], options);
                            }
                            return object;
                        };
    
                        /**
                         * Converts this TranslateTextResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.TranslateTextResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TranslateTextResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TranslateTextResponse;
                    })();
    
                    v3.Translation = (function() {
    
                        /**
                         * Properties of a Translation.
                         * @memberof google.cloud.translation.v3
                         * @interface ITranslation
                         * @property {string|null} [translatedText] Translation translatedText
                         * @property {string|null} [model] Translation model
                         * @property {string|null} [detectedLanguageCode] Translation detectedLanguageCode
                         * @property {google.cloud.translation.v3.ITranslateTextGlossaryConfig|null} [glossaryConfig] Translation glossaryConfig
                         */
    
                        /**
                         * Constructs a new Translation.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a Translation.
                         * @implements ITranslation
                         * @constructor
                         * @param {google.cloud.translation.v3.ITranslation=} [properties] Properties to set
                         */
                        function Translation(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Translation translatedText.
                         * @member {string} translatedText
                         * @memberof google.cloud.translation.v3.Translation
                         * @instance
                         */
                        Translation.prototype.translatedText = "";
    
                        /**
                         * Translation model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3.Translation
                         * @instance
                         */
                        Translation.prototype.model = "";
    
                        /**
                         * Translation detectedLanguageCode.
                         * @member {string} detectedLanguageCode
                         * @memberof google.cloud.translation.v3.Translation
                         * @instance
                         */
                        Translation.prototype.detectedLanguageCode = "";
    
                        /**
                         * Translation glossaryConfig.
                         * @member {google.cloud.translation.v3.ITranslateTextGlossaryConfig|null|undefined} glossaryConfig
                         * @memberof google.cloud.translation.v3.Translation
                         * @instance
                         */
                        Translation.prototype.glossaryConfig = null;
    
                        /**
                         * Creates a new Translation instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.Translation
                         * @static
                         * @param {google.cloud.translation.v3.ITranslation=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.Translation} Translation instance
                         */
                        Translation.create = function create(properties) {
                            return new Translation(properties);
                        };
    
                        /**
                         * Encodes the specified Translation message. Does not implicitly {@link google.cloud.translation.v3.Translation.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.Translation
                         * @static
                         * @param {google.cloud.translation.v3.ITranslation} message Translation message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Translation.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.translatedText != null && Object.hasOwnProperty.call(message, "translatedText"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.translatedText);
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.model);
                            if (message.glossaryConfig != null && Object.hasOwnProperty.call(message, "glossaryConfig"))
                                $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.encode(message.glossaryConfig, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            if (message.detectedLanguageCode != null && Object.hasOwnProperty.call(message, "detectedLanguageCode"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.detectedLanguageCode);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Translation message, length delimited. Does not implicitly {@link google.cloud.translation.v3.Translation.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.Translation
                         * @static
                         * @param {google.cloud.translation.v3.ITranslation} message Translation message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Translation.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Translation message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.Translation
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.Translation} Translation
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Translation.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.Translation();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.translatedText = reader.string();
                                    break;
                                case 2:
                                    message.model = reader.string();
                                    break;
                                case 4:
                                    message.detectedLanguageCode = reader.string();
                                    break;
                                case 3:
                                    message.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Translation message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.Translation
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.Translation} Translation
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Translation.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Translation message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.Translation
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Translation.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                                if (!$util.isString(message.translatedText))
                                    return "translatedText: string expected";
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            if (message.detectedLanguageCode != null && message.hasOwnProperty("detectedLanguageCode"))
                                if (!$util.isString(message.detectedLanguageCode))
                                    return "detectedLanguageCode: string expected";
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig")) {
                                var error = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.verify(message.glossaryConfig);
                                if (error)
                                    return "glossaryConfig." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Translation message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.Translation
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.Translation} Translation
                         */
                        Translation.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.Translation)
                                return object;
                            var message = new $root.google.cloud.translation.v3.Translation();
                            if (object.translatedText != null)
                                message.translatedText = String(object.translatedText);
                            if (object.model != null)
                                message.model = String(object.model);
                            if (object.detectedLanguageCode != null)
                                message.detectedLanguageCode = String(object.detectedLanguageCode);
                            if (object.glossaryConfig != null) {
                                if (typeof object.glossaryConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3.Translation.glossaryConfig: object expected");
                                message.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.fromObject(object.glossaryConfig);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Translation message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.Translation
                         * @static
                         * @param {google.cloud.translation.v3.Translation} message Translation
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Translation.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.translatedText = "";
                                object.model = "";
                                object.glossaryConfig = null;
                                object.detectedLanguageCode = "";
                            }
                            if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                                object.translatedText = message.translatedText;
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig"))
                                object.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.toObject(message.glossaryConfig, options);
                            if (message.detectedLanguageCode != null && message.hasOwnProperty("detectedLanguageCode"))
                                object.detectedLanguageCode = message.detectedLanguageCode;
                            return object;
                        };
    
                        /**
                         * Converts this Translation to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.Translation
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Translation.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Translation;
                    })();
    
                    v3.DetectLanguageRequest = (function() {
    
                        /**
                         * Properties of a DetectLanguageRequest.
                         * @memberof google.cloud.translation.v3
                         * @interface IDetectLanguageRequest
                         * @property {string|null} [parent] DetectLanguageRequest parent
                         * @property {string|null} [model] DetectLanguageRequest model
                         * @property {string|null} [content] DetectLanguageRequest content
                         * @property {string|null} [mimeType] DetectLanguageRequest mimeType
                         * @property {Object.<string,string>|null} [labels] DetectLanguageRequest labels
                         */
    
                        /**
                         * Constructs a new DetectLanguageRequest.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a DetectLanguageRequest.
                         * @implements IDetectLanguageRequest
                         * @constructor
                         * @param {google.cloud.translation.v3.IDetectLanguageRequest=} [properties] Properties to set
                         */
                        function DetectLanguageRequest(properties) {
                            this.labels = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DetectLanguageRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @instance
                         */
                        DetectLanguageRequest.prototype.parent = "";
    
                        /**
                         * DetectLanguageRequest model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @instance
                         */
                        DetectLanguageRequest.prototype.model = "";
    
                        /**
                         * DetectLanguageRequest content.
                         * @member {string|null|undefined} content
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @instance
                         */
                        DetectLanguageRequest.prototype.content = null;
    
                        /**
                         * DetectLanguageRequest mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @instance
                         */
                        DetectLanguageRequest.prototype.mimeType = "";
    
                        /**
                         * DetectLanguageRequest labels.
                         * @member {Object.<string,string>} labels
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @instance
                         */
                        DetectLanguageRequest.prototype.labels = $util.emptyObject;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * DetectLanguageRequest source.
                         * @member {"content"|undefined} source
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @instance
                         */
                        Object.defineProperty(DetectLanguageRequest.prototype, "source", {
                            get: $util.oneOfGetter($oneOfFields = ["content"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new DetectLanguageRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @static
                         * @param {google.cloud.translation.v3.IDetectLanguageRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.DetectLanguageRequest} DetectLanguageRequest instance
                         */
                        DetectLanguageRequest.create = function create(properties) {
                            return new DetectLanguageRequest(properties);
                        };
    
                        /**
                         * Encodes the specified DetectLanguageRequest message. Does not implicitly {@link google.cloud.translation.v3.DetectLanguageRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @static
                         * @param {google.cloud.translation.v3.IDetectLanguageRequest} message DetectLanguageRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectLanguageRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.content);
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.mimeType);
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.model);
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.parent);
                            if (message.labels != null && Object.hasOwnProperty.call(message, "labels"))
                                for (var keys = Object.keys(message.labels), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.labels[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DetectLanguageRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3.DetectLanguageRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @static
                         * @param {google.cloud.translation.v3.IDetectLanguageRequest} message DetectLanguageRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectLanguageRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DetectLanguageRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.DetectLanguageRequest} DetectLanguageRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectLanguageRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.DetectLanguageRequest(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 5:
                                    message.parent = reader.string();
                                    break;
                                case 4:
                                    message.model = reader.string();
                                    break;
                                case 1:
                                    message.content = reader.string();
                                    break;
                                case 3:
                                    message.mimeType = reader.string();
                                    break;
                                case 6:
                                    if (message.labels === $util.emptyObject)
                                        message.labels = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.labels[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DetectLanguageRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.DetectLanguageRequest} DetectLanguageRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectLanguageRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DetectLanguageRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DetectLanguageRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            if (message.content != null && message.hasOwnProperty("content")) {
                                properties.source = 1;
                                if (!$util.isString(message.content))
                                    return "content: string expected";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            if (message.labels != null && message.hasOwnProperty("labels")) {
                                if (!$util.isObject(message.labels))
                                    return "labels: object expected";
                                var key = Object.keys(message.labels);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.labels[key[i]]))
                                        return "labels: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a DetectLanguageRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.DetectLanguageRequest} DetectLanguageRequest
                         */
                        DetectLanguageRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.DetectLanguageRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3.DetectLanguageRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.model != null)
                                message.model = String(object.model);
                            if (object.content != null)
                                message.content = String(object.content);
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            if (object.labels) {
                                if (typeof object.labels !== "object")
                                    throw TypeError(".google.cloud.translation.v3.DetectLanguageRequest.labels: object expected");
                                message.labels = {};
                                for (var keys = Object.keys(object.labels), i = 0; i < keys.length; ++i)
                                    message.labels[keys[i]] = String(object.labels[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DetectLanguageRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @static
                         * @param {google.cloud.translation.v3.DetectLanguageRequest} message DetectLanguageRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DetectLanguageRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.objects || options.defaults)
                                object.labels = {};
                            if (options.defaults) {
                                object.mimeType = "";
                                object.model = "";
                                object.parent = "";
                            }
                            if (message.content != null && message.hasOwnProperty("content")) {
                                object.content = message.content;
                                if (options.oneofs)
                                    object.source = "content";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            var keys2;
                            if (message.labels && (keys2 = Object.keys(message.labels)).length) {
                                object.labels = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.labels[keys2[j]] = message.labels[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this DetectLanguageRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.DetectLanguageRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DetectLanguageRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DetectLanguageRequest;
                    })();
    
                    v3.DetectedLanguage = (function() {
    
                        /**
                         * Properties of a DetectedLanguage.
                         * @memberof google.cloud.translation.v3
                         * @interface IDetectedLanguage
                         * @property {string|null} [languageCode] DetectedLanguage languageCode
                         * @property {number|null} [confidence] DetectedLanguage confidence
                         */
    
                        /**
                         * Constructs a new DetectedLanguage.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a DetectedLanguage.
                         * @implements IDetectedLanguage
                         * @constructor
                         * @param {google.cloud.translation.v3.IDetectedLanguage=} [properties] Properties to set
                         */
                        function DetectedLanguage(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DetectedLanguage languageCode.
                         * @member {string} languageCode
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @instance
                         */
                        DetectedLanguage.prototype.languageCode = "";
    
                        /**
                         * DetectedLanguage confidence.
                         * @member {number} confidence
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @instance
                         */
                        DetectedLanguage.prototype.confidence = 0;
    
                        /**
                         * Creates a new DetectedLanguage instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @static
                         * @param {google.cloud.translation.v3.IDetectedLanguage=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.DetectedLanguage} DetectedLanguage instance
                         */
                        DetectedLanguage.create = function create(properties) {
                            return new DetectedLanguage(properties);
                        };
    
                        /**
                         * Encodes the specified DetectedLanguage message. Does not implicitly {@link google.cloud.translation.v3.DetectedLanguage.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @static
                         * @param {google.cloud.translation.v3.IDetectedLanguage} message DetectedLanguage message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectedLanguage.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.languageCode);
                            if (message.confidence != null && Object.hasOwnProperty.call(message, "confidence"))
                                writer.uint32(/* id 2, wireType 5 =*/21).float(message.confidence);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DetectedLanguage message, length delimited. Does not implicitly {@link google.cloud.translation.v3.DetectedLanguage.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @static
                         * @param {google.cloud.translation.v3.IDetectedLanguage} message DetectedLanguage message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectedLanguage.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DetectedLanguage message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.DetectedLanguage} DetectedLanguage
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectedLanguage.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.DetectedLanguage();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.languageCode = reader.string();
                                    break;
                                case 2:
                                    message.confidence = reader.float();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DetectedLanguage message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.DetectedLanguage} DetectedLanguage
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectedLanguage.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DetectedLanguage message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DetectedLanguage.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                                if (!$util.isString(message.languageCode))
                                    return "languageCode: string expected";
                            if (message.confidence != null && message.hasOwnProperty("confidence"))
                                if (typeof message.confidence !== "number")
                                    return "confidence: number expected";
                            return null;
                        };
    
                        /**
                         * Creates a DetectedLanguage message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.DetectedLanguage} DetectedLanguage
                         */
                        DetectedLanguage.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.DetectedLanguage)
                                return object;
                            var message = new $root.google.cloud.translation.v3.DetectedLanguage();
                            if (object.languageCode != null)
                                message.languageCode = String(object.languageCode);
                            if (object.confidence != null)
                                message.confidence = Number(object.confidence);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DetectedLanguage message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @static
                         * @param {google.cloud.translation.v3.DetectedLanguage} message DetectedLanguage
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DetectedLanguage.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.languageCode = "";
                                object.confidence = 0;
                            }
                            if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                                object.languageCode = message.languageCode;
                            if (message.confidence != null && message.hasOwnProperty("confidence"))
                                object.confidence = options.json && !isFinite(message.confidence) ? String(message.confidence) : message.confidence;
                            return object;
                        };
    
                        /**
                         * Converts this DetectedLanguage to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.DetectedLanguage
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DetectedLanguage.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DetectedLanguage;
                    })();
    
                    v3.DetectLanguageResponse = (function() {
    
                        /**
                         * Properties of a DetectLanguageResponse.
                         * @memberof google.cloud.translation.v3
                         * @interface IDetectLanguageResponse
                         * @property {Array.<google.cloud.translation.v3.IDetectedLanguage>|null} [languages] DetectLanguageResponse languages
                         */
    
                        /**
                         * Constructs a new DetectLanguageResponse.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a DetectLanguageResponse.
                         * @implements IDetectLanguageResponse
                         * @constructor
                         * @param {google.cloud.translation.v3.IDetectLanguageResponse=} [properties] Properties to set
                         */
                        function DetectLanguageResponse(properties) {
                            this.languages = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DetectLanguageResponse languages.
                         * @member {Array.<google.cloud.translation.v3.IDetectedLanguage>} languages
                         * @memberof google.cloud.translation.v3.DetectLanguageResponse
                         * @instance
                         */
                        DetectLanguageResponse.prototype.languages = $util.emptyArray;
    
                        /**
                         * Creates a new DetectLanguageResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.DetectLanguageResponse
                         * @static
                         * @param {google.cloud.translation.v3.IDetectLanguageResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.DetectLanguageResponse} DetectLanguageResponse instance
                         */
                        DetectLanguageResponse.create = function create(properties) {
                            return new DetectLanguageResponse(properties);
                        };
    
                        /**
                         * Encodes the specified DetectLanguageResponse message. Does not implicitly {@link google.cloud.translation.v3.DetectLanguageResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.DetectLanguageResponse
                         * @static
                         * @param {google.cloud.translation.v3.IDetectLanguageResponse} message DetectLanguageResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectLanguageResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.languages != null && message.languages.length)
                                for (var i = 0; i < message.languages.length; ++i)
                                    $root.google.cloud.translation.v3.DetectedLanguage.encode(message.languages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DetectLanguageResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3.DetectLanguageResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.DetectLanguageResponse
                         * @static
                         * @param {google.cloud.translation.v3.IDetectLanguageResponse} message DetectLanguageResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectLanguageResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DetectLanguageResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.DetectLanguageResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.DetectLanguageResponse} DetectLanguageResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectLanguageResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.DetectLanguageResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.languages && message.languages.length))
                                        message.languages = [];
                                    message.languages.push($root.google.cloud.translation.v3.DetectedLanguage.decode(reader, reader.uint32()));
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DetectLanguageResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.DetectLanguageResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.DetectLanguageResponse} DetectLanguageResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectLanguageResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DetectLanguageResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.DetectLanguageResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DetectLanguageResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.languages != null && message.hasOwnProperty("languages")) {
                                if (!Array.isArray(message.languages))
                                    return "languages: array expected";
                                for (var i = 0; i < message.languages.length; ++i) {
                                    var error = $root.google.cloud.translation.v3.DetectedLanguage.verify(message.languages[i]);
                                    if (error)
                                        return "languages." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a DetectLanguageResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.DetectLanguageResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.DetectLanguageResponse} DetectLanguageResponse
                         */
                        DetectLanguageResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.DetectLanguageResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3.DetectLanguageResponse();
                            if (object.languages) {
                                if (!Array.isArray(object.languages))
                                    throw TypeError(".google.cloud.translation.v3.DetectLanguageResponse.languages: array expected");
                                message.languages = [];
                                for (var i = 0; i < object.languages.length; ++i) {
                                    if (typeof object.languages[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3.DetectLanguageResponse.languages: object expected");
                                    message.languages[i] = $root.google.cloud.translation.v3.DetectedLanguage.fromObject(object.languages[i]);
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DetectLanguageResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.DetectLanguageResponse
                         * @static
                         * @param {google.cloud.translation.v3.DetectLanguageResponse} message DetectLanguageResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DetectLanguageResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.languages = [];
                            if (message.languages && message.languages.length) {
                                object.languages = [];
                                for (var j = 0; j < message.languages.length; ++j)
                                    object.languages[j] = $root.google.cloud.translation.v3.DetectedLanguage.toObject(message.languages[j], options);
                            }
                            return object;
                        };
    
                        /**
                         * Converts this DetectLanguageResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.DetectLanguageResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DetectLanguageResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DetectLanguageResponse;
                    })();
    
                    v3.GetSupportedLanguagesRequest = (function() {
    
                        /**
                         * Properties of a GetSupportedLanguagesRequest.
                         * @memberof google.cloud.translation.v3
                         * @interface IGetSupportedLanguagesRequest
                         * @property {string|null} [parent] GetSupportedLanguagesRequest parent
                         * @property {string|null} [displayLanguageCode] GetSupportedLanguagesRequest displayLanguageCode
                         * @property {string|null} [model] GetSupportedLanguagesRequest model
                         */
    
                        /**
                         * Constructs a new GetSupportedLanguagesRequest.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a GetSupportedLanguagesRequest.
                         * @implements IGetSupportedLanguagesRequest
                         * @constructor
                         * @param {google.cloud.translation.v3.IGetSupportedLanguagesRequest=} [properties] Properties to set
                         */
                        function GetSupportedLanguagesRequest(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GetSupportedLanguagesRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @instance
                         */
                        GetSupportedLanguagesRequest.prototype.parent = "";
    
                        /**
                         * GetSupportedLanguagesRequest displayLanguageCode.
                         * @member {string} displayLanguageCode
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @instance
                         */
                        GetSupportedLanguagesRequest.prototype.displayLanguageCode = "";
    
                        /**
                         * GetSupportedLanguagesRequest model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @instance
                         */
                        GetSupportedLanguagesRequest.prototype.model = "";
    
                        /**
                         * Creates a new GetSupportedLanguagesRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @static
                         * @param {google.cloud.translation.v3.IGetSupportedLanguagesRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.GetSupportedLanguagesRequest} GetSupportedLanguagesRequest instance
                         */
                        GetSupportedLanguagesRequest.create = function create(properties) {
                            return new GetSupportedLanguagesRequest(properties);
                        };
    
                        /**
                         * Encodes the specified GetSupportedLanguagesRequest message. Does not implicitly {@link google.cloud.translation.v3.GetSupportedLanguagesRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @static
                         * @param {google.cloud.translation.v3.IGetSupportedLanguagesRequest} message GetSupportedLanguagesRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetSupportedLanguagesRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.displayLanguageCode != null && Object.hasOwnProperty.call(message, "displayLanguageCode"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.displayLanguageCode);
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.model);
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.parent);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GetSupportedLanguagesRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3.GetSupportedLanguagesRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @static
                         * @param {google.cloud.translation.v3.IGetSupportedLanguagesRequest} message GetSupportedLanguagesRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetSupportedLanguagesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GetSupportedLanguagesRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.GetSupportedLanguagesRequest} GetSupportedLanguagesRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetSupportedLanguagesRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.GetSupportedLanguagesRequest();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 3:
                                    message.parent = reader.string();
                                    break;
                                case 1:
                                    message.displayLanguageCode = reader.string();
                                    break;
                                case 2:
                                    message.model = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GetSupportedLanguagesRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.GetSupportedLanguagesRequest} GetSupportedLanguagesRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetSupportedLanguagesRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GetSupportedLanguagesRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetSupportedLanguagesRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.displayLanguageCode != null && message.hasOwnProperty("displayLanguageCode"))
                                if (!$util.isString(message.displayLanguageCode))
                                    return "displayLanguageCode: string expected";
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GetSupportedLanguagesRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.GetSupportedLanguagesRequest} GetSupportedLanguagesRequest
                         */
                        GetSupportedLanguagesRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.GetSupportedLanguagesRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3.GetSupportedLanguagesRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.displayLanguageCode != null)
                                message.displayLanguageCode = String(object.displayLanguageCode);
                            if (object.model != null)
                                message.model = String(object.model);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GetSupportedLanguagesRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @static
                         * @param {google.cloud.translation.v3.GetSupportedLanguagesRequest} message GetSupportedLanguagesRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetSupportedLanguagesRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.displayLanguageCode = "";
                                object.model = "";
                                object.parent = "";
                            }
                            if (message.displayLanguageCode != null && message.hasOwnProperty("displayLanguageCode"))
                                object.displayLanguageCode = message.displayLanguageCode;
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            return object;
                        };
    
                        /**
                         * Converts this GetSupportedLanguagesRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.GetSupportedLanguagesRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetSupportedLanguagesRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GetSupportedLanguagesRequest;
                    })();
    
                    v3.SupportedLanguages = (function() {
    
                        /**
                         * Properties of a SupportedLanguages.
                         * @memberof google.cloud.translation.v3
                         * @interface ISupportedLanguages
                         * @property {Array.<google.cloud.translation.v3.ISupportedLanguage>|null} [languages] SupportedLanguages languages
                         */
    
                        /**
                         * Constructs a new SupportedLanguages.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a SupportedLanguages.
                         * @implements ISupportedLanguages
                         * @constructor
                         * @param {google.cloud.translation.v3.ISupportedLanguages=} [properties] Properties to set
                         */
                        function SupportedLanguages(properties) {
                            this.languages = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * SupportedLanguages languages.
                         * @member {Array.<google.cloud.translation.v3.ISupportedLanguage>} languages
                         * @memberof google.cloud.translation.v3.SupportedLanguages
                         * @instance
                         */
                        SupportedLanguages.prototype.languages = $util.emptyArray;
    
                        /**
                         * Creates a new SupportedLanguages instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.SupportedLanguages
                         * @static
                         * @param {google.cloud.translation.v3.ISupportedLanguages=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.SupportedLanguages} SupportedLanguages instance
                         */
                        SupportedLanguages.create = function create(properties) {
                            return new SupportedLanguages(properties);
                        };
    
                        /**
                         * Encodes the specified SupportedLanguages message. Does not implicitly {@link google.cloud.translation.v3.SupportedLanguages.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.SupportedLanguages
                         * @static
                         * @param {google.cloud.translation.v3.ISupportedLanguages} message SupportedLanguages message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SupportedLanguages.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.languages != null && message.languages.length)
                                for (var i = 0; i < message.languages.length; ++i)
                                    $root.google.cloud.translation.v3.SupportedLanguage.encode(message.languages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified SupportedLanguages message, length delimited. Does not implicitly {@link google.cloud.translation.v3.SupportedLanguages.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.SupportedLanguages
                         * @static
                         * @param {google.cloud.translation.v3.ISupportedLanguages} message SupportedLanguages message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SupportedLanguages.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a SupportedLanguages message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.SupportedLanguages
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.SupportedLanguages} SupportedLanguages
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SupportedLanguages.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.SupportedLanguages();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.languages && message.languages.length))
                                        message.languages = [];
                                    message.languages.push($root.google.cloud.translation.v3.SupportedLanguage.decode(reader, reader.uint32()));
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a SupportedLanguages message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.SupportedLanguages
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.SupportedLanguages} SupportedLanguages
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SupportedLanguages.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a SupportedLanguages message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.SupportedLanguages
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        SupportedLanguages.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.languages != null && message.hasOwnProperty("languages")) {
                                if (!Array.isArray(message.languages))
                                    return "languages: array expected";
                                for (var i = 0; i < message.languages.length; ++i) {
                                    var error = $root.google.cloud.translation.v3.SupportedLanguage.verify(message.languages[i]);
                                    if (error)
                                        return "languages." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a SupportedLanguages message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.SupportedLanguages
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.SupportedLanguages} SupportedLanguages
                         */
                        SupportedLanguages.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.SupportedLanguages)
                                return object;
                            var message = new $root.google.cloud.translation.v3.SupportedLanguages();
                            if (object.languages) {
                                if (!Array.isArray(object.languages))
                                    throw TypeError(".google.cloud.translation.v3.SupportedLanguages.languages: array expected");
                                message.languages = [];
                                for (var i = 0; i < object.languages.length; ++i) {
                                    if (typeof object.languages[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3.SupportedLanguages.languages: object expected");
                                    message.languages[i] = $root.google.cloud.translation.v3.SupportedLanguage.fromObject(object.languages[i]);
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a SupportedLanguages message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.SupportedLanguages
                         * @static
                         * @param {google.cloud.translation.v3.SupportedLanguages} message SupportedLanguages
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        SupportedLanguages.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.languages = [];
                            if (message.languages && message.languages.length) {
                                object.languages = [];
                                for (var j = 0; j < message.languages.length; ++j)
                                    object.languages[j] = $root.google.cloud.translation.v3.SupportedLanguage.toObject(message.languages[j], options);
                            }
                            return object;
                        };
    
                        /**
                         * Converts this SupportedLanguages to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.SupportedLanguages
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        SupportedLanguages.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return SupportedLanguages;
                    })();
    
                    v3.SupportedLanguage = (function() {
    
                        /**
                         * Properties of a SupportedLanguage.
                         * @memberof google.cloud.translation.v3
                         * @interface ISupportedLanguage
                         * @property {string|null} [languageCode] SupportedLanguage languageCode
                         * @property {string|null} [displayName] SupportedLanguage displayName
                         * @property {boolean|null} [supportSource] SupportedLanguage supportSource
                         * @property {boolean|null} [supportTarget] SupportedLanguage supportTarget
                         */
    
                        /**
                         * Constructs a new SupportedLanguage.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a SupportedLanguage.
                         * @implements ISupportedLanguage
                         * @constructor
                         * @param {google.cloud.translation.v3.ISupportedLanguage=} [properties] Properties to set
                         */
                        function SupportedLanguage(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * SupportedLanguage languageCode.
                         * @member {string} languageCode
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @instance
                         */
                        SupportedLanguage.prototype.languageCode = "";
    
                        /**
                         * SupportedLanguage displayName.
                         * @member {string} displayName
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @instance
                         */
                        SupportedLanguage.prototype.displayName = "";
    
                        /**
                         * SupportedLanguage supportSource.
                         * @member {boolean} supportSource
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @instance
                         */
                        SupportedLanguage.prototype.supportSource = false;
    
                        /**
                         * SupportedLanguage supportTarget.
                         * @member {boolean} supportTarget
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @instance
                         */
                        SupportedLanguage.prototype.supportTarget = false;
    
                        /**
                         * Creates a new SupportedLanguage instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @static
                         * @param {google.cloud.translation.v3.ISupportedLanguage=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.SupportedLanguage} SupportedLanguage instance
                         */
                        SupportedLanguage.create = function create(properties) {
                            return new SupportedLanguage(properties);
                        };
    
                        /**
                         * Encodes the specified SupportedLanguage message. Does not implicitly {@link google.cloud.translation.v3.SupportedLanguage.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @static
                         * @param {google.cloud.translation.v3.ISupportedLanguage} message SupportedLanguage message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SupportedLanguage.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.languageCode);
                            if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
                            if (message.supportSource != null && Object.hasOwnProperty.call(message, "supportSource"))
                                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.supportSource);
                            if (message.supportTarget != null && Object.hasOwnProperty.call(message, "supportTarget"))
                                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.supportTarget);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified SupportedLanguage message, length delimited. Does not implicitly {@link google.cloud.translation.v3.SupportedLanguage.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @static
                         * @param {google.cloud.translation.v3.ISupportedLanguage} message SupportedLanguage message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SupportedLanguage.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a SupportedLanguage message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.SupportedLanguage} SupportedLanguage
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SupportedLanguage.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.SupportedLanguage();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.languageCode = reader.string();
                                    break;
                                case 2:
                                    message.displayName = reader.string();
                                    break;
                                case 3:
                                    message.supportSource = reader.bool();
                                    break;
                                case 4:
                                    message.supportTarget = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a SupportedLanguage message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.SupportedLanguage} SupportedLanguage
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SupportedLanguage.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a SupportedLanguage message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        SupportedLanguage.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                                if (!$util.isString(message.languageCode))
                                    return "languageCode: string expected";
                            if (message.displayName != null && message.hasOwnProperty("displayName"))
                                if (!$util.isString(message.displayName))
                                    return "displayName: string expected";
                            if (message.supportSource != null && message.hasOwnProperty("supportSource"))
                                if (typeof message.supportSource !== "boolean")
                                    return "supportSource: boolean expected";
                            if (message.supportTarget != null && message.hasOwnProperty("supportTarget"))
                                if (typeof message.supportTarget !== "boolean")
                                    return "supportTarget: boolean expected";
                            return null;
                        };
    
                        /**
                         * Creates a SupportedLanguage message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.SupportedLanguage} SupportedLanguage
                         */
                        SupportedLanguage.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.SupportedLanguage)
                                return object;
                            var message = new $root.google.cloud.translation.v3.SupportedLanguage();
                            if (object.languageCode != null)
                                message.languageCode = String(object.languageCode);
                            if (object.displayName != null)
                                message.displayName = String(object.displayName);
                            if (object.supportSource != null)
                                message.supportSource = Boolean(object.supportSource);
                            if (object.supportTarget != null)
                                message.supportTarget = Boolean(object.supportTarget);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a SupportedLanguage message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @static
                         * @param {google.cloud.translation.v3.SupportedLanguage} message SupportedLanguage
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        SupportedLanguage.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.languageCode = "";
                                object.displayName = "";
                                object.supportSource = false;
                                object.supportTarget = false;
                            }
                            if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                                object.languageCode = message.languageCode;
                            if (message.displayName != null && message.hasOwnProperty("displayName"))
                                object.displayName = message.displayName;
                            if (message.supportSource != null && message.hasOwnProperty("supportSource"))
                                object.supportSource = message.supportSource;
                            if (message.supportTarget != null && message.hasOwnProperty("supportTarget"))
                                object.supportTarget = message.supportTarget;
                            return object;
                        };
    
                        /**
                         * Converts this SupportedLanguage to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.SupportedLanguage
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        SupportedLanguage.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return SupportedLanguage;
                    })();
    
                    v3.GcsSource = (function() {
    
                        /**
                         * Properties of a GcsSource.
                         * @memberof google.cloud.translation.v3
                         * @interface IGcsSource
                         * @property {string|null} [inputUri] GcsSource inputUri
                         */
    
                        /**
                         * Constructs a new GcsSource.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a GcsSource.
                         * @implements IGcsSource
                         * @constructor
                         * @param {google.cloud.translation.v3.IGcsSource=} [properties] Properties to set
                         */
                        function GcsSource(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GcsSource inputUri.
                         * @member {string} inputUri
                         * @memberof google.cloud.translation.v3.GcsSource
                         * @instance
                         */
                        GcsSource.prototype.inputUri = "";
    
                        /**
                         * Creates a new GcsSource instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.GcsSource
                         * @static
                         * @param {google.cloud.translation.v3.IGcsSource=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.GcsSource} GcsSource instance
                         */
                        GcsSource.create = function create(properties) {
                            return new GcsSource(properties);
                        };
    
                        /**
                         * Encodes the specified GcsSource message. Does not implicitly {@link google.cloud.translation.v3.GcsSource.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.GcsSource
                         * @static
                         * @param {google.cloud.translation.v3.IGcsSource} message GcsSource message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GcsSource.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.inputUri != null && Object.hasOwnProperty.call(message, "inputUri"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.inputUri);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GcsSource message, length delimited. Does not implicitly {@link google.cloud.translation.v3.GcsSource.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.GcsSource
                         * @static
                         * @param {google.cloud.translation.v3.IGcsSource} message GcsSource message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GcsSource.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GcsSource message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.GcsSource
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.GcsSource} GcsSource
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GcsSource.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.GcsSource();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.inputUri = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GcsSource message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.GcsSource
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.GcsSource} GcsSource
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GcsSource.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GcsSource message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.GcsSource
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GcsSource.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.inputUri != null && message.hasOwnProperty("inputUri"))
                                if (!$util.isString(message.inputUri))
                                    return "inputUri: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GcsSource message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.GcsSource
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.GcsSource} GcsSource
                         */
                        GcsSource.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.GcsSource)
                                return object;
                            var message = new $root.google.cloud.translation.v3.GcsSource();
                            if (object.inputUri != null)
                                message.inputUri = String(object.inputUri);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GcsSource message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.GcsSource
                         * @static
                         * @param {google.cloud.translation.v3.GcsSource} message GcsSource
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GcsSource.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.inputUri = "";
                            if (message.inputUri != null && message.hasOwnProperty("inputUri"))
                                object.inputUri = message.inputUri;
                            return object;
                        };
    
                        /**
                         * Converts this GcsSource to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.GcsSource
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GcsSource.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GcsSource;
                    })();
    
                    v3.InputConfig = (function() {
    
                        /**
                         * Properties of an InputConfig.
                         * @memberof google.cloud.translation.v3
                         * @interface IInputConfig
                         * @property {string|null} [mimeType] InputConfig mimeType
                         * @property {google.cloud.translation.v3.IGcsSource|null} [gcsSource] InputConfig gcsSource
                         */
    
                        /**
                         * Constructs a new InputConfig.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents an InputConfig.
                         * @implements IInputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3.IInputConfig=} [properties] Properties to set
                         */
                        function InputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * InputConfig mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @instance
                         */
                        InputConfig.prototype.mimeType = "";
    
                        /**
                         * InputConfig gcsSource.
                         * @member {google.cloud.translation.v3.IGcsSource|null|undefined} gcsSource
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @instance
                         */
                        InputConfig.prototype.gcsSource = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * InputConfig source.
                         * @member {"gcsSource"|undefined} source
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @instance
                         */
                        Object.defineProperty(InputConfig.prototype, "source", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsSource"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new InputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IInputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.InputConfig} InputConfig instance
                         */
                        InputConfig.create = function create(properties) {
                            return new InputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified InputConfig message. Does not implicitly {@link google.cloud.translation.v3.InputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IInputConfig} message InputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        InputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.mimeType);
                            if (message.gcsSource != null && Object.hasOwnProperty.call(message, "gcsSource"))
                                $root.google.cloud.translation.v3.GcsSource.encode(message.gcsSource, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified InputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3.InputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IInputConfig} message InputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        InputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an InputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.InputConfig} InputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        InputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.InputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.mimeType = reader.string();
                                    break;
                                case 2:
                                    message.gcsSource = $root.google.cloud.translation.v3.GcsSource.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an InputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.InputConfig} InputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        InputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an InputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        InputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                properties.source = 1;
                                {
                                    var error = $root.google.cloud.translation.v3.GcsSource.verify(message.gcsSource);
                                    if (error)
                                        return "gcsSource." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates an InputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.InputConfig} InputConfig
                         */
                        InputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.InputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3.InputConfig();
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            if (object.gcsSource != null) {
                                if (typeof object.gcsSource !== "object")
                                    throw TypeError(".google.cloud.translation.v3.InputConfig.gcsSource: object expected");
                                message.gcsSource = $root.google.cloud.translation.v3.GcsSource.fromObject(object.gcsSource);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an InputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @static
                         * @param {google.cloud.translation.v3.InputConfig} message InputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        InputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.mimeType = "";
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                object.gcsSource = $root.google.cloud.translation.v3.GcsSource.toObject(message.gcsSource, options);
                                if (options.oneofs)
                                    object.source = "gcsSource";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this InputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.InputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        InputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return InputConfig;
                    })();
    
                    v3.GcsDestination = (function() {
    
                        /**
                         * Properties of a GcsDestination.
                         * @memberof google.cloud.translation.v3
                         * @interface IGcsDestination
                         * @property {string|null} [outputUriPrefix] GcsDestination outputUriPrefix
                         */
    
                        /**
                         * Constructs a new GcsDestination.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a GcsDestination.
                         * @implements IGcsDestination
                         * @constructor
                         * @param {google.cloud.translation.v3.IGcsDestination=} [properties] Properties to set
                         */
                        function GcsDestination(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GcsDestination outputUriPrefix.
                         * @member {string} outputUriPrefix
                         * @memberof google.cloud.translation.v3.GcsDestination
                         * @instance
                         */
                        GcsDestination.prototype.outputUriPrefix = "";
    
                        /**
                         * Creates a new GcsDestination instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.GcsDestination
                         * @static
                         * @param {google.cloud.translation.v3.IGcsDestination=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.GcsDestination} GcsDestination instance
                         */
                        GcsDestination.create = function create(properties) {
                            return new GcsDestination(properties);
                        };
    
                        /**
                         * Encodes the specified GcsDestination message. Does not implicitly {@link google.cloud.translation.v3.GcsDestination.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.GcsDestination
                         * @static
                         * @param {google.cloud.translation.v3.IGcsDestination} message GcsDestination message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GcsDestination.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.outputUriPrefix != null && Object.hasOwnProperty.call(message, "outputUriPrefix"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.outputUriPrefix);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GcsDestination message, length delimited. Does not implicitly {@link google.cloud.translation.v3.GcsDestination.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.GcsDestination
                         * @static
                         * @param {google.cloud.translation.v3.IGcsDestination} message GcsDestination message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GcsDestination.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GcsDestination message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.GcsDestination
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.GcsDestination} GcsDestination
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GcsDestination.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.GcsDestination();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.outputUriPrefix = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GcsDestination message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.GcsDestination
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.GcsDestination} GcsDestination
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GcsDestination.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GcsDestination message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.GcsDestination
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GcsDestination.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.outputUriPrefix != null && message.hasOwnProperty("outputUriPrefix"))
                                if (!$util.isString(message.outputUriPrefix))
                                    return "outputUriPrefix: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GcsDestination message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.GcsDestination
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.GcsDestination} GcsDestination
                         */
                        GcsDestination.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.GcsDestination)
                                return object;
                            var message = new $root.google.cloud.translation.v3.GcsDestination();
                            if (object.outputUriPrefix != null)
                                message.outputUriPrefix = String(object.outputUriPrefix);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GcsDestination message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.GcsDestination
                         * @static
                         * @param {google.cloud.translation.v3.GcsDestination} message GcsDestination
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GcsDestination.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.outputUriPrefix = "";
                            if (message.outputUriPrefix != null && message.hasOwnProperty("outputUriPrefix"))
                                object.outputUriPrefix = message.outputUriPrefix;
                            return object;
                        };
    
                        /**
                         * Converts this GcsDestination to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.GcsDestination
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GcsDestination.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GcsDestination;
                    })();
    
                    v3.OutputConfig = (function() {
    
                        /**
                         * Properties of an OutputConfig.
                         * @memberof google.cloud.translation.v3
                         * @interface IOutputConfig
                         * @property {google.cloud.translation.v3.IGcsDestination|null} [gcsDestination] OutputConfig gcsDestination
                         */
    
                        /**
                         * Constructs a new OutputConfig.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents an OutputConfig.
                         * @implements IOutputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3.IOutputConfig=} [properties] Properties to set
                         */
                        function OutputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * OutputConfig gcsDestination.
                         * @member {google.cloud.translation.v3.IGcsDestination|null|undefined} gcsDestination
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @instance
                         */
                        OutputConfig.prototype.gcsDestination = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * OutputConfig destination.
                         * @member {"gcsDestination"|undefined} destination
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @instance
                         */
                        Object.defineProperty(OutputConfig.prototype, "destination", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsDestination"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new OutputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IOutputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.OutputConfig} OutputConfig instance
                         */
                        OutputConfig.create = function create(properties) {
                            return new OutputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified OutputConfig message. Does not implicitly {@link google.cloud.translation.v3.OutputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IOutputConfig} message OutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        OutputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.gcsDestination != null && Object.hasOwnProperty.call(message, "gcsDestination"))
                                $root.google.cloud.translation.v3.GcsDestination.encode(message.gcsDestination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified OutputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3.OutputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IOutputConfig} message OutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        OutputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an OutputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.OutputConfig} OutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        OutputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.OutputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.gcsDestination = $root.google.cloud.translation.v3.GcsDestination.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an OutputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.OutputConfig} OutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        OutputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an OutputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        OutputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                properties.destination = 1;
                                {
                                    var error = $root.google.cloud.translation.v3.GcsDestination.verify(message.gcsDestination);
                                    if (error)
                                        return "gcsDestination." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates an OutputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.OutputConfig} OutputConfig
                         */
                        OutputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.OutputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3.OutputConfig();
                            if (object.gcsDestination != null) {
                                if (typeof object.gcsDestination !== "object")
                                    throw TypeError(".google.cloud.translation.v3.OutputConfig.gcsDestination: object expected");
                                message.gcsDestination = $root.google.cloud.translation.v3.GcsDestination.fromObject(object.gcsDestination);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an OutputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.OutputConfig} message OutputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        OutputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                object.gcsDestination = $root.google.cloud.translation.v3.GcsDestination.toObject(message.gcsDestination, options);
                                if (options.oneofs)
                                    object.destination = "gcsDestination";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this OutputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.OutputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        OutputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return OutputConfig;
                    })();
    
                    v3.DocumentInputConfig = (function() {
    
                        /**
                         * Properties of a DocumentInputConfig.
                         * @memberof google.cloud.translation.v3
                         * @interface IDocumentInputConfig
                         * @property {Uint8Array|null} [content] DocumentInputConfig content
                         * @property {google.cloud.translation.v3.IGcsSource|null} [gcsSource] DocumentInputConfig gcsSource
                         * @property {string|null} [mimeType] DocumentInputConfig mimeType
                         */
    
                        /**
                         * Constructs a new DocumentInputConfig.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a DocumentInputConfig.
                         * @implements IDocumentInputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3.IDocumentInputConfig=} [properties] Properties to set
                         */
                        function DocumentInputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DocumentInputConfig content.
                         * @member {Uint8Array|null|undefined} content
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @instance
                         */
                        DocumentInputConfig.prototype.content = null;
    
                        /**
                         * DocumentInputConfig gcsSource.
                         * @member {google.cloud.translation.v3.IGcsSource|null|undefined} gcsSource
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @instance
                         */
                        DocumentInputConfig.prototype.gcsSource = null;
    
                        /**
                         * DocumentInputConfig mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @instance
                         */
                        DocumentInputConfig.prototype.mimeType = "";
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * DocumentInputConfig source.
                         * @member {"content"|"gcsSource"|undefined} source
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @instance
                         */
                        Object.defineProperty(DocumentInputConfig.prototype, "source", {
                            get: $util.oneOfGetter($oneOfFields = ["content", "gcsSource"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new DocumentInputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IDocumentInputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.DocumentInputConfig} DocumentInputConfig instance
                         */
                        DocumentInputConfig.create = function create(properties) {
                            return new DocumentInputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified DocumentInputConfig message. Does not implicitly {@link google.cloud.translation.v3.DocumentInputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IDocumentInputConfig} message DocumentInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentInputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.content);
                            if (message.gcsSource != null && Object.hasOwnProperty.call(message, "gcsSource"))
                                $root.google.cloud.translation.v3.GcsSource.encode(message.gcsSource, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.mimeType);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DocumentInputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3.DocumentInputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IDocumentInputConfig} message DocumentInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentInputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DocumentInputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.DocumentInputConfig} DocumentInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentInputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.DocumentInputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.content = reader.bytes();
                                    break;
                                case 2:
                                    message.gcsSource = $root.google.cloud.translation.v3.GcsSource.decode(reader, reader.uint32());
                                    break;
                                case 4:
                                    message.mimeType = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DocumentInputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.DocumentInputConfig} DocumentInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentInputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DocumentInputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DocumentInputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.content != null && message.hasOwnProperty("content")) {
                                properties.source = 1;
                                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                                    return "content: buffer expected";
                            }
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                if (properties.source === 1)
                                    return "source: multiple values";
                                properties.source = 1;
                                {
                                    var error = $root.google.cloud.translation.v3.GcsSource.verify(message.gcsSource);
                                    if (error)
                                        return "gcsSource." + error;
                                }
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DocumentInputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.DocumentInputConfig} DocumentInputConfig
                         */
                        DocumentInputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.DocumentInputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3.DocumentInputConfig();
                            if (object.content != null)
                                if (typeof object.content === "string")
                                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                                else if (object.content.length)
                                    message.content = object.content;
                            if (object.gcsSource != null) {
                                if (typeof object.gcsSource !== "object")
                                    throw TypeError(".google.cloud.translation.v3.DocumentInputConfig.gcsSource: object expected");
                                message.gcsSource = $root.google.cloud.translation.v3.GcsSource.fromObject(object.gcsSource);
                            }
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DocumentInputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.DocumentInputConfig} message DocumentInputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DocumentInputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.mimeType = "";
                            if (message.content != null && message.hasOwnProperty("content")) {
                                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
                                if (options.oneofs)
                                    object.source = "content";
                            }
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                object.gcsSource = $root.google.cloud.translation.v3.GcsSource.toObject(message.gcsSource, options);
                                if (options.oneofs)
                                    object.source = "gcsSource";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            return object;
                        };
    
                        /**
                         * Converts this DocumentInputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.DocumentInputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DocumentInputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DocumentInputConfig;
                    })();
    
                    v3.DocumentOutputConfig = (function() {
    
                        /**
                         * Properties of a DocumentOutputConfig.
                         * @memberof google.cloud.translation.v3
                         * @interface IDocumentOutputConfig
                         * @property {google.cloud.translation.v3.IGcsDestination|null} [gcsDestination] DocumentOutputConfig gcsDestination
                         * @property {string|null} [mimeType] DocumentOutputConfig mimeType
                         */
    
                        /**
                         * Constructs a new DocumentOutputConfig.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a DocumentOutputConfig.
                         * @implements IDocumentOutputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3.IDocumentOutputConfig=} [properties] Properties to set
                         */
                        function DocumentOutputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DocumentOutputConfig gcsDestination.
                         * @member {google.cloud.translation.v3.IGcsDestination|null|undefined} gcsDestination
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @instance
                         */
                        DocumentOutputConfig.prototype.gcsDestination = null;
    
                        /**
                         * DocumentOutputConfig mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @instance
                         */
                        DocumentOutputConfig.prototype.mimeType = "";
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * DocumentOutputConfig destination.
                         * @member {"gcsDestination"|undefined} destination
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @instance
                         */
                        Object.defineProperty(DocumentOutputConfig.prototype, "destination", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsDestination"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new DocumentOutputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IDocumentOutputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.DocumentOutputConfig} DocumentOutputConfig instance
                         */
                        DocumentOutputConfig.create = function create(properties) {
                            return new DocumentOutputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified DocumentOutputConfig message. Does not implicitly {@link google.cloud.translation.v3.DocumentOutputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IDocumentOutputConfig} message DocumentOutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentOutputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.gcsDestination != null && Object.hasOwnProperty.call(message, "gcsDestination"))
                                $root.google.cloud.translation.v3.GcsDestination.encode(message.gcsDestination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.mimeType);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DocumentOutputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3.DocumentOutputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IDocumentOutputConfig} message DocumentOutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentOutputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DocumentOutputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.DocumentOutputConfig} DocumentOutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentOutputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.DocumentOutputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.gcsDestination = $root.google.cloud.translation.v3.GcsDestination.decode(reader, reader.uint32());
                                    break;
                                case 3:
                                    message.mimeType = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DocumentOutputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.DocumentOutputConfig} DocumentOutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentOutputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DocumentOutputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DocumentOutputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                properties.destination = 1;
                                {
                                    var error = $root.google.cloud.translation.v3.GcsDestination.verify(message.gcsDestination);
                                    if (error)
                                        return "gcsDestination." + error;
                                }
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DocumentOutputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.DocumentOutputConfig} DocumentOutputConfig
                         */
                        DocumentOutputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.DocumentOutputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3.DocumentOutputConfig();
                            if (object.gcsDestination != null) {
                                if (typeof object.gcsDestination !== "object")
                                    throw TypeError(".google.cloud.translation.v3.DocumentOutputConfig.gcsDestination: object expected");
                                message.gcsDestination = $root.google.cloud.translation.v3.GcsDestination.fromObject(object.gcsDestination);
                            }
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DocumentOutputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.DocumentOutputConfig} message DocumentOutputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DocumentOutputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.mimeType = "";
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                object.gcsDestination = $root.google.cloud.translation.v3.GcsDestination.toObject(message.gcsDestination, options);
                                if (options.oneofs)
                                    object.destination = "gcsDestination";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            return object;
                        };
    
                        /**
                         * Converts this DocumentOutputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.DocumentOutputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DocumentOutputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DocumentOutputConfig;
                    })();
    
                    v3.TranslateDocumentRequest = (function() {
    
                        /**
                         * Properties of a TranslateDocumentRequest.
                         * @memberof google.cloud.translation.v3
                         * @interface ITranslateDocumentRequest
                         * @property {string|null} [parent] TranslateDocumentRequest parent
                         * @property {string|null} [sourceLanguageCode] TranslateDocumentRequest sourceLanguageCode
                         * @property {string|null} [targetLanguageCode] TranslateDocumentRequest targetLanguageCode
                         * @property {google.cloud.translation.v3.IDocumentInputConfig|null} [documentInputConfig] TranslateDocumentRequest documentInputConfig
                         * @property {google.cloud.translation.v3.IDocumentOutputConfig|null} [documentOutputConfig] TranslateDocumentRequest documentOutputConfig
                         * @property {string|null} [model] TranslateDocumentRequest model
                         * @property {google.cloud.translation.v3.ITranslateTextGlossaryConfig|null} [glossaryConfig] TranslateDocumentRequest glossaryConfig
                         * @property {Object.<string,string>|null} [labels] TranslateDocumentRequest labels
                         */
    
                        /**
                         * Constructs a new TranslateDocumentRequest.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a TranslateDocumentRequest.
                         * @implements ITranslateDocumentRequest
                         * @constructor
                         * @param {google.cloud.translation.v3.ITranslateDocumentRequest=} [properties] Properties to set
                         */
                        function TranslateDocumentRequest(properties) {
                            this.labels = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TranslateDocumentRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.parent = "";
    
                        /**
                         * TranslateDocumentRequest sourceLanguageCode.
                         * @member {string} sourceLanguageCode
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.sourceLanguageCode = "";
    
                        /**
                         * TranslateDocumentRequest targetLanguageCode.
                         * @member {string} targetLanguageCode
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.targetLanguageCode = "";
    
                        /**
                         * TranslateDocumentRequest documentInputConfig.
                         * @member {google.cloud.translation.v3.IDocumentInputConfig|null|undefined} documentInputConfig
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.documentInputConfig = null;
    
                        /**
                         * TranslateDocumentRequest documentOutputConfig.
                         * @member {google.cloud.translation.v3.IDocumentOutputConfig|null|undefined} documentOutputConfig
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.documentOutputConfig = null;
    
                        /**
                         * TranslateDocumentRequest model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.model = "";
    
                        /**
                         * TranslateDocumentRequest glossaryConfig.
                         * @member {google.cloud.translation.v3.ITranslateTextGlossaryConfig|null|undefined} glossaryConfig
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.glossaryConfig = null;
    
                        /**
                         * TranslateDocumentRequest labels.
                         * @member {Object.<string,string>} labels
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.labels = $util.emptyObject;
    
                        /**
                         * Creates a new TranslateDocumentRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateDocumentRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.TranslateDocumentRequest} TranslateDocumentRequest instance
                         */
                        TranslateDocumentRequest.create = function create(properties) {
                            return new TranslateDocumentRequest(properties);
                        };
    
                        /**
                         * Encodes the specified TranslateDocumentRequest message. Does not implicitly {@link google.cloud.translation.v3.TranslateDocumentRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateDocumentRequest} message TranslateDocumentRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateDocumentRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                            if (message.sourceLanguageCode != null && Object.hasOwnProperty.call(message, "sourceLanguageCode"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.sourceLanguageCode);
                            if (message.targetLanguageCode != null && Object.hasOwnProperty.call(message, "targetLanguageCode"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.targetLanguageCode);
                            if (message.documentInputConfig != null && Object.hasOwnProperty.call(message, "documentInputConfig"))
                                $root.google.cloud.translation.v3.DocumentInputConfig.encode(message.documentInputConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            if (message.documentOutputConfig != null && Object.hasOwnProperty.call(message, "documentOutputConfig"))
                                $root.google.cloud.translation.v3.DocumentOutputConfig.encode(message.documentOutputConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.model);
                            if (message.glossaryConfig != null && Object.hasOwnProperty.call(message, "glossaryConfig"))
                                $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.encode(message.glossaryConfig, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                            if (message.labels != null && Object.hasOwnProperty.call(message, "labels"))
                                for (var keys = Object.keys(message.labels), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 8, wireType 2 =*/66).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.labels[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TranslateDocumentRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3.TranslateDocumentRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateDocumentRequest} message TranslateDocumentRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateDocumentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TranslateDocumentRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.TranslateDocumentRequest} TranslateDocumentRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateDocumentRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.TranslateDocumentRequest(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.parent = reader.string();
                                    break;
                                case 2:
                                    message.sourceLanguageCode = reader.string();
                                    break;
                                case 3:
                                    message.targetLanguageCode = reader.string();
                                    break;
                                case 4:
                                    message.documentInputConfig = $root.google.cloud.translation.v3.DocumentInputConfig.decode(reader, reader.uint32());
                                    break;
                                case 5:
                                    message.documentOutputConfig = $root.google.cloud.translation.v3.DocumentOutputConfig.decode(reader, reader.uint32());
                                    break;
                                case 6:
                                    message.model = reader.string();
                                    break;
                                case 7:
                                    message.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                    break;
                                case 8:
                                    if (message.labels === $util.emptyObject)
                                        message.labels = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.labels[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TranslateDocumentRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.TranslateDocumentRequest} TranslateDocumentRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateDocumentRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TranslateDocumentRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TranslateDocumentRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                if (!$util.isString(message.sourceLanguageCode))
                                    return "sourceLanguageCode: string expected";
                            if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                if (!$util.isString(message.targetLanguageCode))
                                    return "targetLanguageCode: string expected";
                            if (message.documentInputConfig != null && message.hasOwnProperty("documentInputConfig")) {
                                var error = $root.google.cloud.translation.v3.DocumentInputConfig.verify(message.documentInputConfig);
                                if (error)
                                    return "documentInputConfig." + error;
                            }
                            if (message.documentOutputConfig != null && message.hasOwnProperty("documentOutputConfig")) {
                                var error = $root.google.cloud.translation.v3.DocumentOutputConfig.verify(message.documentOutputConfig);
                                if (error)
                                    return "documentOutputConfig." + error;
                            }
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig")) {
                                var error = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.verify(message.glossaryConfig);
                                if (error)
                                    return "glossaryConfig." + error;
                            }
                            if (message.labels != null && message.hasOwnProperty("labels")) {
                                if (!$util.isObject(message.labels))
                                    return "labels: object expected";
                                var key = Object.keys(message.labels);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.labels[key[i]]))
                                        return "labels: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a TranslateDocumentRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.TranslateDocumentRequest} TranslateDocumentRequest
                         */
                        TranslateDocumentRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.TranslateDocumentRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3.TranslateDocumentRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.sourceLanguageCode != null)
                                message.sourceLanguageCode = String(object.sourceLanguageCode);
                            if (object.targetLanguageCode != null)
                                message.targetLanguageCode = String(object.targetLanguageCode);
                            if (object.documentInputConfig != null) {
                                if (typeof object.documentInputConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3.TranslateDocumentRequest.documentInputConfig: object expected");
                                message.documentInputConfig = $root.google.cloud.translation.v3.DocumentInputConfig.fromObject(object.documentInputConfig);
                            }
                            if (object.documentOutputConfig != null) {
                                if (typeof object.documentOutputConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3.TranslateDocumentRequest.documentOutputConfig: object expected");
                                message.documentOutputConfig = $root.google.cloud.translation.v3.DocumentOutputConfig.fromObject(object.documentOutputConfig);
                            }
                            if (object.model != null)
                                message.model = String(object.model);
                            if (object.glossaryConfig != null) {
                                if (typeof object.glossaryConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3.TranslateDocumentRequest.glossaryConfig: object expected");
                                message.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.fromObject(object.glossaryConfig);
                            }
                            if (object.labels) {
                                if (typeof object.labels !== "object")
                                    throw TypeError(".google.cloud.translation.v3.TranslateDocumentRequest.labels: object expected");
                                message.labels = {};
                                for (var keys = Object.keys(object.labels), i = 0; i < keys.length; ++i)
                                    message.labels[keys[i]] = String(object.labels[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TranslateDocumentRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3.TranslateDocumentRequest} message TranslateDocumentRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TranslateDocumentRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.objects || options.defaults)
                                object.labels = {};
                            if (options.defaults) {
                                object.parent = "";
                                object.sourceLanguageCode = "";
                                object.targetLanguageCode = "";
                                object.documentInputConfig = null;
                                object.documentOutputConfig = null;
                                object.model = "";
                                object.glossaryConfig = null;
                            }
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                object.sourceLanguageCode = message.sourceLanguageCode;
                            if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                object.targetLanguageCode = message.targetLanguageCode;
                            if (message.documentInputConfig != null && message.hasOwnProperty("documentInputConfig"))
                                object.documentInputConfig = $root.google.cloud.translation.v3.DocumentInputConfig.toObject(message.documentInputConfig, options);
                            if (message.documentOutputConfig != null && message.hasOwnProperty("documentOutputConfig"))
                                object.documentOutputConfig = $root.google.cloud.translation.v3.DocumentOutputConfig.toObject(message.documentOutputConfig, options);
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig"))
                                object.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.toObject(message.glossaryConfig, options);
                            var keys2;
                            if (message.labels && (keys2 = Object.keys(message.labels)).length) {
                                object.labels = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.labels[keys2[j]] = message.labels[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this TranslateDocumentRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.TranslateDocumentRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TranslateDocumentRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TranslateDocumentRequest;
                    })();
    
                    v3.DocumentTranslation = (function() {
    
                        /**
                         * Properties of a DocumentTranslation.
                         * @memberof google.cloud.translation.v3
                         * @interface IDocumentTranslation
                         * @property {Array.<Uint8Array>|null} [byteStreamOutputs] DocumentTranslation byteStreamOutputs
                         * @property {string|null} [mimeType] DocumentTranslation mimeType
                         * @property {string|null} [detectedLanguageCode] DocumentTranslation detectedLanguageCode
                         */
    
                        /**
                         * Constructs a new DocumentTranslation.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a DocumentTranslation.
                         * @implements IDocumentTranslation
                         * @constructor
                         * @param {google.cloud.translation.v3.IDocumentTranslation=} [properties] Properties to set
                         */
                        function DocumentTranslation(properties) {
                            this.byteStreamOutputs = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DocumentTranslation byteStreamOutputs.
                         * @member {Array.<Uint8Array>} byteStreamOutputs
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @instance
                         */
                        DocumentTranslation.prototype.byteStreamOutputs = $util.emptyArray;
    
                        /**
                         * DocumentTranslation mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @instance
                         */
                        DocumentTranslation.prototype.mimeType = "";
    
                        /**
                         * DocumentTranslation detectedLanguageCode.
                         * @member {string} detectedLanguageCode
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @instance
                         */
                        DocumentTranslation.prototype.detectedLanguageCode = "";
    
                        /**
                         * Creates a new DocumentTranslation instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @static
                         * @param {google.cloud.translation.v3.IDocumentTranslation=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.DocumentTranslation} DocumentTranslation instance
                         */
                        DocumentTranslation.create = function create(properties) {
                            return new DocumentTranslation(properties);
                        };
    
                        /**
                         * Encodes the specified DocumentTranslation message. Does not implicitly {@link google.cloud.translation.v3.DocumentTranslation.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @static
                         * @param {google.cloud.translation.v3.IDocumentTranslation} message DocumentTranslation message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentTranslation.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.byteStreamOutputs != null && message.byteStreamOutputs.length)
                                for (var i = 0; i < message.byteStreamOutputs.length; ++i)
                                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.byteStreamOutputs[i]);
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.mimeType);
                            if (message.detectedLanguageCode != null && Object.hasOwnProperty.call(message, "detectedLanguageCode"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.detectedLanguageCode);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DocumentTranslation message, length delimited. Does not implicitly {@link google.cloud.translation.v3.DocumentTranslation.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @static
                         * @param {google.cloud.translation.v3.IDocumentTranslation} message DocumentTranslation message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentTranslation.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DocumentTranslation message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.DocumentTranslation} DocumentTranslation
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentTranslation.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.DocumentTranslation();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.byteStreamOutputs && message.byteStreamOutputs.length))
                                        message.byteStreamOutputs = [];
                                    message.byteStreamOutputs.push(reader.bytes());
                                    break;
                                case 2:
                                    message.mimeType = reader.string();
                                    break;
                                case 3:
                                    message.detectedLanguageCode = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DocumentTranslation message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.DocumentTranslation} DocumentTranslation
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentTranslation.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DocumentTranslation message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DocumentTranslation.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.byteStreamOutputs != null && message.hasOwnProperty("byteStreamOutputs")) {
                                if (!Array.isArray(message.byteStreamOutputs))
                                    return "byteStreamOutputs: array expected";
                                for (var i = 0; i < message.byteStreamOutputs.length; ++i)
                                    if (!(message.byteStreamOutputs[i] && typeof message.byteStreamOutputs[i].length === "number" || $util.isString(message.byteStreamOutputs[i])))
                                        return "byteStreamOutputs: buffer[] expected";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            if (message.detectedLanguageCode != null && message.hasOwnProperty("detectedLanguageCode"))
                                if (!$util.isString(message.detectedLanguageCode))
                                    return "detectedLanguageCode: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DocumentTranslation message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.DocumentTranslation} DocumentTranslation
                         */
                        DocumentTranslation.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.DocumentTranslation)
                                return object;
                            var message = new $root.google.cloud.translation.v3.DocumentTranslation();
                            if (object.byteStreamOutputs) {
                                if (!Array.isArray(object.byteStreamOutputs))
                                    throw TypeError(".google.cloud.translation.v3.DocumentTranslation.byteStreamOutputs: array expected");
                                message.byteStreamOutputs = [];
                                for (var i = 0; i < object.byteStreamOutputs.length; ++i)
                                    if (typeof object.byteStreamOutputs[i] === "string")
                                        $util.base64.decode(object.byteStreamOutputs[i], message.byteStreamOutputs[i] = $util.newBuffer($util.base64.length(object.byteStreamOutputs[i])), 0);
                                    else if (object.byteStreamOutputs[i].length)
                                        message.byteStreamOutputs[i] = object.byteStreamOutputs[i];
                            }
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            if (object.detectedLanguageCode != null)
                                message.detectedLanguageCode = String(object.detectedLanguageCode);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DocumentTranslation message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @static
                         * @param {google.cloud.translation.v3.DocumentTranslation} message DocumentTranslation
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DocumentTranslation.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.byteStreamOutputs = [];
                            if (options.defaults) {
                                object.mimeType = "";
                                object.detectedLanguageCode = "";
                            }
                            if (message.byteStreamOutputs && message.byteStreamOutputs.length) {
                                object.byteStreamOutputs = [];
                                for (var j = 0; j < message.byteStreamOutputs.length; ++j)
                                    object.byteStreamOutputs[j] = options.bytes === String ? $util.base64.encode(message.byteStreamOutputs[j], 0, message.byteStreamOutputs[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.byteStreamOutputs[j]) : message.byteStreamOutputs[j];
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            if (message.detectedLanguageCode != null && message.hasOwnProperty("detectedLanguageCode"))
                                object.detectedLanguageCode = message.detectedLanguageCode;
                            return object;
                        };
    
                        /**
                         * Converts this DocumentTranslation to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.DocumentTranslation
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DocumentTranslation.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DocumentTranslation;
                    })();
    
                    v3.TranslateDocumentResponse = (function() {
    
                        /**
                         * Properties of a TranslateDocumentResponse.
                         * @memberof google.cloud.translation.v3
                         * @interface ITranslateDocumentResponse
                         * @property {google.cloud.translation.v3.IDocumentTranslation|null} [documentTranslation] TranslateDocumentResponse documentTranslation
                         * @property {google.cloud.translation.v3.IDocumentTranslation|null} [glossaryDocumentTranslation] TranslateDocumentResponse glossaryDocumentTranslation
                         * @property {string|null} [model] TranslateDocumentResponse model
                         * @property {google.cloud.translation.v3.ITranslateTextGlossaryConfig|null} [glossaryConfig] TranslateDocumentResponse glossaryConfig
                         */
    
                        /**
                         * Constructs a new TranslateDocumentResponse.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a TranslateDocumentResponse.
                         * @implements ITranslateDocumentResponse
                         * @constructor
                         * @param {google.cloud.translation.v3.ITranslateDocumentResponse=} [properties] Properties to set
                         */
                        function TranslateDocumentResponse(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TranslateDocumentResponse documentTranslation.
                         * @member {google.cloud.translation.v3.IDocumentTranslation|null|undefined} documentTranslation
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @instance
                         */
                        TranslateDocumentResponse.prototype.documentTranslation = null;
    
                        /**
                         * TranslateDocumentResponse glossaryDocumentTranslation.
                         * @member {google.cloud.translation.v3.IDocumentTranslation|null|undefined} glossaryDocumentTranslation
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @instance
                         */
                        TranslateDocumentResponse.prototype.glossaryDocumentTranslation = null;
    
                        /**
                         * TranslateDocumentResponse model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @instance
                         */
                        TranslateDocumentResponse.prototype.model = "";
    
                        /**
                         * TranslateDocumentResponse glossaryConfig.
                         * @member {google.cloud.translation.v3.ITranslateTextGlossaryConfig|null|undefined} glossaryConfig
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @instance
                         */
                        TranslateDocumentResponse.prototype.glossaryConfig = null;
    
                        /**
                         * Creates a new TranslateDocumentResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateDocumentResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.TranslateDocumentResponse} TranslateDocumentResponse instance
                         */
                        TranslateDocumentResponse.create = function create(properties) {
                            return new TranslateDocumentResponse(properties);
                        };
    
                        /**
                         * Encodes the specified TranslateDocumentResponse message. Does not implicitly {@link google.cloud.translation.v3.TranslateDocumentResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateDocumentResponse} message TranslateDocumentResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateDocumentResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.documentTranslation != null && Object.hasOwnProperty.call(message, "documentTranslation"))
                                $root.google.cloud.translation.v3.DocumentTranslation.encode(message.documentTranslation, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.glossaryDocumentTranslation != null && Object.hasOwnProperty.call(message, "glossaryDocumentTranslation"))
                                $root.google.cloud.translation.v3.DocumentTranslation.encode(message.glossaryDocumentTranslation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.model);
                            if (message.glossaryConfig != null && Object.hasOwnProperty.call(message, "glossaryConfig"))
                                $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.encode(message.glossaryConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TranslateDocumentResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3.TranslateDocumentResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3.ITranslateDocumentResponse} message TranslateDocumentResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateDocumentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TranslateDocumentResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.TranslateDocumentResponse} TranslateDocumentResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateDocumentResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.TranslateDocumentResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.documentTranslation = $root.google.cloud.translation.v3.DocumentTranslation.decode(reader, reader.uint32());
                                    break;
                                case 2:
                                    message.glossaryDocumentTranslation = $root.google.cloud.translation.v3.DocumentTranslation.decode(reader, reader.uint32());
                                    break;
                                case 3:
                                    message.model = reader.string();
                                    break;
                                case 4:
                                    message.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TranslateDocumentResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.TranslateDocumentResponse} TranslateDocumentResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateDocumentResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TranslateDocumentResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TranslateDocumentResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.documentTranslation != null && message.hasOwnProperty("documentTranslation")) {
                                var error = $root.google.cloud.translation.v3.DocumentTranslation.verify(message.documentTranslation);
                                if (error)
                                    return "documentTranslation." + error;
                            }
                            if (message.glossaryDocumentTranslation != null && message.hasOwnProperty("glossaryDocumentTranslation")) {
                                var error = $root.google.cloud.translation.v3.DocumentTranslation.verify(message.glossaryDocumentTranslation);
                                if (error)
                                    return "glossaryDocumentTranslation." + error;
                            }
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig")) {
                                var error = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.verify(message.glossaryConfig);
                                if (error)
                                    return "glossaryConfig." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a TranslateDocumentResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.TranslateDocumentResponse} TranslateDocumentResponse
                         */
                        TranslateDocumentResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.TranslateDocumentResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3.TranslateDocumentResponse();
                            if (object.documentTranslation != null) {
                                if (typeof object.documentTranslation !== "object")
                                    throw TypeError(".google.cloud.translation.v3.TranslateDocumentResponse.documentTranslation: object expected");
                                message.documentTranslation = $root.google.cloud.translation.v3.DocumentTranslation.fromObject(object.documentTranslation);
                            }
                            if (object.glossaryDocumentTranslation != null) {
                                if (typeof object.glossaryDocumentTranslation !== "object")
                                    throw TypeError(".google.cloud.translation.v3.TranslateDocumentResponse.glossaryDocumentTranslation: object expected");
                                message.glossaryDocumentTranslation = $root.google.cloud.translation.v3.DocumentTranslation.fromObject(object.glossaryDocumentTranslation);
                            }
                            if (object.model != null)
                                message.model = String(object.model);
                            if (object.glossaryConfig != null) {
                                if (typeof object.glossaryConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3.TranslateDocumentResponse.glossaryConfig: object expected");
                                message.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.fromObject(object.glossaryConfig);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TranslateDocumentResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3.TranslateDocumentResponse} message TranslateDocumentResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TranslateDocumentResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.documentTranslation = null;
                                object.glossaryDocumentTranslation = null;
                                object.model = "";
                                object.glossaryConfig = null;
                            }
                            if (message.documentTranslation != null && message.hasOwnProperty("documentTranslation"))
                                object.documentTranslation = $root.google.cloud.translation.v3.DocumentTranslation.toObject(message.documentTranslation, options);
                            if (message.glossaryDocumentTranslation != null && message.hasOwnProperty("glossaryDocumentTranslation"))
                                object.glossaryDocumentTranslation = $root.google.cloud.translation.v3.DocumentTranslation.toObject(message.glossaryDocumentTranslation, options);
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig"))
                                object.glossaryConfig = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.toObject(message.glossaryConfig, options);
                            return object;
                        };
    
                        /**
                         * Converts this TranslateDocumentResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.TranslateDocumentResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TranslateDocumentResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TranslateDocumentResponse;
                    })();
    
                    v3.BatchTranslateTextRequest = (function() {
    
                        /**
                         * Properties of a BatchTranslateTextRequest.
                         * @memberof google.cloud.translation.v3
                         * @interface IBatchTranslateTextRequest
                         * @property {string|null} [parent] BatchTranslateTextRequest parent
                         * @property {string|null} [sourceLanguageCode] BatchTranslateTextRequest sourceLanguageCode
                         * @property {Array.<string>|null} [targetLanguageCodes] BatchTranslateTextRequest targetLanguageCodes
                         * @property {Object.<string,string>|null} [models] BatchTranslateTextRequest models
                         * @property {Array.<google.cloud.translation.v3.IInputConfig>|null} [inputConfigs] BatchTranslateTextRequest inputConfigs
                         * @property {google.cloud.translation.v3.IOutputConfig|null} [outputConfig] BatchTranslateTextRequest outputConfig
                         * @property {Object.<string,google.cloud.translation.v3.ITranslateTextGlossaryConfig>|null} [glossaries] BatchTranslateTextRequest glossaries
                         * @property {Object.<string,string>|null} [labels] BatchTranslateTextRequest labels
                         */
    
                        /**
                         * Constructs a new BatchTranslateTextRequest.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a BatchTranslateTextRequest.
                         * @implements IBatchTranslateTextRequest
                         * @constructor
                         * @param {google.cloud.translation.v3.IBatchTranslateTextRequest=} [properties] Properties to set
                         */
                        function BatchTranslateTextRequest(properties) {
                            this.targetLanguageCodes = [];
                            this.models = {};
                            this.inputConfigs = [];
                            this.glossaries = {};
                            this.labels = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateTextRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.parent = "";
    
                        /**
                         * BatchTranslateTextRequest sourceLanguageCode.
                         * @member {string} sourceLanguageCode
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.sourceLanguageCode = "";
    
                        /**
                         * BatchTranslateTextRequest targetLanguageCodes.
                         * @member {Array.<string>} targetLanguageCodes
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.targetLanguageCodes = $util.emptyArray;
    
                        /**
                         * BatchTranslateTextRequest models.
                         * @member {Object.<string,string>} models
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.models = $util.emptyObject;
    
                        /**
                         * BatchTranslateTextRequest inputConfigs.
                         * @member {Array.<google.cloud.translation.v3.IInputConfig>} inputConfigs
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.inputConfigs = $util.emptyArray;
    
                        /**
                         * BatchTranslateTextRequest outputConfig.
                         * @member {google.cloud.translation.v3.IOutputConfig|null|undefined} outputConfig
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.outputConfig = null;
    
                        /**
                         * BatchTranslateTextRequest glossaries.
                         * @member {Object.<string,google.cloud.translation.v3.ITranslateTextGlossaryConfig>} glossaries
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.glossaries = $util.emptyObject;
    
                        /**
                         * BatchTranslateTextRequest labels.
                         * @member {Object.<string,string>} labels
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.labels = $util.emptyObject;
    
                        /**
                         * Creates a new BatchTranslateTextRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateTextRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.BatchTranslateTextRequest} BatchTranslateTextRequest instance
                         */
                        BatchTranslateTextRequest.create = function create(properties) {
                            return new BatchTranslateTextRequest(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateTextRequest message. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateTextRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateTextRequest} message BatchTranslateTextRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateTextRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                            if (message.sourceLanguageCode != null && Object.hasOwnProperty.call(message, "sourceLanguageCode"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.sourceLanguageCode);
                            if (message.targetLanguageCodes != null && message.targetLanguageCodes.length)
                                for (var i = 0; i < message.targetLanguageCodes.length; ++i)
                                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.targetLanguageCodes[i]);
                            if (message.models != null && Object.hasOwnProperty.call(message, "models"))
                                for (var keys = Object.keys(message.models), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.models[keys[i]]).ldelim();
                            if (message.inputConfigs != null && message.inputConfigs.length)
                                for (var i = 0; i < message.inputConfigs.length; ++i)
                                    $root.google.cloud.translation.v3.InputConfig.encode(message.inputConfigs[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            if (message.outputConfig != null && Object.hasOwnProperty.call(message, "outputConfig"))
                                $root.google.cloud.translation.v3.OutputConfig.encode(message.outputConfig, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                            if (message.glossaries != null && Object.hasOwnProperty.call(message, "glossaries"))
                                for (var keys = Object.keys(message.glossaries), i = 0; i < keys.length; ++i) {
                                    writer.uint32(/* id 7, wireType 2 =*/58).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                                    $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.encode(message.glossaries[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                                }
                            if (message.labels != null && Object.hasOwnProperty.call(message, "labels"))
                                for (var keys = Object.keys(message.labels), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 9, wireType 2 =*/74).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.labels[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateTextRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateTextRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateTextRequest} message BatchTranslateTextRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateTextRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateTextRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.BatchTranslateTextRequest} BatchTranslateTextRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateTextRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.BatchTranslateTextRequest(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.parent = reader.string();
                                    break;
                                case 2:
                                    message.sourceLanguageCode = reader.string();
                                    break;
                                case 3:
                                    if (!(message.targetLanguageCodes && message.targetLanguageCodes.length))
                                        message.targetLanguageCodes = [];
                                    message.targetLanguageCodes.push(reader.string());
                                    break;
                                case 4:
                                    if (message.models === $util.emptyObject)
                                        message.models = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.models[key] = value;
                                    break;
                                case 5:
                                    if (!(message.inputConfigs && message.inputConfigs.length))
                                        message.inputConfigs = [];
                                    message.inputConfigs.push($root.google.cloud.translation.v3.InputConfig.decode(reader, reader.uint32()));
                                    break;
                                case 6:
                                    message.outputConfig = $root.google.cloud.translation.v3.OutputConfig.decode(reader, reader.uint32());
                                    break;
                                case 7:
                                    if (message.glossaries === $util.emptyObject)
                                        message.glossaries = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = null;
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.glossaries[key] = value;
                                    break;
                                case 9:
                                    if (message.labels === $util.emptyObject)
                                        message.labels = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.labels[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateTextRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.BatchTranslateTextRequest} BatchTranslateTextRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateTextRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateTextRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateTextRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                if (!$util.isString(message.sourceLanguageCode))
                                    return "sourceLanguageCode: string expected";
                            if (message.targetLanguageCodes != null && message.hasOwnProperty("targetLanguageCodes")) {
                                if (!Array.isArray(message.targetLanguageCodes))
                                    return "targetLanguageCodes: array expected";
                                for (var i = 0; i < message.targetLanguageCodes.length; ++i)
                                    if (!$util.isString(message.targetLanguageCodes[i]))
                                        return "targetLanguageCodes: string[] expected";
                            }
                            if (message.models != null && message.hasOwnProperty("models")) {
                                if (!$util.isObject(message.models))
                                    return "models: object expected";
                                var key = Object.keys(message.models);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.models[key[i]]))
                                        return "models: string{k:string} expected";
                            }
                            if (message.inputConfigs != null && message.hasOwnProperty("inputConfigs")) {
                                if (!Array.isArray(message.inputConfigs))
                                    return "inputConfigs: array expected";
                                for (var i = 0; i < message.inputConfigs.length; ++i) {
                                    var error = $root.google.cloud.translation.v3.InputConfig.verify(message.inputConfigs[i]);
                                    if (error)
                                        return "inputConfigs." + error;
                                }
                            }
                            if (message.outputConfig != null && message.hasOwnProperty("outputConfig")) {
                                var error = $root.google.cloud.translation.v3.OutputConfig.verify(message.outputConfig);
                                if (error)
                                    return "outputConfig." + error;
                            }
                            if (message.glossaries != null && message.hasOwnProperty("glossaries")) {
                                if (!$util.isObject(message.glossaries))
                                    return "glossaries: object expected";
                                var key = Object.keys(message.glossaries);
                                for (var i = 0; i < key.length; ++i) {
                                    var error = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.verify(message.glossaries[key[i]]);
                                    if (error)
                                        return "glossaries." + error;
                                }
                            }
                            if (message.labels != null && message.hasOwnProperty("labels")) {
                                if (!$util.isObject(message.labels))
                                    return "labels: object expected";
                                var key = Object.keys(message.labels);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.labels[key[i]]))
                                        return "labels: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateTextRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.BatchTranslateTextRequest} BatchTranslateTextRequest
                         */
                        BatchTranslateTextRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.BatchTranslateTextRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3.BatchTranslateTextRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.sourceLanguageCode != null)
                                message.sourceLanguageCode = String(object.sourceLanguageCode);
                            if (object.targetLanguageCodes) {
                                if (!Array.isArray(object.targetLanguageCodes))
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateTextRequest.targetLanguageCodes: array expected");
                                message.targetLanguageCodes = [];
                                for (var i = 0; i < object.targetLanguageCodes.length; ++i)
                                    message.targetLanguageCodes[i] = String(object.targetLanguageCodes[i]);
                            }
                            if (object.models) {
                                if (typeof object.models !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateTextRequest.models: object expected");
                                message.models = {};
                                for (var keys = Object.keys(object.models), i = 0; i < keys.length; ++i)
                                    message.models[keys[i]] = String(object.models[keys[i]]);
                            }
                            if (object.inputConfigs) {
                                if (!Array.isArray(object.inputConfigs))
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateTextRequest.inputConfigs: array expected");
                                message.inputConfigs = [];
                                for (var i = 0; i < object.inputConfigs.length; ++i) {
                                    if (typeof object.inputConfigs[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3.BatchTranslateTextRequest.inputConfigs: object expected");
                                    message.inputConfigs[i] = $root.google.cloud.translation.v3.InputConfig.fromObject(object.inputConfigs[i]);
                                }
                            }
                            if (object.outputConfig != null) {
                                if (typeof object.outputConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateTextRequest.outputConfig: object expected");
                                message.outputConfig = $root.google.cloud.translation.v3.OutputConfig.fromObject(object.outputConfig);
                            }
                            if (object.glossaries) {
                                if (typeof object.glossaries !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateTextRequest.glossaries: object expected");
                                message.glossaries = {};
                                for (var keys = Object.keys(object.glossaries), i = 0; i < keys.length; ++i) {
                                    if (typeof object.glossaries[keys[i]] !== "object")
                                        throw TypeError(".google.cloud.translation.v3.BatchTranslateTextRequest.glossaries: object expected");
                                    message.glossaries[keys[i]] = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.fromObject(object.glossaries[keys[i]]);
                                }
                            }
                            if (object.labels) {
                                if (typeof object.labels !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateTextRequest.labels: object expected");
                                message.labels = {};
                                for (var keys = Object.keys(object.labels), i = 0; i < keys.length; ++i)
                                    message.labels[keys[i]] = String(object.labels[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateTextRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3.BatchTranslateTextRequest} message BatchTranslateTextRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateTextRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.targetLanguageCodes = [];
                                object.inputConfigs = [];
                            }
                            if (options.objects || options.defaults) {
                                object.models = {};
                                object.glossaries = {};
                                object.labels = {};
                            }
                            if (options.defaults) {
                                object.parent = "";
                                object.sourceLanguageCode = "";
                                object.outputConfig = null;
                            }
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                object.sourceLanguageCode = message.sourceLanguageCode;
                            if (message.targetLanguageCodes && message.targetLanguageCodes.length) {
                                object.targetLanguageCodes = [];
                                for (var j = 0; j < message.targetLanguageCodes.length; ++j)
                                    object.targetLanguageCodes[j] = message.targetLanguageCodes[j];
                            }
                            var keys2;
                            if (message.models && (keys2 = Object.keys(message.models)).length) {
                                object.models = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.models[keys2[j]] = message.models[keys2[j]];
                            }
                            if (message.inputConfigs && message.inputConfigs.length) {
                                object.inputConfigs = [];
                                for (var j = 0; j < message.inputConfigs.length; ++j)
                                    object.inputConfigs[j] = $root.google.cloud.translation.v3.InputConfig.toObject(message.inputConfigs[j], options);
                            }
                            if (message.outputConfig != null && message.hasOwnProperty("outputConfig"))
                                object.outputConfig = $root.google.cloud.translation.v3.OutputConfig.toObject(message.outputConfig, options);
                            if (message.glossaries && (keys2 = Object.keys(message.glossaries)).length) {
                                object.glossaries = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.glossaries[keys2[j]] = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.toObject(message.glossaries[keys2[j]], options);
                            }
                            if (message.labels && (keys2 = Object.keys(message.labels)).length) {
                                object.labels = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.labels[keys2[j]] = message.labels[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateTextRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.BatchTranslateTextRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateTextRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchTranslateTextRequest;
                    })();
    
                    v3.BatchTranslateMetadata = (function() {
    
                        /**
                         * Properties of a BatchTranslateMetadata.
                         * @memberof google.cloud.translation.v3
                         * @interface IBatchTranslateMetadata
                         * @property {google.cloud.translation.v3.BatchTranslateMetadata.State|null} [state] BatchTranslateMetadata state
                         * @property {number|Long|null} [translatedCharacters] BatchTranslateMetadata translatedCharacters
                         * @property {number|Long|null} [failedCharacters] BatchTranslateMetadata failedCharacters
                         * @property {number|Long|null} [totalCharacters] BatchTranslateMetadata totalCharacters
                         * @property {google.protobuf.ITimestamp|null} [submitTime] BatchTranslateMetadata submitTime
                         */
    
                        /**
                         * Constructs a new BatchTranslateMetadata.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a BatchTranslateMetadata.
                         * @implements IBatchTranslateMetadata
                         * @constructor
                         * @param {google.cloud.translation.v3.IBatchTranslateMetadata=} [properties] Properties to set
                         */
                        function BatchTranslateMetadata(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateMetadata state.
                         * @member {google.cloud.translation.v3.BatchTranslateMetadata.State} state
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @instance
                         */
                        BatchTranslateMetadata.prototype.state = 0;
    
                        /**
                         * BatchTranslateMetadata translatedCharacters.
                         * @member {number|Long} translatedCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @instance
                         */
                        BatchTranslateMetadata.prototype.translatedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateMetadata failedCharacters.
                         * @member {number|Long} failedCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @instance
                         */
                        BatchTranslateMetadata.prototype.failedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateMetadata totalCharacters.
                         * @member {number|Long} totalCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @instance
                         */
                        BatchTranslateMetadata.prototype.totalCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateMetadata submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @instance
                         */
                        BatchTranslateMetadata.prototype.submitTime = null;
    
                        /**
                         * Creates a new BatchTranslateMetadata instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateMetadata=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.BatchTranslateMetadata} BatchTranslateMetadata instance
                         */
                        BatchTranslateMetadata.create = function create(properties) {
                            return new BatchTranslateMetadata(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateMetadata message. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateMetadata.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateMetadata} message BatchTranslateMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateMetadata.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                            if (message.translatedCharacters != null && Object.hasOwnProperty.call(message, "translatedCharacters"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.translatedCharacters);
                            if (message.failedCharacters != null && Object.hasOwnProperty.call(message, "failedCharacters"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.failedCharacters);
                            if (message.totalCharacters != null && Object.hasOwnProperty.call(message, "totalCharacters"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.totalCharacters);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateMetadata message, length delimited. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateMetadata.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateMetadata} message BatchTranslateMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateMetadata message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.BatchTranslateMetadata} BatchTranslateMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateMetadata.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.BatchTranslateMetadata();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.state = reader.int32();
                                    break;
                                case 2:
                                    message.translatedCharacters = reader.int64();
                                    break;
                                case 3:
                                    message.failedCharacters = reader.int64();
                                    break;
                                case 4:
                                    message.totalCharacters = reader.int64();
                                    break;
                                case 5:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateMetadata message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.BatchTranslateMetadata} BatchTranslateMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateMetadata.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateMetadata message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateMetadata.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.state != null && message.hasOwnProperty("state"))
                                switch (message.state) {
                                default:
                                    return "state: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (!$util.isInteger(message.translatedCharacters) && !(message.translatedCharacters && $util.isInteger(message.translatedCharacters.low) && $util.isInteger(message.translatedCharacters.high)))
                                    return "translatedCharacters: integer|Long expected";
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (!$util.isInteger(message.failedCharacters) && !(message.failedCharacters && $util.isInteger(message.failedCharacters.low) && $util.isInteger(message.failedCharacters.high)))
                                    return "failedCharacters: integer|Long expected";
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (!$util.isInteger(message.totalCharacters) && !(message.totalCharacters && $util.isInteger(message.totalCharacters.low) && $util.isInteger(message.totalCharacters.high)))
                                    return "totalCharacters: integer|Long expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateMetadata message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.BatchTranslateMetadata} BatchTranslateMetadata
                         */
                        BatchTranslateMetadata.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.BatchTranslateMetadata)
                                return object;
                            var message = new $root.google.cloud.translation.v3.BatchTranslateMetadata();
                            switch (object.state) {
                            case "STATE_UNSPECIFIED":
                            case 0:
                                message.state = 0;
                                break;
                            case "RUNNING":
                            case 1:
                                message.state = 1;
                                break;
                            case "SUCCEEDED":
                            case 2:
                                message.state = 2;
                                break;
                            case "FAILED":
                            case 3:
                                message.state = 3;
                                break;
                            case "CANCELLING":
                            case 4:
                                message.state = 4;
                                break;
                            case "CANCELLED":
                            case 5:
                                message.state = 5;
                                break;
                            }
                            if (object.translatedCharacters != null)
                                if ($util.Long)
                                    (message.translatedCharacters = $util.Long.fromValue(object.translatedCharacters)).unsigned = false;
                                else if (typeof object.translatedCharacters === "string")
                                    message.translatedCharacters = parseInt(object.translatedCharacters, 10);
                                else if (typeof object.translatedCharacters === "number")
                                    message.translatedCharacters = object.translatedCharacters;
                                else if (typeof object.translatedCharacters === "object")
                                    message.translatedCharacters = new $util.LongBits(object.translatedCharacters.low >>> 0, object.translatedCharacters.high >>> 0).toNumber();
                            if (object.failedCharacters != null)
                                if ($util.Long)
                                    (message.failedCharacters = $util.Long.fromValue(object.failedCharacters)).unsigned = false;
                                else if (typeof object.failedCharacters === "string")
                                    message.failedCharacters = parseInt(object.failedCharacters, 10);
                                else if (typeof object.failedCharacters === "number")
                                    message.failedCharacters = object.failedCharacters;
                                else if (typeof object.failedCharacters === "object")
                                    message.failedCharacters = new $util.LongBits(object.failedCharacters.low >>> 0, object.failedCharacters.high >>> 0).toNumber();
                            if (object.totalCharacters != null)
                                if ($util.Long)
                                    (message.totalCharacters = $util.Long.fromValue(object.totalCharacters)).unsigned = false;
                                else if (typeof object.totalCharacters === "string")
                                    message.totalCharacters = parseInt(object.totalCharacters, 10);
                                else if (typeof object.totalCharacters === "number")
                                    message.totalCharacters = object.totalCharacters;
                                else if (typeof object.totalCharacters === "object")
                                    message.totalCharacters = new $util.LongBits(object.totalCharacters.low >>> 0, object.totalCharacters.high >>> 0).toNumber();
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateMetadata.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateMetadata message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @static
                         * @param {google.cloud.translation.v3.BatchTranslateMetadata} message BatchTranslateMetadata
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateMetadata.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalCharacters = options.longs === String ? "0" : 0;
                                object.submitTime = null;
                            }
                            if (message.state != null && message.hasOwnProperty("state"))
                                object.state = options.enums === String ? $root.google.cloud.translation.v3.BatchTranslateMetadata.State[message.state] : message.state;
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (typeof message.translatedCharacters === "number")
                                    object.translatedCharacters = options.longs === String ? String(message.translatedCharacters) : message.translatedCharacters;
                                else
                                    object.translatedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.translatedCharacters) : options.longs === Number ? new $util.LongBits(message.translatedCharacters.low >>> 0, message.translatedCharacters.high >>> 0).toNumber() : message.translatedCharacters;
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (typeof message.failedCharacters === "number")
                                    object.failedCharacters = options.longs === String ? String(message.failedCharacters) : message.failedCharacters;
                                else
                                    object.failedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.failedCharacters) : options.longs === Number ? new $util.LongBits(message.failedCharacters.low >>> 0, message.failedCharacters.high >>> 0).toNumber() : message.failedCharacters;
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (typeof message.totalCharacters === "number")
                                    object.totalCharacters = options.longs === String ? String(message.totalCharacters) : message.totalCharacters;
                                else
                                    object.totalCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalCharacters) : options.longs === Number ? new $util.LongBits(message.totalCharacters.low >>> 0, message.totalCharacters.high >>> 0).toNumber() : message.totalCharacters;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateMetadata to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.BatchTranslateMetadata
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateMetadata.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * State enum.
                         * @name google.cloud.translation.v3.BatchTranslateMetadata.State
                         * @enum {number}
                         * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                         * @property {number} RUNNING=1 RUNNING value
                         * @property {number} SUCCEEDED=2 SUCCEEDED value
                         * @property {number} FAILED=3 FAILED value
                         * @property {number} CANCELLING=4 CANCELLING value
                         * @property {number} CANCELLED=5 CANCELLED value
                         */
                        BatchTranslateMetadata.State = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "RUNNING"] = 1;
                            values[valuesById[2] = "SUCCEEDED"] = 2;
                            values[valuesById[3] = "FAILED"] = 3;
                            values[valuesById[4] = "CANCELLING"] = 4;
                            values[valuesById[5] = "CANCELLED"] = 5;
                            return values;
                        })();
    
                        return BatchTranslateMetadata;
                    })();
    
                    v3.BatchTranslateResponse = (function() {
    
                        /**
                         * Properties of a BatchTranslateResponse.
                         * @memberof google.cloud.translation.v3
                         * @interface IBatchTranslateResponse
                         * @property {number|Long|null} [totalCharacters] BatchTranslateResponse totalCharacters
                         * @property {number|Long|null} [translatedCharacters] BatchTranslateResponse translatedCharacters
                         * @property {number|Long|null} [failedCharacters] BatchTranslateResponse failedCharacters
                         * @property {google.protobuf.ITimestamp|null} [submitTime] BatchTranslateResponse submitTime
                         * @property {google.protobuf.ITimestamp|null} [endTime] BatchTranslateResponse endTime
                         */
    
                        /**
                         * Constructs a new BatchTranslateResponse.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a BatchTranslateResponse.
                         * @implements IBatchTranslateResponse
                         * @constructor
                         * @param {google.cloud.translation.v3.IBatchTranslateResponse=} [properties] Properties to set
                         */
                        function BatchTranslateResponse(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateResponse totalCharacters.
                         * @member {number|Long} totalCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @instance
                         */
                        BatchTranslateResponse.prototype.totalCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateResponse translatedCharacters.
                         * @member {number|Long} translatedCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @instance
                         */
                        BatchTranslateResponse.prototype.translatedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateResponse failedCharacters.
                         * @member {number|Long} failedCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @instance
                         */
                        BatchTranslateResponse.prototype.failedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateResponse submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @instance
                         */
                        BatchTranslateResponse.prototype.submitTime = null;
    
                        /**
                         * BatchTranslateResponse endTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} endTime
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @instance
                         */
                        BatchTranslateResponse.prototype.endTime = null;
    
                        /**
                         * Creates a new BatchTranslateResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.BatchTranslateResponse} BatchTranslateResponse instance
                         */
                        BatchTranslateResponse.create = function create(properties) {
                            return new BatchTranslateResponse(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateResponse message. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateResponse} message BatchTranslateResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.totalCharacters != null && Object.hasOwnProperty.call(message, "totalCharacters"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.totalCharacters);
                            if (message.translatedCharacters != null && Object.hasOwnProperty.call(message, "translatedCharacters"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.translatedCharacters);
                            if (message.failedCharacters != null && Object.hasOwnProperty.call(message, "failedCharacters"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.failedCharacters);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                $root.google.protobuf.Timestamp.encode(message.endTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateResponse} message BatchTranslateResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.BatchTranslateResponse} BatchTranslateResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.BatchTranslateResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.totalCharacters = reader.int64();
                                    break;
                                case 2:
                                    message.translatedCharacters = reader.int64();
                                    break;
                                case 3:
                                    message.failedCharacters = reader.int64();
                                    break;
                                case 4:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                case 5:
                                    message.endTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.BatchTranslateResponse} BatchTranslateResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (!$util.isInteger(message.totalCharacters) && !(message.totalCharacters && $util.isInteger(message.totalCharacters.low) && $util.isInteger(message.totalCharacters.high)))
                                    return "totalCharacters: integer|Long expected";
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (!$util.isInteger(message.translatedCharacters) && !(message.translatedCharacters && $util.isInteger(message.translatedCharacters.low) && $util.isInteger(message.translatedCharacters.high)))
                                    return "translatedCharacters: integer|Long expected";
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (!$util.isInteger(message.failedCharacters) && !(message.failedCharacters && $util.isInteger(message.failedCharacters.low) && $util.isInteger(message.failedCharacters.high)))
                                    return "failedCharacters: integer|Long expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            if (message.endTime != null && message.hasOwnProperty("endTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.endTime);
                                if (error)
                                    return "endTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.BatchTranslateResponse} BatchTranslateResponse
                         */
                        BatchTranslateResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.BatchTranslateResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3.BatchTranslateResponse();
                            if (object.totalCharacters != null)
                                if ($util.Long)
                                    (message.totalCharacters = $util.Long.fromValue(object.totalCharacters)).unsigned = false;
                                else if (typeof object.totalCharacters === "string")
                                    message.totalCharacters = parseInt(object.totalCharacters, 10);
                                else if (typeof object.totalCharacters === "number")
                                    message.totalCharacters = object.totalCharacters;
                                else if (typeof object.totalCharacters === "object")
                                    message.totalCharacters = new $util.LongBits(object.totalCharacters.low >>> 0, object.totalCharacters.high >>> 0).toNumber();
                            if (object.translatedCharacters != null)
                                if ($util.Long)
                                    (message.translatedCharacters = $util.Long.fromValue(object.translatedCharacters)).unsigned = false;
                                else if (typeof object.translatedCharacters === "string")
                                    message.translatedCharacters = parseInt(object.translatedCharacters, 10);
                                else if (typeof object.translatedCharacters === "number")
                                    message.translatedCharacters = object.translatedCharacters;
                                else if (typeof object.translatedCharacters === "object")
                                    message.translatedCharacters = new $util.LongBits(object.translatedCharacters.low >>> 0, object.translatedCharacters.high >>> 0).toNumber();
                            if (object.failedCharacters != null)
                                if ($util.Long)
                                    (message.failedCharacters = $util.Long.fromValue(object.failedCharacters)).unsigned = false;
                                else if (typeof object.failedCharacters === "string")
                                    message.failedCharacters = parseInt(object.failedCharacters, 10);
                                else if (typeof object.failedCharacters === "number")
                                    message.failedCharacters = object.failedCharacters;
                                else if (typeof object.failedCharacters === "object")
                                    message.failedCharacters = new $util.LongBits(object.failedCharacters.low >>> 0, object.failedCharacters.high >>> 0).toNumber();
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateResponse.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            if (object.endTime != null) {
                                if (typeof object.endTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateResponse.endTime: object expected");
                                message.endTime = $root.google.protobuf.Timestamp.fromObject(object.endTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @static
                         * @param {google.cloud.translation.v3.BatchTranslateResponse} message BatchTranslateResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedCharacters = options.longs === String ? "0" : 0;
                                object.submitTime = null;
                                object.endTime = null;
                            }
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (typeof message.totalCharacters === "number")
                                    object.totalCharacters = options.longs === String ? String(message.totalCharacters) : message.totalCharacters;
                                else
                                    object.totalCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalCharacters) : options.longs === Number ? new $util.LongBits(message.totalCharacters.low >>> 0, message.totalCharacters.high >>> 0).toNumber() : message.totalCharacters;
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (typeof message.translatedCharacters === "number")
                                    object.translatedCharacters = options.longs === String ? String(message.translatedCharacters) : message.translatedCharacters;
                                else
                                    object.translatedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.translatedCharacters) : options.longs === Number ? new $util.LongBits(message.translatedCharacters.low >>> 0, message.translatedCharacters.high >>> 0).toNumber() : message.translatedCharacters;
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (typeof message.failedCharacters === "number")
                                    object.failedCharacters = options.longs === String ? String(message.failedCharacters) : message.failedCharacters;
                                else
                                    object.failedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.failedCharacters) : options.longs === Number ? new $util.LongBits(message.failedCharacters.low >>> 0, message.failedCharacters.high >>> 0).toNumber() : message.failedCharacters;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                object.endTime = $root.google.protobuf.Timestamp.toObject(message.endTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.BatchTranslateResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchTranslateResponse;
                    })();
    
                    v3.GlossaryInputConfig = (function() {
    
                        /**
                         * Properties of a GlossaryInputConfig.
                         * @memberof google.cloud.translation.v3
                         * @interface IGlossaryInputConfig
                         * @property {google.cloud.translation.v3.IGcsSource|null} [gcsSource] GlossaryInputConfig gcsSource
                         */
    
                        /**
                         * Constructs a new GlossaryInputConfig.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a GlossaryInputConfig.
                         * @implements IGlossaryInputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3.IGlossaryInputConfig=} [properties] Properties to set
                         */
                        function GlossaryInputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GlossaryInputConfig gcsSource.
                         * @member {google.cloud.translation.v3.IGcsSource|null|undefined} gcsSource
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @instance
                         */
                        GlossaryInputConfig.prototype.gcsSource = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * GlossaryInputConfig source.
                         * @member {"gcsSource"|undefined} source
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @instance
                         */
                        Object.defineProperty(GlossaryInputConfig.prototype, "source", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsSource"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new GlossaryInputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IGlossaryInputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.GlossaryInputConfig} GlossaryInputConfig instance
                         */
                        GlossaryInputConfig.create = function create(properties) {
                            return new GlossaryInputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified GlossaryInputConfig message. Does not implicitly {@link google.cloud.translation.v3.GlossaryInputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IGlossaryInputConfig} message GlossaryInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GlossaryInputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.gcsSource != null && Object.hasOwnProperty.call(message, "gcsSource"))
                                $root.google.cloud.translation.v3.GcsSource.encode(message.gcsSource, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GlossaryInputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3.GlossaryInputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IGlossaryInputConfig} message GlossaryInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GlossaryInputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GlossaryInputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.GlossaryInputConfig} GlossaryInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GlossaryInputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.GlossaryInputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.gcsSource = $root.google.cloud.translation.v3.GcsSource.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GlossaryInputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.GlossaryInputConfig} GlossaryInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GlossaryInputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GlossaryInputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GlossaryInputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                properties.source = 1;
                                {
                                    var error = $root.google.cloud.translation.v3.GcsSource.verify(message.gcsSource);
                                    if (error)
                                        return "gcsSource." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a GlossaryInputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.GlossaryInputConfig} GlossaryInputConfig
                         */
                        GlossaryInputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.GlossaryInputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3.GlossaryInputConfig();
                            if (object.gcsSource != null) {
                                if (typeof object.gcsSource !== "object")
                                    throw TypeError(".google.cloud.translation.v3.GlossaryInputConfig.gcsSource: object expected");
                                message.gcsSource = $root.google.cloud.translation.v3.GcsSource.fromObject(object.gcsSource);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GlossaryInputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.GlossaryInputConfig} message GlossaryInputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GlossaryInputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                object.gcsSource = $root.google.cloud.translation.v3.GcsSource.toObject(message.gcsSource, options);
                                if (options.oneofs)
                                    object.source = "gcsSource";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this GlossaryInputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.GlossaryInputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GlossaryInputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GlossaryInputConfig;
                    })();
    
                    v3.Glossary = (function() {
    
                        /**
                         * Properties of a Glossary.
                         * @memberof google.cloud.translation.v3
                         * @interface IGlossary
                         * @property {string|null} [name] Glossary name
                         * @property {google.cloud.translation.v3.Glossary.ILanguageCodePair|null} [languagePair] Glossary languagePair
                         * @property {google.cloud.translation.v3.Glossary.ILanguageCodesSet|null} [languageCodesSet] Glossary languageCodesSet
                         * @property {google.cloud.translation.v3.IGlossaryInputConfig|null} [inputConfig] Glossary inputConfig
                         * @property {number|null} [entryCount] Glossary entryCount
                         * @property {google.protobuf.ITimestamp|null} [submitTime] Glossary submitTime
                         * @property {google.protobuf.ITimestamp|null} [endTime] Glossary endTime
                         */
    
                        /**
                         * Constructs a new Glossary.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a Glossary.
                         * @implements IGlossary
                         * @constructor
                         * @param {google.cloud.translation.v3.IGlossary=} [properties] Properties to set
                         */
                        function Glossary(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Glossary name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3.Glossary
                         * @instance
                         */
                        Glossary.prototype.name = "";
    
                        /**
                         * Glossary languagePair.
                         * @member {google.cloud.translation.v3.Glossary.ILanguageCodePair|null|undefined} languagePair
                         * @memberof google.cloud.translation.v3.Glossary
                         * @instance
                         */
                        Glossary.prototype.languagePair = null;
    
                        /**
                         * Glossary languageCodesSet.
                         * @member {google.cloud.translation.v3.Glossary.ILanguageCodesSet|null|undefined} languageCodesSet
                         * @memberof google.cloud.translation.v3.Glossary
                         * @instance
                         */
                        Glossary.prototype.languageCodesSet = null;
    
                        /**
                         * Glossary inputConfig.
                         * @member {google.cloud.translation.v3.IGlossaryInputConfig|null|undefined} inputConfig
                         * @memberof google.cloud.translation.v3.Glossary
                         * @instance
                         */
                        Glossary.prototype.inputConfig = null;
    
                        /**
                         * Glossary entryCount.
                         * @member {number} entryCount
                         * @memberof google.cloud.translation.v3.Glossary
                         * @instance
                         */
                        Glossary.prototype.entryCount = 0;
    
                        /**
                         * Glossary submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3.Glossary
                         * @instance
                         */
                        Glossary.prototype.submitTime = null;
    
                        /**
                         * Glossary endTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} endTime
                         * @memberof google.cloud.translation.v3.Glossary
                         * @instance
                         */
                        Glossary.prototype.endTime = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * Glossary languages.
                         * @member {"languagePair"|"languageCodesSet"|undefined} languages
                         * @memberof google.cloud.translation.v3.Glossary
                         * @instance
                         */
                        Object.defineProperty(Glossary.prototype, "languages", {
                            get: $util.oneOfGetter($oneOfFields = ["languagePair", "languageCodesSet"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new Glossary instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.Glossary
                         * @static
                         * @param {google.cloud.translation.v3.IGlossary=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.Glossary} Glossary instance
                         */
                        Glossary.create = function create(properties) {
                            return new Glossary(properties);
                        };
    
                        /**
                         * Encodes the specified Glossary message. Does not implicitly {@link google.cloud.translation.v3.Glossary.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.Glossary
                         * @static
                         * @param {google.cloud.translation.v3.IGlossary} message Glossary message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Glossary.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            if (message.languagePair != null && Object.hasOwnProperty.call(message, "languagePair"))
                                $root.google.cloud.translation.v3.Glossary.LanguageCodePair.encode(message.languagePair, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            if (message.languageCodesSet != null && Object.hasOwnProperty.call(message, "languageCodesSet"))
                                $root.google.cloud.translation.v3.Glossary.LanguageCodesSet.encode(message.languageCodesSet, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            if (message.inputConfig != null && Object.hasOwnProperty.call(message, "inputConfig"))
                                $root.google.cloud.translation.v3.GlossaryInputConfig.encode(message.inputConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            if (message.entryCount != null && Object.hasOwnProperty.call(message, "entryCount"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.entryCount);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                $root.google.protobuf.Timestamp.encode(message.endTime, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Glossary message, length delimited. Does not implicitly {@link google.cloud.translation.v3.Glossary.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.Glossary
                         * @static
                         * @param {google.cloud.translation.v3.IGlossary} message Glossary message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Glossary.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Glossary message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.Glossary
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.Glossary} Glossary
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Glossary.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.Glossary();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                case 3:
                                    message.languagePair = $root.google.cloud.translation.v3.Glossary.LanguageCodePair.decode(reader, reader.uint32());
                                    break;
                                case 4:
                                    message.languageCodesSet = $root.google.cloud.translation.v3.Glossary.LanguageCodesSet.decode(reader, reader.uint32());
                                    break;
                                case 5:
                                    message.inputConfig = $root.google.cloud.translation.v3.GlossaryInputConfig.decode(reader, reader.uint32());
                                    break;
                                case 6:
                                    message.entryCount = reader.int32();
                                    break;
                                case 7:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                case 8:
                                    message.endTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Glossary message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.Glossary
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.Glossary} Glossary
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Glossary.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Glossary message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.Glossary
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Glossary.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.languagePair != null && message.hasOwnProperty("languagePair")) {
                                properties.languages = 1;
                                {
                                    var error = $root.google.cloud.translation.v3.Glossary.LanguageCodePair.verify(message.languagePair);
                                    if (error)
                                        return "languagePair." + error;
                                }
                            }
                            if (message.languageCodesSet != null && message.hasOwnProperty("languageCodesSet")) {
                                if (properties.languages === 1)
                                    return "languages: multiple values";
                                properties.languages = 1;
                                {
                                    var error = $root.google.cloud.translation.v3.Glossary.LanguageCodesSet.verify(message.languageCodesSet);
                                    if (error)
                                        return "languageCodesSet." + error;
                                }
                            }
                            if (message.inputConfig != null && message.hasOwnProperty("inputConfig")) {
                                var error = $root.google.cloud.translation.v3.GlossaryInputConfig.verify(message.inputConfig);
                                if (error)
                                    return "inputConfig." + error;
                            }
                            if (message.entryCount != null && message.hasOwnProperty("entryCount"))
                                if (!$util.isInteger(message.entryCount))
                                    return "entryCount: integer expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            if (message.endTime != null && message.hasOwnProperty("endTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.endTime);
                                if (error)
                                    return "endTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Glossary message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.Glossary
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.Glossary} Glossary
                         */
                        Glossary.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.Glossary)
                                return object;
                            var message = new $root.google.cloud.translation.v3.Glossary();
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.languagePair != null) {
                                if (typeof object.languagePair !== "object")
                                    throw TypeError(".google.cloud.translation.v3.Glossary.languagePair: object expected");
                                message.languagePair = $root.google.cloud.translation.v3.Glossary.LanguageCodePair.fromObject(object.languagePair);
                            }
                            if (object.languageCodesSet != null) {
                                if (typeof object.languageCodesSet !== "object")
                                    throw TypeError(".google.cloud.translation.v3.Glossary.languageCodesSet: object expected");
                                message.languageCodesSet = $root.google.cloud.translation.v3.Glossary.LanguageCodesSet.fromObject(object.languageCodesSet);
                            }
                            if (object.inputConfig != null) {
                                if (typeof object.inputConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3.Glossary.inputConfig: object expected");
                                message.inputConfig = $root.google.cloud.translation.v3.GlossaryInputConfig.fromObject(object.inputConfig);
                            }
                            if (object.entryCount != null)
                                message.entryCount = object.entryCount | 0;
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.Glossary.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            if (object.endTime != null) {
                                if (typeof object.endTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.Glossary.endTime: object expected");
                                message.endTime = $root.google.protobuf.Timestamp.fromObject(object.endTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Glossary message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.Glossary
                         * @static
                         * @param {google.cloud.translation.v3.Glossary} message Glossary
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Glossary.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.name = "";
                                object.inputConfig = null;
                                object.entryCount = 0;
                                object.submitTime = null;
                                object.endTime = null;
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.languagePair != null && message.hasOwnProperty("languagePair")) {
                                object.languagePair = $root.google.cloud.translation.v3.Glossary.LanguageCodePair.toObject(message.languagePair, options);
                                if (options.oneofs)
                                    object.languages = "languagePair";
                            }
                            if (message.languageCodesSet != null && message.hasOwnProperty("languageCodesSet")) {
                                object.languageCodesSet = $root.google.cloud.translation.v3.Glossary.LanguageCodesSet.toObject(message.languageCodesSet, options);
                                if (options.oneofs)
                                    object.languages = "languageCodesSet";
                            }
                            if (message.inputConfig != null && message.hasOwnProperty("inputConfig"))
                                object.inputConfig = $root.google.cloud.translation.v3.GlossaryInputConfig.toObject(message.inputConfig, options);
                            if (message.entryCount != null && message.hasOwnProperty("entryCount"))
                                object.entryCount = message.entryCount;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                object.endTime = $root.google.protobuf.Timestamp.toObject(message.endTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this Glossary to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.Glossary
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Glossary.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        Glossary.LanguageCodePair = (function() {
    
                            /**
                             * Properties of a LanguageCodePair.
                             * @memberof google.cloud.translation.v3.Glossary
                             * @interface ILanguageCodePair
                             * @property {string|null} [sourceLanguageCode] LanguageCodePair sourceLanguageCode
                             * @property {string|null} [targetLanguageCode] LanguageCodePair targetLanguageCode
                             */
    
                            /**
                             * Constructs a new LanguageCodePair.
                             * @memberof google.cloud.translation.v3.Glossary
                             * @classdesc Represents a LanguageCodePair.
                             * @implements ILanguageCodePair
                             * @constructor
                             * @param {google.cloud.translation.v3.Glossary.ILanguageCodePair=} [properties] Properties to set
                             */
                            function LanguageCodePair(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * LanguageCodePair sourceLanguageCode.
                             * @member {string} sourceLanguageCode
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @instance
                             */
                            LanguageCodePair.prototype.sourceLanguageCode = "";
    
                            /**
                             * LanguageCodePair targetLanguageCode.
                             * @member {string} targetLanguageCode
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @instance
                             */
                            LanguageCodePair.prototype.targetLanguageCode = "";
    
                            /**
                             * Creates a new LanguageCodePair instance using the specified properties.
                             * @function create
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @static
                             * @param {google.cloud.translation.v3.Glossary.ILanguageCodePair=} [properties] Properties to set
                             * @returns {google.cloud.translation.v3.Glossary.LanguageCodePair} LanguageCodePair instance
                             */
                            LanguageCodePair.create = function create(properties) {
                                return new LanguageCodePair(properties);
                            };
    
                            /**
                             * Encodes the specified LanguageCodePair message. Does not implicitly {@link google.cloud.translation.v3.Glossary.LanguageCodePair.verify|verify} messages.
                             * @function encode
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @static
                             * @param {google.cloud.translation.v3.Glossary.ILanguageCodePair} message LanguageCodePair message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            LanguageCodePair.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.sourceLanguageCode != null && Object.hasOwnProperty.call(message, "sourceLanguageCode"))
                                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sourceLanguageCode);
                                if (message.targetLanguageCode != null && Object.hasOwnProperty.call(message, "targetLanguageCode"))
                                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.targetLanguageCode);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified LanguageCodePair message, length delimited. Does not implicitly {@link google.cloud.translation.v3.Glossary.LanguageCodePair.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @static
                             * @param {google.cloud.translation.v3.Glossary.ILanguageCodePair} message LanguageCodePair message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            LanguageCodePair.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a LanguageCodePair message from the specified reader or buffer.
                             * @function decode
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {google.cloud.translation.v3.Glossary.LanguageCodePair} LanguageCodePair
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            LanguageCodePair.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.Glossary.LanguageCodePair();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        message.sourceLanguageCode = reader.string();
                                        break;
                                    case 2:
                                        message.targetLanguageCode = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a LanguageCodePair message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {google.cloud.translation.v3.Glossary.LanguageCodePair} LanguageCodePair
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            LanguageCodePair.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a LanguageCodePair message.
                             * @function verify
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            LanguageCodePair.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                    if (!$util.isString(message.sourceLanguageCode))
                                        return "sourceLanguageCode: string expected";
                                if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                    if (!$util.isString(message.targetLanguageCode))
                                        return "targetLanguageCode: string expected";
                                return null;
                            };
    
                            /**
                             * Creates a LanguageCodePair message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {google.cloud.translation.v3.Glossary.LanguageCodePair} LanguageCodePair
                             */
                            LanguageCodePair.fromObject = function fromObject(object) {
                                if (object instanceof $root.google.cloud.translation.v3.Glossary.LanguageCodePair)
                                    return object;
                                var message = new $root.google.cloud.translation.v3.Glossary.LanguageCodePair();
                                if (object.sourceLanguageCode != null)
                                    message.sourceLanguageCode = String(object.sourceLanguageCode);
                                if (object.targetLanguageCode != null)
                                    message.targetLanguageCode = String(object.targetLanguageCode);
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a LanguageCodePair message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @static
                             * @param {google.cloud.translation.v3.Glossary.LanguageCodePair} message LanguageCodePair
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            LanguageCodePair.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.sourceLanguageCode = "";
                                    object.targetLanguageCode = "";
                                }
                                if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                    object.sourceLanguageCode = message.sourceLanguageCode;
                                if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                    object.targetLanguageCode = message.targetLanguageCode;
                                return object;
                            };
    
                            /**
                             * Converts this LanguageCodePair to JSON.
                             * @function toJSON
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodePair
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            LanguageCodePair.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return LanguageCodePair;
                        })();
    
                        Glossary.LanguageCodesSet = (function() {
    
                            /**
                             * Properties of a LanguageCodesSet.
                             * @memberof google.cloud.translation.v3.Glossary
                             * @interface ILanguageCodesSet
                             * @property {Array.<string>|null} [languageCodes] LanguageCodesSet languageCodes
                             */
    
                            /**
                             * Constructs a new LanguageCodesSet.
                             * @memberof google.cloud.translation.v3.Glossary
                             * @classdesc Represents a LanguageCodesSet.
                             * @implements ILanguageCodesSet
                             * @constructor
                             * @param {google.cloud.translation.v3.Glossary.ILanguageCodesSet=} [properties] Properties to set
                             */
                            function LanguageCodesSet(properties) {
                                this.languageCodes = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * LanguageCodesSet languageCodes.
                             * @member {Array.<string>} languageCodes
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodesSet
                             * @instance
                             */
                            LanguageCodesSet.prototype.languageCodes = $util.emptyArray;
    
                            /**
                             * Creates a new LanguageCodesSet instance using the specified properties.
                             * @function create
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodesSet
                             * @static
                             * @param {google.cloud.translation.v3.Glossary.ILanguageCodesSet=} [properties] Properties to set
                             * @returns {google.cloud.translation.v3.Glossary.LanguageCodesSet} LanguageCodesSet instance
                             */
                            LanguageCodesSet.create = function create(properties) {
                                return new LanguageCodesSet(properties);
                            };
    
                            /**
                             * Encodes the specified LanguageCodesSet message. Does not implicitly {@link google.cloud.translation.v3.Glossary.LanguageCodesSet.verify|verify} messages.
                             * @function encode
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodesSet
                             * @static
                             * @param {google.cloud.translation.v3.Glossary.ILanguageCodesSet} message LanguageCodesSet message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            LanguageCodesSet.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.languageCodes != null && message.languageCodes.length)
                                    for (var i = 0; i < message.languageCodes.length; ++i)
                                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.languageCodes[i]);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified LanguageCodesSet message, length delimited. Does not implicitly {@link google.cloud.translation.v3.Glossary.LanguageCodesSet.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodesSet
                             * @static
                             * @param {google.cloud.translation.v3.Glossary.ILanguageCodesSet} message LanguageCodesSet message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            LanguageCodesSet.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a LanguageCodesSet message from the specified reader or buffer.
                             * @function decode
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodesSet
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {google.cloud.translation.v3.Glossary.LanguageCodesSet} LanguageCodesSet
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            LanguageCodesSet.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.Glossary.LanguageCodesSet();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        if (!(message.languageCodes && message.languageCodes.length))
                                            message.languageCodes = [];
                                        message.languageCodes.push(reader.string());
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a LanguageCodesSet message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodesSet
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {google.cloud.translation.v3.Glossary.LanguageCodesSet} LanguageCodesSet
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            LanguageCodesSet.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a LanguageCodesSet message.
                             * @function verify
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodesSet
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            LanguageCodesSet.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.languageCodes != null && message.hasOwnProperty("languageCodes")) {
                                    if (!Array.isArray(message.languageCodes))
                                        return "languageCodes: array expected";
                                    for (var i = 0; i < message.languageCodes.length; ++i)
                                        if (!$util.isString(message.languageCodes[i]))
                                            return "languageCodes: string[] expected";
                                }
                                return null;
                            };
    
                            /**
                             * Creates a LanguageCodesSet message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodesSet
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {google.cloud.translation.v3.Glossary.LanguageCodesSet} LanguageCodesSet
                             */
                            LanguageCodesSet.fromObject = function fromObject(object) {
                                if (object instanceof $root.google.cloud.translation.v3.Glossary.LanguageCodesSet)
                                    return object;
                                var message = new $root.google.cloud.translation.v3.Glossary.LanguageCodesSet();
                                if (object.languageCodes) {
                                    if (!Array.isArray(object.languageCodes))
                                        throw TypeError(".google.cloud.translation.v3.Glossary.LanguageCodesSet.languageCodes: array expected");
                                    message.languageCodes = [];
                                    for (var i = 0; i < object.languageCodes.length; ++i)
                                        message.languageCodes[i] = String(object.languageCodes[i]);
                                }
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a LanguageCodesSet message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodesSet
                             * @static
                             * @param {google.cloud.translation.v3.Glossary.LanguageCodesSet} message LanguageCodesSet
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            LanguageCodesSet.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.arrays || options.defaults)
                                    object.languageCodes = [];
                                if (message.languageCodes && message.languageCodes.length) {
                                    object.languageCodes = [];
                                    for (var j = 0; j < message.languageCodes.length; ++j)
                                        object.languageCodes[j] = message.languageCodes[j];
                                }
                                return object;
                            };
    
                            /**
                             * Converts this LanguageCodesSet to JSON.
                             * @function toJSON
                             * @memberof google.cloud.translation.v3.Glossary.LanguageCodesSet
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            LanguageCodesSet.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return LanguageCodesSet;
                        })();
    
                        return Glossary;
                    })();
    
                    v3.CreateGlossaryRequest = (function() {
    
                        /**
                         * Properties of a CreateGlossaryRequest.
                         * @memberof google.cloud.translation.v3
                         * @interface ICreateGlossaryRequest
                         * @property {string|null} [parent] CreateGlossaryRequest parent
                         * @property {google.cloud.translation.v3.IGlossary|null} [glossary] CreateGlossaryRequest glossary
                         */
    
                        /**
                         * Constructs a new CreateGlossaryRequest.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a CreateGlossaryRequest.
                         * @implements ICreateGlossaryRequest
                         * @constructor
                         * @param {google.cloud.translation.v3.ICreateGlossaryRequest=} [properties] Properties to set
                         */
                        function CreateGlossaryRequest(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * CreateGlossaryRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @instance
                         */
                        CreateGlossaryRequest.prototype.parent = "";
    
                        /**
                         * CreateGlossaryRequest glossary.
                         * @member {google.cloud.translation.v3.IGlossary|null|undefined} glossary
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @instance
                         */
                        CreateGlossaryRequest.prototype.glossary = null;
    
                        /**
                         * Creates a new CreateGlossaryRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.ICreateGlossaryRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.CreateGlossaryRequest} CreateGlossaryRequest instance
                         */
                        CreateGlossaryRequest.create = function create(properties) {
                            return new CreateGlossaryRequest(properties);
                        };
    
                        /**
                         * Encodes the specified CreateGlossaryRequest message. Does not implicitly {@link google.cloud.translation.v3.CreateGlossaryRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.ICreateGlossaryRequest} message CreateGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CreateGlossaryRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                            if (message.glossary != null && Object.hasOwnProperty.call(message, "glossary"))
                                $root.google.cloud.translation.v3.Glossary.encode(message.glossary, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified CreateGlossaryRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3.CreateGlossaryRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.ICreateGlossaryRequest} message CreateGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CreateGlossaryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a CreateGlossaryRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.CreateGlossaryRequest} CreateGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CreateGlossaryRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.CreateGlossaryRequest();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.parent = reader.string();
                                    break;
                                case 2:
                                    message.glossary = $root.google.cloud.translation.v3.Glossary.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a CreateGlossaryRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.CreateGlossaryRequest} CreateGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CreateGlossaryRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a CreateGlossaryRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        CreateGlossaryRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.glossary != null && message.hasOwnProperty("glossary")) {
                                var error = $root.google.cloud.translation.v3.Glossary.verify(message.glossary);
                                if (error)
                                    return "glossary." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a CreateGlossaryRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.CreateGlossaryRequest} CreateGlossaryRequest
                         */
                        CreateGlossaryRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.CreateGlossaryRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3.CreateGlossaryRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.glossary != null) {
                                if (typeof object.glossary !== "object")
                                    throw TypeError(".google.cloud.translation.v3.CreateGlossaryRequest.glossary: object expected");
                                message.glossary = $root.google.cloud.translation.v3.Glossary.fromObject(object.glossary);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a CreateGlossaryRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.CreateGlossaryRequest} message CreateGlossaryRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        CreateGlossaryRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.parent = "";
                                object.glossary = null;
                            }
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            if (message.glossary != null && message.hasOwnProperty("glossary"))
                                object.glossary = $root.google.cloud.translation.v3.Glossary.toObject(message.glossary, options);
                            return object;
                        };
    
                        /**
                         * Converts this CreateGlossaryRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.CreateGlossaryRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        CreateGlossaryRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return CreateGlossaryRequest;
                    })();
    
                    v3.GetGlossaryRequest = (function() {
    
                        /**
                         * Properties of a GetGlossaryRequest.
                         * @memberof google.cloud.translation.v3
                         * @interface IGetGlossaryRequest
                         * @property {string|null} [name] GetGlossaryRequest name
                         */
    
                        /**
                         * Constructs a new GetGlossaryRequest.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a GetGlossaryRequest.
                         * @implements IGetGlossaryRequest
                         * @constructor
                         * @param {google.cloud.translation.v3.IGetGlossaryRequest=} [properties] Properties to set
                         */
                        function GetGlossaryRequest(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GetGlossaryRequest name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3.GetGlossaryRequest
                         * @instance
                         */
                        GetGlossaryRequest.prototype.name = "";
    
                        /**
                         * Creates a new GetGlossaryRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.GetGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.IGetGlossaryRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.GetGlossaryRequest} GetGlossaryRequest instance
                         */
                        GetGlossaryRequest.create = function create(properties) {
                            return new GetGlossaryRequest(properties);
                        };
    
                        /**
                         * Encodes the specified GetGlossaryRequest message. Does not implicitly {@link google.cloud.translation.v3.GetGlossaryRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.GetGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.IGetGlossaryRequest} message GetGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetGlossaryRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GetGlossaryRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3.GetGlossaryRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.GetGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.IGetGlossaryRequest} message GetGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetGlossaryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GetGlossaryRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.GetGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.GetGlossaryRequest} GetGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetGlossaryRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.GetGlossaryRequest();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GetGlossaryRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.GetGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.GetGlossaryRequest} GetGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetGlossaryRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GetGlossaryRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.GetGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetGlossaryRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GetGlossaryRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.GetGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.GetGlossaryRequest} GetGlossaryRequest
                         */
                        GetGlossaryRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.GetGlossaryRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3.GetGlossaryRequest();
                            if (object.name != null)
                                message.name = String(object.name);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GetGlossaryRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.GetGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.GetGlossaryRequest} message GetGlossaryRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetGlossaryRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.name = "";
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            return object;
                        };
    
                        /**
                         * Converts this GetGlossaryRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.GetGlossaryRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetGlossaryRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GetGlossaryRequest;
                    })();
    
                    v3.DeleteGlossaryRequest = (function() {
    
                        /**
                         * Properties of a DeleteGlossaryRequest.
                         * @memberof google.cloud.translation.v3
                         * @interface IDeleteGlossaryRequest
                         * @property {string|null} [name] DeleteGlossaryRequest name
                         */
    
                        /**
                         * Constructs a new DeleteGlossaryRequest.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a DeleteGlossaryRequest.
                         * @implements IDeleteGlossaryRequest
                         * @constructor
                         * @param {google.cloud.translation.v3.IDeleteGlossaryRequest=} [properties] Properties to set
                         */
                        function DeleteGlossaryRequest(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DeleteGlossaryRequest name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3.DeleteGlossaryRequest
                         * @instance
                         */
                        DeleteGlossaryRequest.prototype.name = "";
    
                        /**
                         * Creates a new DeleteGlossaryRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.DeleteGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.IDeleteGlossaryRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.DeleteGlossaryRequest} DeleteGlossaryRequest instance
                         */
                        DeleteGlossaryRequest.create = function create(properties) {
                            return new DeleteGlossaryRequest(properties);
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryRequest message. Does not implicitly {@link google.cloud.translation.v3.DeleteGlossaryRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.DeleteGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.IDeleteGlossaryRequest} message DeleteGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3.DeleteGlossaryRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.DeleteGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.IDeleteGlossaryRequest} message DeleteGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DeleteGlossaryRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.DeleteGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.DeleteGlossaryRequest} DeleteGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.DeleteGlossaryRequest();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DeleteGlossaryRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.DeleteGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.DeleteGlossaryRequest} DeleteGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DeleteGlossaryRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.DeleteGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DeleteGlossaryRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DeleteGlossaryRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.DeleteGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.DeleteGlossaryRequest} DeleteGlossaryRequest
                         */
                        DeleteGlossaryRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.DeleteGlossaryRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3.DeleteGlossaryRequest();
                            if (object.name != null)
                                message.name = String(object.name);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DeleteGlossaryRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.DeleteGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3.DeleteGlossaryRequest} message DeleteGlossaryRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DeleteGlossaryRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.name = "";
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            return object;
                        };
    
                        /**
                         * Converts this DeleteGlossaryRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.DeleteGlossaryRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DeleteGlossaryRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DeleteGlossaryRequest;
                    })();
    
                    v3.ListGlossariesRequest = (function() {
    
                        /**
                         * Properties of a ListGlossariesRequest.
                         * @memberof google.cloud.translation.v3
                         * @interface IListGlossariesRequest
                         * @property {string|null} [parent] ListGlossariesRequest parent
                         * @property {number|null} [pageSize] ListGlossariesRequest pageSize
                         * @property {string|null} [pageToken] ListGlossariesRequest pageToken
                         * @property {string|null} [filter] ListGlossariesRequest filter
                         */
    
                        /**
                         * Constructs a new ListGlossariesRequest.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a ListGlossariesRequest.
                         * @implements IListGlossariesRequest
                         * @constructor
                         * @param {google.cloud.translation.v3.IListGlossariesRequest=} [properties] Properties to set
                         */
                        function ListGlossariesRequest(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ListGlossariesRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @instance
                         */
                        ListGlossariesRequest.prototype.parent = "";
    
                        /**
                         * ListGlossariesRequest pageSize.
                         * @member {number} pageSize
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @instance
                         */
                        ListGlossariesRequest.prototype.pageSize = 0;
    
                        /**
                         * ListGlossariesRequest pageToken.
                         * @member {string} pageToken
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @instance
                         */
                        ListGlossariesRequest.prototype.pageToken = "";
    
                        /**
                         * ListGlossariesRequest filter.
                         * @member {string} filter
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @instance
                         */
                        ListGlossariesRequest.prototype.filter = "";
    
                        /**
                         * Creates a new ListGlossariesRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @static
                         * @param {google.cloud.translation.v3.IListGlossariesRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.ListGlossariesRequest} ListGlossariesRequest instance
                         */
                        ListGlossariesRequest.create = function create(properties) {
                            return new ListGlossariesRequest(properties);
                        };
    
                        /**
                         * Encodes the specified ListGlossariesRequest message. Does not implicitly {@link google.cloud.translation.v3.ListGlossariesRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @static
                         * @param {google.cloud.translation.v3.IListGlossariesRequest} message ListGlossariesRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ListGlossariesRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                            if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.filter);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ListGlossariesRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3.ListGlossariesRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @static
                         * @param {google.cloud.translation.v3.IListGlossariesRequest} message ListGlossariesRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ListGlossariesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ListGlossariesRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.ListGlossariesRequest} ListGlossariesRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ListGlossariesRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.ListGlossariesRequest();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.parent = reader.string();
                                    break;
                                case 2:
                                    message.pageSize = reader.int32();
                                    break;
                                case 3:
                                    message.pageToken = reader.string();
                                    break;
                                case 4:
                                    message.filter = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ListGlossariesRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.ListGlossariesRequest} ListGlossariesRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ListGlossariesRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ListGlossariesRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ListGlossariesRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                                if (!$util.isInteger(message.pageSize))
                                    return "pageSize: integer expected";
                            if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                                if (!$util.isString(message.pageToken))
                                    return "pageToken: string expected";
                            if (message.filter != null && message.hasOwnProperty("filter"))
                                if (!$util.isString(message.filter))
                                    return "filter: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a ListGlossariesRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.ListGlossariesRequest} ListGlossariesRequest
                         */
                        ListGlossariesRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.ListGlossariesRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3.ListGlossariesRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.pageSize != null)
                                message.pageSize = object.pageSize | 0;
                            if (object.pageToken != null)
                                message.pageToken = String(object.pageToken);
                            if (object.filter != null)
                                message.filter = String(object.filter);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ListGlossariesRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @static
                         * @param {google.cloud.translation.v3.ListGlossariesRequest} message ListGlossariesRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ListGlossariesRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.parent = "";
                                object.pageSize = 0;
                                object.pageToken = "";
                                object.filter = "";
                            }
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                                object.pageSize = message.pageSize;
                            if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                                object.pageToken = message.pageToken;
                            if (message.filter != null && message.hasOwnProperty("filter"))
                                object.filter = message.filter;
                            return object;
                        };
    
                        /**
                         * Converts this ListGlossariesRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.ListGlossariesRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ListGlossariesRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ListGlossariesRequest;
                    })();
    
                    v3.ListGlossariesResponse = (function() {
    
                        /**
                         * Properties of a ListGlossariesResponse.
                         * @memberof google.cloud.translation.v3
                         * @interface IListGlossariesResponse
                         * @property {Array.<google.cloud.translation.v3.IGlossary>|null} [glossaries] ListGlossariesResponse glossaries
                         * @property {string|null} [nextPageToken] ListGlossariesResponse nextPageToken
                         */
    
                        /**
                         * Constructs a new ListGlossariesResponse.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a ListGlossariesResponse.
                         * @implements IListGlossariesResponse
                         * @constructor
                         * @param {google.cloud.translation.v3.IListGlossariesResponse=} [properties] Properties to set
                         */
                        function ListGlossariesResponse(properties) {
                            this.glossaries = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ListGlossariesResponse glossaries.
                         * @member {Array.<google.cloud.translation.v3.IGlossary>} glossaries
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @instance
                         */
                        ListGlossariesResponse.prototype.glossaries = $util.emptyArray;
    
                        /**
                         * ListGlossariesResponse nextPageToken.
                         * @member {string} nextPageToken
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @instance
                         */
                        ListGlossariesResponse.prototype.nextPageToken = "";
    
                        /**
                         * Creates a new ListGlossariesResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @static
                         * @param {google.cloud.translation.v3.IListGlossariesResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.ListGlossariesResponse} ListGlossariesResponse instance
                         */
                        ListGlossariesResponse.create = function create(properties) {
                            return new ListGlossariesResponse(properties);
                        };
    
                        /**
                         * Encodes the specified ListGlossariesResponse message. Does not implicitly {@link google.cloud.translation.v3.ListGlossariesResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @static
                         * @param {google.cloud.translation.v3.IListGlossariesResponse} message ListGlossariesResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ListGlossariesResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.glossaries != null && message.glossaries.length)
                                for (var i = 0; i < message.glossaries.length; ++i)
                                    $root.google.cloud.translation.v3.Glossary.encode(message.glossaries[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ListGlossariesResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3.ListGlossariesResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @static
                         * @param {google.cloud.translation.v3.IListGlossariesResponse} message ListGlossariesResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ListGlossariesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ListGlossariesResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.ListGlossariesResponse} ListGlossariesResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ListGlossariesResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.ListGlossariesResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.glossaries && message.glossaries.length))
                                        message.glossaries = [];
                                    message.glossaries.push($root.google.cloud.translation.v3.Glossary.decode(reader, reader.uint32()));
                                    break;
                                case 2:
                                    message.nextPageToken = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ListGlossariesResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.ListGlossariesResponse} ListGlossariesResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ListGlossariesResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ListGlossariesResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ListGlossariesResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.glossaries != null && message.hasOwnProperty("glossaries")) {
                                if (!Array.isArray(message.glossaries))
                                    return "glossaries: array expected";
                                for (var i = 0; i < message.glossaries.length; ++i) {
                                    var error = $root.google.cloud.translation.v3.Glossary.verify(message.glossaries[i]);
                                    if (error)
                                        return "glossaries." + error;
                                }
                            }
                            if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                                if (!$util.isString(message.nextPageToken))
                                    return "nextPageToken: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a ListGlossariesResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.ListGlossariesResponse} ListGlossariesResponse
                         */
                        ListGlossariesResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.ListGlossariesResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3.ListGlossariesResponse();
                            if (object.glossaries) {
                                if (!Array.isArray(object.glossaries))
                                    throw TypeError(".google.cloud.translation.v3.ListGlossariesResponse.glossaries: array expected");
                                message.glossaries = [];
                                for (var i = 0; i < object.glossaries.length; ++i) {
                                    if (typeof object.glossaries[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3.ListGlossariesResponse.glossaries: object expected");
                                    message.glossaries[i] = $root.google.cloud.translation.v3.Glossary.fromObject(object.glossaries[i]);
                                }
                            }
                            if (object.nextPageToken != null)
                                message.nextPageToken = String(object.nextPageToken);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ListGlossariesResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @static
                         * @param {google.cloud.translation.v3.ListGlossariesResponse} message ListGlossariesResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ListGlossariesResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.glossaries = [];
                            if (options.defaults)
                                object.nextPageToken = "";
                            if (message.glossaries && message.glossaries.length) {
                                object.glossaries = [];
                                for (var j = 0; j < message.glossaries.length; ++j)
                                    object.glossaries[j] = $root.google.cloud.translation.v3.Glossary.toObject(message.glossaries[j], options);
                            }
                            if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                                object.nextPageToken = message.nextPageToken;
                            return object;
                        };
    
                        /**
                         * Converts this ListGlossariesResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.ListGlossariesResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ListGlossariesResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ListGlossariesResponse;
                    })();
    
                    v3.CreateGlossaryMetadata = (function() {
    
                        /**
                         * Properties of a CreateGlossaryMetadata.
                         * @memberof google.cloud.translation.v3
                         * @interface ICreateGlossaryMetadata
                         * @property {string|null} [name] CreateGlossaryMetadata name
                         * @property {google.cloud.translation.v3.CreateGlossaryMetadata.State|null} [state] CreateGlossaryMetadata state
                         * @property {google.protobuf.ITimestamp|null} [submitTime] CreateGlossaryMetadata submitTime
                         */
    
                        /**
                         * Constructs a new CreateGlossaryMetadata.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a CreateGlossaryMetadata.
                         * @implements ICreateGlossaryMetadata
                         * @constructor
                         * @param {google.cloud.translation.v3.ICreateGlossaryMetadata=} [properties] Properties to set
                         */
                        function CreateGlossaryMetadata(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * CreateGlossaryMetadata name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @instance
                         */
                        CreateGlossaryMetadata.prototype.name = "";
    
                        /**
                         * CreateGlossaryMetadata state.
                         * @member {google.cloud.translation.v3.CreateGlossaryMetadata.State} state
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @instance
                         */
                        CreateGlossaryMetadata.prototype.state = 0;
    
                        /**
                         * CreateGlossaryMetadata submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @instance
                         */
                        CreateGlossaryMetadata.prototype.submitTime = null;
    
                        /**
                         * Creates a new CreateGlossaryMetadata instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3.ICreateGlossaryMetadata=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.CreateGlossaryMetadata} CreateGlossaryMetadata instance
                         */
                        CreateGlossaryMetadata.create = function create(properties) {
                            return new CreateGlossaryMetadata(properties);
                        };
    
                        /**
                         * Encodes the specified CreateGlossaryMetadata message. Does not implicitly {@link google.cloud.translation.v3.CreateGlossaryMetadata.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3.ICreateGlossaryMetadata} message CreateGlossaryMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CreateGlossaryMetadata.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.state);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified CreateGlossaryMetadata message, length delimited. Does not implicitly {@link google.cloud.translation.v3.CreateGlossaryMetadata.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3.ICreateGlossaryMetadata} message CreateGlossaryMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CreateGlossaryMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a CreateGlossaryMetadata message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.CreateGlossaryMetadata} CreateGlossaryMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CreateGlossaryMetadata.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.CreateGlossaryMetadata();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                case 2:
                                    message.state = reader.int32();
                                    break;
                                case 3:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a CreateGlossaryMetadata message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.CreateGlossaryMetadata} CreateGlossaryMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CreateGlossaryMetadata.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a CreateGlossaryMetadata message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        CreateGlossaryMetadata.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.state != null && message.hasOwnProperty("state"))
                                switch (message.state) {
                                default:
                                    return "state: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a CreateGlossaryMetadata message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.CreateGlossaryMetadata} CreateGlossaryMetadata
                         */
                        CreateGlossaryMetadata.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.CreateGlossaryMetadata)
                                return object;
                            var message = new $root.google.cloud.translation.v3.CreateGlossaryMetadata();
                            if (object.name != null)
                                message.name = String(object.name);
                            switch (object.state) {
                            case "STATE_UNSPECIFIED":
                            case 0:
                                message.state = 0;
                                break;
                            case "RUNNING":
                            case 1:
                                message.state = 1;
                                break;
                            case "SUCCEEDED":
                            case 2:
                                message.state = 2;
                                break;
                            case "FAILED":
                            case 3:
                                message.state = 3;
                                break;
                            case "CANCELLING":
                            case 4:
                                message.state = 4;
                                break;
                            case "CANCELLED":
                            case 5:
                                message.state = 5;
                                break;
                            }
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.CreateGlossaryMetadata.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a CreateGlossaryMetadata message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3.CreateGlossaryMetadata} message CreateGlossaryMetadata
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        CreateGlossaryMetadata.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.name = "";
                                object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                                object.submitTime = null;
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.state != null && message.hasOwnProperty("state"))
                                object.state = options.enums === String ? $root.google.cloud.translation.v3.CreateGlossaryMetadata.State[message.state] : message.state;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this CreateGlossaryMetadata to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.CreateGlossaryMetadata
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        CreateGlossaryMetadata.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * State enum.
                         * @name google.cloud.translation.v3.CreateGlossaryMetadata.State
                         * @enum {number}
                         * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                         * @property {number} RUNNING=1 RUNNING value
                         * @property {number} SUCCEEDED=2 SUCCEEDED value
                         * @property {number} FAILED=3 FAILED value
                         * @property {number} CANCELLING=4 CANCELLING value
                         * @property {number} CANCELLED=5 CANCELLED value
                         */
                        CreateGlossaryMetadata.State = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "RUNNING"] = 1;
                            values[valuesById[2] = "SUCCEEDED"] = 2;
                            values[valuesById[3] = "FAILED"] = 3;
                            values[valuesById[4] = "CANCELLING"] = 4;
                            values[valuesById[5] = "CANCELLED"] = 5;
                            return values;
                        })();
    
                        return CreateGlossaryMetadata;
                    })();
    
                    v3.DeleteGlossaryMetadata = (function() {
    
                        /**
                         * Properties of a DeleteGlossaryMetadata.
                         * @memberof google.cloud.translation.v3
                         * @interface IDeleteGlossaryMetadata
                         * @property {string|null} [name] DeleteGlossaryMetadata name
                         * @property {google.cloud.translation.v3.DeleteGlossaryMetadata.State|null} [state] DeleteGlossaryMetadata state
                         * @property {google.protobuf.ITimestamp|null} [submitTime] DeleteGlossaryMetadata submitTime
                         */
    
                        /**
                         * Constructs a new DeleteGlossaryMetadata.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a DeleteGlossaryMetadata.
                         * @implements IDeleteGlossaryMetadata
                         * @constructor
                         * @param {google.cloud.translation.v3.IDeleteGlossaryMetadata=} [properties] Properties to set
                         */
                        function DeleteGlossaryMetadata(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DeleteGlossaryMetadata name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @instance
                         */
                        DeleteGlossaryMetadata.prototype.name = "";
    
                        /**
                         * DeleteGlossaryMetadata state.
                         * @member {google.cloud.translation.v3.DeleteGlossaryMetadata.State} state
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @instance
                         */
                        DeleteGlossaryMetadata.prototype.state = 0;
    
                        /**
                         * DeleteGlossaryMetadata submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @instance
                         */
                        DeleteGlossaryMetadata.prototype.submitTime = null;
    
                        /**
                         * Creates a new DeleteGlossaryMetadata instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3.IDeleteGlossaryMetadata=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.DeleteGlossaryMetadata} DeleteGlossaryMetadata instance
                         */
                        DeleteGlossaryMetadata.create = function create(properties) {
                            return new DeleteGlossaryMetadata(properties);
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryMetadata message. Does not implicitly {@link google.cloud.translation.v3.DeleteGlossaryMetadata.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3.IDeleteGlossaryMetadata} message DeleteGlossaryMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryMetadata.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.state);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryMetadata message, length delimited. Does not implicitly {@link google.cloud.translation.v3.DeleteGlossaryMetadata.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3.IDeleteGlossaryMetadata} message DeleteGlossaryMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DeleteGlossaryMetadata message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.DeleteGlossaryMetadata} DeleteGlossaryMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryMetadata.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.DeleteGlossaryMetadata();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                case 2:
                                    message.state = reader.int32();
                                    break;
                                case 3:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DeleteGlossaryMetadata message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.DeleteGlossaryMetadata} DeleteGlossaryMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryMetadata.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DeleteGlossaryMetadata message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DeleteGlossaryMetadata.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.state != null && message.hasOwnProperty("state"))
                                switch (message.state) {
                                default:
                                    return "state: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a DeleteGlossaryMetadata message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.DeleteGlossaryMetadata} DeleteGlossaryMetadata
                         */
                        DeleteGlossaryMetadata.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.DeleteGlossaryMetadata)
                                return object;
                            var message = new $root.google.cloud.translation.v3.DeleteGlossaryMetadata();
                            if (object.name != null)
                                message.name = String(object.name);
                            switch (object.state) {
                            case "STATE_UNSPECIFIED":
                            case 0:
                                message.state = 0;
                                break;
                            case "RUNNING":
                            case 1:
                                message.state = 1;
                                break;
                            case "SUCCEEDED":
                            case 2:
                                message.state = 2;
                                break;
                            case "FAILED":
                            case 3:
                                message.state = 3;
                                break;
                            case "CANCELLING":
                            case 4:
                                message.state = 4;
                                break;
                            case "CANCELLED":
                            case 5:
                                message.state = 5;
                                break;
                            }
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.DeleteGlossaryMetadata.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DeleteGlossaryMetadata message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3.DeleteGlossaryMetadata} message DeleteGlossaryMetadata
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DeleteGlossaryMetadata.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.name = "";
                                object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                                object.submitTime = null;
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.state != null && message.hasOwnProperty("state"))
                                object.state = options.enums === String ? $root.google.cloud.translation.v3.DeleteGlossaryMetadata.State[message.state] : message.state;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this DeleteGlossaryMetadata to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.DeleteGlossaryMetadata
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DeleteGlossaryMetadata.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * State enum.
                         * @name google.cloud.translation.v3.DeleteGlossaryMetadata.State
                         * @enum {number}
                         * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                         * @property {number} RUNNING=1 RUNNING value
                         * @property {number} SUCCEEDED=2 SUCCEEDED value
                         * @property {number} FAILED=3 FAILED value
                         * @property {number} CANCELLING=4 CANCELLING value
                         * @property {number} CANCELLED=5 CANCELLED value
                         */
                        DeleteGlossaryMetadata.State = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "RUNNING"] = 1;
                            values[valuesById[2] = "SUCCEEDED"] = 2;
                            values[valuesById[3] = "FAILED"] = 3;
                            values[valuesById[4] = "CANCELLING"] = 4;
                            values[valuesById[5] = "CANCELLED"] = 5;
                            return values;
                        })();
    
                        return DeleteGlossaryMetadata;
                    })();
    
                    v3.DeleteGlossaryResponse = (function() {
    
                        /**
                         * Properties of a DeleteGlossaryResponse.
                         * @memberof google.cloud.translation.v3
                         * @interface IDeleteGlossaryResponse
                         * @property {string|null} [name] DeleteGlossaryResponse name
                         * @property {google.protobuf.ITimestamp|null} [submitTime] DeleteGlossaryResponse submitTime
                         * @property {google.protobuf.ITimestamp|null} [endTime] DeleteGlossaryResponse endTime
                         */
    
                        /**
                         * Constructs a new DeleteGlossaryResponse.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a DeleteGlossaryResponse.
                         * @implements IDeleteGlossaryResponse
                         * @constructor
                         * @param {google.cloud.translation.v3.IDeleteGlossaryResponse=} [properties] Properties to set
                         */
                        function DeleteGlossaryResponse(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DeleteGlossaryResponse name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @instance
                         */
                        DeleteGlossaryResponse.prototype.name = "";
    
                        /**
                         * DeleteGlossaryResponse submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @instance
                         */
                        DeleteGlossaryResponse.prototype.submitTime = null;
    
                        /**
                         * DeleteGlossaryResponse endTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} endTime
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @instance
                         */
                        DeleteGlossaryResponse.prototype.endTime = null;
    
                        /**
                         * Creates a new DeleteGlossaryResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @static
                         * @param {google.cloud.translation.v3.IDeleteGlossaryResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.DeleteGlossaryResponse} DeleteGlossaryResponse instance
                         */
                        DeleteGlossaryResponse.create = function create(properties) {
                            return new DeleteGlossaryResponse(properties);
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryResponse message. Does not implicitly {@link google.cloud.translation.v3.DeleteGlossaryResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @static
                         * @param {google.cloud.translation.v3.IDeleteGlossaryResponse} message DeleteGlossaryResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                $root.google.protobuf.Timestamp.encode(message.endTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3.DeleteGlossaryResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @static
                         * @param {google.cloud.translation.v3.IDeleteGlossaryResponse} message DeleteGlossaryResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DeleteGlossaryResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.DeleteGlossaryResponse} DeleteGlossaryResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.DeleteGlossaryResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                case 2:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                case 3:
                                    message.endTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DeleteGlossaryResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.DeleteGlossaryResponse} DeleteGlossaryResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DeleteGlossaryResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DeleteGlossaryResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            if (message.endTime != null && message.hasOwnProperty("endTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.endTime);
                                if (error)
                                    return "endTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a DeleteGlossaryResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.DeleteGlossaryResponse} DeleteGlossaryResponse
                         */
                        DeleteGlossaryResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.DeleteGlossaryResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3.DeleteGlossaryResponse();
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.DeleteGlossaryResponse.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            if (object.endTime != null) {
                                if (typeof object.endTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.DeleteGlossaryResponse.endTime: object expected");
                                message.endTime = $root.google.protobuf.Timestamp.fromObject(object.endTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DeleteGlossaryResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @static
                         * @param {google.cloud.translation.v3.DeleteGlossaryResponse} message DeleteGlossaryResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DeleteGlossaryResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.name = "";
                                object.submitTime = null;
                                object.endTime = null;
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                object.endTime = $root.google.protobuf.Timestamp.toObject(message.endTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this DeleteGlossaryResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.DeleteGlossaryResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DeleteGlossaryResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DeleteGlossaryResponse;
                    })();
    
                    v3.BatchTranslateDocumentRequest = (function() {
    
                        /**
                         * Properties of a BatchTranslateDocumentRequest.
                         * @memberof google.cloud.translation.v3
                         * @interface IBatchTranslateDocumentRequest
                         * @property {string|null} [parent] BatchTranslateDocumentRequest parent
                         * @property {string|null} [sourceLanguageCode] BatchTranslateDocumentRequest sourceLanguageCode
                         * @property {Array.<string>|null} [targetLanguageCodes] BatchTranslateDocumentRequest targetLanguageCodes
                         * @property {Array.<google.cloud.translation.v3.IBatchDocumentInputConfig>|null} [inputConfigs] BatchTranslateDocumentRequest inputConfigs
                         * @property {google.cloud.translation.v3.IBatchDocumentOutputConfig|null} [outputConfig] BatchTranslateDocumentRequest outputConfig
                         * @property {Object.<string,string>|null} [models] BatchTranslateDocumentRequest models
                         * @property {Object.<string,google.cloud.translation.v3.ITranslateTextGlossaryConfig>|null} [glossaries] BatchTranslateDocumentRequest glossaries
                         * @property {Object.<string,string>|null} [formatConversions] BatchTranslateDocumentRequest formatConversions
                         */
    
                        /**
                         * Constructs a new BatchTranslateDocumentRequest.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a BatchTranslateDocumentRequest.
                         * @implements IBatchTranslateDocumentRequest
                         * @constructor
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentRequest=} [properties] Properties to set
                         */
                        function BatchTranslateDocumentRequest(properties) {
                            this.targetLanguageCodes = [];
                            this.inputConfigs = [];
                            this.models = {};
                            this.glossaries = {};
                            this.formatConversions = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateDocumentRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.parent = "";
    
                        /**
                         * BatchTranslateDocumentRequest sourceLanguageCode.
                         * @member {string} sourceLanguageCode
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.sourceLanguageCode = "";
    
                        /**
                         * BatchTranslateDocumentRequest targetLanguageCodes.
                         * @member {Array.<string>} targetLanguageCodes
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.targetLanguageCodes = $util.emptyArray;
    
                        /**
                         * BatchTranslateDocumentRequest inputConfigs.
                         * @member {Array.<google.cloud.translation.v3.IBatchDocumentInputConfig>} inputConfigs
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.inputConfigs = $util.emptyArray;
    
                        /**
                         * BatchTranslateDocumentRequest outputConfig.
                         * @member {google.cloud.translation.v3.IBatchDocumentOutputConfig|null|undefined} outputConfig
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.outputConfig = null;
    
                        /**
                         * BatchTranslateDocumentRequest models.
                         * @member {Object.<string,string>} models
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.models = $util.emptyObject;
    
                        /**
                         * BatchTranslateDocumentRequest glossaries.
                         * @member {Object.<string,google.cloud.translation.v3.ITranslateTextGlossaryConfig>} glossaries
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.glossaries = $util.emptyObject;
    
                        /**
                         * BatchTranslateDocumentRequest formatConversions.
                         * @member {Object.<string,string>} formatConversions
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.formatConversions = $util.emptyObject;
    
                        /**
                         * Creates a new BatchTranslateDocumentRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentRequest} BatchTranslateDocumentRequest instance
                         */
                        BatchTranslateDocumentRequest.create = function create(properties) {
                            return new BatchTranslateDocumentRequest(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentRequest message. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateDocumentRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentRequest} message BatchTranslateDocumentRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                            if (message.sourceLanguageCode != null && Object.hasOwnProperty.call(message, "sourceLanguageCode"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.sourceLanguageCode);
                            if (message.targetLanguageCodes != null && message.targetLanguageCodes.length)
                                for (var i = 0; i < message.targetLanguageCodes.length; ++i)
                                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.targetLanguageCodes[i]);
                            if (message.inputConfigs != null && message.inputConfigs.length)
                                for (var i = 0; i < message.inputConfigs.length; ++i)
                                    $root.google.cloud.translation.v3.BatchDocumentInputConfig.encode(message.inputConfigs[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            if (message.outputConfig != null && Object.hasOwnProperty.call(message, "outputConfig"))
                                $root.google.cloud.translation.v3.BatchDocumentOutputConfig.encode(message.outputConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            if (message.models != null && Object.hasOwnProperty.call(message, "models"))
                                for (var keys = Object.keys(message.models), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.models[keys[i]]).ldelim();
                            if (message.glossaries != null && Object.hasOwnProperty.call(message, "glossaries"))
                                for (var keys = Object.keys(message.glossaries), i = 0; i < keys.length; ++i) {
                                    writer.uint32(/* id 7, wireType 2 =*/58).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                                    $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.encode(message.glossaries[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                                }
                            if (message.formatConversions != null && Object.hasOwnProperty.call(message, "formatConversions"))
                                for (var keys = Object.keys(message.formatConversions), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 8, wireType 2 =*/66).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.formatConversions[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateDocumentRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentRequest} message BatchTranslateDocumentRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentRequest} BatchTranslateDocumentRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.BatchTranslateDocumentRequest(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.parent = reader.string();
                                    break;
                                case 2:
                                    message.sourceLanguageCode = reader.string();
                                    break;
                                case 3:
                                    if (!(message.targetLanguageCodes && message.targetLanguageCodes.length))
                                        message.targetLanguageCodes = [];
                                    message.targetLanguageCodes.push(reader.string());
                                    break;
                                case 4:
                                    if (!(message.inputConfigs && message.inputConfigs.length))
                                        message.inputConfigs = [];
                                    message.inputConfigs.push($root.google.cloud.translation.v3.BatchDocumentInputConfig.decode(reader, reader.uint32()));
                                    break;
                                case 5:
                                    message.outputConfig = $root.google.cloud.translation.v3.BatchDocumentOutputConfig.decode(reader, reader.uint32());
                                    break;
                                case 6:
                                    if (message.models === $util.emptyObject)
                                        message.models = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.models[key] = value;
                                    break;
                                case 7:
                                    if (message.glossaries === $util.emptyObject)
                                        message.glossaries = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = null;
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.glossaries[key] = value;
                                    break;
                                case 8:
                                    if (message.formatConversions === $util.emptyObject)
                                        message.formatConversions = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.formatConversions[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentRequest} BatchTranslateDocumentRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateDocumentRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateDocumentRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                if (!$util.isString(message.sourceLanguageCode))
                                    return "sourceLanguageCode: string expected";
                            if (message.targetLanguageCodes != null && message.hasOwnProperty("targetLanguageCodes")) {
                                if (!Array.isArray(message.targetLanguageCodes))
                                    return "targetLanguageCodes: array expected";
                                for (var i = 0; i < message.targetLanguageCodes.length; ++i)
                                    if (!$util.isString(message.targetLanguageCodes[i]))
                                        return "targetLanguageCodes: string[] expected";
                            }
                            if (message.inputConfigs != null && message.hasOwnProperty("inputConfigs")) {
                                if (!Array.isArray(message.inputConfigs))
                                    return "inputConfigs: array expected";
                                for (var i = 0; i < message.inputConfigs.length; ++i) {
                                    var error = $root.google.cloud.translation.v3.BatchDocumentInputConfig.verify(message.inputConfigs[i]);
                                    if (error)
                                        return "inputConfigs." + error;
                                }
                            }
                            if (message.outputConfig != null && message.hasOwnProperty("outputConfig")) {
                                var error = $root.google.cloud.translation.v3.BatchDocumentOutputConfig.verify(message.outputConfig);
                                if (error)
                                    return "outputConfig." + error;
                            }
                            if (message.models != null && message.hasOwnProperty("models")) {
                                if (!$util.isObject(message.models))
                                    return "models: object expected";
                                var key = Object.keys(message.models);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.models[key[i]]))
                                        return "models: string{k:string} expected";
                            }
                            if (message.glossaries != null && message.hasOwnProperty("glossaries")) {
                                if (!$util.isObject(message.glossaries))
                                    return "glossaries: object expected";
                                var key = Object.keys(message.glossaries);
                                for (var i = 0; i < key.length; ++i) {
                                    var error = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.verify(message.glossaries[key[i]]);
                                    if (error)
                                        return "glossaries." + error;
                                }
                            }
                            if (message.formatConversions != null && message.hasOwnProperty("formatConversions")) {
                                if (!$util.isObject(message.formatConversions))
                                    return "formatConversions: object expected";
                                var key = Object.keys(message.formatConversions);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.formatConversions[key[i]]))
                                        return "formatConversions: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateDocumentRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentRequest} BatchTranslateDocumentRequest
                         */
                        BatchTranslateDocumentRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.BatchTranslateDocumentRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3.BatchTranslateDocumentRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.sourceLanguageCode != null)
                                message.sourceLanguageCode = String(object.sourceLanguageCode);
                            if (object.targetLanguageCodes) {
                                if (!Array.isArray(object.targetLanguageCodes))
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentRequest.targetLanguageCodes: array expected");
                                message.targetLanguageCodes = [];
                                for (var i = 0; i < object.targetLanguageCodes.length; ++i)
                                    message.targetLanguageCodes[i] = String(object.targetLanguageCodes[i]);
                            }
                            if (object.inputConfigs) {
                                if (!Array.isArray(object.inputConfigs))
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentRequest.inputConfigs: array expected");
                                message.inputConfigs = [];
                                for (var i = 0; i < object.inputConfigs.length; ++i) {
                                    if (typeof object.inputConfigs[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentRequest.inputConfigs: object expected");
                                    message.inputConfigs[i] = $root.google.cloud.translation.v3.BatchDocumentInputConfig.fromObject(object.inputConfigs[i]);
                                }
                            }
                            if (object.outputConfig != null) {
                                if (typeof object.outputConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentRequest.outputConfig: object expected");
                                message.outputConfig = $root.google.cloud.translation.v3.BatchDocumentOutputConfig.fromObject(object.outputConfig);
                            }
                            if (object.models) {
                                if (typeof object.models !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentRequest.models: object expected");
                                message.models = {};
                                for (var keys = Object.keys(object.models), i = 0; i < keys.length; ++i)
                                    message.models[keys[i]] = String(object.models[keys[i]]);
                            }
                            if (object.glossaries) {
                                if (typeof object.glossaries !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentRequest.glossaries: object expected");
                                message.glossaries = {};
                                for (var keys = Object.keys(object.glossaries), i = 0; i < keys.length; ++i) {
                                    if (typeof object.glossaries[keys[i]] !== "object")
                                        throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentRequest.glossaries: object expected");
                                    message.glossaries[keys[i]] = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.fromObject(object.glossaries[keys[i]]);
                                }
                            }
                            if (object.formatConversions) {
                                if (typeof object.formatConversions !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentRequest.formatConversions: object expected");
                                message.formatConversions = {};
                                for (var keys = Object.keys(object.formatConversions), i = 0; i < keys.length; ++i)
                                    message.formatConversions[keys[i]] = String(object.formatConversions[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateDocumentRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3.BatchTranslateDocumentRequest} message BatchTranslateDocumentRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateDocumentRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.targetLanguageCodes = [];
                                object.inputConfigs = [];
                            }
                            if (options.objects || options.defaults) {
                                object.models = {};
                                object.glossaries = {};
                                object.formatConversions = {};
                            }
                            if (options.defaults) {
                                object.parent = "";
                                object.sourceLanguageCode = "";
                                object.outputConfig = null;
                            }
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                object.sourceLanguageCode = message.sourceLanguageCode;
                            if (message.targetLanguageCodes && message.targetLanguageCodes.length) {
                                object.targetLanguageCodes = [];
                                for (var j = 0; j < message.targetLanguageCodes.length; ++j)
                                    object.targetLanguageCodes[j] = message.targetLanguageCodes[j];
                            }
                            if (message.inputConfigs && message.inputConfigs.length) {
                                object.inputConfigs = [];
                                for (var j = 0; j < message.inputConfigs.length; ++j)
                                    object.inputConfigs[j] = $root.google.cloud.translation.v3.BatchDocumentInputConfig.toObject(message.inputConfigs[j], options);
                            }
                            if (message.outputConfig != null && message.hasOwnProperty("outputConfig"))
                                object.outputConfig = $root.google.cloud.translation.v3.BatchDocumentOutputConfig.toObject(message.outputConfig, options);
                            var keys2;
                            if (message.models && (keys2 = Object.keys(message.models)).length) {
                                object.models = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.models[keys2[j]] = message.models[keys2[j]];
                            }
                            if (message.glossaries && (keys2 = Object.keys(message.glossaries)).length) {
                                object.glossaries = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.glossaries[keys2[j]] = $root.google.cloud.translation.v3.TranslateTextGlossaryConfig.toObject(message.glossaries[keys2[j]], options);
                            }
                            if (message.formatConversions && (keys2 = Object.keys(message.formatConversions)).length) {
                                object.formatConversions = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.formatConversions[keys2[j]] = message.formatConversions[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateDocumentRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateDocumentRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchTranslateDocumentRequest;
                    })();
    
                    v3.BatchDocumentInputConfig = (function() {
    
                        /**
                         * Properties of a BatchDocumentInputConfig.
                         * @memberof google.cloud.translation.v3
                         * @interface IBatchDocumentInputConfig
                         * @property {google.cloud.translation.v3.IGcsSource|null} [gcsSource] BatchDocumentInputConfig gcsSource
                         */
    
                        /**
                         * Constructs a new BatchDocumentInputConfig.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a BatchDocumentInputConfig.
                         * @implements IBatchDocumentInputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3.IBatchDocumentInputConfig=} [properties] Properties to set
                         */
                        function BatchDocumentInputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchDocumentInputConfig gcsSource.
                         * @member {google.cloud.translation.v3.IGcsSource|null|undefined} gcsSource
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @instance
                         */
                        BatchDocumentInputConfig.prototype.gcsSource = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * BatchDocumentInputConfig source.
                         * @member {"gcsSource"|undefined} source
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @instance
                         */
                        Object.defineProperty(BatchDocumentInputConfig.prototype, "source", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsSource"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new BatchDocumentInputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IBatchDocumentInputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.BatchDocumentInputConfig} BatchDocumentInputConfig instance
                         */
                        BatchDocumentInputConfig.create = function create(properties) {
                            return new BatchDocumentInputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified BatchDocumentInputConfig message. Does not implicitly {@link google.cloud.translation.v3.BatchDocumentInputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IBatchDocumentInputConfig} message BatchDocumentInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchDocumentInputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.gcsSource != null && Object.hasOwnProperty.call(message, "gcsSource"))
                                $root.google.cloud.translation.v3.GcsSource.encode(message.gcsSource, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchDocumentInputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3.BatchDocumentInputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IBatchDocumentInputConfig} message BatchDocumentInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchDocumentInputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchDocumentInputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.BatchDocumentInputConfig} BatchDocumentInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchDocumentInputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.BatchDocumentInputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.gcsSource = $root.google.cloud.translation.v3.GcsSource.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchDocumentInputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.BatchDocumentInputConfig} BatchDocumentInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchDocumentInputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchDocumentInputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchDocumentInputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                properties.source = 1;
                                {
                                    var error = $root.google.cloud.translation.v3.GcsSource.verify(message.gcsSource);
                                    if (error)
                                        return "gcsSource." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchDocumentInputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.BatchDocumentInputConfig} BatchDocumentInputConfig
                         */
                        BatchDocumentInputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.BatchDocumentInputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3.BatchDocumentInputConfig();
                            if (object.gcsSource != null) {
                                if (typeof object.gcsSource !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchDocumentInputConfig.gcsSource: object expected");
                                message.gcsSource = $root.google.cloud.translation.v3.GcsSource.fromObject(object.gcsSource);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchDocumentInputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3.BatchDocumentInputConfig} message BatchDocumentInputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchDocumentInputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                object.gcsSource = $root.google.cloud.translation.v3.GcsSource.toObject(message.gcsSource, options);
                                if (options.oneofs)
                                    object.source = "gcsSource";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this BatchDocumentInputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.BatchDocumentInputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchDocumentInputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchDocumentInputConfig;
                    })();
    
                    v3.BatchDocumentOutputConfig = (function() {
    
                        /**
                         * Properties of a BatchDocumentOutputConfig.
                         * @memberof google.cloud.translation.v3
                         * @interface IBatchDocumentOutputConfig
                         * @property {google.cloud.translation.v3.IGcsDestination|null} [gcsDestination] BatchDocumentOutputConfig gcsDestination
                         */
    
                        /**
                         * Constructs a new BatchDocumentOutputConfig.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a BatchDocumentOutputConfig.
                         * @implements IBatchDocumentOutputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3.IBatchDocumentOutputConfig=} [properties] Properties to set
                         */
                        function BatchDocumentOutputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchDocumentOutputConfig gcsDestination.
                         * @member {google.cloud.translation.v3.IGcsDestination|null|undefined} gcsDestination
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @instance
                         */
                        BatchDocumentOutputConfig.prototype.gcsDestination = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * BatchDocumentOutputConfig destination.
                         * @member {"gcsDestination"|undefined} destination
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @instance
                         */
                        Object.defineProperty(BatchDocumentOutputConfig.prototype, "destination", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsDestination"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new BatchDocumentOutputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IBatchDocumentOutputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.BatchDocumentOutputConfig} BatchDocumentOutputConfig instance
                         */
                        BatchDocumentOutputConfig.create = function create(properties) {
                            return new BatchDocumentOutputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified BatchDocumentOutputConfig message. Does not implicitly {@link google.cloud.translation.v3.BatchDocumentOutputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IBatchDocumentOutputConfig} message BatchDocumentOutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchDocumentOutputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.gcsDestination != null && Object.hasOwnProperty.call(message, "gcsDestination"))
                                $root.google.cloud.translation.v3.GcsDestination.encode(message.gcsDestination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchDocumentOutputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3.BatchDocumentOutputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.IBatchDocumentOutputConfig} message BatchDocumentOutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchDocumentOutputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchDocumentOutputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.BatchDocumentOutputConfig} BatchDocumentOutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchDocumentOutputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.BatchDocumentOutputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.gcsDestination = $root.google.cloud.translation.v3.GcsDestination.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchDocumentOutputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.BatchDocumentOutputConfig} BatchDocumentOutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchDocumentOutputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchDocumentOutputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchDocumentOutputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                properties.destination = 1;
                                {
                                    var error = $root.google.cloud.translation.v3.GcsDestination.verify(message.gcsDestination);
                                    if (error)
                                        return "gcsDestination." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchDocumentOutputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.BatchDocumentOutputConfig} BatchDocumentOutputConfig
                         */
                        BatchDocumentOutputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.BatchDocumentOutputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3.BatchDocumentOutputConfig();
                            if (object.gcsDestination != null) {
                                if (typeof object.gcsDestination !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchDocumentOutputConfig.gcsDestination: object expected");
                                message.gcsDestination = $root.google.cloud.translation.v3.GcsDestination.fromObject(object.gcsDestination);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchDocumentOutputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3.BatchDocumentOutputConfig} message BatchDocumentOutputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchDocumentOutputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                object.gcsDestination = $root.google.cloud.translation.v3.GcsDestination.toObject(message.gcsDestination, options);
                                if (options.oneofs)
                                    object.destination = "gcsDestination";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this BatchDocumentOutputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.BatchDocumentOutputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchDocumentOutputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchDocumentOutputConfig;
                    })();
    
                    v3.BatchTranslateDocumentResponse = (function() {
    
                        /**
                         * Properties of a BatchTranslateDocumentResponse.
                         * @memberof google.cloud.translation.v3
                         * @interface IBatchTranslateDocumentResponse
                         * @property {number|Long|null} [totalPages] BatchTranslateDocumentResponse totalPages
                         * @property {number|Long|null} [translatedPages] BatchTranslateDocumentResponse translatedPages
                         * @property {number|Long|null} [failedPages] BatchTranslateDocumentResponse failedPages
                         * @property {number|Long|null} [totalBillablePages] BatchTranslateDocumentResponse totalBillablePages
                         * @property {number|Long|null} [totalCharacters] BatchTranslateDocumentResponse totalCharacters
                         * @property {number|Long|null} [translatedCharacters] BatchTranslateDocumentResponse translatedCharacters
                         * @property {number|Long|null} [failedCharacters] BatchTranslateDocumentResponse failedCharacters
                         * @property {number|Long|null} [totalBillableCharacters] BatchTranslateDocumentResponse totalBillableCharacters
                         * @property {google.protobuf.ITimestamp|null} [submitTime] BatchTranslateDocumentResponse submitTime
                         * @property {google.protobuf.ITimestamp|null} [endTime] BatchTranslateDocumentResponse endTime
                         */
    
                        /**
                         * Constructs a new BatchTranslateDocumentResponse.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a BatchTranslateDocumentResponse.
                         * @implements IBatchTranslateDocumentResponse
                         * @constructor
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentResponse=} [properties] Properties to set
                         */
                        function BatchTranslateDocumentResponse(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateDocumentResponse totalPages.
                         * @member {number|Long} totalPages
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.totalPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse translatedPages.
                         * @member {number|Long} translatedPages
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.translatedPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse failedPages.
                         * @member {number|Long} failedPages
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.failedPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse totalBillablePages.
                         * @member {number|Long} totalBillablePages
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.totalBillablePages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse totalCharacters.
                         * @member {number|Long} totalCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.totalCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse translatedCharacters.
                         * @member {number|Long} translatedCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.translatedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse failedCharacters.
                         * @member {number|Long} failedCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.failedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse totalBillableCharacters.
                         * @member {number|Long} totalBillableCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.totalBillableCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.submitTime = null;
    
                        /**
                         * BatchTranslateDocumentResponse endTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} endTime
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.endTime = null;
    
                        /**
                         * Creates a new BatchTranslateDocumentResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentResponse} BatchTranslateDocumentResponse instance
                         */
                        BatchTranslateDocumentResponse.create = function create(properties) {
                            return new BatchTranslateDocumentResponse(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentResponse message. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateDocumentResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentResponse} message BatchTranslateDocumentResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.totalPages != null && Object.hasOwnProperty.call(message, "totalPages"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.totalPages);
                            if (message.translatedPages != null && Object.hasOwnProperty.call(message, "translatedPages"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.translatedPages);
                            if (message.failedPages != null && Object.hasOwnProperty.call(message, "failedPages"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.failedPages);
                            if (message.totalBillablePages != null && Object.hasOwnProperty.call(message, "totalBillablePages"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.totalBillablePages);
                            if (message.totalCharacters != null && Object.hasOwnProperty.call(message, "totalCharacters"))
                                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.totalCharacters);
                            if (message.translatedCharacters != null && Object.hasOwnProperty.call(message, "translatedCharacters"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.translatedCharacters);
                            if (message.failedCharacters != null && Object.hasOwnProperty.call(message, "failedCharacters"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.failedCharacters);
                            if (message.totalBillableCharacters != null && Object.hasOwnProperty.call(message, "totalBillableCharacters"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.totalBillableCharacters);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                $root.google.protobuf.Timestamp.encode(message.endTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateDocumentResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentResponse} message BatchTranslateDocumentResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentResponse} BatchTranslateDocumentResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.BatchTranslateDocumentResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.totalPages = reader.int64();
                                    break;
                                case 2:
                                    message.translatedPages = reader.int64();
                                    break;
                                case 3:
                                    message.failedPages = reader.int64();
                                    break;
                                case 4:
                                    message.totalBillablePages = reader.int64();
                                    break;
                                case 5:
                                    message.totalCharacters = reader.int64();
                                    break;
                                case 6:
                                    message.translatedCharacters = reader.int64();
                                    break;
                                case 7:
                                    message.failedCharacters = reader.int64();
                                    break;
                                case 8:
                                    message.totalBillableCharacters = reader.int64();
                                    break;
                                case 9:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                case 10:
                                    message.endTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentResponse} BatchTranslateDocumentResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateDocumentResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateDocumentResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.totalPages != null && message.hasOwnProperty("totalPages"))
                                if (!$util.isInteger(message.totalPages) && !(message.totalPages && $util.isInteger(message.totalPages.low) && $util.isInteger(message.totalPages.high)))
                                    return "totalPages: integer|Long expected";
                            if (message.translatedPages != null && message.hasOwnProperty("translatedPages"))
                                if (!$util.isInteger(message.translatedPages) && !(message.translatedPages && $util.isInteger(message.translatedPages.low) && $util.isInteger(message.translatedPages.high)))
                                    return "translatedPages: integer|Long expected";
                            if (message.failedPages != null && message.hasOwnProperty("failedPages"))
                                if (!$util.isInteger(message.failedPages) && !(message.failedPages && $util.isInteger(message.failedPages.low) && $util.isInteger(message.failedPages.high)))
                                    return "failedPages: integer|Long expected";
                            if (message.totalBillablePages != null && message.hasOwnProperty("totalBillablePages"))
                                if (!$util.isInteger(message.totalBillablePages) && !(message.totalBillablePages && $util.isInteger(message.totalBillablePages.low) && $util.isInteger(message.totalBillablePages.high)))
                                    return "totalBillablePages: integer|Long expected";
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (!$util.isInteger(message.totalCharacters) && !(message.totalCharacters && $util.isInteger(message.totalCharacters.low) && $util.isInteger(message.totalCharacters.high)))
                                    return "totalCharacters: integer|Long expected";
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (!$util.isInteger(message.translatedCharacters) && !(message.translatedCharacters && $util.isInteger(message.translatedCharacters.low) && $util.isInteger(message.translatedCharacters.high)))
                                    return "translatedCharacters: integer|Long expected";
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (!$util.isInteger(message.failedCharacters) && !(message.failedCharacters && $util.isInteger(message.failedCharacters.low) && $util.isInteger(message.failedCharacters.high)))
                                    return "failedCharacters: integer|Long expected";
                            if (message.totalBillableCharacters != null && message.hasOwnProperty("totalBillableCharacters"))
                                if (!$util.isInteger(message.totalBillableCharacters) && !(message.totalBillableCharacters && $util.isInteger(message.totalBillableCharacters.low) && $util.isInteger(message.totalBillableCharacters.high)))
                                    return "totalBillableCharacters: integer|Long expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            if (message.endTime != null && message.hasOwnProperty("endTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.endTime);
                                if (error)
                                    return "endTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateDocumentResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentResponse} BatchTranslateDocumentResponse
                         */
                        BatchTranslateDocumentResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.BatchTranslateDocumentResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3.BatchTranslateDocumentResponse();
                            if (object.totalPages != null)
                                if ($util.Long)
                                    (message.totalPages = $util.Long.fromValue(object.totalPages)).unsigned = false;
                                else if (typeof object.totalPages === "string")
                                    message.totalPages = parseInt(object.totalPages, 10);
                                else if (typeof object.totalPages === "number")
                                    message.totalPages = object.totalPages;
                                else if (typeof object.totalPages === "object")
                                    message.totalPages = new $util.LongBits(object.totalPages.low >>> 0, object.totalPages.high >>> 0).toNumber();
                            if (object.translatedPages != null)
                                if ($util.Long)
                                    (message.translatedPages = $util.Long.fromValue(object.translatedPages)).unsigned = false;
                                else if (typeof object.translatedPages === "string")
                                    message.translatedPages = parseInt(object.translatedPages, 10);
                                else if (typeof object.translatedPages === "number")
                                    message.translatedPages = object.translatedPages;
                                else if (typeof object.translatedPages === "object")
                                    message.translatedPages = new $util.LongBits(object.translatedPages.low >>> 0, object.translatedPages.high >>> 0).toNumber();
                            if (object.failedPages != null)
                                if ($util.Long)
                                    (message.failedPages = $util.Long.fromValue(object.failedPages)).unsigned = false;
                                else if (typeof object.failedPages === "string")
                                    message.failedPages = parseInt(object.failedPages, 10);
                                else if (typeof object.failedPages === "number")
                                    message.failedPages = object.failedPages;
                                else if (typeof object.failedPages === "object")
                                    message.failedPages = new $util.LongBits(object.failedPages.low >>> 0, object.failedPages.high >>> 0).toNumber();
                            if (object.totalBillablePages != null)
                                if ($util.Long)
                                    (message.totalBillablePages = $util.Long.fromValue(object.totalBillablePages)).unsigned = false;
                                else if (typeof object.totalBillablePages === "string")
                                    message.totalBillablePages = parseInt(object.totalBillablePages, 10);
                                else if (typeof object.totalBillablePages === "number")
                                    message.totalBillablePages = object.totalBillablePages;
                                else if (typeof object.totalBillablePages === "object")
                                    message.totalBillablePages = new $util.LongBits(object.totalBillablePages.low >>> 0, object.totalBillablePages.high >>> 0).toNumber();
                            if (object.totalCharacters != null)
                                if ($util.Long)
                                    (message.totalCharacters = $util.Long.fromValue(object.totalCharacters)).unsigned = false;
                                else if (typeof object.totalCharacters === "string")
                                    message.totalCharacters = parseInt(object.totalCharacters, 10);
                                else if (typeof object.totalCharacters === "number")
                                    message.totalCharacters = object.totalCharacters;
                                else if (typeof object.totalCharacters === "object")
                                    message.totalCharacters = new $util.LongBits(object.totalCharacters.low >>> 0, object.totalCharacters.high >>> 0).toNumber();
                            if (object.translatedCharacters != null)
                                if ($util.Long)
                                    (message.translatedCharacters = $util.Long.fromValue(object.translatedCharacters)).unsigned = false;
                                else if (typeof object.translatedCharacters === "string")
                                    message.translatedCharacters = parseInt(object.translatedCharacters, 10);
                                else if (typeof object.translatedCharacters === "number")
                                    message.translatedCharacters = object.translatedCharacters;
                                else if (typeof object.translatedCharacters === "object")
                                    message.translatedCharacters = new $util.LongBits(object.translatedCharacters.low >>> 0, object.translatedCharacters.high >>> 0).toNumber();
                            if (object.failedCharacters != null)
                                if ($util.Long)
                                    (message.failedCharacters = $util.Long.fromValue(object.failedCharacters)).unsigned = false;
                                else if (typeof object.failedCharacters === "string")
                                    message.failedCharacters = parseInt(object.failedCharacters, 10);
                                else if (typeof object.failedCharacters === "number")
                                    message.failedCharacters = object.failedCharacters;
                                else if (typeof object.failedCharacters === "object")
                                    message.failedCharacters = new $util.LongBits(object.failedCharacters.low >>> 0, object.failedCharacters.high >>> 0).toNumber();
                            if (object.totalBillableCharacters != null)
                                if ($util.Long)
                                    (message.totalBillableCharacters = $util.Long.fromValue(object.totalBillableCharacters)).unsigned = false;
                                else if (typeof object.totalBillableCharacters === "string")
                                    message.totalBillableCharacters = parseInt(object.totalBillableCharacters, 10);
                                else if (typeof object.totalBillableCharacters === "number")
                                    message.totalBillableCharacters = object.totalBillableCharacters;
                                else if (typeof object.totalBillableCharacters === "object")
                                    message.totalBillableCharacters = new $util.LongBits(object.totalBillableCharacters.low >>> 0, object.totalBillableCharacters.high >>> 0).toNumber();
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentResponse.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            if (object.endTime != null) {
                                if (typeof object.endTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentResponse.endTime: object expected");
                                message.endTime = $root.google.protobuf.Timestamp.fromObject(object.endTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateDocumentResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3.BatchTranslateDocumentResponse} message BatchTranslateDocumentResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateDocumentResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalBillablePages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalBillablePages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalBillableCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalBillableCharacters = options.longs === String ? "0" : 0;
                                object.submitTime = null;
                                object.endTime = null;
                            }
                            if (message.totalPages != null && message.hasOwnProperty("totalPages"))
                                if (typeof message.totalPages === "number")
                                    object.totalPages = options.longs === String ? String(message.totalPages) : message.totalPages;
                                else
                                    object.totalPages = options.longs === String ? $util.Long.prototype.toString.call(message.totalPages) : options.longs === Number ? new $util.LongBits(message.totalPages.low >>> 0, message.totalPages.high >>> 0).toNumber() : message.totalPages;
                            if (message.translatedPages != null && message.hasOwnProperty("translatedPages"))
                                if (typeof message.translatedPages === "number")
                                    object.translatedPages = options.longs === String ? String(message.translatedPages) : message.translatedPages;
                                else
                                    object.translatedPages = options.longs === String ? $util.Long.prototype.toString.call(message.translatedPages) : options.longs === Number ? new $util.LongBits(message.translatedPages.low >>> 0, message.translatedPages.high >>> 0).toNumber() : message.translatedPages;
                            if (message.failedPages != null && message.hasOwnProperty("failedPages"))
                                if (typeof message.failedPages === "number")
                                    object.failedPages = options.longs === String ? String(message.failedPages) : message.failedPages;
                                else
                                    object.failedPages = options.longs === String ? $util.Long.prototype.toString.call(message.failedPages) : options.longs === Number ? new $util.LongBits(message.failedPages.low >>> 0, message.failedPages.high >>> 0).toNumber() : message.failedPages;
                            if (message.totalBillablePages != null && message.hasOwnProperty("totalBillablePages"))
                                if (typeof message.totalBillablePages === "number")
                                    object.totalBillablePages = options.longs === String ? String(message.totalBillablePages) : message.totalBillablePages;
                                else
                                    object.totalBillablePages = options.longs === String ? $util.Long.prototype.toString.call(message.totalBillablePages) : options.longs === Number ? new $util.LongBits(message.totalBillablePages.low >>> 0, message.totalBillablePages.high >>> 0).toNumber() : message.totalBillablePages;
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (typeof message.totalCharacters === "number")
                                    object.totalCharacters = options.longs === String ? String(message.totalCharacters) : message.totalCharacters;
                                else
                                    object.totalCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalCharacters) : options.longs === Number ? new $util.LongBits(message.totalCharacters.low >>> 0, message.totalCharacters.high >>> 0).toNumber() : message.totalCharacters;
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (typeof message.translatedCharacters === "number")
                                    object.translatedCharacters = options.longs === String ? String(message.translatedCharacters) : message.translatedCharacters;
                                else
                                    object.translatedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.translatedCharacters) : options.longs === Number ? new $util.LongBits(message.translatedCharacters.low >>> 0, message.translatedCharacters.high >>> 0).toNumber() : message.translatedCharacters;
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (typeof message.failedCharacters === "number")
                                    object.failedCharacters = options.longs === String ? String(message.failedCharacters) : message.failedCharacters;
                                else
                                    object.failedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.failedCharacters) : options.longs === Number ? new $util.LongBits(message.failedCharacters.low >>> 0, message.failedCharacters.high >>> 0).toNumber() : message.failedCharacters;
                            if (message.totalBillableCharacters != null && message.hasOwnProperty("totalBillableCharacters"))
                                if (typeof message.totalBillableCharacters === "number")
                                    object.totalBillableCharacters = options.longs === String ? String(message.totalBillableCharacters) : message.totalBillableCharacters;
                                else
                                    object.totalBillableCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalBillableCharacters) : options.longs === Number ? new $util.LongBits(message.totalBillableCharacters.low >>> 0, message.totalBillableCharacters.high >>> 0).toNumber() : message.totalBillableCharacters;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                object.endTime = $root.google.protobuf.Timestamp.toObject(message.endTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateDocumentResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateDocumentResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchTranslateDocumentResponse;
                    })();
    
                    v3.BatchTranslateDocumentMetadata = (function() {
    
                        /**
                         * Properties of a BatchTranslateDocumentMetadata.
                         * @memberof google.cloud.translation.v3
                         * @interface IBatchTranslateDocumentMetadata
                         * @property {google.cloud.translation.v3.BatchTranslateDocumentMetadata.State|null} [state] BatchTranslateDocumentMetadata state
                         * @property {number|Long|null} [totalPages] BatchTranslateDocumentMetadata totalPages
                         * @property {number|Long|null} [translatedPages] BatchTranslateDocumentMetadata translatedPages
                         * @property {number|Long|null} [failedPages] BatchTranslateDocumentMetadata failedPages
                         * @property {number|Long|null} [totalBillablePages] BatchTranslateDocumentMetadata totalBillablePages
                         * @property {number|Long|null} [totalCharacters] BatchTranslateDocumentMetadata totalCharacters
                         * @property {number|Long|null} [translatedCharacters] BatchTranslateDocumentMetadata translatedCharacters
                         * @property {number|Long|null} [failedCharacters] BatchTranslateDocumentMetadata failedCharacters
                         * @property {number|Long|null} [totalBillableCharacters] BatchTranslateDocumentMetadata totalBillableCharacters
                         * @property {google.protobuf.ITimestamp|null} [submitTime] BatchTranslateDocumentMetadata submitTime
                         */
    
                        /**
                         * Constructs a new BatchTranslateDocumentMetadata.
                         * @memberof google.cloud.translation.v3
                         * @classdesc Represents a BatchTranslateDocumentMetadata.
                         * @implements IBatchTranslateDocumentMetadata
                         * @constructor
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentMetadata=} [properties] Properties to set
                         */
                        function BatchTranslateDocumentMetadata(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateDocumentMetadata state.
                         * @member {google.cloud.translation.v3.BatchTranslateDocumentMetadata.State} state
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.state = 0;
    
                        /**
                         * BatchTranslateDocumentMetadata totalPages.
                         * @member {number|Long} totalPages
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.totalPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata translatedPages.
                         * @member {number|Long} translatedPages
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.translatedPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata failedPages.
                         * @member {number|Long} failedPages
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.failedPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata totalBillablePages.
                         * @member {number|Long} totalBillablePages
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.totalBillablePages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata totalCharacters.
                         * @member {number|Long} totalCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.totalCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata translatedCharacters.
                         * @member {number|Long} translatedCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.translatedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata failedCharacters.
                         * @member {number|Long} failedCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.failedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata totalBillableCharacters.
                         * @member {number|Long} totalBillableCharacters
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.totalBillableCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.submitTime = null;
    
                        /**
                         * Creates a new BatchTranslateDocumentMetadata instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentMetadata=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentMetadata} BatchTranslateDocumentMetadata instance
                         */
                        BatchTranslateDocumentMetadata.create = function create(properties) {
                            return new BatchTranslateDocumentMetadata(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentMetadata message. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateDocumentMetadata.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentMetadata} message BatchTranslateDocumentMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentMetadata.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                            if (message.totalPages != null && Object.hasOwnProperty.call(message, "totalPages"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalPages);
                            if (message.translatedPages != null && Object.hasOwnProperty.call(message, "translatedPages"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.translatedPages);
                            if (message.failedPages != null && Object.hasOwnProperty.call(message, "failedPages"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.failedPages);
                            if (message.totalBillablePages != null && Object.hasOwnProperty.call(message, "totalBillablePages"))
                                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.totalBillablePages);
                            if (message.totalCharacters != null && Object.hasOwnProperty.call(message, "totalCharacters"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.totalCharacters);
                            if (message.translatedCharacters != null && Object.hasOwnProperty.call(message, "translatedCharacters"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.translatedCharacters);
                            if (message.failedCharacters != null && Object.hasOwnProperty.call(message, "failedCharacters"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.failedCharacters);
                            if (message.totalBillableCharacters != null && Object.hasOwnProperty.call(message, "totalBillableCharacters"))
                                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.totalBillableCharacters);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentMetadata message, length delimited. Does not implicitly {@link google.cloud.translation.v3.BatchTranslateDocumentMetadata.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @static
                         * @param {google.cloud.translation.v3.IBatchTranslateDocumentMetadata} message BatchTranslateDocumentMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentMetadata message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentMetadata} BatchTranslateDocumentMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentMetadata.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3.BatchTranslateDocumentMetadata();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.state = reader.int32();
                                    break;
                                case 2:
                                    message.totalPages = reader.int64();
                                    break;
                                case 3:
                                    message.translatedPages = reader.int64();
                                    break;
                                case 4:
                                    message.failedPages = reader.int64();
                                    break;
                                case 5:
                                    message.totalBillablePages = reader.int64();
                                    break;
                                case 6:
                                    message.totalCharacters = reader.int64();
                                    break;
                                case 7:
                                    message.translatedCharacters = reader.int64();
                                    break;
                                case 8:
                                    message.failedCharacters = reader.int64();
                                    break;
                                case 9:
                                    message.totalBillableCharacters = reader.int64();
                                    break;
                                case 10:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentMetadata message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentMetadata} BatchTranslateDocumentMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentMetadata.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateDocumentMetadata message.
                         * @function verify
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateDocumentMetadata.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.state != null && message.hasOwnProperty("state"))
                                switch (message.state) {
                                default:
                                    return "state: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                            if (message.totalPages != null && message.hasOwnProperty("totalPages"))
                                if (!$util.isInteger(message.totalPages) && !(message.totalPages && $util.isInteger(message.totalPages.low) && $util.isInteger(message.totalPages.high)))
                                    return "totalPages: integer|Long expected";
                            if (message.translatedPages != null && message.hasOwnProperty("translatedPages"))
                                if (!$util.isInteger(message.translatedPages) && !(message.translatedPages && $util.isInteger(message.translatedPages.low) && $util.isInteger(message.translatedPages.high)))
                                    return "translatedPages: integer|Long expected";
                            if (message.failedPages != null && message.hasOwnProperty("failedPages"))
                                if (!$util.isInteger(message.failedPages) && !(message.failedPages && $util.isInteger(message.failedPages.low) && $util.isInteger(message.failedPages.high)))
                                    return "failedPages: integer|Long expected";
                            if (message.totalBillablePages != null && message.hasOwnProperty("totalBillablePages"))
                                if (!$util.isInteger(message.totalBillablePages) && !(message.totalBillablePages && $util.isInteger(message.totalBillablePages.low) && $util.isInteger(message.totalBillablePages.high)))
                                    return "totalBillablePages: integer|Long expected";
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (!$util.isInteger(message.totalCharacters) && !(message.totalCharacters && $util.isInteger(message.totalCharacters.low) && $util.isInteger(message.totalCharacters.high)))
                                    return "totalCharacters: integer|Long expected";
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (!$util.isInteger(message.translatedCharacters) && !(message.translatedCharacters && $util.isInteger(message.translatedCharacters.low) && $util.isInteger(message.translatedCharacters.high)))
                                    return "translatedCharacters: integer|Long expected";
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (!$util.isInteger(message.failedCharacters) && !(message.failedCharacters && $util.isInteger(message.failedCharacters.low) && $util.isInteger(message.failedCharacters.high)))
                                    return "failedCharacters: integer|Long expected";
                            if (message.totalBillableCharacters != null && message.hasOwnProperty("totalBillableCharacters"))
                                if (!$util.isInteger(message.totalBillableCharacters) && !(message.totalBillableCharacters && $util.isInteger(message.totalBillableCharacters.low) && $util.isInteger(message.totalBillableCharacters.high)))
                                    return "totalBillableCharacters: integer|Long expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateDocumentMetadata message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3.BatchTranslateDocumentMetadata} BatchTranslateDocumentMetadata
                         */
                        BatchTranslateDocumentMetadata.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3.BatchTranslateDocumentMetadata)
                                return object;
                            var message = new $root.google.cloud.translation.v3.BatchTranslateDocumentMetadata();
                            switch (object.state) {
                            case "STATE_UNSPECIFIED":
                            case 0:
                                message.state = 0;
                                break;
                            case "RUNNING":
                            case 1:
                                message.state = 1;
                                break;
                            case "SUCCEEDED":
                            case 2:
                                message.state = 2;
                                break;
                            case "FAILED":
                            case 3:
                                message.state = 3;
                                break;
                            case "CANCELLING":
                            case 4:
                                message.state = 4;
                                break;
                            case "CANCELLED":
                            case 5:
                                message.state = 5;
                                break;
                            }
                            if (object.totalPages != null)
                                if ($util.Long)
                                    (message.totalPages = $util.Long.fromValue(object.totalPages)).unsigned = false;
                                else if (typeof object.totalPages === "string")
                                    message.totalPages = parseInt(object.totalPages, 10);
                                else if (typeof object.totalPages === "number")
                                    message.totalPages = object.totalPages;
                                else if (typeof object.totalPages === "object")
                                    message.totalPages = new $util.LongBits(object.totalPages.low >>> 0, object.totalPages.high >>> 0).toNumber();
                            if (object.translatedPages != null)
                                if ($util.Long)
                                    (message.translatedPages = $util.Long.fromValue(object.translatedPages)).unsigned = false;
                                else if (typeof object.translatedPages === "string")
                                    message.translatedPages = parseInt(object.translatedPages, 10);
                                else if (typeof object.translatedPages === "number")
                                    message.translatedPages = object.translatedPages;
                                else if (typeof object.translatedPages === "object")
                                    message.translatedPages = new $util.LongBits(object.translatedPages.low >>> 0, object.translatedPages.high >>> 0).toNumber();
                            if (object.failedPages != null)
                                if ($util.Long)
                                    (message.failedPages = $util.Long.fromValue(object.failedPages)).unsigned = false;
                                else if (typeof object.failedPages === "string")
                                    message.failedPages = parseInt(object.failedPages, 10);
                                else if (typeof object.failedPages === "number")
                                    message.failedPages = object.failedPages;
                                else if (typeof object.failedPages === "object")
                                    message.failedPages = new $util.LongBits(object.failedPages.low >>> 0, object.failedPages.high >>> 0).toNumber();
                            if (object.totalBillablePages != null)
                                if ($util.Long)
                                    (message.totalBillablePages = $util.Long.fromValue(object.totalBillablePages)).unsigned = false;
                                else if (typeof object.totalBillablePages === "string")
                                    message.totalBillablePages = parseInt(object.totalBillablePages, 10);
                                else if (typeof object.totalBillablePages === "number")
                                    message.totalBillablePages = object.totalBillablePages;
                                else if (typeof object.totalBillablePages === "object")
                                    message.totalBillablePages = new $util.LongBits(object.totalBillablePages.low >>> 0, object.totalBillablePages.high >>> 0).toNumber();
                            if (object.totalCharacters != null)
                                if ($util.Long)
                                    (message.totalCharacters = $util.Long.fromValue(object.totalCharacters)).unsigned = false;
                                else if (typeof object.totalCharacters === "string")
                                    message.totalCharacters = parseInt(object.totalCharacters, 10);
                                else if (typeof object.totalCharacters === "number")
                                    message.totalCharacters = object.totalCharacters;
                                else if (typeof object.totalCharacters === "object")
                                    message.totalCharacters = new $util.LongBits(object.totalCharacters.low >>> 0, object.totalCharacters.high >>> 0).toNumber();
                            if (object.translatedCharacters != null)
                                if ($util.Long)
                                    (message.translatedCharacters = $util.Long.fromValue(object.translatedCharacters)).unsigned = false;
                                else if (typeof object.translatedCharacters === "string")
                                    message.translatedCharacters = parseInt(object.translatedCharacters, 10);
                                else if (typeof object.translatedCharacters === "number")
                                    message.translatedCharacters = object.translatedCharacters;
                                else if (typeof object.translatedCharacters === "object")
                                    message.translatedCharacters = new $util.LongBits(object.translatedCharacters.low >>> 0, object.translatedCharacters.high >>> 0).toNumber();
                            if (object.failedCharacters != null)
                                if ($util.Long)
                                    (message.failedCharacters = $util.Long.fromValue(object.failedCharacters)).unsigned = false;
                                else if (typeof object.failedCharacters === "string")
                                    message.failedCharacters = parseInt(object.failedCharacters, 10);
                                else if (typeof object.failedCharacters === "number")
                                    message.failedCharacters = object.failedCharacters;
                                else if (typeof object.failedCharacters === "object")
                                    message.failedCharacters = new $util.LongBits(object.failedCharacters.low >>> 0, object.failedCharacters.high >>> 0).toNumber();
                            if (object.totalBillableCharacters != null)
                                if ($util.Long)
                                    (message.totalBillableCharacters = $util.Long.fromValue(object.totalBillableCharacters)).unsigned = false;
                                else if (typeof object.totalBillableCharacters === "string")
                                    message.totalBillableCharacters = parseInt(object.totalBillableCharacters, 10);
                                else if (typeof object.totalBillableCharacters === "number")
                                    message.totalBillableCharacters = object.totalBillableCharacters;
                                else if (typeof object.totalBillableCharacters === "object")
                                    message.totalBillableCharacters = new $util.LongBits(object.totalBillableCharacters.low >>> 0, object.totalBillableCharacters.high >>> 0).toNumber();
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3.BatchTranslateDocumentMetadata.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateDocumentMetadata message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @static
                         * @param {google.cloud.translation.v3.BatchTranslateDocumentMetadata} message BatchTranslateDocumentMetadata
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateDocumentMetadata.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalBillablePages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalBillablePages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalBillableCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalBillableCharacters = options.longs === String ? "0" : 0;
                                object.submitTime = null;
                            }
                            if (message.state != null && message.hasOwnProperty("state"))
                                object.state = options.enums === String ? $root.google.cloud.translation.v3.BatchTranslateDocumentMetadata.State[message.state] : message.state;
                            if (message.totalPages != null && message.hasOwnProperty("totalPages"))
                                if (typeof message.totalPages === "number")
                                    object.totalPages = options.longs === String ? String(message.totalPages) : message.totalPages;
                                else
                                    object.totalPages = options.longs === String ? $util.Long.prototype.toString.call(message.totalPages) : options.longs === Number ? new $util.LongBits(message.totalPages.low >>> 0, message.totalPages.high >>> 0).toNumber() : message.totalPages;
                            if (message.translatedPages != null && message.hasOwnProperty("translatedPages"))
                                if (typeof message.translatedPages === "number")
                                    object.translatedPages = options.longs === String ? String(message.translatedPages) : message.translatedPages;
                                else
                                    object.translatedPages = options.longs === String ? $util.Long.prototype.toString.call(message.translatedPages) : options.longs === Number ? new $util.LongBits(message.translatedPages.low >>> 0, message.translatedPages.high >>> 0).toNumber() : message.translatedPages;
                            if (message.failedPages != null && message.hasOwnProperty("failedPages"))
                                if (typeof message.failedPages === "number")
                                    object.failedPages = options.longs === String ? String(message.failedPages) : message.failedPages;
                                else
                                    object.failedPages = options.longs === String ? $util.Long.prototype.toString.call(message.failedPages) : options.longs === Number ? new $util.LongBits(message.failedPages.low >>> 0, message.failedPages.high >>> 0).toNumber() : message.failedPages;
                            if (message.totalBillablePages != null && message.hasOwnProperty("totalBillablePages"))
                                if (typeof message.totalBillablePages === "number")
                                    object.totalBillablePages = options.longs === String ? String(message.totalBillablePages) : message.totalBillablePages;
                                else
                                    object.totalBillablePages = options.longs === String ? $util.Long.prototype.toString.call(message.totalBillablePages) : options.longs === Number ? new $util.LongBits(message.totalBillablePages.low >>> 0, message.totalBillablePages.high >>> 0).toNumber() : message.totalBillablePages;
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (typeof message.totalCharacters === "number")
                                    object.totalCharacters = options.longs === String ? String(message.totalCharacters) : message.totalCharacters;
                                else
                                    object.totalCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalCharacters) : options.longs === Number ? new $util.LongBits(message.totalCharacters.low >>> 0, message.totalCharacters.high >>> 0).toNumber() : message.totalCharacters;
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (typeof message.translatedCharacters === "number")
                                    object.translatedCharacters = options.longs === String ? String(message.translatedCharacters) : message.translatedCharacters;
                                else
                                    object.translatedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.translatedCharacters) : options.longs === Number ? new $util.LongBits(message.translatedCharacters.low >>> 0, message.translatedCharacters.high >>> 0).toNumber() : message.translatedCharacters;
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (typeof message.failedCharacters === "number")
                                    object.failedCharacters = options.longs === String ? String(message.failedCharacters) : message.failedCharacters;
                                else
                                    object.failedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.failedCharacters) : options.longs === Number ? new $util.LongBits(message.failedCharacters.low >>> 0, message.failedCharacters.high >>> 0).toNumber() : message.failedCharacters;
                            if (message.totalBillableCharacters != null && message.hasOwnProperty("totalBillableCharacters"))
                                if (typeof message.totalBillableCharacters === "number")
                                    object.totalBillableCharacters = options.longs === String ? String(message.totalBillableCharacters) : message.totalBillableCharacters;
                                else
                                    object.totalBillableCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalBillableCharacters) : options.longs === Number ? new $util.LongBits(message.totalBillableCharacters.low >>> 0, message.totalBillableCharacters.high >>> 0).toNumber() : message.totalBillableCharacters;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateDocumentMetadata to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3.BatchTranslateDocumentMetadata
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateDocumentMetadata.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * State enum.
                         * @name google.cloud.translation.v3.BatchTranslateDocumentMetadata.State
                         * @enum {number}
                         * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                         * @property {number} RUNNING=1 RUNNING value
                         * @property {number} SUCCEEDED=2 SUCCEEDED value
                         * @property {number} FAILED=3 FAILED value
                         * @property {number} CANCELLING=4 CANCELLING value
                         * @property {number} CANCELLED=5 CANCELLED value
                         */
                        BatchTranslateDocumentMetadata.State = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "RUNNING"] = 1;
                            values[valuesById[2] = "SUCCEEDED"] = 2;
                            values[valuesById[3] = "FAILED"] = 3;
                            values[valuesById[4] = "CANCELLING"] = 4;
                            values[valuesById[5] = "CANCELLED"] = 5;
                            return values;
                        })();
    
                        return BatchTranslateDocumentMetadata;
                    })();
    
                    return v3;
                })();
    
                translation.v3beta1 = (function() {
    
                    /**
                     * Namespace v3beta1.
                     * @memberof google.cloud.translation
                     * @namespace
                     */
                    var v3beta1 = {};
    
                    v3beta1.TranslationService = (function() {
    
                        /**
                         * Constructs a new TranslationService service.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a TranslationService
                         * @extends $protobuf.rpc.Service
                         * @constructor
                         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                         */
                        function TranslationService(rpcImpl, requestDelimited, responseDelimited) {
                            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                        }
    
                        (TranslationService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = TranslationService;
    
                        /**
                         * Creates new TranslationService service using the specified rpc implementation.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @static
                         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                         * @returns {TranslationService} RPC service. Useful where requests and/or responses are streamed.
                         */
                        TranslationService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                            return new this(rpcImpl, requestDelimited, responseDelimited);
                        };
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3beta1.TranslationService#translateText}.
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @typedef TranslateTextCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3beta1.TranslateTextResponse} [response] TranslateTextResponse
                         */
    
                        /**
                         * Calls TranslateText.
                         * @function translateText
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.ITranslateTextRequest} request TranslateTextRequest message or plain object
                         * @param {google.cloud.translation.v3beta1.TranslationService.TranslateTextCallback} callback Node-style callback called with the error, if any, and TranslateTextResponse
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.translateText = function translateText(request, callback) {
                            return this.rpcCall(translateText, $root.google.cloud.translation.v3beta1.TranslateTextRequest, $root.google.cloud.translation.v3beta1.TranslateTextResponse, request, callback);
                        }, "name", { value: "TranslateText" });
    
                        /**
                         * Calls TranslateText.
                         * @function translateText
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.ITranslateTextRequest} request TranslateTextRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3beta1.TranslateTextResponse>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3beta1.TranslationService#detectLanguage}.
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @typedef DetectLanguageCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3beta1.DetectLanguageResponse} [response] DetectLanguageResponse
                         */
    
                        /**
                         * Calls DetectLanguage.
                         * @function detectLanguage
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IDetectLanguageRequest} request DetectLanguageRequest message or plain object
                         * @param {google.cloud.translation.v3beta1.TranslationService.DetectLanguageCallback} callback Node-style callback called with the error, if any, and DetectLanguageResponse
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.detectLanguage = function detectLanguage(request, callback) {
                            return this.rpcCall(detectLanguage, $root.google.cloud.translation.v3beta1.DetectLanguageRequest, $root.google.cloud.translation.v3beta1.DetectLanguageResponse, request, callback);
                        }, "name", { value: "DetectLanguage" });
    
                        /**
                         * Calls DetectLanguage.
                         * @function detectLanguage
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IDetectLanguageRequest} request DetectLanguageRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3beta1.DetectLanguageResponse>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3beta1.TranslationService#getSupportedLanguages}.
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @typedef GetSupportedLanguagesCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3beta1.SupportedLanguages} [response] SupportedLanguages
                         */
    
                        /**
                         * Calls GetSupportedLanguages.
                         * @function getSupportedLanguages
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IGetSupportedLanguagesRequest} request GetSupportedLanguagesRequest message or plain object
                         * @param {google.cloud.translation.v3beta1.TranslationService.GetSupportedLanguagesCallback} callback Node-style callback called with the error, if any, and SupportedLanguages
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.getSupportedLanguages = function getSupportedLanguages(request, callback) {
                            return this.rpcCall(getSupportedLanguages, $root.google.cloud.translation.v3beta1.GetSupportedLanguagesRequest, $root.google.cloud.translation.v3beta1.SupportedLanguages, request, callback);
                        }, "name", { value: "GetSupportedLanguages" });
    
                        /**
                         * Calls GetSupportedLanguages.
                         * @function getSupportedLanguages
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IGetSupportedLanguagesRequest} request GetSupportedLanguagesRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3beta1.SupportedLanguages>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3beta1.TranslationService#translateDocument}.
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @typedef TranslateDocumentCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3beta1.TranslateDocumentResponse} [response] TranslateDocumentResponse
                         */
    
                        /**
                         * Calls TranslateDocument.
                         * @function translateDocument
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.ITranslateDocumentRequest} request TranslateDocumentRequest message or plain object
                         * @param {google.cloud.translation.v3beta1.TranslationService.TranslateDocumentCallback} callback Node-style callback called with the error, if any, and TranslateDocumentResponse
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.translateDocument = function translateDocument(request, callback) {
                            return this.rpcCall(translateDocument, $root.google.cloud.translation.v3beta1.TranslateDocumentRequest, $root.google.cloud.translation.v3beta1.TranslateDocumentResponse, request, callback);
                        }, "name", { value: "TranslateDocument" });
    
                        /**
                         * Calls TranslateDocument.
                         * @function translateDocument
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.ITranslateDocumentRequest} request TranslateDocumentRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3beta1.TranslateDocumentResponse>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3beta1.TranslationService#batchTranslateText}.
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @typedef BatchTranslateTextCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.longrunning.Operation} [response] Operation
                         */
    
                        /**
                         * Calls BatchTranslateText.
                         * @function batchTranslateText
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateTextRequest} request BatchTranslateTextRequest message or plain object
                         * @param {google.cloud.translation.v3beta1.TranslationService.BatchTranslateTextCallback} callback Node-style callback called with the error, if any, and Operation
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.batchTranslateText = function batchTranslateText(request, callback) {
                            return this.rpcCall(batchTranslateText, $root.google.cloud.translation.v3beta1.BatchTranslateTextRequest, $root.google.longrunning.Operation, request, callback);
                        }, "name", { value: "BatchTranslateText" });
    
                        /**
                         * Calls BatchTranslateText.
                         * @function batchTranslateText
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateTextRequest} request BatchTranslateTextRequest message or plain object
                         * @returns {Promise<google.longrunning.Operation>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3beta1.TranslationService#batchTranslateDocument}.
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @typedef BatchTranslateDocumentCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.longrunning.Operation} [response] Operation
                         */
    
                        /**
                         * Calls BatchTranslateDocument.
                         * @function batchTranslateDocument
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentRequest} request BatchTranslateDocumentRequest message or plain object
                         * @param {google.cloud.translation.v3beta1.TranslationService.BatchTranslateDocumentCallback} callback Node-style callback called with the error, if any, and Operation
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.batchTranslateDocument = function batchTranslateDocument(request, callback) {
                            return this.rpcCall(batchTranslateDocument, $root.google.cloud.translation.v3beta1.BatchTranslateDocumentRequest, $root.google.longrunning.Operation, request, callback);
                        }, "name", { value: "BatchTranslateDocument" });
    
                        /**
                         * Calls BatchTranslateDocument.
                         * @function batchTranslateDocument
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentRequest} request BatchTranslateDocumentRequest message or plain object
                         * @returns {Promise<google.longrunning.Operation>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3beta1.TranslationService#createGlossary}.
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @typedef CreateGlossaryCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.longrunning.Operation} [response] Operation
                         */
    
                        /**
                         * Calls CreateGlossary.
                         * @function createGlossary
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.ICreateGlossaryRequest} request CreateGlossaryRequest message or plain object
                         * @param {google.cloud.translation.v3beta1.TranslationService.CreateGlossaryCallback} callback Node-style callback called with the error, if any, and Operation
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.createGlossary = function createGlossary(request, callback) {
                            return this.rpcCall(createGlossary, $root.google.cloud.translation.v3beta1.CreateGlossaryRequest, $root.google.longrunning.Operation, request, callback);
                        }, "name", { value: "CreateGlossary" });
    
                        /**
                         * Calls CreateGlossary.
                         * @function createGlossary
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.ICreateGlossaryRequest} request CreateGlossaryRequest message or plain object
                         * @returns {Promise<google.longrunning.Operation>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3beta1.TranslationService#listGlossaries}.
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @typedef ListGlossariesCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3beta1.ListGlossariesResponse} [response] ListGlossariesResponse
                         */
    
                        /**
                         * Calls ListGlossaries.
                         * @function listGlossaries
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IListGlossariesRequest} request ListGlossariesRequest message or plain object
                         * @param {google.cloud.translation.v3beta1.TranslationService.ListGlossariesCallback} callback Node-style callback called with the error, if any, and ListGlossariesResponse
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.listGlossaries = function listGlossaries(request, callback) {
                            return this.rpcCall(listGlossaries, $root.google.cloud.translation.v3beta1.ListGlossariesRequest, $root.google.cloud.translation.v3beta1.ListGlossariesResponse, request, callback);
                        }, "name", { value: "ListGlossaries" });
    
                        /**
                         * Calls ListGlossaries.
                         * @function listGlossaries
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IListGlossariesRequest} request ListGlossariesRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3beta1.ListGlossariesResponse>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3beta1.TranslationService#getGlossary}.
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @typedef GetGlossaryCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.cloud.translation.v3beta1.Glossary} [response] Glossary
                         */
    
                        /**
                         * Calls GetGlossary.
                         * @function getGlossary
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IGetGlossaryRequest} request GetGlossaryRequest message or plain object
                         * @param {google.cloud.translation.v3beta1.TranslationService.GetGlossaryCallback} callback Node-style callback called with the error, if any, and Glossary
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.getGlossary = function getGlossary(request, callback) {
                            return this.rpcCall(getGlossary, $root.google.cloud.translation.v3beta1.GetGlossaryRequest, $root.google.cloud.translation.v3beta1.Glossary, request, callback);
                        }, "name", { value: "GetGlossary" });
    
                        /**
                         * Calls GetGlossary.
                         * @function getGlossary
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IGetGlossaryRequest} request GetGlossaryRequest message or plain object
                         * @returns {Promise<google.cloud.translation.v3beta1.Glossary>} Promise
                         * @variation 2
                         */
    
                        /**
                         * Callback as used by {@link google.cloud.translation.v3beta1.TranslationService#deleteGlossary}.
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @typedef DeleteGlossaryCallback
                         * @type {function}
                         * @param {Error|null} error Error, if any
                         * @param {google.longrunning.Operation} [response] Operation
                         */
    
                        /**
                         * Calls DeleteGlossary.
                         * @function deleteGlossary
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryRequest} request DeleteGlossaryRequest message or plain object
                         * @param {google.cloud.translation.v3beta1.TranslationService.DeleteGlossaryCallback} callback Node-style callback called with the error, if any, and Operation
                         * @returns {undefined}
                         * @variation 1
                         */
                        Object.defineProperty(TranslationService.prototype.deleteGlossary = function deleteGlossary(request, callback) {
                            return this.rpcCall(deleteGlossary, $root.google.cloud.translation.v3beta1.DeleteGlossaryRequest, $root.google.longrunning.Operation, request, callback);
                        }, "name", { value: "DeleteGlossary" });
    
                        /**
                         * Calls DeleteGlossary.
                         * @function deleteGlossary
                         * @memberof google.cloud.translation.v3beta1.TranslationService
                         * @instance
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryRequest} request DeleteGlossaryRequest message or plain object
                         * @returns {Promise<google.longrunning.Operation>} Promise
                         * @variation 2
                         */
    
                        return TranslationService;
                    })();
    
                    v3beta1.TranslateTextGlossaryConfig = (function() {
    
                        /**
                         * Properties of a TranslateTextGlossaryConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface ITranslateTextGlossaryConfig
                         * @property {string|null} [glossary] TranslateTextGlossaryConfig glossary
                         * @property {boolean|null} [ignoreCase] TranslateTextGlossaryConfig ignoreCase
                         */
    
                        /**
                         * Constructs a new TranslateTextGlossaryConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a TranslateTextGlossaryConfig.
                         * @implements ITranslateTextGlossaryConfig
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig=} [properties] Properties to set
                         */
                        function TranslateTextGlossaryConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TranslateTextGlossaryConfig glossary.
                         * @member {string} glossary
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @instance
                         */
                        TranslateTextGlossaryConfig.prototype.glossary = "";
    
                        /**
                         * TranslateTextGlossaryConfig ignoreCase.
                         * @member {boolean} ignoreCase
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @instance
                         */
                        TranslateTextGlossaryConfig.prototype.ignoreCase = false;
    
                        /**
                         * Creates a new TranslateTextGlossaryConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.TranslateTextGlossaryConfig} TranslateTextGlossaryConfig instance
                         */
                        TranslateTextGlossaryConfig.create = function create(properties) {
                            return new TranslateTextGlossaryConfig(properties);
                        };
    
                        /**
                         * Encodes the specified TranslateTextGlossaryConfig message. Does not implicitly {@link google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig} message TranslateTextGlossaryConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextGlossaryConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.glossary != null && Object.hasOwnProperty.call(message, "glossary"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.glossary);
                            if (message.ignoreCase != null && Object.hasOwnProperty.call(message, "ignoreCase"))
                                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.ignoreCase);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TranslateTextGlossaryConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig} message TranslateTextGlossaryConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextGlossaryConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TranslateTextGlossaryConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.TranslateTextGlossaryConfig} TranslateTextGlossaryConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextGlossaryConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.glossary = reader.string();
                                    break;
                                case 2:
                                    message.ignoreCase = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TranslateTextGlossaryConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.TranslateTextGlossaryConfig} TranslateTextGlossaryConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextGlossaryConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TranslateTextGlossaryConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TranslateTextGlossaryConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.glossary != null && message.hasOwnProperty("glossary"))
                                if (!$util.isString(message.glossary))
                                    return "glossary: string expected";
                            if (message.ignoreCase != null && message.hasOwnProperty("ignoreCase"))
                                if (typeof message.ignoreCase !== "boolean")
                                    return "ignoreCase: boolean expected";
                            return null;
                        };
    
                        /**
                         * Creates a TranslateTextGlossaryConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.TranslateTextGlossaryConfig} TranslateTextGlossaryConfig
                         */
                        TranslateTextGlossaryConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig();
                            if (object.glossary != null)
                                message.glossary = String(object.glossary);
                            if (object.ignoreCase != null)
                                message.ignoreCase = Boolean(object.ignoreCase);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TranslateTextGlossaryConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.TranslateTextGlossaryConfig} message TranslateTextGlossaryConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TranslateTextGlossaryConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.glossary = "";
                                object.ignoreCase = false;
                            }
                            if (message.glossary != null && message.hasOwnProperty("glossary"))
                                object.glossary = message.glossary;
                            if (message.ignoreCase != null && message.hasOwnProperty("ignoreCase"))
                                object.ignoreCase = message.ignoreCase;
                            return object;
                        };
    
                        /**
                         * Converts this TranslateTextGlossaryConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.TranslateTextGlossaryConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TranslateTextGlossaryConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TranslateTextGlossaryConfig;
                    })();
    
                    v3beta1.TranslateTextRequest = (function() {
    
                        /**
                         * Properties of a TranslateTextRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface ITranslateTextRequest
                         * @property {Array.<string>|null} [contents] TranslateTextRequest contents
                         * @property {string|null} [mimeType] TranslateTextRequest mimeType
                         * @property {string|null} [sourceLanguageCode] TranslateTextRequest sourceLanguageCode
                         * @property {string|null} [targetLanguageCode] TranslateTextRequest targetLanguageCode
                         * @property {string|null} [parent] TranslateTextRequest parent
                         * @property {string|null} [model] TranslateTextRequest model
                         * @property {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig|null} [glossaryConfig] TranslateTextRequest glossaryConfig
                         * @property {Object.<string,string>|null} [labels] TranslateTextRequest labels
                         */
    
                        /**
                         * Constructs a new TranslateTextRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a TranslateTextRequest.
                         * @implements ITranslateTextRequest
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.ITranslateTextRequest=} [properties] Properties to set
                         */
                        function TranslateTextRequest(properties) {
                            this.contents = [];
                            this.labels = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TranslateTextRequest contents.
                         * @member {Array.<string>} contents
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.contents = $util.emptyArray;
    
                        /**
                         * TranslateTextRequest mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.mimeType = "";
    
                        /**
                         * TranslateTextRequest sourceLanguageCode.
                         * @member {string} sourceLanguageCode
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.sourceLanguageCode = "";
    
                        /**
                         * TranslateTextRequest targetLanguageCode.
                         * @member {string} targetLanguageCode
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.targetLanguageCode = "";
    
                        /**
                         * TranslateTextRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.parent = "";
    
                        /**
                         * TranslateTextRequest model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.model = "";
    
                        /**
                         * TranslateTextRequest glossaryConfig.
                         * @member {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig|null|undefined} glossaryConfig
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.glossaryConfig = null;
    
                        /**
                         * TranslateTextRequest labels.
                         * @member {Object.<string,string>} labels
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @instance
                         */
                        TranslateTextRequest.prototype.labels = $util.emptyObject;
    
                        /**
                         * Creates a new TranslateTextRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateTextRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.TranslateTextRequest} TranslateTextRequest instance
                         */
                        TranslateTextRequest.create = function create(properties) {
                            return new TranslateTextRequest(properties);
                        };
    
                        /**
                         * Encodes the specified TranslateTextRequest message. Does not implicitly {@link google.cloud.translation.v3beta1.TranslateTextRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateTextRequest} message TranslateTextRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.contents != null && message.contents.length)
                                for (var i = 0; i < message.contents.length; ++i)
                                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.contents[i]);
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.mimeType);
                            if (message.sourceLanguageCode != null && Object.hasOwnProperty.call(message, "sourceLanguageCode"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.sourceLanguageCode);
                            if (message.targetLanguageCode != null && Object.hasOwnProperty.call(message, "targetLanguageCode"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.targetLanguageCode);
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.model);
                            if (message.glossaryConfig != null && Object.hasOwnProperty.call(message, "glossaryConfig"))
                                $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.encode(message.glossaryConfig, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 8, wireType 2 =*/66).string(message.parent);
                            if (message.labels != null && Object.hasOwnProperty.call(message, "labels"))
                                for (var keys = Object.keys(message.labels), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 10, wireType 2 =*/82).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.labels[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TranslateTextRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.TranslateTextRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateTextRequest} message TranslateTextRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TranslateTextRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.TranslateTextRequest} TranslateTextRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.TranslateTextRequest(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.contents && message.contents.length))
                                        message.contents = [];
                                    message.contents.push(reader.string());
                                    break;
                                case 3:
                                    message.mimeType = reader.string();
                                    break;
                                case 4:
                                    message.sourceLanguageCode = reader.string();
                                    break;
                                case 5:
                                    message.targetLanguageCode = reader.string();
                                    break;
                                case 8:
                                    message.parent = reader.string();
                                    break;
                                case 6:
                                    message.model = reader.string();
                                    break;
                                case 7:
                                    message.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                    break;
                                case 10:
                                    if (message.labels === $util.emptyObject)
                                        message.labels = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.labels[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TranslateTextRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.TranslateTextRequest} TranslateTextRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TranslateTextRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TranslateTextRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.contents != null && message.hasOwnProperty("contents")) {
                                if (!Array.isArray(message.contents))
                                    return "contents: array expected";
                                for (var i = 0; i < message.contents.length; ++i)
                                    if (!$util.isString(message.contents[i]))
                                        return "contents: string[] expected";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                if (!$util.isString(message.sourceLanguageCode))
                                    return "sourceLanguageCode: string expected";
                            if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                if (!$util.isString(message.targetLanguageCode))
                                    return "targetLanguageCode: string expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig")) {
                                var error = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.verify(message.glossaryConfig);
                                if (error)
                                    return "glossaryConfig." + error;
                            }
                            if (message.labels != null && message.hasOwnProperty("labels")) {
                                if (!$util.isObject(message.labels))
                                    return "labels: object expected";
                                var key = Object.keys(message.labels);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.labels[key[i]]))
                                        return "labels: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a TranslateTextRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.TranslateTextRequest} TranslateTextRequest
                         */
                        TranslateTextRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.TranslateTextRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.TranslateTextRequest();
                            if (object.contents) {
                                if (!Array.isArray(object.contents))
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateTextRequest.contents: array expected");
                                message.contents = [];
                                for (var i = 0; i < object.contents.length; ++i)
                                    message.contents[i] = String(object.contents[i]);
                            }
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            if (object.sourceLanguageCode != null)
                                message.sourceLanguageCode = String(object.sourceLanguageCode);
                            if (object.targetLanguageCode != null)
                                message.targetLanguageCode = String(object.targetLanguageCode);
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.model != null)
                                message.model = String(object.model);
                            if (object.glossaryConfig != null) {
                                if (typeof object.glossaryConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateTextRequest.glossaryConfig: object expected");
                                message.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.fromObject(object.glossaryConfig);
                            }
                            if (object.labels) {
                                if (typeof object.labels !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateTextRequest.labels: object expected");
                                message.labels = {};
                                for (var keys = Object.keys(object.labels), i = 0; i < keys.length; ++i)
                                    message.labels[keys[i]] = String(object.labels[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TranslateTextRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.TranslateTextRequest} message TranslateTextRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TranslateTextRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.contents = [];
                            if (options.objects || options.defaults)
                                object.labels = {};
                            if (options.defaults) {
                                object.mimeType = "";
                                object.sourceLanguageCode = "";
                                object.targetLanguageCode = "";
                                object.model = "";
                                object.glossaryConfig = null;
                                object.parent = "";
                            }
                            if (message.contents && message.contents.length) {
                                object.contents = [];
                                for (var j = 0; j < message.contents.length; ++j)
                                    object.contents[j] = message.contents[j];
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                object.sourceLanguageCode = message.sourceLanguageCode;
                            if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                object.targetLanguageCode = message.targetLanguageCode;
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig"))
                                object.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.toObject(message.glossaryConfig, options);
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            var keys2;
                            if (message.labels && (keys2 = Object.keys(message.labels)).length) {
                                object.labels = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.labels[keys2[j]] = message.labels[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this TranslateTextRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.TranslateTextRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TranslateTextRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TranslateTextRequest;
                    })();
    
                    v3beta1.TranslateTextResponse = (function() {
    
                        /**
                         * Properties of a TranslateTextResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface ITranslateTextResponse
                         * @property {Array.<google.cloud.translation.v3beta1.ITranslation>|null} [translations] TranslateTextResponse translations
                         * @property {Array.<google.cloud.translation.v3beta1.ITranslation>|null} [glossaryTranslations] TranslateTextResponse glossaryTranslations
                         */
    
                        /**
                         * Constructs a new TranslateTextResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a TranslateTextResponse.
                         * @implements ITranslateTextResponse
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.ITranslateTextResponse=} [properties] Properties to set
                         */
                        function TranslateTextResponse(properties) {
                            this.translations = [];
                            this.glossaryTranslations = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TranslateTextResponse translations.
                         * @member {Array.<google.cloud.translation.v3beta1.ITranslation>} translations
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @instance
                         */
                        TranslateTextResponse.prototype.translations = $util.emptyArray;
    
                        /**
                         * TranslateTextResponse glossaryTranslations.
                         * @member {Array.<google.cloud.translation.v3beta1.ITranslation>} glossaryTranslations
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @instance
                         */
                        TranslateTextResponse.prototype.glossaryTranslations = $util.emptyArray;
    
                        /**
                         * Creates a new TranslateTextResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateTextResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.TranslateTextResponse} TranslateTextResponse instance
                         */
                        TranslateTextResponse.create = function create(properties) {
                            return new TranslateTextResponse(properties);
                        };
    
                        /**
                         * Encodes the specified TranslateTextResponse message. Does not implicitly {@link google.cloud.translation.v3beta1.TranslateTextResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateTextResponse} message TranslateTextResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.translations != null && message.translations.length)
                                for (var i = 0; i < message.translations.length; ++i)
                                    $root.google.cloud.translation.v3beta1.Translation.encode(message.translations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.glossaryTranslations != null && message.glossaryTranslations.length)
                                for (var i = 0; i < message.glossaryTranslations.length; ++i)
                                    $root.google.cloud.translation.v3beta1.Translation.encode(message.glossaryTranslations[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TranslateTextResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.TranslateTextResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateTextResponse} message TranslateTextResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateTextResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TranslateTextResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.TranslateTextResponse} TranslateTextResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.TranslateTextResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.translations && message.translations.length))
                                        message.translations = [];
                                    message.translations.push($root.google.cloud.translation.v3beta1.Translation.decode(reader, reader.uint32()));
                                    break;
                                case 3:
                                    if (!(message.glossaryTranslations && message.glossaryTranslations.length))
                                        message.glossaryTranslations = [];
                                    message.glossaryTranslations.push($root.google.cloud.translation.v3beta1.Translation.decode(reader, reader.uint32()));
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TranslateTextResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.TranslateTextResponse} TranslateTextResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateTextResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TranslateTextResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TranslateTextResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.translations != null && message.hasOwnProperty("translations")) {
                                if (!Array.isArray(message.translations))
                                    return "translations: array expected";
                                for (var i = 0; i < message.translations.length; ++i) {
                                    var error = $root.google.cloud.translation.v3beta1.Translation.verify(message.translations[i]);
                                    if (error)
                                        return "translations." + error;
                                }
                            }
                            if (message.glossaryTranslations != null && message.hasOwnProperty("glossaryTranslations")) {
                                if (!Array.isArray(message.glossaryTranslations))
                                    return "glossaryTranslations: array expected";
                                for (var i = 0; i < message.glossaryTranslations.length; ++i) {
                                    var error = $root.google.cloud.translation.v3beta1.Translation.verify(message.glossaryTranslations[i]);
                                    if (error)
                                        return "glossaryTranslations." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a TranslateTextResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.TranslateTextResponse} TranslateTextResponse
                         */
                        TranslateTextResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.TranslateTextResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.TranslateTextResponse();
                            if (object.translations) {
                                if (!Array.isArray(object.translations))
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateTextResponse.translations: array expected");
                                message.translations = [];
                                for (var i = 0; i < object.translations.length; ++i) {
                                    if (typeof object.translations[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3beta1.TranslateTextResponse.translations: object expected");
                                    message.translations[i] = $root.google.cloud.translation.v3beta1.Translation.fromObject(object.translations[i]);
                                }
                            }
                            if (object.glossaryTranslations) {
                                if (!Array.isArray(object.glossaryTranslations))
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateTextResponse.glossaryTranslations: array expected");
                                message.glossaryTranslations = [];
                                for (var i = 0; i < object.glossaryTranslations.length; ++i) {
                                    if (typeof object.glossaryTranslations[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3beta1.TranslateTextResponse.glossaryTranslations: object expected");
                                    message.glossaryTranslations[i] = $root.google.cloud.translation.v3beta1.Translation.fromObject(object.glossaryTranslations[i]);
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TranslateTextResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.TranslateTextResponse} message TranslateTextResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TranslateTextResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.translations = [];
                                object.glossaryTranslations = [];
                            }
                            if (message.translations && message.translations.length) {
                                object.translations = [];
                                for (var j = 0; j < message.translations.length; ++j)
                                    object.translations[j] = $root.google.cloud.translation.v3beta1.Translation.toObject(message.translations[j], options);
                            }
                            if (message.glossaryTranslations && message.glossaryTranslations.length) {
                                object.glossaryTranslations = [];
                                for (var j = 0; j < message.glossaryTranslations.length; ++j)
                                    object.glossaryTranslations[j] = $root.google.cloud.translation.v3beta1.Translation.toObject(message.glossaryTranslations[j], options);
                            }
                            return object;
                        };
    
                        /**
                         * Converts this TranslateTextResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.TranslateTextResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TranslateTextResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TranslateTextResponse;
                    })();
    
                    v3beta1.Translation = (function() {
    
                        /**
                         * Properties of a Translation.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface ITranslation
                         * @property {string|null} [translatedText] Translation translatedText
                         * @property {string|null} [model] Translation model
                         * @property {string|null} [detectedLanguageCode] Translation detectedLanguageCode
                         * @property {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig|null} [glossaryConfig] Translation glossaryConfig
                         */
    
                        /**
                         * Constructs a new Translation.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a Translation.
                         * @implements ITranslation
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.ITranslation=} [properties] Properties to set
                         */
                        function Translation(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Translation translatedText.
                         * @member {string} translatedText
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @instance
                         */
                        Translation.prototype.translatedText = "";
    
                        /**
                         * Translation model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @instance
                         */
                        Translation.prototype.model = "";
    
                        /**
                         * Translation detectedLanguageCode.
                         * @member {string} detectedLanguageCode
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @instance
                         */
                        Translation.prototype.detectedLanguageCode = "";
    
                        /**
                         * Translation glossaryConfig.
                         * @member {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig|null|undefined} glossaryConfig
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @instance
                         */
                        Translation.prototype.glossaryConfig = null;
    
                        /**
                         * Creates a new Translation instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslation=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.Translation} Translation instance
                         */
                        Translation.create = function create(properties) {
                            return new Translation(properties);
                        };
    
                        /**
                         * Encodes the specified Translation message. Does not implicitly {@link google.cloud.translation.v3beta1.Translation.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslation} message Translation message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Translation.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.translatedText != null && Object.hasOwnProperty.call(message, "translatedText"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.translatedText);
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.model);
                            if (message.glossaryConfig != null && Object.hasOwnProperty.call(message, "glossaryConfig"))
                                $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.encode(message.glossaryConfig, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            if (message.detectedLanguageCode != null && Object.hasOwnProperty.call(message, "detectedLanguageCode"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.detectedLanguageCode);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Translation message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.Translation.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslation} message Translation message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Translation.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Translation message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.Translation} Translation
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Translation.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.Translation();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.translatedText = reader.string();
                                    break;
                                case 2:
                                    message.model = reader.string();
                                    break;
                                case 4:
                                    message.detectedLanguageCode = reader.string();
                                    break;
                                case 3:
                                    message.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Translation message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.Translation} Translation
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Translation.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Translation message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Translation.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                                if (!$util.isString(message.translatedText))
                                    return "translatedText: string expected";
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            if (message.detectedLanguageCode != null && message.hasOwnProperty("detectedLanguageCode"))
                                if (!$util.isString(message.detectedLanguageCode))
                                    return "detectedLanguageCode: string expected";
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig")) {
                                var error = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.verify(message.glossaryConfig);
                                if (error)
                                    return "glossaryConfig." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Translation message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.Translation} Translation
                         */
                        Translation.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.Translation)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.Translation();
                            if (object.translatedText != null)
                                message.translatedText = String(object.translatedText);
                            if (object.model != null)
                                message.model = String(object.model);
                            if (object.detectedLanguageCode != null)
                                message.detectedLanguageCode = String(object.detectedLanguageCode);
                            if (object.glossaryConfig != null) {
                                if (typeof object.glossaryConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.Translation.glossaryConfig: object expected");
                                message.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.fromObject(object.glossaryConfig);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Translation message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @static
                         * @param {google.cloud.translation.v3beta1.Translation} message Translation
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Translation.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.translatedText = "";
                                object.model = "";
                                object.glossaryConfig = null;
                                object.detectedLanguageCode = "";
                            }
                            if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                                object.translatedText = message.translatedText;
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig"))
                                object.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.toObject(message.glossaryConfig, options);
                            if (message.detectedLanguageCode != null && message.hasOwnProperty("detectedLanguageCode"))
                                object.detectedLanguageCode = message.detectedLanguageCode;
                            return object;
                        };
    
                        /**
                         * Converts this Translation to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.Translation
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Translation.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Translation;
                    })();
    
                    v3beta1.DetectLanguageRequest = (function() {
    
                        /**
                         * Properties of a DetectLanguageRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IDetectLanguageRequest
                         * @property {string|null} [parent] DetectLanguageRequest parent
                         * @property {string|null} [model] DetectLanguageRequest model
                         * @property {string|null} [content] DetectLanguageRequest content
                         * @property {string|null} [mimeType] DetectLanguageRequest mimeType
                         * @property {Object.<string,string>|null} [labels] DetectLanguageRequest labels
                         */
    
                        /**
                         * Constructs a new DetectLanguageRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a DetectLanguageRequest.
                         * @implements IDetectLanguageRequest
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IDetectLanguageRequest=} [properties] Properties to set
                         */
                        function DetectLanguageRequest(properties) {
                            this.labels = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DetectLanguageRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @instance
                         */
                        DetectLanguageRequest.prototype.parent = "";
    
                        /**
                         * DetectLanguageRequest model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @instance
                         */
                        DetectLanguageRequest.prototype.model = "";
    
                        /**
                         * DetectLanguageRequest content.
                         * @member {string|null|undefined} content
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @instance
                         */
                        DetectLanguageRequest.prototype.content = null;
    
                        /**
                         * DetectLanguageRequest mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @instance
                         */
                        DetectLanguageRequest.prototype.mimeType = "";
    
                        /**
                         * DetectLanguageRequest labels.
                         * @member {Object.<string,string>} labels
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @instance
                         */
                        DetectLanguageRequest.prototype.labels = $util.emptyObject;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * DetectLanguageRequest source.
                         * @member {"content"|undefined} source
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @instance
                         */
                        Object.defineProperty(DetectLanguageRequest.prototype, "source", {
                            get: $util.oneOfGetter($oneOfFields = ["content"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new DetectLanguageRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDetectLanguageRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.DetectLanguageRequest} DetectLanguageRequest instance
                         */
                        DetectLanguageRequest.create = function create(properties) {
                            return new DetectLanguageRequest(properties);
                        };
    
                        /**
                         * Encodes the specified DetectLanguageRequest message. Does not implicitly {@link google.cloud.translation.v3beta1.DetectLanguageRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDetectLanguageRequest} message DetectLanguageRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectLanguageRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.content);
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.mimeType);
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.model);
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.parent);
                            if (message.labels != null && Object.hasOwnProperty.call(message, "labels"))
                                for (var keys = Object.keys(message.labels), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.labels[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DetectLanguageRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.DetectLanguageRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDetectLanguageRequest} message DetectLanguageRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectLanguageRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DetectLanguageRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.DetectLanguageRequest} DetectLanguageRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectLanguageRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.DetectLanguageRequest(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 5:
                                    message.parent = reader.string();
                                    break;
                                case 4:
                                    message.model = reader.string();
                                    break;
                                case 1:
                                    message.content = reader.string();
                                    break;
                                case 3:
                                    message.mimeType = reader.string();
                                    break;
                                case 6:
                                    if (message.labels === $util.emptyObject)
                                        message.labels = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.labels[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DetectLanguageRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.DetectLanguageRequest} DetectLanguageRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectLanguageRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DetectLanguageRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DetectLanguageRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            if (message.content != null && message.hasOwnProperty("content")) {
                                properties.source = 1;
                                if (!$util.isString(message.content))
                                    return "content: string expected";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            if (message.labels != null && message.hasOwnProperty("labels")) {
                                if (!$util.isObject(message.labels))
                                    return "labels: object expected";
                                var key = Object.keys(message.labels);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.labels[key[i]]))
                                        return "labels: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a DetectLanguageRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.DetectLanguageRequest} DetectLanguageRequest
                         */
                        DetectLanguageRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.DetectLanguageRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.DetectLanguageRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.model != null)
                                message.model = String(object.model);
                            if (object.content != null)
                                message.content = String(object.content);
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            if (object.labels) {
                                if (typeof object.labels !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.DetectLanguageRequest.labels: object expected");
                                message.labels = {};
                                for (var keys = Object.keys(object.labels), i = 0; i < keys.length; ++i)
                                    message.labels[keys[i]] = String(object.labels[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DetectLanguageRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.DetectLanguageRequest} message DetectLanguageRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DetectLanguageRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.objects || options.defaults)
                                object.labels = {};
                            if (options.defaults) {
                                object.mimeType = "";
                                object.model = "";
                                object.parent = "";
                            }
                            if (message.content != null && message.hasOwnProperty("content")) {
                                object.content = message.content;
                                if (options.oneofs)
                                    object.source = "content";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            var keys2;
                            if (message.labels && (keys2 = Object.keys(message.labels)).length) {
                                object.labels = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.labels[keys2[j]] = message.labels[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this DetectLanguageRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DetectLanguageRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DetectLanguageRequest;
                    })();
    
                    v3beta1.DetectedLanguage = (function() {
    
                        /**
                         * Properties of a DetectedLanguage.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IDetectedLanguage
                         * @property {string|null} [languageCode] DetectedLanguage languageCode
                         * @property {number|null} [confidence] DetectedLanguage confidence
                         */
    
                        /**
                         * Constructs a new DetectedLanguage.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a DetectedLanguage.
                         * @implements IDetectedLanguage
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IDetectedLanguage=} [properties] Properties to set
                         */
                        function DetectedLanguage(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DetectedLanguage languageCode.
                         * @member {string} languageCode
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @instance
                         */
                        DetectedLanguage.prototype.languageCode = "";
    
                        /**
                         * DetectedLanguage confidence.
                         * @member {number} confidence
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @instance
                         */
                        DetectedLanguage.prototype.confidence = 0;
    
                        /**
                         * Creates a new DetectedLanguage instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDetectedLanguage=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.DetectedLanguage} DetectedLanguage instance
                         */
                        DetectedLanguage.create = function create(properties) {
                            return new DetectedLanguage(properties);
                        };
    
                        /**
                         * Encodes the specified DetectedLanguage message. Does not implicitly {@link google.cloud.translation.v3beta1.DetectedLanguage.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDetectedLanguage} message DetectedLanguage message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectedLanguage.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.languageCode);
                            if (message.confidence != null && Object.hasOwnProperty.call(message, "confidence"))
                                writer.uint32(/* id 2, wireType 5 =*/21).float(message.confidence);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DetectedLanguage message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.DetectedLanguage.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDetectedLanguage} message DetectedLanguage message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectedLanguage.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DetectedLanguage message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.DetectedLanguage} DetectedLanguage
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectedLanguage.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.DetectedLanguage();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.languageCode = reader.string();
                                    break;
                                case 2:
                                    message.confidence = reader.float();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DetectedLanguage message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.DetectedLanguage} DetectedLanguage
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectedLanguage.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DetectedLanguage message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DetectedLanguage.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                                if (!$util.isString(message.languageCode))
                                    return "languageCode: string expected";
                            if (message.confidence != null && message.hasOwnProperty("confidence"))
                                if (typeof message.confidence !== "number")
                                    return "confidence: number expected";
                            return null;
                        };
    
                        /**
                         * Creates a DetectedLanguage message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.DetectedLanguage} DetectedLanguage
                         */
                        DetectedLanguage.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.DetectedLanguage)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.DetectedLanguage();
                            if (object.languageCode != null)
                                message.languageCode = String(object.languageCode);
                            if (object.confidence != null)
                                message.confidence = Number(object.confidence);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DetectedLanguage message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @static
                         * @param {google.cloud.translation.v3beta1.DetectedLanguage} message DetectedLanguage
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DetectedLanguage.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.languageCode = "";
                                object.confidence = 0;
                            }
                            if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                                object.languageCode = message.languageCode;
                            if (message.confidence != null && message.hasOwnProperty("confidence"))
                                object.confidence = options.json && !isFinite(message.confidence) ? String(message.confidence) : message.confidence;
                            return object;
                        };
    
                        /**
                         * Converts this DetectedLanguage to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.DetectedLanguage
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DetectedLanguage.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DetectedLanguage;
                    })();
    
                    v3beta1.DetectLanguageResponse = (function() {
    
                        /**
                         * Properties of a DetectLanguageResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IDetectLanguageResponse
                         * @property {Array.<google.cloud.translation.v3beta1.IDetectedLanguage>|null} [languages] DetectLanguageResponse languages
                         */
    
                        /**
                         * Constructs a new DetectLanguageResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a DetectLanguageResponse.
                         * @implements IDetectLanguageResponse
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IDetectLanguageResponse=} [properties] Properties to set
                         */
                        function DetectLanguageResponse(properties) {
                            this.languages = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DetectLanguageResponse languages.
                         * @member {Array.<google.cloud.translation.v3beta1.IDetectedLanguage>} languages
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageResponse
                         * @instance
                         */
                        DetectLanguageResponse.prototype.languages = $util.emptyArray;
    
                        /**
                         * Creates a new DetectLanguageResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDetectLanguageResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.DetectLanguageResponse} DetectLanguageResponse instance
                         */
                        DetectLanguageResponse.create = function create(properties) {
                            return new DetectLanguageResponse(properties);
                        };
    
                        /**
                         * Encodes the specified DetectLanguageResponse message. Does not implicitly {@link google.cloud.translation.v3beta1.DetectLanguageResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDetectLanguageResponse} message DetectLanguageResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectLanguageResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.languages != null && message.languages.length)
                                for (var i = 0; i < message.languages.length; ++i)
                                    $root.google.cloud.translation.v3beta1.DetectedLanguage.encode(message.languages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DetectLanguageResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.DetectLanguageResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDetectLanguageResponse} message DetectLanguageResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DetectLanguageResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DetectLanguageResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.DetectLanguageResponse} DetectLanguageResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectLanguageResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.DetectLanguageResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.languages && message.languages.length))
                                        message.languages = [];
                                    message.languages.push($root.google.cloud.translation.v3beta1.DetectedLanguage.decode(reader, reader.uint32()));
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DetectLanguageResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.DetectLanguageResponse} DetectLanguageResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DetectLanguageResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DetectLanguageResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DetectLanguageResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.languages != null && message.hasOwnProperty("languages")) {
                                if (!Array.isArray(message.languages))
                                    return "languages: array expected";
                                for (var i = 0; i < message.languages.length; ++i) {
                                    var error = $root.google.cloud.translation.v3beta1.DetectedLanguage.verify(message.languages[i]);
                                    if (error)
                                        return "languages." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a DetectLanguageResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.DetectLanguageResponse} DetectLanguageResponse
                         */
                        DetectLanguageResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.DetectLanguageResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.DetectLanguageResponse();
                            if (object.languages) {
                                if (!Array.isArray(object.languages))
                                    throw TypeError(".google.cloud.translation.v3beta1.DetectLanguageResponse.languages: array expected");
                                message.languages = [];
                                for (var i = 0; i < object.languages.length; ++i) {
                                    if (typeof object.languages[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3beta1.DetectLanguageResponse.languages: object expected");
                                    message.languages[i] = $root.google.cloud.translation.v3beta1.DetectedLanguage.fromObject(object.languages[i]);
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DetectLanguageResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.DetectLanguageResponse} message DetectLanguageResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DetectLanguageResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.languages = [];
                            if (message.languages && message.languages.length) {
                                object.languages = [];
                                for (var j = 0; j < message.languages.length; ++j)
                                    object.languages[j] = $root.google.cloud.translation.v3beta1.DetectedLanguage.toObject(message.languages[j], options);
                            }
                            return object;
                        };
    
                        /**
                         * Converts this DetectLanguageResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.DetectLanguageResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DetectLanguageResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DetectLanguageResponse;
                    })();
    
                    v3beta1.GetSupportedLanguagesRequest = (function() {
    
                        /**
                         * Properties of a GetSupportedLanguagesRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IGetSupportedLanguagesRequest
                         * @property {string|null} [parent] GetSupportedLanguagesRequest parent
                         * @property {string|null} [displayLanguageCode] GetSupportedLanguagesRequest displayLanguageCode
                         * @property {string|null} [model] GetSupportedLanguagesRequest model
                         */
    
                        /**
                         * Constructs a new GetSupportedLanguagesRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a GetSupportedLanguagesRequest.
                         * @implements IGetSupportedLanguagesRequest
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IGetSupportedLanguagesRequest=} [properties] Properties to set
                         */
                        function GetSupportedLanguagesRequest(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GetSupportedLanguagesRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @instance
                         */
                        GetSupportedLanguagesRequest.prototype.parent = "";
    
                        /**
                         * GetSupportedLanguagesRequest displayLanguageCode.
                         * @member {string} displayLanguageCode
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @instance
                         */
                        GetSupportedLanguagesRequest.prototype.displayLanguageCode = "";
    
                        /**
                         * GetSupportedLanguagesRequest model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @instance
                         */
                        GetSupportedLanguagesRequest.prototype.model = "";
    
                        /**
                         * Creates a new GetSupportedLanguagesRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGetSupportedLanguagesRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.GetSupportedLanguagesRequest} GetSupportedLanguagesRequest instance
                         */
                        GetSupportedLanguagesRequest.create = function create(properties) {
                            return new GetSupportedLanguagesRequest(properties);
                        };
    
                        /**
                         * Encodes the specified GetSupportedLanguagesRequest message. Does not implicitly {@link google.cloud.translation.v3beta1.GetSupportedLanguagesRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGetSupportedLanguagesRequest} message GetSupportedLanguagesRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetSupportedLanguagesRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.displayLanguageCode != null && Object.hasOwnProperty.call(message, "displayLanguageCode"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.displayLanguageCode);
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.model);
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.parent);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GetSupportedLanguagesRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.GetSupportedLanguagesRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGetSupportedLanguagesRequest} message GetSupportedLanguagesRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetSupportedLanguagesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GetSupportedLanguagesRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.GetSupportedLanguagesRequest} GetSupportedLanguagesRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetSupportedLanguagesRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.GetSupportedLanguagesRequest();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 3:
                                    message.parent = reader.string();
                                    break;
                                case 1:
                                    message.displayLanguageCode = reader.string();
                                    break;
                                case 2:
                                    message.model = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GetSupportedLanguagesRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.GetSupportedLanguagesRequest} GetSupportedLanguagesRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetSupportedLanguagesRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GetSupportedLanguagesRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetSupportedLanguagesRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.displayLanguageCode != null && message.hasOwnProperty("displayLanguageCode"))
                                if (!$util.isString(message.displayLanguageCode))
                                    return "displayLanguageCode: string expected";
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GetSupportedLanguagesRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.GetSupportedLanguagesRequest} GetSupportedLanguagesRequest
                         */
                        GetSupportedLanguagesRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.GetSupportedLanguagesRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.GetSupportedLanguagesRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.displayLanguageCode != null)
                                message.displayLanguageCode = String(object.displayLanguageCode);
                            if (object.model != null)
                                message.model = String(object.model);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GetSupportedLanguagesRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.GetSupportedLanguagesRequest} message GetSupportedLanguagesRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetSupportedLanguagesRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.displayLanguageCode = "";
                                object.model = "";
                                object.parent = "";
                            }
                            if (message.displayLanguageCode != null && message.hasOwnProperty("displayLanguageCode"))
                                object.displayLanguageCode = message.displayLanguageCode;
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            return object;
                        };
    
                        /**
                         * Converts this GetSupportedLanguagesRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.GetSupportedLanguagesRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetSupportedLanguagesRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GetSupportedLanguagesRequest;
                    })();
    
                    v3beta1.SupportedLanguages = (function() {
    
                        /**
                         * Properties of a SupportedLanguages.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface ISupportedLanguages
                         * @property {Array.<google.cloud.translation.v3beta1.ISupportedLanguage>|null} [languages] SupportedLanguages languages
                         */
    
                        /**
                         * Constructs a new SupportedLanguages.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a SupportedLanguages.
                         * @implements ISupportedLanguages
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.ISupportedLanguages=} [properties] Properties to set
                         */
                        function SupportedLanguages(properties) {
                            this.languages = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * SupportedLanguages languages.
                         * @member {Array.<google.cloud.translation.v3beta1.ISupportedLanguage>} languages
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguages
                         * @instance
                         */
                        SupportedLanguages.prototype.languages = $util.emptyArray;
    
                        /**
                         * Creates a new SupportedLanguages instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguages
                         * @static
                         * @param {google.cloud.translation.v3beta1.ISupportedLanguages=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.SupportedLanguages} SupportedLanguages instance
                         */
                        SupportedLanguages.create = function create(properties) {
                            return new SupportedLanguages(properties);
                        };
    
                        /**
                         * Encodes the specified SupportedLanguages message. Does not implicitly {@link google.cloud.translation.v3beta1.SupportedLanguages.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguages
                         * @static
                         * @param {google.cloud.translation.v3beta1.ISupportedLanguages} message SupportedLanguages message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SupportedLanguages.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.languages != null && message.languages.length)
                                for (var i = 0; i < message.languages.length; ++i)
                                    $root.google.cloud.translation.v3beta1.SupportedLanguage.encode(message.languages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified SupportedLanguages message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.SupportedLanguages.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguages
                         * @static
                         * @param {google.cloud.translation.v3beta1.ISupportedLanguages} message SupportedLanguages message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SupportedLanguages.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a SupportedLanguages message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguages
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.SupportedLanguages} SupportedLanguages
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SupportedLanguages.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.SupportedLanguages();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.languages && message.languages.length))
                                        message.languages = [];
                                    message.languages.push($root.google.cloud.translation.v3beta1.SupportedLanguage.decode(reader, reader.uint32()));
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a SupportedLanguages message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguages
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.SupportedLanguages} SupportedLanguages
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SupportedLanguages.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a SupportedLanguages message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguages
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        SupportedLanguages.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.languages != null && message.hasOwnProperty("languages")) {
                                if (!Array.isArray(message.languages))
                                    return "languages: array expected";
                                for (var i = 0; i < message.languages.length; ++i) {
                                    var error = $root.google.cloud.translation.v3beta1.SupportedLanguage.verify(message.languages[i]);
                                    if (error)
                                        return "languages." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a SupportedLanguages message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguages
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.SupportedLanguages} SupportedLanguages
                         */
                        SupportedLanguages.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.SupportedLanguages)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.SupportedLanguages();
                            if (object.languages) {
                                if (!Array.isArray(object.languages))
                                    throw TypeError(".google.cloud.translation.v3beta1.SupportedLanguages.languages: array expected");
                                message.languages = [];
                                for (var i = 0; i < object.languages.length; ++i) {
                                    if (typeof object.languages[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3beta1.SupportedLanguages.languages: object expected");
                                    message.languages[i] = $root.google.cloud.translation.v3beta1.SupportedLanguage.fromObject(object.languages[i]);
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a SupportedLanguages message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguages
                         * @static
                         * @param {google.cloud.translation.v3beta1.SupportedLanguages} message SupportedLanguages
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        SupportedLanguages.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.languages = [];
                            if (message.languages && message.languages.length) {
                                object.languages = [];
                                for (var j = 0; j < message.languages.length; ++j)
                                    object.languages[j] = $root.google.cloud.translation.v3beta1.SupportedLanguage.toObject(message.languages[j], options);
                            }
                            return object;
                        };
    
                        /**
                         * Converts this SupportedLanguages to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguages
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        SupportedLanguages.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return SupportedLanguages;
                    })();
    
                    v3beta1.SupportedLanguage = (function() {
    
                        /**
                         * Properties of a SupportedLanguage.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface ISupportedLanguage
                         * @property {string|null} [languageCode] SupportedLanguage languageCode
                         * @property {string|null} [displayName] SupportedLanguage displayName
                         * @property {boolean|null} [supportSource] SupportedLanguage supportSource
                         * @property {boolean|null} [supportTarget] SupportedLanguage supportTarget
                         */
    
                        /**
                         * Constructs a new SupportedLanguage.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a SupportedLanguage.
                         * @implements ISupportedLanguage
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.ISupportedLanguage=} [properties] Properties to set
                         */
                        function SupportedLanguage(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * SupportedLanguage languageCode.
                         * @member {string} languageCode
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @instance
                         */
                        SupportedLanguage.prototype.languageCode = "";
    
                        /**
                         * SupportedLanguage displayName.
                         * @member {string} displayName
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @instance
                         */
                        SupportedLanguage.prototype.displayName = "";
    
                        /**
                         * SupportedLanguage supportSource.
                         * @member {boolean} supportSource
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @instance
                         */
                        SupportedLanguage.prototype.supportSource = false;
    
                        /**
                         * SupportedLanguage supportTarget.
                         * @member {boolean} supportTarget
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @instance
                         */
                        SupportedLanguage.prototype.supportTarget = false;
    
                        /**
                         * Creates a new SupportedLanguage instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @static
                         * @param {google.cloud.translation.v3beta1.ISupportedLanguage=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.SupportedLanguage} SupportedLanguage instance
                         */
                        SupportedLanguage.create = function create(properties) {
                            return new SupportedLanguage(properties);
                        };
    
                        /**
                         * Encodes the specified SupportedLanguage message. Does not implicitly {@link google.cloud.translation.v3beta1.SupportedLanguage.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @static
                         * @param {google.cloud.translation.v3beta1.ISupportedLanguage} message SupportedLanguage message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SupportedLanguage.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.languageCode);
                            if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
                            if (message.supportSource != null && Object.hasOwnProperty.call(message, "supportSource"))
                                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.supportSource);
                            if (message.supportTarget != null && Object.hasOwnProperty.call(message, "supportTarget"))
                                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.supportTarget);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified SupportedLanguage message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.SupportedLanguage.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @static
                         * @param {google.cloud.translation.v3beta1.ISupportedLanguage} message SupportedLanguage message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SupportedLanguage.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a SupportedLanguage message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.SupportedLanguage} SupportedLanguage
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SupportedLanguage.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.SupportedLanguage();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.languageCode = reader.string();
                                    break;
                                case 2:
                                    message.displayName = reader.string();
                                    break;
                                case 3:
                                    message.supportSource = reader.bool();
                                    break;
                                case 4:
                                    message.supportTarget = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a SupportedLanguage message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.SupportedLanguage} SupportedLanguage
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SupportedLanguage.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a SupportedLanguage message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        SupportedLanguage.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                                if (!$util.isString(message.languageCode))
                                    return "languageCode: string expected";
                            if (message.displayName != null && message.hasOwnProperty("displayName"))
                                if (!$util.isString(message.displayName))
                                    return "displayName: string expected";
                            if (message.supportSource != null && message.hasOwnProperty("supportSource"))
                                if (typeof message.supportSource !== "boolean")
                                    return "supportSource: boolean expected";
                            if (message.supportTarget != null && message.hasOwnProperty("supportTarget"))
                                if (typeof message.supportTarget !== "boolean")
                                    return "supportTarget: boolean expected";
                            return null;
                        };
    
                        /**
                         * Creates a SupportedLanguage message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.SupportedLanguage} SupportedLanguage
                         */
                        SupportedLanguage.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.SupportedLanguage)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.SupportedLanguage();
                            if (object.languageCode != null)
                                message.languageCode = String(object.languageCode);
                            if (object.displayName != null)
                                message.displayName = String(object.displayName);
                            if (object.supportSource != null)
                                message.supportSource = Boolean(object.supportSource);
                            if (object.supportTarget != null)
                                message.supportTarget = Boolean(object.supportTarget);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a SupportedLanguage message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @static
                         * @param {google.cloud.translation.v3beta1.SupportedLanguage} message SupportedLanguage
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        SupportedLanguage.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.languageCode = "";
                                object.displayName = "";
                                object.supportSource = false;
                                object.supportTarget = false;
                            }
                            if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                                object.languageCode = message.languageCode;
                            if (message.displayName != null && message.hasOwnProperty("displayName"))
                                object.displayName = message.displayName;
                            if (message.supportSource != null && message.hasOwnProperty("supportSource"))
                                object.supportSource = message.supportSource;
                            if (message.supportTarget != null && message.hasOwnProperty("supportTarget"))
                                object.supportTarget = message.supportTarget;
                            return object;
                        };
    
                        /**
                         * Converts this SupportedLanguage to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.SupportedLanguage
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        SupportedLanguage.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return SupportedLanguage;
                    })();
    
                    v3beta1.GcsSource = (function() {
    
                        /**
                         * Properties of a GcsSource.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IGcsSource
                         * @property {string|null} [inputUri] GcsSource inputUri
                         */
    
                        /**
                         * Constructs a new GcsSource.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a GcsSource.
                         * @implements IGcsSource
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IGcsSource=} [properties] Properties to set
                         */
                        function GcsSource(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GcsSource inputUri.
                         * @member {string} inputUri
                         * @memberof google.cloud.translation.v3beta1.GcsSource
                         * @instance
                         */
                        GcsSource.prototype.inputUri = "";
    
                        /**
                         * Creates a new GcsSource instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.GcsSource
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGcsSource=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.GcsSource} GcsSource instance
                         */
                        GcsSource.create = function create(properties) {
                            return new GcsSource(properties);
                        };
    
                        /**
                         * Encodes the specified GcsSource message. Does not implicitly {@link google.cloud.translation.v3beta1.GcsSource.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.GcsSource
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGcsSource} message GcsSource message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GcsSource.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.inputUri != null && Object.hasOwnProperty.call(message, "inputUri"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.inputUri);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GcsSource message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.GcsSource.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.GcsSource
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGcsSource} message GcsSource message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GcsSource.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GcsSource message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.GcsSource
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.GcsSource} GcsSource
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GcsSource.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.GcsSource();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.inputUri = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GcsSource message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.GcsSource
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.GcsSource} GcsSource
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GcsSource.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GcsSource message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.GcsSource
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GcsSource.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.inputUri != null && message.hasOwnProperty("inputUri"))
                                if (!$util.isString(message.inputUri))
                                    return "inputUri: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GcsSource message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.GcsSource
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.GcsSource} GcsSource
                         */
                        GcsSource.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.GcsSource)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.GcsSource();
                            if (object.inputUri != null)
                                message.inputUri = String(object.inputUri);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GcsSource message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.GcsSource
                         * @static
                         * @param {google.cloud.translation.v3beta1.GcsSource} message GcsSource
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GcsSource.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.inputUri = "";
                            if (message.inputUri != null && message.hasOwnProperty("inputUri"))
                                object.inputUri = message.inputUri;
                            return object;
                        };
    
                        /**
                         * Converts this GcsSource to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.GcsSource
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GcsSource.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GcsSource;
                    })();
    
                    v3beta1.InputConfig = (function() {
    
                        /**
                         * Properties of an InputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IInputConfig
                         * @property {string|null} [mimeType] InputConfig mimeType
                         * @property {google.cloud.translation.v3beta1.IGcsSource|null} [gcsSource] InputConfig gcsSource
                         */
    
                        /**
                         * Constructs a new InputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents an InputConfig.
                         * @implements IInputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IInputConfig=} [properties] Properties to set
                         */
                        function InputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * InputConfig mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @instance
                         */
                        InputConfig.prototype.mimeType = "";
    
                        /**
                         * InputConfig gcsSource.
                         * @member {google.cloud.translation.v3beta1.IGcsSource|null|undefined} gcsSource
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @instance
                         */
                        InputConfig.prototype.gcsSource = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * InputConfig source.
                         * @member {"gcsSource"|undefined} source
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @instance
                         */
                        Object.defineProperty(InputConfig.prototype, "source", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsSource"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new InputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IInputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.InputConfig} InputConfig instance
                         */
                        InputConfig.create = function create(properties) {
                            return new InputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified InputConfig message. Does not implicitly {@link google.cloud.translation.v3beta1.InputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IInputConfig} message InputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        InputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.mimeType);
                            if (message.gcsSource != null && Object.hasOwnProperty.call(message, "gcsSource"))
                                $root.google.cloud.translation.v3beta1.GcsSource.encode(message.gcsSource, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified InputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.InputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IInputConfig} message InputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        InputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an InputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.InputConfig} InputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        InputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.InputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.mimeType = reader.string();
                                    break;
                                case 2:
                                    message.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an InputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.InputConfig} InputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        InputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an InputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        InputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                properties.source = 1;
                                {
                                    var error = $root.google.cloud.translation.v3beta1.GcsSource.verify(message.gcsSource);
                                    if (error)
                                        return "gcsSource." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates an InputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.InputConfig} InputConfig
                         */
                        InputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.InputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.InputConfig();
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            if (object.gcsSource != null) {
                                if (typeof object.gcsSource !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.InputConfig.gcsSource: object expected");
                                message.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.fromObject(object.gcsSource);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an InputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.InputConfig} message InputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        InputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.mimeType = "";
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                object.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.toObject(message.gcsSource, options);
                                if (options.oneofs)
                                    object.source = "gcsSource";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this InputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.InputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        InputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return InputConfig;
                    })();
    
                    v3beta1.GcsDestination = (function() {
    
                        /**
                         * Properties of a GcsDestination.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IGcsDestination
                         * @property {string|null} [outputUriPrefix] GcsDestination outputUriPrefix
                         */
    
                        /**
                         * Constructs a new GcsDestination.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a GcsDestination.
                         * @implements IGcsDestination
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IGcsDestination=} [properties] Properties to set
                         */
                        function GcsDestination(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GcsDestination outputUriPrefix.
                         * @member {string} outputUriPrefix
                         * @memberof google.cloud.translation.v3beta1.GcsDestination
                         * @instance
                         */
                        GcsDestination.prototype.outputUriPrefix = "";
    
                        /**
                         * Creates a new GcsDestination instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.GcsDestination
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGcsDestination=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.GcsDestination} GcsDestination instance
                         */
                        GcsDestination.create = function create(properties) {
                            return new GcsDestination(properties);
                        };
    
                        /**
                         * Encodes the specified GcsDestination message. Does not implicitly {@link google.cloud.translation.v3beta1.GcsDestination.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.GcsDestination
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGcsDestination} message GcsDestination message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GcsDestination.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.outputUriPrefix != null && Object.hasOwnProperty.call(message, "outputUriPrefix"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.outputUriPrefix);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GcsDestination message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.GcsDestination.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.GcsDestination
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGcsDestination} message GcsDestination message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GcsDestination.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GcsDestination message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.GcsDestination
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.GcsDestination} GcsDestination
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GcsDestination.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.GcsDestination();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.outputUriPrefix = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GcsDestination message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.GcsDestination
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.GcsDestination} GcsDestination
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GcsDestination.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GcsDestination message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.GcsDestination
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GcsDestination.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.outputUriPrefix != null && message.hasOwnProperty("outputUriPrefix"))
                                if (!$util.isString(message.outputUriPrefix))
                                    return "outputUriPrefix: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GcsDestination message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.GcsDestination
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.GcsDestination} GcsDestination
                         */
                        GcsDestination.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.GcsDestination)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.GcsDestination();
                            if (object.outputUriPrefix != null)
                                message.outputUriPrefix = String(object.outputUriPrefix);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GcsDestination message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.GcsDestination
                         * @static
                         * @param {google.cloud.translation.v3beta1.GcsDestination} message GcsDestination
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GcsDestination.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.outputUriPrefix = "";
                            if (message.outputUriPrefix != null && message.hasOwnProperty("outputUriPrefix"))
                                object.outputUriPrefix = message.outputUriPrefix;
                            return object;
                        };
    
                        /**
                         * Converts this GcsDestination to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.GcsDestination
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GcsDestination.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GcsDestination;
                    })();
    
                    v3beta1.OutputConfig = (function() {
    
                        /**
                         * Properties of an OutputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IOutputConfig
                         * @property {google.cloud.translation.v3beta1.IGcsDestination|null} [gcsDestination] OutputConfig gcsDestination
                         */
    
                        /**
                         * Constructs a new OutputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents an OutputConfig.
                         * @implements IOutputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IOutputConfig=} [properties] Properties to set
                         */
                        function OutputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * OutputConfig gcsDestination.
                         * @member {google.cloud.translation.v3beta1.IGcsDestination|null|undefined} gcsDestination
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @instance
                         */
                        OutputConfig.prototype.gcsDestination = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * OutputConfig destination.
                         * @member {"gcsDestination"|undefined} destination
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @instance
                         */
                        Object.defineProperty(OutputConfig.prototype, "destination", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsDestination"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new OutputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IOutputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.OutputConfig} OutputConfig instance
                         */
                        OutputConfig.create = function create(properties) {
                            return new OutputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified OutputConfig message. Does not implicitly {@link google.cloud.translation.v3beta1.OutputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IOutputConfig} message OutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        OutputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.gcsDestination != null && Object.hasOwnProperty.call(message, "gcsDestination"))
                                $root.google.cloud.translation.v3beta1.GcsDestination.encode(message.gcsDestination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified OutputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.OutputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IOutputConfig} message OutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        OutputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an OutputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.OutputConfig} OutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        OutputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.OutputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.gcsDestination = $root.google.cloud.translation.v3beta1.GcsDestination.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an OutputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.OutputConfig} OutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        OutputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an OutputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        OutputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                properties.destination = 1;
                                {
                                    var error = $root.google.cloud.translation.v3beta1.GcsDestination.verify(message.gcsDestination);
                                    if (error)
                                        return "gcsDestination." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates an OutputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.OutputConfig} OutputConfig
                         */
                        OutputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.OutputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.OutputConfig();
                            if (object.gcsDestination != null) {
                                if (typeof object.gcsDestination !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.OutputConfig.gcsDestination: object expected");
                                message.gcsDestination = $root.google.cloud.translation.v3beta1.GcsDestination.fromObject(object.gcsDestination);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an OutputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.OutputConfig} message OutputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        OutputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                object.gcsDestination = $root.google.cloud.translation.v3beta1.GcsDestination.toObject(message.gcsDestination, options);
                                if (options.oneofs)
                                    object.destination = "gcsDestination";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this OutputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.OutputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        OutputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return OutputConfig;
                    })();
    
                    v3beta1.DocumentInputConfig = (function() {
    
                        /**
                         * Properties of a DocumentInputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IDocumentInputConfig
                         * @property {Uint8Array|null} [content] DocumentInputConfig content
                         * @property {google.cloud.translation.v3beta1.IGcsSource|null} [gcsSource] DocumentInputConfig gcsSource
                         * @property {string|null} [mimeType] DocumentInputConfig mimeType
                         */
    
                        /**
                         * Constructs a new DocumentInputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a DocumentInputConfig.
                         * @implements IDocumentInputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IDocumentInputConfig=} [properties] Properties to set
                         */
                        function DocumentInputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DocumentInputConfig content.
                         * @member {Uint8Array|null|undefined} content
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @instance
                         */
                        DocumentInputConfig.prototype.content = null;
    
                        /**
                         * DocumentInputConfig gcsSource.
                         * @member {google.cloud.translation.v3beta1.IGcsSource|null|undefined} gcsSource
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @instance
                         */
                        DocumentInputConfig.prototype.gcsSource = null;
    
                        /**
                         * DocumentInputConfig mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @instance
                         */
                        DocumentInputConfig.prototype.mimeType = "";
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * DocumentInputConfig source.
                         * @member {"content"|"gcsSource"|undefined} source
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @instance
                         */
                        Object.defineProperty(DocumentInputConfig.prototype, "source", {
                            get: $util.oneOfGetter($oneOfFields = ["content", "gcsSource"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new DocumentInputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDocumentInputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.DocumentInputConfig} DocumentInputConfig instance
                         */
                        DocumentInputConfig.create = function create(properties) {
                            return new DocumentInputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified DocumentInputConfig message. Does not implicitly {@link google.cloud.translation.v3beta1.DocumentInputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDocumentInputConfig} message DocumentInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentInputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.content);
                            if (message.gcsSource != null && Object.hasOwnProperty.call(message, "gcsSource"))
                                $root.google.cloud.translation.v3beta1.GcsSource.encode(message.gcsSource, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.mimeType);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DocumentInputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.DocumentInputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDocumentInputConfig} message DocumentInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentInputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DocumentInputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.DocumentInputConfig} DocumentInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentInputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.DocumentInputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.content = reader.bytes();
                                    break;
                                case 2:
                                    message.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.decode(reader, reader.uint32());
                                    break;
                                case 4:
                                    message.mimeType = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DocumentInputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.DocumentInputConfig} DocumentInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentInputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DocumentInputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DocumentInputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.content != null && message.hasOwnProperty("content")) {
                                properties.source = 1;
                                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                                    return "content: buffer expected";
                            }
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                if (properties.source === 1)
                                    return "source: multiple values";
                                properties.source = 1;
                                {
                                    var error = $root.google.cloud.translation.v3beta1.GcsSource.verify(message.gcsSource);
                                    if (error)
                                        return "gcsSource." + error;
                                }
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DocumentInputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.DocumentInputConfig} DocumentInputConfig
                         */
                        DocumentInputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.DocumentInputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.DocumentInputConfig();
                            if (object.content != null)
                                if (typeof object.content === "string")
                                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                                else if (object.content.length)
                                    message.content = object.content;
                            if (object.gcsSource != null) {
                                if (typeof object.gcsSource !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.DocumentInputConfig.gcsSource: object expected");
                                message.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.fromObject(object.gcsSource);
                            }
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DocumentInputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.DocumentInputConfig} message DocumentInputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DocumentInputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.mimeType = "";
                            if (message.content != null && message.hasOwnProperty("content")) {
                                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
                                if (options.oneofs)
                                    object.source = "content";
                            }
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                object.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.toObject(message.gcsSource, options);
                                if (options.oneofs)
                                    object.source = "gcsSource";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            return object;
                        };
    
                        /**
                         * Converts this DocumentInputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.DocumentInputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DocumentInputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DocumentInputConfig;
                    })();
    
                    v3beta1.DocumentOutputConfig = (function() {
    
                        /**
                         * Properties of a DocumentOutputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IDocumentOutputConfig
                         * @property {google.cloud.translation.v3beta1.IGcsDestination|null} [gcsDestination] DocumentOutputConfig gcsDestination
                         * @property {string|null} [mimeType] DocumentOutputConfig mimeType
                         */
    
                        /**
                         * Constructs a new DocumentOutputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a DocumentOutputConfig.
                         * @implements IDocumentOutputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IDocumentOutputConfig=} [properties] Properties to set
                         */
                        function DocumentOutputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DocumentOutputConfig gcsDestination.
                         * @member {google.cloud.translation.v3beta1.IGcsDestination|null|undefined} gcsDestination
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @instance
                         */
                        DocumentOutputConfig.prototype.gcsDestination = null;
    
                        /**
                         * DocumentOutputConfig mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @instance
                         */
                        DocumentOutputConfig.prototype.mimeType = "";
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * DocumentOutputConfig destination.
                         * @member {"gcsDestination"|undefined} destination
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @instance
                         */
                        Object.defineProperty(DocumentOutputConfig.prototype, "destination", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsDestination"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new DocumentOutputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDocumentOutputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.DocumentOutputConfig} DocumentOutputConfig instance
                         */
                        DocumentOutputConfig.create = function create(properties) {
                            return new DocumentOutputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified DocumentOutputConfig message. Does not implicitly {@link google.cloud.translation.v3beta1.DocumentOutputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDocumentOutputConfig} message DocumentOutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentOutputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.gcsDestination != null && Object.hasOwnProperty.call(message, "gcsDestination"))
                                $root.google.cloud.translation.v3beta1.GcsDestination.encode(message.gcsDestination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.mimeType);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DocumentOutputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.DocumentOutputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDocumentOutputConfig} message DocumentOutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentOutputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DocumentOutputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.DocumentOutputConfig} DocumentOutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentOutputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.DocumentOutputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.gcsDestination = $root.google.cloud.translation.v3beta1.GcsDestination.decode(reader, reader.uint32());
                                    break;
                                case 3:
                                    message.mimeType = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DocumentOutputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.DocumentOutputConfig} DocumentOutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentOutputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DocumentOutputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DocumentOutputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                properties.destination = 1;
                                {
                                    var error = $root.google.cloud.translation.v3beta1.GcsDestination.verify(message.gcsDestination);
                                    if (error)
                                        return "gcsDestination." + error;
                                }
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DocumentOutputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.DocumentOutputConfig} DocumentOutputConfig
                         */
                        DocumentOutputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.DocumentOutputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.DocumentOutputConfig();
                            if (object.gcsDestination != null) {
                                if (typeof object.gcsDestination !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.DocumentOutputConfig.gcsDestination: object expected");
                                message.gcsDestination = $root.google.cloud.translation.v3beta1.GcsDestination.fromObject(object.gcsDestination);
                            }
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DocumentOutputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.DocumentOutputConfig} message DocumentOutputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DocumentOutputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.mimeType = "";
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                object.gcsDestination = $root.google.cloud.translation.v3beta1.GcsDestination.toObject(message.gcsDestination, options);
                                if (options.oneofs)
                                    object.destination = "gcsDestination";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            return object;
                        };
    
                        /**
                         * Converts this DocumentOutputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.DocumentOutputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DocumentOutputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DocumentOutputConfig;
                    })();
    
                    v3beta1.TranslateDocumentRequest = (function() {
    
                        /**
                         * Properties of a TranslateDocumentRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface ITranslateDocumentRequest
                         * @property {string|null} [parent] TranslateDocumentRequest parent
                         * @property {string|null} [sourceLanguageCode] TranslateDocumentRequest sourceLanguageCode
                         * @property {string|null} [targetLanguageCode] TranslateDocumentRequest targetLanguageCode
                         * @property {google.cloud.translation.v3beta1.IDocumentInputConfig|null} [documentInputConfig] TranslateDocumentRequest documentInputConfig
                         * @property {google.cloud.translation.v3beta1.IDocumentOutputConfig|null} [documentOutputConfig] TranslateDocumentRequest documentOutputConfig
                         * @property {string|null} [model] TranslateDocumentRequest model
                         * @property {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig|null} [glossaryConfig] TranslateDocumentRequest glossaryConfig
                         * @property {Object.<string,string>|null} [labels] TranslateDocumentRequest labels
                         */
    
                        /**
                         * Constructs a new TranslateDocumentRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a TranslateDocumentRequest.
                         * @implements ITranslateDocumentRequest
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.ITranslateDocumentRequest=} [properties] Properties to set
                         */
                        function TranslateDocumentRequest(properties) {
                            this.labels = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TranslateDocumentRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.parent = "";
    
                        /**
                         * TranslateDocumentRequest sourceLanguageCode.
                         * @member {string} sourceLanguageCode
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.sourceLanguageCode = "";
    
                        /**
                         * TranslateDocumentRequest targetLanguageCode.
                         * @member {string} targetLanguageCode
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.targetLanguageCode = "";
    
                        /**
                         * TranslateDocumentRequest documentInputConfig.
                         * @member {google.cloud.translation.v3beta1.IDocumentInputConfig|null|undefined} documentInputConfig
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.documentInputConfig = null;
    
                        /**
                         * TranslateDocumentRequest documentOutputConfig.
                         * @member {google.cloud.translation.v3beta1.IDocumentOutputConfig|null|undefined} documentOutputConfig
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.documentOutputConfig = null;
    
                        /**
                         * TranslateDocumentRequest model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.model = "";
    
                        /**
                         * TranslateDocumentRequest glossaryConfig.
                         * @member {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig|null|undefined} glossaryConfig
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.glossaryConfig = null;
    
                        /**
                         * TranslateDocumentRequest labels.
                         * @member {Object.<string,string>} labels
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @instance
                         */
                        TranslateDocumentRequest.prototype.labels = $util.emptyObject;
    
                        /**
                         * Creates a new TranslateDocumentRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateDocumentRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.TranslateDocumentRequest} TranslateDocumentRequest instance
                         */
                        TranslateDocumentRequest.create = function create(properties) {
                            return new TranslateDocumentRequest(properties);
                        };
    
                        /**
                         * Encodes the specified TranslateDocumentRequest message. Does not implicitly {@link google.cloud.translation.v3beta1.TranslateDocumentRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateDocumentRequest} message TranslateDocumentRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateDocumentRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                            if (message.sourceLanguageCode != null && Object.hasOwnProperty.call(message, "sourceLanguageCode"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.sourceLanguageCode);
                            if (message.targetLanguageCode != null && Object.hasOwnProperty.call(message, "targetLanguageCode"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.targetLanguageCode);
                            if (message.documentInputConfig != null && Object.hasOwnProperty.call(message, "documentInputConfig"))
                                $root.google.cloud.translation.v3beta1.DocumentInputConfig.encode(message.documentInputConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            if (message.documentOutputConfig != null && Object.hasOwnProperty.call(message, "documentOutputConfig"))
                                $root.google.cloud.translation.v3beta1.DocumentOutputConfig.encode(message.documentOutputConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.model);
                            if (message.glossaryConfig != null && Object.hasOwnProperty.call(message, "glossaryConfig"))
                                $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.encode(message.glossaryConfig, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                            if (message.labels != null && Object.hasOwnProperty.call(message, "labels"))
                                for (var keys = Object.keys(message.labels), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 8, wireType 2 =*/66).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.labels[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TranslateDocumentRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.TranslateDocumentRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateDocumentRequest} message TranslateDocumentRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateDocumentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TranslateDocumentRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.TranslateDocumentRequest} TranslateDocumentRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateDocumentRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.TranslateDocumentRequest(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.parent = reader.string();
                                    break;
                                case 2:
                                    message.sourceLanguageCode = reader.string();
                                    break;
                                case 3:
                                    message.targetLanguageCode = reader.string();
                                    break;
                                case 4:
                                    message.documentInputConfig = $root.google.cloud.translation.v3beta1.DocumentInputConfig.decode(reader, reader.uint32());
                                    break;
                                case 5:
                                    message.documentOutputConfig = $root.google.cloud.translation.v3beta1.DocumentOutputConfig.decode(reader, reader.uint32());
                                    break;
                                case 6:
                                    message.model = reader.string();
                                    break;
                                case 7:
                                    message.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                    break;
                                case 8:
                                    if (message.labels === $util.emptyObject)
                                        message.labels = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.labels[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TranslateDocumentRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.TranslateDocumentRequest} TranslateDocumentRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateDocumentRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TranslateDocumentRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TranslateDocumentRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                if (!$util.isString(message.sourceLanguageCode))
                                    return "sourceLanguageCode: string expected";
                            if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                if (!$util.isString(message.targetLanguageCode))
                                    return "targetLanguageCode: string expected";
                            if (message.documentInputConfig != null && message.hasOwnProperty("documentInputConfig")) {
                                var error = $root.google.cloud.translation.v3beta1.DocumentInputConfig.verify(message.documentInputConfig);
                                if (error)
                                    return "documentInputConfig." + error;
                            }
                            if (message.documentOutputConfig != null && message.hasOwnProperty("documentOutputConfig")) {
                                var error = $root.google.cloud.translation.v3beta1.DocumentOutputConfig.verify(message.documentOutputConfig);
                                if (error)
                                    return "documentOutputConfig." + error;
                            }
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig")) {
                                var error = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.verify(message.glossaryConfig);
                                if (error)
                                    return "glossaryConfig." + error;
                            }
                            if (message.labels != null && message.hasOwnProperty("labels")) {
                                if (!$util.isObject(message.labels))
                                    return "labels: object expected";
                                var key = Object.keys(message.labels);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.labels[key[i]]))
                                        return "labels: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a TranslateDocumentRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.TranslateDocumentRequest} TranslateDocumentRequest
                         */
                        TranslateDocumentRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.TranslateDocumentRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.TranslateDocumentRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.sourceLanguageCode != null)
                                message.sourceLanguageCode = String(object.sourceLanguageCode);
                            if (object.targetLanguageCode != null)
                                message.targetLanguageCode = String(object.targetLanguageCode);
                            if (object.documentInputConfig != null) {
                                if (typeof object.documentInputConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateDocumentRequest.documentInputConfig: object expected");
                                message.documentInputConfig = $root.google.cloud.translation.v3beta1.DocumentInputConfig.fromObject(object.documentInputConfig);
                            }
                            if (object.documentOutputConfig != null) {
                                if (typeof object.documentOutputConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateDocumentRequest.documentOutputConfig: object expected");
                                message.documentOutputConfig = $root.google.cloud.translation.v3beta1.DocumentOutputConfig.fromObject(object.documentOutputConfig);
                            }
                            if (object.model != null)
                                message.model = String(object.model);
                            if (object.glossaryConfig != null) {
                                if (typeof object.glossaryConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateDocumentRequest.glossaryConfig: object expected");
                                message.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.fromObject(object.glossaryConfig);
                            }
                            if (object.labels) {
                                if (typeof object.labels !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateDocumentRequest.labels: object expected");
                                message.labels = {};
                                for (var keys = Object.keys(object.labels), i = 0; i < keys.length; ++i)
                                    message.labels[keys[i]] = String(object.labels[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TranslateDocumentRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.TranslateDocumentRequest} message TranslateDocumentRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TranslateDocumentRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.objects || options.defaults)
                                object.labels = {};
                            if (options.defaults) {
                                object.parent = "";
                                object.sourceLanguageCode = "";
                                object.targetLanguageCode = "";
                                object.documentInputConfig = null;
                                object.documentOutputConfig = null;
                                object.model = "";
                                object.glossaryConfig = null;
                            }
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                object.sourceLanguageCode = message.sourceLanguageCode;
                            if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                object.targetLanguageCode = message.targetLanguageCode;
                            if (message.documentInputConfig != null && message.hasOwnProperty("documentInputConfig"))
                                object.documentInputConfig = $root.google.cloud.translation.v3beta1.DocumentInputConfig.toObject(message.documentInputConfig, options);
                            if (message.documentOutputConfig != null && message.hasOwnProperty("documentOutputConfig"))
                                object.documentOutputConfig = $root.google.cloud.translation.v3beta1.DocumentOutputConfig.toObject(message.documentOutputConfig, options);
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig"))
                                object.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.toObject(message.glossaryConfig, options);
                            var keys2;
                            if (message.labels && (keys2 = Object.keys(message.labels)).length) {
                                object.labels = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.labels[keys2[j]] = message.labels[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this TranslateDocumentRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TranslateDocumentRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TranslateDocumentRequest;
                    })();
    
                    v3beta1.DocumentTranslation = (function() {
    
                        /**
                         * Properties of a DocumentTranslation.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IDocumentTranslation
                         * @property {Array.<Uint8Array>|null} [byteStreamOutputs] DocumentTranslation byteStreamOutputs
                         * @property {string|null} [mimeType] DocumentTranslation mimeType
                         * @property {string|null} [detectedLanguageCode] DocumentTranslation detectedLanguageCode
                         */
    
                        /**
                         * Constructs a new DocumentTranslation.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a DocumentTranslation.
                         * @implements IDocumentTranslation
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IDocumentTranslation=} [properties] Properties to set
                         */
                        function DocumentTranslation(properties) {
                            this.byteStreamOutputs = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DocumentTranslation byteStreamOutputs.
                         * @member {Array.<Uint8Array>} byteStreamOutputs
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @instance
                         */
                        DocumentTranslation.prototype.byteStreamOutputs = $util.emptyArray;
    
                        /**
                         * DocumentTranslation mimeType.
                         * @member {string} mimeType
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @instance
                         */
                        DocumentTranslation.prototype.mimeType = "";
    
                        /**
                         * DocumentTranslation detectedLanguageCode.
                         * @member {string} detectedLanguageCode
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @instance
                         */
                        DocumentTranslation.prototype.detectedLanguageCode = "";
    
                        /**
                         * Creates a new DocumentTranslation instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDocumentTranslation=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.DocumentTranslation} DocumentTranslation instance
                         */
                        DocumentTranslation.create = function create(properties) {
                            return new DocumentTranslation(properties);
                        };
    
                        /**
                         * Encodes the specified DocumentTranslation message. Does not implicitly {@link google.cloud.translation.v3beta1.DocumentTranslation.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDocumentTranslation} message DocumentTranslation message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentTranslation.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.byteStreamOutputs != null && message.byteStreamOutputs.length)
                                for (var i = 0; i < message.byteStreamOutputs.length; ++i)
                                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.byteStreamOutputs[i]);
                            if (message.mimeType != null && Object.hasOwnProperty.call(message, "mimeType"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.mimeType);
                            if (message.detectedLanguageCode != null && Object.hasOwnProperty.call(message, "detectedLanguageCode"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.detectedLanguageCode);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DocumentTranslation message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.DocumentTranslation.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDocumentTranslation} message DocumentTranslation message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DocumentTranslation.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DocumentTranslation message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.DocumentTranslation} DocumentTranslation
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentTranslation.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.DocumentTranslation();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.byteStreamOutputs && message.byteStreamOutputs.length))
                                        message.byteStreamOutputs = [];
                                    message.byteStreamOutputs.push(reader.bytes());
                                    break;
                                case 2:
                                    message.mimeType = reader.string();
                                    break;
                                case 3:
                                    message.detectedLanguageCode = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DocumentTranslation message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.DocumentTranslation} DocumentTranslation
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DocumentTranslation.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DocumentTranslation message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DocumentTranslation.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.byteStreamOutputs != null && message.hasOwnProperty("byteStreamOutputs")) {
                                if (!Array.isArray(message.byteStreamOutputs))
                                    return "byteStreamOutputs: array expected";
                                for (var i = 0; i < message.byteStreamOutputs.length; ++i)
                                    if (!(message.byteStreamOutputs[i] && typeof message.byteStreamOutputs[i].length === "number" || $util.isString(message.byteStreamOutputs[i])))
                                        return "byteStreamOutputs: buffer[] expected";
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                if (!$util.isString(message.mimeType))
                                    return "mimeType: string expected";
                            if (message.detectedLanguageCode != null && message.hasOwnProperty("detectedLanguageCode"))
                                if (!$util.isString(message.detectedLanguageCode))
                                    return "detectedLanguageCode: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DocumentTranslation message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.DocumentTranslation} DocumentTranslation
                         */
                        DocumentTranslation.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.DocumentTranslation)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.DocumentTranslation();
                            if (object.byteStreamOutputs) {
                                if (!Array.isArray(object.byteStreamOutputs))
                                    throw TypeError(".google.cloud.translation.v3beta1.DocumentTranslation.byteStreamOutputs: array expected");
                                message.byteStreamOutputs = [];
                                for (var i = 0; i < object.byteStreamOutputs.length; ++i)
                                    if (typeof object.byteStreamOutputs[i] === "string")
                                        $util.base64.decode(object.byteStreamOutputs[i], message.byteStreamOutputs[i] = $util.newBuffer($util.base64.length(object.byteStreamOutputs[i])), 0);
                                    else if (object.byteStreamOutputs[i].length)
                                        message.byteStreamOutputs[i] = object.byteStreamOutputs[i];
                            }
                            if (object.mimeType != null)
                                message.mimeType = String(object.mimeType);
                            if (object.detectedLanguageCode != null)
                                message.detectedLanguageCode = String(object.detectedLanguageCode);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DocumentTranslation message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @static
                         * @param {google.cloud.translation.v3beta1.DocumentTranslation} message DocumentTranslation
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DocumentTranslation.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.byteStreamOutputs = [];
                            if (options.defaults) {
                                object.mimeType = "";
                                object.detectedLanguageCode = "";
                            }
                            if (message.byteStreamOutputs && message.byteStreamOutputs.length) {
                                object.byteStreamOutputs = [];
                                for (var j = 0; j < message.byteStreamOutputs.length; ++j)
                                    object.byteStreamOutputs[j] = options.bytes === String ? $util.base64.encode(message.byteStreamOutputs[j], 0, message.byteStreamOutputs[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.byteStreamOutputs[j]) : message.byteStreamOutputs[j];
                            }
                            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
                                object.mimeType = message.mimeType;
                            if (message.detectedLanguageCode != null && message.hasOwnProperty("detectedLanguageCode"))
                                object.detectedLanguageCode = message.detectedLanguageCode;
                            return object;
                        };
    
                        /**
                         * Converts this DocumentTranslation to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.DocumentTranslation
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DocumentTranslation.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DocumentTranslation;
                    })();
    
                    v3beta1.TranslateDocumentResponse = (function() {
    
                        /**
                         * Properties of a TranslateDocumentResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface ITranslateDocumentResponse
                         * @property {google.cloud.translation.v3beta1.IDocumentTranslation|null} [documentTranslation] TranslateDocumentResponse documentTranslation
                         * @property {google.cloud.translation.v3beta1.IDocumentTranslation|null} [glossaryDocumentTranslation] TranslateDocumentResponse glossaryDocumentTranslation
                         * @property {string|null} [model] TranslateDocumentResponse model
                         * @property {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig|null} [glossaryConfig] TranslateDocumentResponse glossaryConfig
                         */
    
                        /**
                         * Constructs a new TranslateDocumentResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a TranslateDocumentResponse.
                         * @implements ITranslateDocumentResponse
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.ITranslateDocumentResponse=} [properties] Properties to set
                         */
                        function TranslateDocumentResponse(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TranslateDocumentResponse documentTranslation.
                         * @member {google.cloud.translation.v3beta1.IDocumentTranslation|null|undefined} documentTranslation
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @instance
                         */
                        TranslateDocumentResponse.prototype.documentTranslation = null;
    
                        /**
                         * TranslateDocumentResponse glossaryDocumentTranslation.
                         * @member {google.cloud.translation.v3beta1.IDocumentTranslation|null|undefined} glossaryDocumentTranslation
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @instance
                         */
                        TranslateDocumentResponse.prototype.glossaryDocumentTranslation = null;
    
                        /**
                         * TranslateDocumentResponse model.
                         * @member {string} model
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @instance
                         */
                        TranslateDocumentResponse.prototype.model = "";
    
                        /**
                         * TranslateDocumentResponse glossaryConfig.
                         * @member {google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig|null|undefined} glossaryConfig
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @instance
                         */
                        TranslateDocumentResponse.prototype.glossaryConfig = null;
    
                        /**
                         * Creates a new TranslateDocumentResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateDocumentResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.TranslateDocumentResponse} TranslateDocumentResponse instance
                         */
                        TranslateDocumentResponse.create = function create(properties) {
                            return new TranslateDocumentResponse(properties);
                        };
    
                        /**
                         * Encodes the specified TranslateDocumentResponse message. Does not implicitly {@link google.cloud.translation.v3beta1.TranslateDocumentResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateDocumentResponse} message TranslateDocumentResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateDocumentResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.documentTranslation != null && Object.hasOwnProperty.call(message, "documentTranslation"))
                                $root.google.cloud.translation.v3beta1.DocumentTranslation.encode(message.documentTranslation, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.glossaryDocumentTranslation != null && Object.hasOwnProperty.call(message, "glossaryDocumentTranslation"))
                                $root.google.cloud.translation.v3beta1.DocumentTranslation.encode(message.glossaryDocumentTranslation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.model);
                            if (message.glossaryConfig != null && Object.hasOwnProperty.call(message, "glossaryConfig"))
                                $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.encode(message.glossaryConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TranslateDocumentResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.TranslateDocumentResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.ITranslateDocumentResponse} message TranslateDocumentResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TranslateDocumentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TranslateDocumentResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.TranslateDocumentResponse} TranslateDocumentResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateDocumentResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.TranslateDocumentResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.documentTranslation = $root.google.cloud.translation.v3beta1.DocumentTranslation.decode(reader, reader.uint32());
                                    break;
                                case 2:
                                    message.glossaryDocumentTranslation = $root.google.cloud.translation.v3beta1.DocumentTranslation.decode(reader, reader.uint32());
                                    break;
                                case 3:
                                    message.model = reader.string();
                                    break;
                                case 4:
                                    message.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TranslateDocumentResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.TranslateDocumentResponse} TranslateDocumentResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TranslateDocumentResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TranslateDocumentResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TranslateDocumentResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.documentTranslation != null && message.hasOwnProperty("documentTranslation")) {
                                var error = $root.google.cloud.translation.v3beta1.DocumentTranslation.verify(message.documentTranslation);
                                if (error)
                                    return "documentTranslation." + error;
                            }
                            if (message.glossaryDocumentTranslation != null && message.hasOwnProperty("glossaryDocumentTranslation")) {
                                var error = $root.google.cloud.translation.v3beta1.DocumentTranslation.verify(message.glossaryDocumentTranslation);
                                if (error)
                                    return "glossaryDocumentTranslation." + error;
                            }
                            if (message.model != null && message.hasOwnProperty("model"))
                                if (!$util.isString(message.model))
                                    return "model: string expected";
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig")) {
                                var error = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.verify(message.glossaryConfig);
                                if (error)
                                    return "glossaryConfig." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a TranslateDocumentResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.TranslateDocumentResponse} TranslateDocumentResponse
                         */
                        TranslateDocumentResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.TranslateDocumentResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.TranslateDocumentResponse();
                            if (object.documentTranslation != null) {
                                if (typeof object.documentTranslation !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateDocumentResponse.documentTranslation: object expected");
                                message.documentTranslation = $root.google.cloud.translation.v3beta1.DocumentTranslation.fromObject(object.documentTranslation);
                            }
                            if (object.glossaryDocumentTranslation != null) {
                                if (typeof object.glossaryDocumentTranslation !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateDocumentResponse.glossaryDocumentTranslation: object expected");
                                message.glossaryDocumentTranslation = $root.google.cloud.translation.v3beta1.DocumentTranslation.fromObject(object.glossaryDocumentTranslation);
                            }
                            if (object.model != null)
                                message.model = String(object.model);
                            if (object.glossaryConfig != null) {
                                if (typeof object.glossaryConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.TranslateDocumentResponse.glossaryConfig: object expected");
                                message.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.fromObject(object.glossaryConfig);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TranslateDocumentResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.TranslateDocumentResponse} message TranslateDocumentResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TranslateDocumentResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.documentTranslation = null;
                                object.glossaryDocumentTranslation = null;
                                object.model = "";
                                object.glossaryConfig = null;
                            }
                            if (message.documentTranslation != null && message.hasOwnProperty("documentTranslation"))
                                object.documentTranslation = $root.google.cloud.translation.v3beta1.DocumentTranslation.toObject(message.documentTranslation, options);
                            if (message.glossaryDocumentTranslation != null && message.hasOwnProperty("glossaryDocumentTranslation"))
                                object.glossaryDocumentTranslation = $root.google.cloud.translation.v3beta1.DocumentTranslation.toObject(message.glossaryDocumentTranslation, options);
                            if (message.model != null && message.hasOwnProperty("model"))
                                object.model = message.model;
                            if (message.glossaryConfig != null && message.hasOwnProperty("glossaryConfig"))
                                object.glossaryConfig = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.toObject(message.glossaryConfig, options);
                            return object;
                        };
    
                        /**
                         * Converts this TranslateDocumentResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.TranslateDocumentResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TranslateDocumentResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TranslateDocumentResponse;
                    })();
    
                    v3beta1.BatchTranslateTextRequest = (function() {
    
                        /**
                         * Properties of a BatchTranslateTextRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IBatchTranslateTextRequest
                         * @property {string|null} [parent] BatchTranslateTextRequest parent
                         * @property {string|null} [sourceLanguageCode] BatchTranslateTextRequest sourceLanguageCode
                         * @property {Array.<string>|null} [targetLanguageCodes] BatchTranslateTextRequest targetLanguageCodes
                         * @property {Object.<string,string>|null} [models] BatchTranslateTextRequest models
                         * @property {Array.<google.cloud.translation.v3beta1.IInputConfig>|null} [inputConfigs] BatchTranslateTextRequest inputConfigs
                         * @property {google.cloud.translation.v3beta1.IOutputConfig|null} [outputConfig] BatchTranslateTextRequest outputConfig
                         * @property {Object.<string,google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig>|null} [glossaries] BatchTranslateTextRequest glossaries
                         * @property {Object.<string,string>|null} [labels] BatchTranslateTextRequest labels
                         */
    
                        /**
                         * Constructs a new BatchTranslateTextRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a BatchTranslateTextRequest.
                         * @implements IBatchTranslateTextRequest
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateTextRequest=} [properties] Properties to set
                         */
                        function BatchTranslateTextRequest(properties) {
                            this.targetLanguageCodes = [];
                            this.models = {};
                            this.inputConfigs = [];
                            this.glossaries = {};
                            this.labels = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateTextRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.parent = "";
    
                        /**
                         * BatchTranslateTextRequest sourceLanguageCode.
                         * @member {string} sourceLanguageCode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.sourceLanguageCode = "";
    
                        /**
                         * BatchTranslateTextRequest targetLanguageCodes.
                         * @member {Array.<string>} targetLanguageCodes
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.targetLanguageCodes = $util.emptyArray;
    
                        /**
                         * BatchTranslateTextRequest models.
                         * @member {Object.<string,string>} models
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.models = $util.emptyObject;
    
                        /**
                         * BatchTranslateTextRequest inputConfigs.
                         * @member {Array.<google.cloud.translation.v3beta1.IInputConfig>} inputConfigs
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.inputConfigs = $util.emptyArray;
    
                        /**
                         * BatchTranslateTextRequest outputConfig.
                         * @member {google.cloud.translation.v3beta1.IOutputConfig|null|undefined} outputConfig
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.outputConfig = null;
    
                        /**
                         * BatchTranslateTextRequest glossaries.
                         * @member {Object.<string,google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig>} glossaries
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.glossaries = $util.emptyObject;
    
                        /**
                         * BatchTranslateTextRequest labels.
                         * @member {Object.<string,string>} labels
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @instance
                         */
                        BatchTranslateTextRequest.prototype.labels = $util.emptyObject;
    
                        /**
                         * Creates a new BatchTranslateTextRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateTextRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateTextRequest} BatchTranslateTextRequest instance
                         */
                        BatchTranslateTextRequest.create = function create(properties) {
                            return new BatchTranslateTextRequest(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateTextRequest message. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateTextRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateTextRequest} message BatchTranslateTextRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateTextRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                            if (message.sourceLanguageCode != null && Object.hasOwnProperty.call(message, "sourceLanguageCode"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.sourceLanguageCode);
                            if (message.targetLanguageCodes != null && message.targetLanguageCodes.length)
                                for (var i = 0; i < message.targetLanguageCodes.length; ++i)
                                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.targetLanguageCodes[i]);
                            if (message.models != null && Object.hasOwnProperty.call(message, "models"))
                                for (var keys = Object.keys(message.models), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.models[keys[i]]).ldelim();
                            if (message.inputConfigs != null && message.inputConfigs.length)
                                for (var i = 0; i < message.inputConfigs.length; ++i)
                                    $root.google.cloud.translation.v3beta1.InputConfig.encode(message.inputConfigs[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            if (message.outputConfig != null && Object.hasOwnProperty.call(message, "outputConfig"))
                                $root.google.cloud.translation.v3beta1.OutputConfig.encode(message.outputConfig, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                            if (message.glossaries != null && Object.hasOwnProperty.call(message, "glossaries"))
                                for (var keys = Object.keys(message.glossaries), i = 0; i < keys.length; ++i) {
                                    writer.uint32(/* id 7, wireType 2 =*/58).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                                    $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.encode(message.glossaries[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                                }
                            if (message.labels != null && Object.hasOwnProperty.call(message, "labels"))
                                for (var keys = Object.keys(message.labels), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 9, wireType 2 =*/74).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.labels[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateTextRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateTextRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateTextRequest} message BatchTranslateTextRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateTextRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateTextRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateTextRequest} BatchTranslateTextRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateTextRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.BatchTranslateTextRequest(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.parent = reader.string();
                                    break;
                                case 2:
                                    message.sourceLanguageCode = reader.string();
                                    break;
                                case 3:
                                    if (!(message.targetLanguageCodes && message.targetLanguageCodes.length))
                                        message.targetLanguageCodes = [];
                                    message.targetLanguageCodes.push(reader.string());
                                    break;
                                case 4:
                                    if (message.models === $util.emptyObject)
                                        message.models = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.models[key] = value;
                                    break;
                                case 5:
                                    if (!(message.inputConfigs && message.inputConfigs.length))
                                        message.inputConfigs = [];
                                    message.inputConfigs.push($root.google.cloud.translation.v3beta1.InputConfig.decode(reader, reader.uint32()));
                                    break;
                                case 6:
                                    message.outputConfig = $root.google.cloud.translation.v3beta1.OutputConfig.decode(reader, reader.uint32());
                                    break;
                                case 7:
                                    if (message.glossaries === $util.emptyObject)
                                        message.glossaries = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = null;
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.glossaries[key] = value;
                                    break;
                                case 9:
                                    if (message.labels === $util.emptyObject)
                                        message.labels = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.labels[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateTextRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateTextRequest} BatchTranslateTextRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateTextRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateTextRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateTextRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                if (!$util.isString(message.sourceLanguageCode))
                                    return "sourceLanguageCode: string expected";
                            if (message.targetLanguageCodes != null && message.hasOwnProperty("targetLanguageCodes")) {
                                if (!Array.isArray(message.targetLanguageCodes))
                                    return "targetLanguageCodes: array expected";
                                for (var i = 0; i < message.targetLanguageCodes.length; ++i)
                                    if (!$util.isString(message.targetLanguageCodes[i]))
                                        return "targetLanguageCodes: string[] expected";
                            }
                            if (message.models != null && message.hasOwnProperty("models")) {
                                if (!$util.isObject(message.models))
                                    return "models: object expected";
                                var key = Object.keys(message.models);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.models[key[i]]))
                                        return "models: string{k:string} expected";
                            }
                            if (message.inputConfigs != null && message.hasOwnProperty("inputConfigs")) {
                                if (!Array.isArray(message.inputConfigs))
                                    return "inputConfigs: array expected";
                                for (var i = 0; i < message.inputConfigs.length; ++i) {
                                    var error = $root.google.cloud.translation.v3beta1.InputConfig.verify(message.inputConfigs[i]);
                                    if (error)
                                        return "inputConfigs." + error;
                                }
                            }
                            if (message.outputConfig != null && message.hasOwnProperty("outputConfig")) {
                                var error = $root.google.cloud.translation.v3beta1.OutputConfig.verify(message.outputConfig);
                                if (error)
                                    return "outputConfig." + error;
                            }
                            if (message.glossaries != null && message.hasOwnProperty("glossaries")) {
                                if (!$util.isObject(message.glossaries))
                                    return "glossaries: object expected";
                                var key = Object.keys(message.glossaries);
                                for (var i = 0; i < key.length; ++i) {
                                    var error = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.verify(message.glossaries[key[i]]);
                                    if (error)
                                        return "glossaries." + error;
                                }
                            }
                            if (message.labels != null && message.hasOwnProperty("labels")) {
                                if (!$util.isObject(message.labels))
                                    return "labels: object expected";
                                var key = Object.keys(message.labels);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.labels[key[i]]))
                                        return "labels: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateTextRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateTextRequest} BatchTranslateTextRequest
                         */
                        BatchTranslateTextRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.BatchTranslateTextRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.BatchTranslateTextRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.sourceLanguageCode != null)
                                message.sourceLanguageCode = String(object.sourceLanguageCode);
                            if (object.targetLanguageCodes) {
                                if (!Array.isArray(object.targetLanguageCodes))
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateTextRequest.targetLanguageCodes: array expected");
                                message.targetLanguageCodes = [];
                                for (var i = 0; i < object.targetLanguageCodes.length; ++i)
                                    message.targetLanguageCodes[i] = String(object.targetLanguageCodes[i]);
                            }
                            if (object.models) {
                                if (typeof object.models !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateTextRequest.models: object expected");
                                message.models = {};
                                for (var keys = Object.keys(object.models), i = 0; i < keys.length; ++i)
                                    message.models[keys[i]] = String(object.models[keys[i]]);
                            }
                            if (object.inputConfigs) {
                                if (!Array.isArray(object.inputConfigs))
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateTextRequest.inputConfigs: array expected");
                                message.inputConfigs = [];
                                for (var i = 0; i < object.inputConfigs.length; ++i) {
                                    if (typeof object.inputConfigs[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateTextRequest.inputConfigs: object expected");
                                    message.inputConfigs[i] = $root.google.cloud.translation.v3beta1.InputConfig.fromObject(object.inputConfigs[i]);
                                }
                            }
                            if (object.outputConfig != null) {
                                if (typeof object.outputConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateTextRequest.outputConfig: object expected");
                                message.outputConfig = $root.google.cloud.translation.v3beta1.OutputConfig.fromObject(object.outputConfig);
                            }
                            if (object.glossaries) {
                                if (typeof object.glossaries !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateTextRequest.glossaries: object expected");
                                message.glossaries = {};
                                for (var keys = Object.keys(object.glossaries), i = 0; i < keys.length; ++i) {
                                    if (typeof object.glossaries[keys[i]] !== "object")
                                        throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateTextRequest.glossaries: object expected");
                                    message.glossaries[keys[i]] = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.fromObject(object.glossaries[keys[i]]);
                                }
                            }
                            if (object.labels) {
                                if (typeof object.labels !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateTextRequest.labels: object expected");
                                message.labels = {};
                                for (var keys = Object.keys(object.labels), i = 0; i < keys.length; ++i)
                                    message.labels[keys[i]] = String(object.labels[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateTextRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.BatchTranslateTextRequest} message BatchTranslateTextRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateTextRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.targetLanguageCodes = [];
                                object.inputConfigs = [];
                            }
                            if (options.objects || options.defaults) {
                                object.models = {};
                                object.glossaries = {};
                                object.labels = {};
                            }
                            if (options.defaults) {
                                object.parent = "";
                                object.sourceLanguageCode = "";
                                object.outputConfig = null;
                            }
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                object.sourceLanguageCode = message.sourceLanguageCode;
                            if (message.targetLanguageCodes && message.targetLanguageCodes.length) {
                                object.targetLanguageCodes = [];
                                for (var j = 0; j < message.targetLanguageCodes.length; ++j)
                                    object.targetLanguageCodes[j] = message.targetLanguageCodes[j];
                            }
                            var keys2;
                            if (message.models && (keys2 = Object.keys(message.models)).length) {
                                object.models = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.models[keys2[j]] = message.models[keys2[j]];
                            }
                            if (message.inputConfigs && message.inputConfigs.length) {
                                object.inputConfigs = [];
                                for (var j = 0; j < message.inputConfigs.length; ++j)
                                    object.inputConfigs[j] = $root.google.cloud.translation.v3beta1.InputConfig.toObject(message.inputConfigs[j], options);
                            }
                            if (message.outputConfig != null && message.hasOwnProperty("outputConfig"))
                                object.outputConfig = $root.google.cloud.translation.v3beta1.OutputConfig.toObject(message.outputConfig, options);
                            if (message.glossaries && (keys2 = Object.keys(message.glossaries)).length) {
                                object.glossaries = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.glossaries[keys2[j]] = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.toObject(message.glossaries[keys2[j]], options);
                            }
                            if (message.labels && (keys2 = Object.keys(message.labels)).length) {
                                object.labels = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.labels[keys2[j]] = message.labels[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateTextRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateTextRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateTextRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchTranslateTextRequest;
                    })();
    
                    v3beta1.BatchTranslateMetadata = (function() {
    
                        /**
                         * Properties of a BatchTranslateMetadata.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IBatchTranslateMetadata
                         * @property {google.cloud.translation.v3beta1.BatchTranslateMetadata.State|null} [state] BatchTranslateMetadata state
                         * @property {number|Long|null} [translatedCharacters] BatchTranslateMetadata translatedCharacters
                         * @property {number|Long|null} [failedCharacters] BatchTranslateMetadata failedCharacters
                         * @property {number|Long|null} [totalCharacters] BatchTranslateMetadata totalCharacters
                         * @property {google.protobuf.ITimestamp|null} [submitTime] BatchTranslateMetadata submitTime
                         */
    
                        /**
                         * Constructs a new BatchTranslateMetadata.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a BatchTranslateMetadata.
                         * @implements IBatchTranslateMetadata
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateMetadata=} [properties] Properties to set
                         */
                        function BatchTranslateMetadata(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateMetadata state.
                         * @member {google.cloud.translation.v3beta1.BatchTranslateMetadata.State} state
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @instance
                         */
                        BatchTranslateMetadata.prototype.state = 0;
    
                        /**
                         * BatchTranslateMetadata translatedCharacters.
                         * @member {number|Long} translatedCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @instance
                         */
                        BatchTranslateMetadata.prototype.translatedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateMetadata failedCharacters.
                         * @member {number|Long} failedCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @instance
                         */
                        BatchTranslateMetadata.prototype.failedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateMetadata totalCharacters.
                         * @member {number|Long} totalCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @instance
                         */
                        BatchTranslateMetadata.prototype.totalCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateMetadata submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @instance
                         */
                        BatchTranslateMetadata.prototype.submitTime = null;
    
                        /**
                         * Creates a new BatchTranslateMetadata instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateMetadata=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateMetadata} BatchTranslateMetadata instance
                         */
                        BatchTranslateMetadata.create = function create(properties) {
                            return new BatchTranslateMetadata(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateMetadata message. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateMetadata.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateMetadata} message BatchTranslateMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateMetadata.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                            if (message.translatedCharacters != null && Object.hasOwnProperty.call(message, "translatedCharacters"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.translatedCharacters);
                            if (message.failedCharacters != null && Object.hasOwnProperty.call(message, "failedCharacters"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.failedCharacters);
                            if (message.totalCharacters != null && Object.hasOwnProperty.call(message, "totalCharacters"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.totalCharacters);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateMetadata message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateMetadata.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateMetadata} message BatchTranslateMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateMetadata message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateMetadata} BatchTranslateMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateMetadata.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.BatchTranslateMetadata();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.state = reader.int32();
                                    break;
                                case 2:
                                    message.translatedCharacters = reader.int64();
                                    break;
                                case 3:
                                    message.failedCharacters = reader.int64();
                                    break;
                                case 4:
                                    message.totalCharacters = reader.int64();
                                    break;
                                case 5:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateMetadata message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateMetadata} BatchTranslateMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateMetadata.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateMetadata message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateMetadata.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.state != null && message.hasOwnProperty("state"))
                                switch (message.state) {
                                default:
                                    return "state: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (!$util.isInteger(message.translatedCharacters) && !(message.translatedCharacters && $util.isInteger(message.translatedCharacters.low) && $util.isInteger(message.translatedCharacters.high)))
                                    return "translatedCharacters: integer|Long expected";
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (!$util.isInteger(message.failedCharacters) && !(message.failedCharacters && $util.isInteger(message.failedCharacters.low) && $util.isInteger(message.failedCharacters.high)))
                                    return "failedCharacters: integer|Long expected";
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (!$util.isInteger(message.totalCharacters) && !(message.totalCharacters && $util.isInteger(message.totalCharacters.low) && $util.isInteger(message.totalCharacters.high)))
                                    return "totalCharacters: integer|Long expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateMetadata message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateMetadata} BatchTranslateMetadata
                         */
                        BatchTranslateMetadata.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.BatchTranslateMetadata)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.BatchTranslateMetadata();
                            switch (object.state) {
                            case "STATE_UNSPECIFIED":
                            case 0:
                                message.state = 0;
                                break;
                            case "RUNNING":
                            case 1:
                                message.state = 1;
                                break;
                            case "SUCCEEDED":
                            case 2:
                                message.state = 2;
                                break;
                            case "FAILED":
                            case 3:
                                message.state = 3;
                                break;
                            case "CANCELLING":
                            case 4:
                                message.state = 4;
                                break;
                            case "CANCELLED":
                            case 5:
                                message.state = 5;
                                break;
                            }
                            if (object.translatedCharacters != null)
                                if ($util.Long)
                                    (message.translatedCharacters = $util.Long.fromValue(object.translatedCharacters)).unsigned = false;
                                else if (typeof object.translatedCharacters === "string")
                                    message.translatedCharacters = parseInt(object.translatedCharacters, 10);
                                else if (typeof object.translatedCharacters === "number")
                                    message.translatedCharacters = object.translatedCharacters;
                                else if (typeof object.translatedCharacters === "object")
                                    message.translatedCharacters = new $util.LongBits(object.translatedCharacters.low >>> 0, object.translatedCharacters.high >>> 0).toNumber();
                            if (object.failedCharacters != null)
                                if ($util.Long)
                                    (message.failedCharacters = $util.Long.fromValue(object.failedCharacters)).unsigned = false;
                                else if (typeof object.failedCharacters === "string")
                                    message.failedCharacters = parseInt(object.failedCharacters, 10);
                                else if (typeof object.failedCharacters === "number")
                                    message.failedCharacters = object.failedCharacters;
                                else if (typeof object.failedCharacters === "object")
                                    message.failedCharacters = new $util.LongBits(object.failedCharacters.low >>> 0, object.failedCharacters.high >>> 0).toNumber();
                            if (object.totalCharacters != null)
                                if ($util.Long)
                                    (message.totalCharacters = $util.Long.fromValue(object.totalCharacters)).unsigned = false;
                                else if (typeof object.totalCharacters === "string")
                                    message.totalCharacters = parseInt(object.totalCharacters, 10);
                                else if (typeof object.totalCharacters === "number")
                                    message.totalCharacters = object.totalCharacters;
                                else if (typeof object.totalCharacters === "object")
                                    message.totalCharacters = new $util.LongBits(object.totalCharacters.low >>> 0, object.totalCharacters.high >>> 0).toNumber();
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateMetadata.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateMetadata message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.BatchTranslateMetadata} message BatchTranslateMetadata
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateMetadata.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalCharacters = options.longs === String ? "0" : 0;
                                object.submitTime = null;
                            }
                            if (message.state != null && message.hasOwnProperty("state"))
                                object.state = options.enums === String ? $root.google.cloud.translation.v3beta1.BatchTranslateMetadata.State[message.state] : message.state;
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (typeof message.translatedCharacters === "number")
                                    object.translatedCharacters = options.longs === String ? String(message.translatedCharacters) : message.translatedCharacters;
                                else
                                    object.translatedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.translatedCharacters) : options.longs === Number ? new $util.LongBits(message.translatedCharacters.low >>> 0, message.translatedCharacters.high >>> 0).toNumber() : message.translatedCharacters;
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (typeof message.failedCharacters === "number")
                                    object.failedCharacters = options.longs === String ? String(message.failedCharacters) : message.failedCharacters;
                                else
                                    object.failedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.failedCharacters) : options.longs === Number ? new $util.LongBits(message.failedCharacters.low >>> 0, message.failedCharacters.high >>> 0).toNumber() : message.failedCharacters;
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (typeof message.totalCharacters === "number")
                                    object.totalCharacters = options.longs === String ? String(message.totalCharacters) : message.totalCharacters;
                                else
                                    object.totalCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalCharacters) : options.longs === Number ? new $util.LongBits(message.totalCharacters.low >>> 0, message.totalCharacters.high >>> 0).toNumber() : message.totalCharacters;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateMetadata to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateMetadata
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateMetadata.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * State enum.
                         * @name google.cloud.translation.v3beta1.BatchTranslateMetadata.State
                         * @enum {number}
                         * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                         * @property {number} RUNNING=1 RUNNING value
                         * @property {number} SUCCEEDED=2 SUCCEEDED value
                         * @property {number} FAILED=3 FAILED value
                         * @property {number} CANCELLING=4 CANCELLING value
                         * @property {number} CANCELLED=5 CANCELLED value
                         */
                        BatchTranslateMetadata.State = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "RUNNING"] = 1;
                            values[valuesById[2] = "SUCCEEDED"] = 2;
                            values[valuesById[3] = "FAILED"] = 3;
                            values[valuesById[4] = "CANCELLING"] = 4;
                            values[valuesById[5] = "CANCELLED"] = 5;
                            return values;
                        })();
    
                        return BatchTranslateMetadata;
                    })();
    
                    v3beta1.BatchTranslateResponse = (function() {
    
                        /**
                         * Properties of a BatchTranslateResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IBatchTranslateResponse
                         * @property {number|Long|null} [totalCharacters] BatchTranslateResponse totalCharacters
                         * @property {number|Long|null} [translatedCharacters] BatchTranslateResponse translatedCharacters
                         * @property {number|Long|null} [failedCharacters] BatchTranslateResponse failedCharacters
                         * @property {google.protobuf.ITimestamp|null} [submitTime] BatchTranslateResponse submitTime
                         * @property {google.protobuf.ITimestamp|null} [endTime] BatchTranslateResponse endTime
                         */
    
                        /**
                         * Constructs a new BatchTranslateResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a BatchTranslateResponse.
                         * @implements IBatchTranslateResponse
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateResponse=} [properties] Properties to set
                         */
                        function BatchTranslateResponse(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateResponse totalCharacters.
                         * @member {number|Long} totalCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @instance
                         */
                        BatchTranslateResponse.prototype.totalCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateResponse translatedCharacters.
                         * @member {number|Long} translatedCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @instance
                         */
                        BatchTranslateResponse.prototype.translatedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateResponse failedCharacters.
                         * @member {number|Long} failedCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @instance
                         */
                        BatchTranslateResponse.prototype.failedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateResponse submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @instance
                         */
                        BatchTranslateResponse.prototype.submitTime = null;
    
                        /**
                         * BatchTranslateResponse endTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} endTime
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @instance
                         */
                        BatchTranslateResponse.prototype.endTime = null;
    
                        /**
                         * Creates a new BatchTranslateResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateResponse} BatchTranslateResponse instance
                         */
                        BatchTranslateResponse.create = function create(properties) {
                            return new BatchTranslateResponse(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateResponse message. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateResponse} message BatchTranslateResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.totalCharacters != null && Object.hasOwnProperty.call(message, "totalCharacters"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.totalCharacters);
                            if (message.translatedCharacters != null && Object.hasOwnProperty.call(message, "translatedCharacters"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.translatedCharacters);
                            if (message.failedCharacters != null && Object.hasOwnProperty.call(message, "failedCharacters"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.failedCharacters);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                $root.google.protobuf.Timestamp.encode(message.endTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateResponse} message BatchTranslateResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateResponse} BatchTranslateResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.BatchTranslateResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.totalCharacters = reader.int64();
                                    break;
                                case 2:
                                    message.translatedCharacters = reader.int64();
                                    break;
                                case 3:
                                    message.failedCharacters = reader.int64();
                                    break;
                                case 4:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                case 5:
                                    message.endTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateResponse} BatchTranslateResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (!$util.isInteger(message.totalCharacters) && !(message.totalCharacters && $util.isInteger(message.totalCharacters.low) && $util.isInteger(message.totalCharacters.high)))
                                    return "totalCharacters: integer|Long expected";
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (!$util.isInteger(message.translatedCharacters) && !(message.translatedCharacters && $util.isInteger(message.translatedCharacters.low) && $util.isInteger(message.translatedCharacters.high)))
                                    return "translatedCharacters: integer|Long expected";
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (!$util.isInteger(message.failedCharacters) && !(message.failedCharacters && $util.isInteger(message.failedCharacters.low) && $util.isInteger(message.failedCharacters.high)))
                                    return "failedCharacters: integer|Long expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            if (message.endTime != null && message.hasOwnProperty("endTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.endTime);
                                if (error)
                                    return "endTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateResponse} BatchTranslateResponse
                         */
                        BatchTranslateResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.BatchTranslateResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.BatchTranslateResponse();
                            if (object.totalCharacters != null)
                                if ($util.Long)
                                    (message.totalCharacters = $util.Long.fromValue(object.totalCharacters)).unsigned = false;
                                else if (typeof object.totalCharacters === "string")
                                    message.totalCharacters = parseInt(object.totalCharacters, 10);
                                else if (typeof object.totalCharacters === "number")
                                    message.totalCharacters = object.totalCharacters;
                                else if (typeof object.totalCharacters === "object")
                                    message.totalCharacters = new $util.LongBits(object.totalCharacters.low >>> 0, object.totalCharacters.high >>> 0).toNumber();
                            if (object.translatedCharacters != null)
                                if ($util.Long)
                                    (message.translatedCharacters = $util.Long.fromValue(object.translatedCharacters)).unsigned = false;
                                else if (typeof object.translatedCharacters === "string")
                                    message.translatedCharacters = parseInt(object.translatedCharacters, 10);
                                else if (typeof object.translatedCharacters === "number")
                                    message.translatedCharacters = object.translatedCharacters;
                                else if (typeof object.translatedCharacters === "object")
                                    message.translatedCharacters = new $util.LongBits(object.translatedCharacters.low >>> 0, object.translatedCharacters.high >>> 0).toNumber();
                            if (object.failedCharacters != null)
                                if ($util.Long)
                                    (message.failedCharacters = $util.Long.fromValue(object.failedCharacters)).unsigned = false;
                                else if (typeof object.failedCharacters === "string")
                                    message.failedCharacters = parseInt(object.failedCharacters, 10);
                                else if (typeof object.failedCharacters === "number")
                                    message.failedCharacters = object.failedCharacters;
                                else if (typeof object.failedCharacters === "object")
                                    message.failedCharacters = new $util.LongBits(object.failedCharacters.low >>> 0, object.failedCharacters.high >>> 0).toNumber();
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateResponse.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            if (object.endTime != null) {
                                if (typeof object.endTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateResponse.endTime: object expected");
                                message.endTime = $root.google.protobuf.Timestamp.fromObject(object.endTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.BatchTranslateResponse} message BatchTranslateResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedCharacters = options.longs === String ? "0" : 0;
                                object.submitTime = null;
                                object.endTime = null;
                            }
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (typeof message.totalCharacters === "number")
                                    object.totalCharacters = options.longs === String ? String(message.totalCharacters) : message.totalCharacters;
                                else
                                    object.totalCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalCharacters) : options.longs === Number ? new $util.LongBits(message.totalCharacters.low >>> 0, message.totalCharacters.high >>> 0).toNumber() : message.totalCharacters;
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (typeof message.translatedCharacters === "number")
                                    object.translatedCharacters = options.longs === String ? String(message.translatedCharacters) : message.translatedCharacters;
                                else
                                    object.translatedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.translatedCharacters) : options.longs === Number ? new $util.LongBits(message.translatedCharacters.low >>> 0, message.translatedCharacters.high >>> 0).toNumber() : message.translatedCharacters;
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (typeof message.failedCharacters === "number")
                                    object.failedCharacters = options.longs === String ? String(message.failedCharacters) : message.failedCharacters;
                                else
                                    object.failedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.failedCharacters) : options.longs === Number ? new $util.LongBits(message.failedCharacters.low >>> 0, message.failedCharacters.high >>> 0).toNumber() : message.failedCharacters;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                object.endTime = $root.google.protobuf.Timestamp.toObject(message.endTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchTranslateResponse;
                    })();
    
                    v3beta1.GlossaryInputConfig = (function() {
    
                        /**
                         * Properties of a GlossaryInputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IGlossaryInputConfig
                         * @property {google.cloud.translation.v3beta1.IGcsSource|null} [gcsSource] GlossaryInputConfig gcsSource
                         */
    
                        /**
                         * Constructs a new GlossaryInputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a GlossaryInputConfig.
                         * @implements IGlossaryInputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IGlossaryInputConfig=} [properties] Properties to set
                         */
                        function GlossaryInputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GlossaryInputConfig gcsSource.
                         * @member {google.cloud.translation.v3beta1.IGcsSource|null|undefined} gcsSource
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @instance
                         */
                        GlossaryInputConfig.prototype.gcsSource = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * GlossaryInputConfig source.
                         * @member {"gcsSource"|undefined} source
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @instance
                         */
                        Object.defineProperty(GlossaryInputConfig.prototype, "source", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsSource"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new GlossaryInputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGlossaryInputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.GlossaryInputConfig} GlossaryInputConfig instance
                         */
                        GlossaryInputConfig.create = function create(properties) {
                            return new GlossaryInputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified GlossaryInputConfig message. Does not implicitly {@link google.cloud.translation.v3beta1.GlossaryInputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGlossaryInputConfig} message GlossaryInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GlossaryInputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.gcsSource != null && Object.hasOwnProperty.call(message, "gcsSource"))
                                $root.google.cloud.translation.v3beta1.GcsSource.encode(message.gcsSource, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GlossaryInputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.GlossaryInputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGlossaryInputConfig} message GlossaryInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GlossaryInputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GlossaryInputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.GlossaryInputConfig} GlossaryInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GlossaryInputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.GlossaryInputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GlossaryInputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.GlossaryInputConfig} GlossaryInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GlossaryInputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GlossaryInputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GlossaryInputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                properties.source = 1;
                                {
                                    var error = $root.google.cloud.translation.v3beta1.GcsSource.verify(message.gcsSource);
                                    if (error)
                                        return "gcsSource." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a GlossaryInputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.GlossaryInputConfig} GlossaryInputConfig
                         */
                        GlossaryInputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.GlossaryInputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.GlossaryInputConfig();
                            if (object.gcsSource != null) {
                                if (typeof object.gcsSource !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.GlossaryInputConfig.gcsSource: object expected");
                                message.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.fromObject(object.gcsSource);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GlossaryInputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.GlossaryInputConfig} message GlossaryInputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GlossaryInputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                object.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.toObject(message.gcsSource, options);
                                if (options.oneofs)
                                    object.source = "gcsSource";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this GlossaryInputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.GlossaryInputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GlossaryInputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GlossaryInputConfig;
                    })();
    
                    v3beta1.Glossary = (function() {
    
                        /**
                         * Properties of a Glossary.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IGlossary
                         * @property {string|null} [name] Glossary name
                         * @property {google.cloud.translation.v3beta1.Glossary.ILanguageCodePair|null} [languagePair] Glossary languagePair
                         * @property {google.cloud.translation.v3beta1.Glossary.ILanguageCodesSet|null} [languageCodesSet] Glossary languageCodesSet
                         * @property {google.cloud.translation.v3beta1.IGlossaryInputConfig|null} [inputConfig] Glossary inputConfig
                         * @property {number|null} [entryCount] Glossary entryCount
                         * @property {google.protobuf.ITimestamp|null} [submitTime] Glossary submitTime
                         * @property {google.protobuf.ITimestamp|null} [endTime] Glossary endTime
                         */
    
                        /**
                         * Constructs a new Glossary.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a Glossary.
                         * @implements IGlossary
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IGlossary=} [properties] Properties to set
                         */
                        function Glossary(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Glossary name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @instance
                         */
                        Glossary.prototype.name = "";
    
                        /**
                         * Glossary languagePair.
                         * @member {google.cloud.translation.v3beta1.Glossary.ILanguageCodePair|null|undefined} languagePair
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @instance
                         */
                        Glossary.prototype.languagePair = null;
    
                        /**
                         * Glossary languageCodesSet.
                         * @member {google.cloud.translation.v3beta1.Glossary.ILanguageCodesSet|null|undefined} languageCodesSet
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @instance
                         */
                        Glossary.prototype.languageCodesSet = null;
    
                        /**
                         * Glossary inputConfig.
                         * @member {google.cloud.translation.v3beta1.IGlossaryInputConfig|null|undefined} inputConfig
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @instance
                         */
                        Glossary.prototype.inputConfig = null;
    
                        /**
                         * Glossary entryCount.
                         * @member {number} entryCount
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @instance
                         */
                        Glossary.prototype.entryCount = 0;
    
                        /**
                         * Glossary submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @instance
                         */
                        Glossary.prototype.submitTime = null;
    
                        /**
                         * Glossary endTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} endTime
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @instance
                         */
                        Glossary.prototype.endTime = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * Glossary languages.
                         * @member {"languagePair"|"languageCodesSet"|undefined} languages
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @instance
                         */
                        Object.defineProperty(Glossary.prototype, "languages", {
                            get: $util.oneOfGetter($oneOfFields = ["languagePair", "languageCodesSet"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new Glossary instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGlossary=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.Glossary} Glossary instance
                         */
                        Glossary.create = function create(properties) {
                            return new Glossary(properties);
                        };
    
                        /**
                         * Encodes the specified Glossary message. Does not implicitly {@link google.cloud.translation.v3beta1.Glossary.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGlossary} message Glossary message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Glossary.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            if (message.languagePair != null && Object.hasOwnProperty.call(message, "languagePair"))
                                $root.google.cloud.translation.v3beta1.Glossary.LanguageCodePair.encode(message.languagePair, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            if (message.languageCodesSet != null && Object.hasOwnProperty.call(message, "languageCodesSet"))
                                $root.google.cloud.translation.v3beta1.Glossary.LanguageCodesSet.encode(message.languageCodesSet, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            if (message.inputConfig != null && Object.hasOwnProperty.call(message, "inputConfig"))
                                $root.google.cloud.translation.v3beta1.GlossaryInputConfig.encode(message.inputConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            if (message.entryCount != null && Object.hasOwnProperty.call(message, "entryCount"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.entryCount);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                $root.google.protobuf.Timestamp.encode(message.endTime, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Glossary message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.Glossary.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGlossary} message Glossary message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Glossary.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Glossary message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.Glossary} Glossary
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Glossary.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.Glossary();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                case 3:
                                    message.languagePair = $root.google.cloud.translation.v3beta1.Glossary.LanguageCodePair.decode(reader, reader.uint32());
                                    break;
                                case 4:
                                    message.languageCodesSet = $root.google.cloud.translation.v3beta1.Glossary.LanguageCodesSet.decode(reader, reader.uint32());
                                    break;
                                case 5:
                                    message.inputConfig = $root.google.cloud.translation.v3beta1.GlossaryInputConfig.decode(reader, reader.uint32());
                                    break;
                                case 6:
                                    message.entryCount = reader.int32();
                                    break;
                                case 7:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                case 8:
                                    message.endTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Glossary message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.Glossary} Glossary
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Glossary.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Glossary message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Glossary.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.languagePair != null && message.hasOwnProperty("languagePair")) {
                                properties.languages = 1;
                                {
                                    var error = $root.google.cloud.translation.v3beta1.Glossary.LanguageCodePair.verify(message.languagePair);
                                    if (error)
                                        return "languagePair." + error;
                                }
                            }
                            if (message.languageCodesSet != null && message.hasOwnProperty("languageCodesSet")) {
                                if (properties.languages === 1)
                                    return "languages: multiple values";
                                properties.languages = 1;
                                {
                                    var error = $root.google.cloud.translation.v3beta1.Glossary.LanguageCodesSet.verify(message.languageCodesSet);
                                    if (error)
                                        return "languageCodesSet." + error;
                                }
                            }
                            if (message.inputConfig != null && message.hasOwnProperty("inputConfig")) {
                                var error = $root.google.cloud.translation.v3beta1.GlossaryInputConfig.verify(message.inputConfig);
                                if (error)
                                    return "inputConfig." + error;
                            }
                            if (message.entryCount != null && message.hasOwnProperty("entryCount"))
                                if (!$util.isInteger(message.entryCount))
                                    return "entryCount: integer expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            if (message.endTime != null && message.hasOwnProperty("endTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.endTime);
                                if (error)
                                    return "endTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Glossary message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.Glossary} Glossary
                         */
                        Glossary.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.Glossary)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.Glossary();
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.languagePair != null) {
                                if (typeof object.languagePair !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.Glossary.languagePair: object expected");
                                message.languagePair = $root.google.cloud.translation.v3beta1.Glossary.LanguageCodePair.fromObject(object.languagePair);
                            }
                            if (object.languageCodesSet != null) {
                                if (typeof object.languageCodesSet !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.Glossary.languageCodesSet: object expected");
                                message.languageCodesSet = $root.google.cloud.translation.v3beta1.Glossary.LanguageCodesSet.fromObject(object.languageCodesSet);
                            }
                            if (object.inputConfig != null) {
                                if (typeof object.inputConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.Glossary.inputConfig: object expected");
                                message.inputConfig = $root.google.cloud.translation.v3beta1.GlossaryInputConfig.fromObject(object.inputConfig);
                            }
                            if (object.entryCount != null)
                                message.entryCount = object.entryCount | 0;
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.Glossary.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            if (object.endTime != null) {
                                if (typeof object.endTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.Glossary.endTime: object expected");
                                message.endTime = $root.google.protobuf.Timestamp.fromObject(object.endTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Glossary message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @static
                         * @param {google.cloud.translation.v3beta1.Glossary} message Glossary
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Glossary.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.name = "";
                                object.inputConfig = null;
                                object.entryCount = 0;
                                object.submitTime = null;
                                object.endTime = null;
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.languagePair != null && message.hasOwnProperty("languagePair")) {
                                object.languagePair = $root.google.cloud.translation.v3beta1.Glossary.LanguageCodePair.toObject(message.languagePair, options);
                                if (options.oneofs)
                                    object.languages = "languagePair";
                            }
                            if (message.languageCodesSet != null && message.hasOwnProperty("languageCodesSet")) {
                                object.languageCodesSet = $root.google.cloud.translation.v3beta1.Glossary.LanguageCodesSet.toObject(message.languageCodesSet, options);
                                if (options.oneofs)
                                    object.languages = "languageCodesSet";
                            }
                            if (message.inputConfig != null && message.hasOwnProperty("inputConfig"))
                                object.inputConfig = $root.google.cloud.translation.v3beta1.GlossaryInputConfig.toObject(message.inputConfig, options);
                            if (message.entryCount != null && message.hasOwnProperty("entryCount"))
                                object.entryCount = message.entryCount;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                object.endTime = $root.google.protobuf.Timestamp.toObject(message.endTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this Glossary to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.Glossary
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Glossary.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        Glossary.LanguageCodePair = (function() {
    
                            /**
                             * Properties of a LanguageCodePair.
                             * @memberof google.cloud.translation.v3beta1.Glossary
                             * @interface ILanguageCodePair
                             * @property {string|null} [sourceLanguageCode] LanguageCodePair sourceLanguageCode
                             * @property {string|null} [targetLanguageCode] LanguageCodePair targetLanguageCode
                             */
    
                            /**
                             * Constructs a new LanguageCodePair.
                             * @memberof google.cloud.translation.v3beta1.Glossary
                             * @classdesc Represents a LanguageCodePair.
                             * @implements ILanguageCodePair
                             * @constructor
                             * @param {google.cloud.translation.v3beta1.Glossary.ILanguageCodePair=} [properties] Properties to set
                             */
                            function LanguageCodePair(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * LanguageCodePair sourceLanguageCode.
                             * @member {string} sourceLanguageCode
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @instance
                             */
                            LanguageCodePair.prototype.sourceLanguageCode = "";
    
                            /**
                             * LanguageCodePair targetLanguageCode.
                             * @member {string} targetLanguageCode
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @instance
                             */
                            LanguageCodePair.prototype.targetLanguageCode = "";
    
                            /**
                             * Creates a new LanguageCodePair instance using the specified properties.
                             * @function create
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @static
                             * @param {google.cloud.translation.v3beta1.Glossary.ILanguageCodePair=} [properties] Properties to set
                             * @returns {google.cloud.translation.v3beta1.Glossary.LanguageCodePair} LanguageCodePair instance
                             */
                            LanguageCodePair.create = function create(properties) {
                                return new LanguageCodePair(properties);
                            };
    
                            /**
                             * Encodes the specified LanguageCodePair message. Does not implicitly {@link google.cloud.translation.v3beta1.Glossary.LanguageCodePair.verify|verify} messages.
                             * @function encode
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @static
                             * @param {google.cloud.translation.v3beta1.Glossary.ILanguageCodePair} message LanguageCodePair message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            LanguageCodePair.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.sourceLanguageCode != null && Object.hasOwnProperty.call(message, "sourceLanguageCode"))
                                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.sourceLanguageCode);
                                if (message.targetLanguageCode != null && Object.hasOwnProperty.call(message, "targetLanguageCode"))
                                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.targetLanguageCode);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified LanguageCodePair message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.Glossary.LanguageCodePair.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @static
                             * @param {google.cloud.translation.v3beta1.Glossary.ILanguageCodePair} message LanguageCodePair message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            LanguageCodePair.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a LanguageCodePair message from the specified reader or buffer.
                             * @function decode
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {google.cloud.translation.v3beta1.Glossary.LanguageCodePair} LanguageCodePair
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            LanguageCodePair.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.Glossary.LanguageCodePair();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        message.sourceLanguageCode = reader.string();
                                        break;
                                    case 2:
                                        message.targetLanguageCode = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a LanguageCodePair message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {google.cloud.translation.v3beta1.Glossary.LanguageCodePair} LanguageCodePair
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            LanguageCodePair.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a LanguageCodePair message.
                             * @function verify
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            LanguageCodePair.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                    if (!$util.isString(message.sourceLanguageCode))
                                        return "sourceLanguageCode: string expected";
                                if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                    if (!$util.isString(message.targetLanguageCode))
                                        return "targetLanguageCode: string expected";
                                return null;
                            };
    
                            /**
                             * Creates a LanguageCodePair message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {google.cloud.translation.v3beta1.Glossary.LanguageCodePair} LanguageCodePair
                             */
                            LanguageCodePair.fromObject = function fromObject(object) {
                                if (object instanceof $root.google.cloud.translation.v3beta1.Glossary.LanguageCodePair)
                                    return object;
                                var message = new $root.google.cloud.translation.v3beta1.Glossary.LanguageCodePair();
                                if (object.sourceLanguageCode != null)
                                    message.sourceLanguageCode = String(object.sourceLanguageCode);
                                if (object.targetLanguageCode != null)
                                    message.targetLanguageCode = String(object.targetLanguageCode);
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a LanguageCodePair message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @static
                             * @param {google.cloud.translation.v3beta1.Glossary.LanguageCodePair} message LanguageCodePair
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            LanguageCodePair.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.defaults) {
                                    object.sourceLanguageCode = "";
                                    object.targetLanguageCode = "";
                                }
                                if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                    object.sourceLanguageCode = message.sourceLanguageCode;
                                if (message.targetLanguageCode != null && message.hasOwnProperty("targetLanguageCode"))
                                    object.targetLanguageCode = message.targetLanguageCode;
                                return object;
                            };
    
                            /**
                             * Converts this LanguageCodePair to JSON.
                             * @function toJSON
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodePair
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            LanguageCodePair.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return LanguageCodePair;
                        })();
    
                        Glossary.LanguageCodesSet = (function() {
    
                            /**
                             * Properties of a LanguageCodesSet.
                             * @memberof google.cloud.translation.v3beta1.Glossary
                             * @interface ILanguageCodesSet
                             * @property {Array.<string>|null} [languageCodes] LanguageCodesSet languageCodes
                             */
    
                            /**
                             * Constructs a new LanguageCodesSet.
                             * @memberof google.cloud.translation.v3beta1.Glossary
                             * @classdesc Represents a LanguageCodesSet.
                             * @implements ILanguageCodesSet
                             * @constructor
                             * @param {google.cloud.translation.v3beta1.Glossary.ILanguageCodesSet=} [properties] Properties to set
                             */
                            function LanguageCodesSet(properties) {
                                this.languageCodes = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * LanguageCodesSet languageCodes.
                             * @member {Array.<string>} languageCodes
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodesSet
                             * @instance
                             */
                            LanguageCodesSet.prototype.languageCodes = $util.emptyArray;
    
                            /**
                             * Creates a new LanguageCodesSet instance using the specified properties.
                             * @function create
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodesSet
                             * @static
                             * @param {google.cloud.translation.v3beta1.Glossary.ILanguageCodesSet=} [properties] Properties to set
                             * @returns {google.cloud.translation.v3beta1.Glossary.LanguageCodesSet} LanguageCodesSet instance
                             */
                            LanguageCodesSet.create = function create(properties) {
                                return new LanguageCodesSet(properties);
                            };
    
                            /**
                             * Encodes the specified LanguageCodesSet message. Does not implicitly {@link google.cloud.translation.v3beta1.Glossary.LanguageCodesSet.verify|verify} messages.
                             * @function encode
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodesSet
                             * @static
                             * @param {google.cloud.translation.v3beta1.Glossary.ILanguageCodesSet} message LanguageCodesSet message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            LanguageCodesSet.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.languageCodes != null && message.languageCodes.length)
                                    for (var i = 0; i < message.languageCodes.length; ++i)
                                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.languageCodes[i]);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified LanguageCodesSet message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.Glossary.LanguageCodesSet.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodesSet
                             * @static
                             * @param {google.cloud.translation.v3beta1.Glossary.ILanguageCodesSet} message LanguageCodesSet message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            LanguageCodesSet.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a LanguageCodesSet message from the specified reader or buffer.
                             * @function decode
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodesSet
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {google.cloud.translation.v3beta1.Glossary.LanguageCodesSet} LanguageCodesSet
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            LanguageCodesSet.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.Glossary.LanguageCodesSet();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        if (!(message.languageCodes && message.languageCodes.length))
                                            message.languageCodes = [];
                                        message.languageCodes.push(reader.string());
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a LanguageCodesSet message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodesSet
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {google.cloud.translation.v3beta1.Glossary.LanguageCodesSet} LanguageCodesSet
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            LanguageCodesSet.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a LanguageCodesSet message.
                             * @function verify
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodesSet
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            LanguageCodesSet.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.languageCodes != null && message.hasOwnProperty("languageCodes")) {
                                    if (!Array.isArray(message.languageCodes))
                                        return "languageCodes: array expected";
                                    for (var i = 0; i < message.languageCodes.length; ++i)
                                        if (!$util.isString(message.languageCodes[i]))
                                            return "languageCodes: string[] expected";
                                }
                                return null;
                            };
    
                            /**
                             * Creates a LanguageCodesSet message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodesSet
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {google.cloud.translation.v3beta1.Glossary.LanguageCodesSet} LanguageCodesSet
                             */
                            LanguageCodesSet.fromObject = function fromObject(object) {
                                if (object instanceof $root.google.cloud.translation.v3beta1.Glossary.LanguageCodesSet)
                                    return object;
                                var message = new $root.google.cloud.translation.v3beta1.Glossary.LanguageCodesSet();
                                if (object.languageCodes) {
                                    if (!Array.isArray(object.languageCodes))
                                        throw TypeError(".google.cloud.translation.v3beta1.Glossary.LanguageCodesSet.languageCodes: array expected");
                                    message.languageCodes = [];
                                    for (var i = 0; i < object.languageCodes.length; ++i)
                                        message.languageCodes[i] = String(object.languageCodes[i]);
                                }
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a LanguageCodesSet message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodesSet
                             * @static
                             * @param {google.cloud.translation.v3beta1.Glossary.LanguageCodesSet} message LanguageCodesSet
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            LanguageCodesSet.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.arrays || options.defaults)
                                    object.languageCodes = [];
                                if (message.languageCodes && message.languageCodes.length) {
                                    object.languageCodes = [];
                                    for (var j = 0; j < message.languageCodes.length; ++j)
                                        object.languageCodes[j] = message.languageCodes[j];
                                }
                                return object;
                            };
    
                            /**
                             * Converts this LanguageCodesSet to JSON.
                             * @function toJSON
                             * @memberof google.cloud.translation.v3beta1.Glossary.LanguageCodesSet
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            LanguageCodesSet.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return LanguageCodesSet;
                        })();
    
                        return Glossary;
                    })();
    
                    v3beta1.CreateGlossaryRequest = (function() {
    
                        /**
                         * Properties of a CreateGlossaryRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface ICreateGlossaryRequest
                         * @property {string|null} [parent] CreateGlossaryRequest parent
                         * @property {google.cloud.translation.v3beta1.IGlossary|null} [glossary] CreateGlossaryRequest glossary
                         */
    
                        /**
                         * Constructs a new CreateGlossaryRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a CreateGlossaryRequest.
                         * @implements ICreateGlossaryRequest
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.ICreateGlossaryRequest=} [properties] Properties to set
                         */
                        function CreateGlossaryRequest(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * CreateGlossaryRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @instance
                         */
                        CreateGlossaryRequest.prototype.parent = "";
    
                        /**
                         * CreateGlossaryRequest glossary.
                         * @member {google.cloud.translation.v3beta1.IGlossary|null|undefined} glossary
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @instance
                         */
                        CreateGlossaryRequest.prototype.glossary = null;
    
                        /**
                         * Creates a new CreateGlossaryRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.ICreateGlossaryRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.CreateGlossaryRequest} CreateGlossaryRequest instance
                         */
                        CreateGlossaryRequest.create = function create(properties) {
                            return new CreateGlossaryRequest(properties);
                        };
    
                        /**
                         * Encodes the specified CreateGlossaryRequest message. Does not implicitly {@link google.cloud.translation.v3beta1.CreateGlossaryRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.ICreateGlossaryRequest} message CreateGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CreateGlossaryRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                            if (message.glossary != null && Object.hasOwnProperty.call(message, "glossary"))
                                $root.google.cloud.translation.v3beta1.Glossary.encode(message.glossary, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified CreateGlossaryRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.CreateGlossaryRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.ICreateGlossaryRequest} message CreateGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CreateGlossaryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a CreateGlossaryRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.CreateGlossaryRequest} CreateGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CreateGlossaryRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.CreateGlossaryRequest();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.parent = reader.string();
                                    break;
                                case 2:
                                    message.glossary = $root.google.cloud.translation.v3beta1.Glossary.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a CreateGlossaryRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.CreateGlossaryRequest} CreateGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CreateGlossaryRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a CreateGlossaryRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        CreateGlossaryRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.glossary != null && message.hasOwnProperty("glossary")) {
                                var error = $root.google.cloud.translation.v3beta1.Glossary.verify(message.glossary);
                                if (error)
                                    return "glossary." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a CreateGlossaryRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.CreateGlossaryRequest} CreateGlossaryRequest
                         */
                        CreateGlossaryRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.CreateGlossaryRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.CreateGlossaryRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.glossary != null) {
                                if (typeof object.glossary !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.CreateGlossaryRequest.glossary: object expected");
                                message.glossary = $root.google.cloud.translation.v3beta1.Glossary.fromObject(object.glossary);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a CreateGlossaryRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.CreateGlossaryRequest} message CreateGlossaryRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        CreateGlossaryRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.parent = "";
                                object.glossary = null;
                            }
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            if (message.glossary != null && message.hasOwnProperty("glossary"))
                                object.glossary = $root.google.cloud.translation.v3beta1.Glossary.toObject(message.glossary, options);
                            return object;
                        };
    
                        /**
                         * Converts this CreateGlossaryRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        CreateGlossaryRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return CreateGlossaryRequest;
                    })();
    
                    v3beta1.GetGlossaryRequest = (function() {
    
                        /**
                         * Properties of a GetGlossaryRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IGetGlossaryRequest
                         * @property {string|null} [name] GetGlossaryRequest name
                         */
    
                        /**
                         * Constructs a new GetGlossaryRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a GetGlossaryRequest.
                         * @implements IGetGlossaryRequest
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IGetGlossaryRequest=} [properties] Properties to set
                         */
                        function GetGlossaryRequest(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GetGlossaryRequest name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3beta1.GetGlossaryRequest
                         * @instance
                         */
                        GetGlossaryRequest.prototype.name = "";
    
                        /**
                         * Creates a new GetGlossaryRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.GetGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGetGlossaryRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.GetGlossaryRequest} GetGlossaryRequest instance
                         */
                        GetGlossaryRequest.create = function create(properties) {
                            return new GetGlossaryRequest(properties);
                        };
    
                        /**
                         * Encodes the specified GetGlossaryRequest message. Does not implicitly {@link google.cloud.translation.v3beta1.GetGlossaryRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.GetGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGetGlossaryRequest} message GetGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetGlossaryRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GetGlossaryRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.GetGlossaryRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.GetGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IGetGlossaryRequest} message GetGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetGlossaryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GetGlossaryRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.GetGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.GetGlossaryRequest} GetGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetGlossaryRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.GetGlossaryRequest();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GetGlossaryRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.GetGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.GetGlossaryRequest} GetGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetGlossaryRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GetGlossaryRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.GetGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetGlossaryRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GetGlossaryRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.GetGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.GetGlossaryRequest} GetGlossaryRequest
                         */
                        GetGlossaryRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.GetGlossaryRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.GetGlossaryRequest();
                            if (object.name != null)
                                message.name = String(object.name);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GetGlossaryRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.GetGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.GetGlossaryRequest} message GetGlossaryRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetGlossaryRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.name = "";
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            return object;
                        };
    
                        /**
                         * Converts this GetGlossaryRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.GetGlossaryRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetGlossaryRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GetGlossaryRequest;
                    })();
    
                    v3beta1.DeleteGlossaryRequest = (function() {
    
                        /**
                         * Properties of a DeleteGlossaryRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IDeleteGlossaryRequest
                         * @property {string|null} [name] DeleteGlossaryRequest name
                         */
    
                        /**
                         * Constructs a new DeleteGlossaryRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a DeleteGlossaryRequest.
                         * @implements IDeleteGlossaryRequest
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryRequest=} [properties] Properties to set
                         */
                        function DeleteGlossaryRequest(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DeleteGlossaryRequest name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryRequest
                         * @instance
                         */
                        DeleteGlossaryRequest.prototype.name = "";
    
                        /**
                         * Creates a new DeleteGlossaryRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryRequest} DeleteGlossaryRequest instance
                         */
                        DeleteGlossaryRequest.create = function create(properties) {
                            return new DeleteGlossaryRequest(properties);
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryRequest message. Does not implicitly {@link google.cloud.translation.v3beta1.DeleteGlossaryRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryRequest} message DeleteGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.DeleteGlossaryRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryRequest} message DeleteGlossaryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DeleteGlossaryRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryRequest} DeleteGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.DeleteGlossaryRequest();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DeleteGlossaryRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryRequest} DeleteGlossaryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DeleteGlossaryRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DeleteGlossaryRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DeleteGlossaryRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryRequest} DeleteGlossaryRequest
                         */
                        DeleteGlossaryRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.DeleteGlossaryRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.DeleteGlossaryRequest();
                            if (object.name != null)
                                message.name = String(object.name);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DeleteGlossaryRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.DeleteGlossaryRequest} message DeleteGlossaryRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DeleteGlossaryRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.name = "";
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            return object;
                        };
    
                        /**
                         * Converts this DeleteGlossaryRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DeleteGlossaryRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DeleteGlossaryRequest;
                    })();
    
                    v3beta1.ListGlossariesRequest = (function() {
    
                        /**
                         * Properties of a ListGlossariesRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IListGlossariesRequest
                         * @property {string|null} [parent] ListGlossariesRequest parent
                         * @property {number|null} [pageSize] ListGlossariesRequest pageSize
                         * @property {string|null} [pageToken] ListGlossariesRequest pageToken
                         * @property {string|null} [filter] ListGlossariesRequest filter
                         */
    
                        /**
                         * Constructs a new ListGlossariesRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a ListGlossariesRequest.
                         * @implements IListGlossariesRequest
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IListGlossariesRequest=} [properties] Properties to set
                         */
                        function ListGlossariesRequest(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ListGlossariesRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @instance
                         */
                        ListGlossariesRequest.prototype.parent = "";
    
                        /**
                         * ListGlossariesRequest pageSize.
                         * @member {number} pageSize
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @instance
                         */
                        ListGlossariesRequest.prototype.pageSize = 0;
    
                        /**
                         * ListGlossariesRequest pageToken.
                         * @member {string} pageToken
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @instance
                         */
                        ListGlossariesRequest.prototype.pageToken = "";
    
                        /**
                         * ListGlossariesRequest filter.
                         * @member {string} filter
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @instance
                         */
                        ListGlossariesRequest.prototype.filter = "";
    
                        /**
                         * Creates a new ListGlossariesRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IListGlossariesRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.ListGlossariesRequest} ListGlossariesRequest instance
                         */
                        ListGlossariesRequest.create = function create(properties) {
                            return new ListGlossariesRequest(properties);
                        };
    
                        /**
                         * Encodes the specified ListGlossariesRequest message. Does not implicitly {@link google.cloud.translation.v3beta1.ListGlossariesRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IListGlossariesRequest} message ListGlossariesRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ListGlossariesRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                            if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.filter);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ListGlossariesRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.ListGlossariesRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IListGlossariesRequest} message ListGlossariesRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ListGlossariesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ListGlossariesRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.ListGlossariesRequest} ListGlossariesRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ListGlossariesRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.ListGlossariesRequest();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.parent = reader.string();
                                    break;
                                case 2:
                                    message.pageSize = reader.int32();
                                    break;
                                case 3:
                                    message.pageToken = reader.string();
                                    break;
                                case 4:
                                    message.filter = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ListGlossariesRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.ListGlossariesRequest} ListGlossariesRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ListGlossariesRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ListGlossariesRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ListGlossariesRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                                if (!$util.isInteger(message.pageSize))
                                    return "pageSize: integer expected";
                            if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                                if (!$util.isString(message.pageToken))
                                    return "pageToken: string expected";
                            if (message.filter != null && message.hasOwnProperty("filter"))
                                if (!$util.isString(message.filter))
                                    return "filter: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a ListGlossariesRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.ListGlossariesRequest} ListGlossariesRequest
                         */
                        ListGlossariesRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.ListGlossariesRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.ListGlossariesRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.pageSize != null)
                                message.pageSize = object.pageSize | 0;
                            if (object.pageToken != null)
                                message.pageToken = String(object.pageToken);
                            if (object.filter != null)
                                message.filter = String(object.filter);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ListGlossariesRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.ListGlossariesRequest} message ListGlossariesRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ListGlossariesRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.parent = "";
                                object.pageSize = 0;
                                object.pageToken = "";
                                object.filter = "";
                            }
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                                object.pageSize = message.pageSize;
                            if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                                object.pageToken = message.pageToken;
                            if (message.filter != null && message.hasOwnProperty("filter"))
                                object.filter = message.filter;
                            return object;
                        };
    
                        /**
                         * Converts this ListGlossariesRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ListGlossariesRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ListGlossariesRequest;
                    })();
    
                    v3beta1.ListGlossariesResponse = (function() {
    
                        /**
                         * Properties of a ListGlossariesResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IListGlossariesResponse
                         * @property {Array.<google.cloud.translation.v3beta1.IGlossary>|null} [glossaries] ListGlossariesResponse glossaries
                         * @property {string|null} [nextPageToken] ListGlossariesResponse nextPageToken
                         */
    
                        /**
                         * Constructs a new ListGlossariesResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a ListGlossariesResponse.
                         * @implements IListGlossariesResponse
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IListGlossariesResponse=} [properties] Properties to set
                         */
                        function ListGlossariesResponse(properties) {
                            this.glossaries = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ListGlossariesResponse glossaries.
                         * @member {Array.<google.cloud.translation.v3beta1.IGlossary>} glossaries
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @instance
                         */
                        ListGlossariesResponse.prototype.glossaries = $util.emptyArray;
    
                        /**
                         * ListGlossariesResponse nextPageToken.
                         * @member {string} nextPageToken
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @instance
                         */
                        ListGlossariesResponse.prototype.nextPageToken = "";
    
                        /**
                         * Creates a new ListGlossariesResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IListGlossariesResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.ListGlossariesResponse} ListGlossariesResponse instance
                         */
                        ListGlossariesResponse.create = function create(properties) {
                            return new ListGlossariesResponse(properties);
                        };
    
                        /**
                         * Encodes the specified ListGlossariesResponse message. Does not implicitly {@link google.cloud.translation.v3beta1.ListGlossariesResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IListGlossariesResponse} message ListGlossariesResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ListGlossariesResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.glossaries != null && message.glossaries.length)
                                for (var i = 0; i < message.glossaries.length; ++i)
                                    $root.google.cloud.translation.v3beta1.Glossary.encode(message.glossaries[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ListGlossariesResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.ListGlossariesResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IListGlossariesResponse} message ListGlossariesResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ListGlossariesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ListGlossariesResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.ListGlossariesResponse} ListGlossariesResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ListGlossariesResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.ListGlossariesResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.glossaries && message.glossaries.length))
                                        message.glossaries = [];
                                    message.glossaries.push($root.google.cloud.translation.v3beta1.Glossary.decode(reader, reader.uint32()));
                                    break;
                                case 2:
                                    message.nextPageToken = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ListGlossariesResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.ListGlossariesResponse} ListGlossariesResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ListGlossariesResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ListGlossariesResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ListGlossariesResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.glossaries != null && message.hasOwnProperty("glossaries")) {
                                if (!Array.isArray(message.glossaries))
                                    return "glossaries: array expected";
                                for (var i = 0; i < message.glossaries.length; ++i) {
                                    var error = $root.google.cloud.translation.v3beta1.Glossary.verify(message.glossaries[i]);
                                    if (error)
                                        return "glossaries." + error;
                                }
                            }
                            if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                                if (!$util.isString(message.nextPageToken))
                                    return "nextPageToken: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a ListGlossariesResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.ListGlossariesResponse} ListGlossariesResponse
                         */
                        ListGlossariesResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.ListGlossariesResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.ListGlossariesResponse();
                            if (object.glossaries) {
                                if (!Array.isArray(object.glossaries))
                                    throw TypeError(".google.cloud.translation.v3beta1.ListGlossariesResponse.glossaries: array expected");
                                message.glossaries = [];
                                for (var i = 0; i < object.glossaries.length; ++i) {
                                    if (typeof object.glossaries[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3beta1.ListGlossariesResponse.glossaries: object expected");
                                    message.glossaries[i] = $root.google.cloud.translation.v3beta1.Glossary.fromObject(object.glossaries[i]);
                                }
                            }
                            if (object.nextPageToken != null)
                                message.nextPageToken = String(object.nextPageToken);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ListGlossariesResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.ListGlossariesResponse} message ListGlossariesResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ListGlossariesResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.glossaries = [];
                            if (options.defaults)
                                object.nextPageToken = "";
                            if (message.glossaries && message.glossaries.length) {
                                object.glossaries = [];
                                for (var j = 0; j < message.glossaries.length; ++j)
                                    object.glossaries[j] = $root.google.cloud.translation.v3beta1.Glossary.toObject(message.glossaries[j], options);
                            }
                            if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                                object.nextPageToken = message.nextPageToken;
                            return object;
                        };
    
                        /**
                         * Converts this ListGlossariesResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.ListGlossariesResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ListGlossariesResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ListGlossariesResponse;
                    })();
    
                    v3beta1.CreateGlossaryMetadata = (function() {
    
                        /**
                         * Properties of a CreateGlossaryMetadata.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface ICreateGlossaryMetadata
                         * @property {string|null} [name] CreateGlossaryMetadata name
                         * @property {google.cloud.translation.v3beta1.CreateGlossaryMetadata.State|null} [state] CreateGlossaryMetadata state
                         * @property {google.protobuf.ITimestamp|null} [submitTime] CreateGlossaryMetadata submitTime
                         */
    
                        /**
                         * Constructs a new CreateGlossaryMetadata.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a CreateGlossaryMetadata.
                         * @implements ICreateGlossaryMetadata
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.ICreateGlossaryMetadata=} [properties] Properties to set
                         */
                        function CreateGlossaryMetadata(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * CreateGlossaryMetadata name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @instance
                         */
                        CreateGlossaryMetadata.prototype.name = "";
    
                        /**
                         * CreateGlossaryMetadata state.
                         * @member {google.cloud.translation.v3beta1.CreateGlossaryMetadata.State} state
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @instance
                         */
                        CreateGlossaryMetadata.prototype.state = 0;
    
                        /**
                         * CreateGlossaryMetadata submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @instance
                         */
                        CreateGlossaryMetadata.prototype.submitTime = null;
    
                        /**
                         * Creates a new CreateGlossaryMetadata instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.ICreateGlossaryMetadata=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.CreateGlossaryMetadata} CreateGlossaryMetadata instance
                         */
                        CreateGlossaryMetadata.create = function create(properties) {
                            return new CreateGlossaryMetadata(properties);
                        };
    
                        /**
                         * Encodes the specified CreateGlossaryMetadata message. Does not implicitly {@link google.cloud.translation.v3beta1.CreateGlossaryMetadata.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.ICreateGlossaryMetadata} message CreateGlossaryMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CreateGlossaryMetadata.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.state);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified CreateGlossaryMetadata message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.CreateGlossaryMetadata.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.ICreateGlossaryMetadata} message CreateGlossaryMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CreateGlossaryMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a CreateGlossaryMetadata message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.CreateGlossaryMetadata} CreateGlossaryMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CreateGlossaryMetadata.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.CreateGlossaryMetadata();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                case 2:
                                    message.state = reader.int32();
                                    break;
                                case 3:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a CreateGlossaryMetadata message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.CreateGlossaryMetadata} CreateGlossaryMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CreateGlossaryMetadata.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a CreateGlossaryMetadata message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        CreateGlossaryMetadata.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.state != null && message.hasOwnProperty("state"))
                                switch (message.state) {
                                default:
                                    return "state: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a CreateGlossaryMetadata message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.CreateGlossaryMetadata} CreateGlossaryMetadata
                         */
                        CreateGlossaryMetadata.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.CreateGlossaryMetadata)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.CreateGlossaryMetadata();
                            if (object.name != null)
                                message.name = String(object.name);
                            switch (object.state) {
                            case "STATE_UNSPECIFIED":
                            case 0:
                                message.state = 0;
                                break;
                            case "RUNNING":
                            case 1:
                                message.state = 1;
                                break;
                            case "SUCCEEDED":
                            case 2:
                                message.state = 2;
                                break;
                            case "FAILED":
                            case 3:
                                message.state = 3;
                                break;
                            case "CANCELLING":
                            case 4:
                                message.state = 4;
                                break;
                            case "CANCELLED":
                            case 5:
                                message.state = 5;
                                break;
                            }
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.CreateGlossaryMetadata.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a CreateGlossaryMetadata message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.CreateGlossaryMetadata} message CreateGlossaryMetadata
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        CreateGlossaryMetadata.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.name = "";
                                object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                                object.submitTime = null;
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.state != null && message.hasOwnProperty("state"))
                                object.state = options.enums === String ? $root.google.cloud.translation.v3beta1.CreateGlossaryMetadata.State[message.state] : message.state;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this CreateGlossaryMetadata to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.CreateGlossaryMetadata
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        CreateGlossaryMetadata.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * State enum.
                         * @name google.cloud.translation.v3beta1.CreateGlossaryMetadata.State
                         * @enum {number}
                         * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                         * @property {number} RUNNING=1 RUNNING value
                         * @property {number} SUCCEEDED=2 SUCCEEDED value
                         * @property {number} FAILED=3 FAILED value
                         * @property {number} CANCELLING=4 CANCELLING value
                         * @property {number} CANCELLED=5 CANCELLED value
                         */
                        CreateGlossaryMetadata.State = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "RUNNING"] = 1;
                            values[valuesById[2] = "SUCCEEDED"] = 2;
                            values[valuesById[3] = "FAILED"] = 3;
                            values[valuesById[4] = "CANCELLING"] = 4;
                            values[valuesById[5] = "CANCELLED"] = 5;
                            return values;
                        })();
    
                        return CreateGlossaryMetadata;
                    })();
    
                    v3beta1.DeleteGlossaryMetadata = (function() {
    
                        /**
                         * Properties of a DeleteGlossaryMetadata.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IDeleteGlossaryMetadata
                         * @property {string|null} [name] DeleteGlossaryMetadata name
                         * @property {google.cloud.translation.v3beta1.DeleteGlossaryMetadata.State|null} [state] DeleteGlossaryMetadata state
                         * @property {google.protobuf.ITimestamp|null} [submitTime] DeleteGlossaryMetadata submitTime
                         */
    
                        /**
                         * Constructs a new DeleteGlossaryMetadata.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a DeleteGlossaryMetadata.
                         * @implements IDeleteGlossaryMetadata
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryMetadata=} [properties] Properties to set
                         */
                        function DeleteGlossaryMetadata(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DeleteGlossaryMetadata name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @instance
                         */
                        DeleteGlossaryMetadata.prototype.name = "";
    
                        /**
                         * DeleteGlossaryMetadata state.
                         * @member {google.cloud.translation.v3beta1.DeleteGlossaryMetadata.State} state
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @instance
                         */
                        DeleteGlossaryMetadata.prototype.state = 0;
    
                        /**
                         * DeleteGlossaryMetadata submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @instance
                         */
                        DeleteGlossaryMetadata.prototype.submitTime = null;
    
                        /**
                         * Creates a new DeleteGlossaryMetadata instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryMetadata=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryMetadata} DeleteGlossaryMetadata instance
                         */
                        DeleteGlossaryMetadata.create = function create(properties) {
                            return new DeleteGlossaryMetadata(properties);
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryMetadata message. Does not implicitly {@link google.cloud.translation.v3beta1.DeleteGlossaryMetadata.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryMetadata} message DeleteGlossaryMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryMetadata.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.state);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryMetadata message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.DeleteGlossaryMetadata.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryMetadata} message DeleteGlossaryMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DeleteGlossaryMetadata message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryMetadata} DeleteGlossaryMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryMetadata.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.DeleteGlossaryMetadata();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                case 2:
                                    message.state = reader.int32();
                                    break;
                                case 3:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DeleteGlossaryMetadata message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryMetadata} DeleteGlossaryMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryMetadata.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DeleteGlossaryMetadata message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DeleteGlossaryMetadata.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.state != null && message.hasOwnProperty("state"))
                                switch (message.state) {
                                default:
                                    return "state: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a DeleteGlossaryMetadata message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryMetadata} DeleteGlossaryMetadata
                         */
                        DeleteGlossaryMetadata.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.DeleteGlossaryMetadata)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.DeleteGlossaryMetadata();
                            if (object.name != null)
                                message.name = String(object.name);
                            switch (object.state) {
                            case "STATE_UNSPECIFIED":
                            case 0:
                                message.state = 0;
                                break;
                            case "RUNNING":
                            case 1:
                                message.state = 1;
                                break;
                            case "SUCCEEDED":
                            case 2:
                                message.state = 2;
                                break;
                            case "FAILED":
                            case 3:
                                message.state = 3;
                                break;
                            case "CANCELLING":
                            case 4:
                                message.state = 4;
                                break;
                            case "CANCELLED":
                            case 5:
                                message.state = 5;
                                break;
                            }
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.DeleteGlossaryMetadata.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DeleteGlossaryMetadata message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.DeleteGlossaryMetadata} message DeleteGlossaryMetadata
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DeleteGlossaryMetadata.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.name = "";
                                object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                                object.submitTime = null;
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.state != null && message.hasOwnProperty("state"))
                                object.state = options.enums === String ? $root.google.cloud.translation.v3beta1.DeleteGlossaryMetadata.State[message.state] : message.state;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this DeleteGlossaryMetadata to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryMetadata
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DeleteGlossaryMetadata.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * State enum.
                         * @name google.cloud.translation.v3beta1.DeleteGlossaryMetadata.State
                         * @enum {number}
                         * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                         * @property {number} RUNNING=1 RUNNING value
                         * @property {number} SUCCEEDED=2 SUCCEEDED value
                         * @property {number} FAILED=3 FAILED value
                         * @property {number} CANCELLING=4 CANCELLING value
                         * @property {number} CANCELLED=5 CANCELLED value
                         */
                        DeleteGlossaryMetadata.State = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "RUNNING"] = 1;
                            values[valuesById[2] = "SUCCEEDED"] = 2;
                            values[valuesById[3] = "FAILED"] = 3;
                            values[valuesById[4] = "CANCELLING"] = 4;
                            values[valuesById[5] = "CANCELLED"] = 5;
                            return values;
                        })();
    
                        return DeleteGlossaryMetadata;
                    })();
    
                    v3beta1.DeleteGlossaryResponse = (function() {
    
                        /**
                         * Properties of a DeleteGlossaryResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IDeleteGlossaryResponse
                         * @property {string|null} [name] DeleteGlossaryResponse name
                         * @property {google.protobuf.ITimestamp|null} [submitTime] DeleteGlossaryResponse submitTime
                         * @property {google.protobuf.ITimestamp|null} [endTime] DeleteGlossaryResponse endTime
                         */
    
                        /**
                         * Constructs a new DeleteGlossaryResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a DeleteGlossaryResponse.
                         * @implements IDeleteGlossaryResponse
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryResponse=} [properties] Properties to set
                         */
                        function DeleteGlossaryResponse(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DeleteGlossaryResponse name.
                         * @member {string} name
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @instance
                         */
                        DeleteGlossaryResponse.prototype.name = "";
    
                        /**
                         * DeleteGlossaryResponse submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @instance
                         */
                        DeleteGlossaryResponse.prototype.submitTime = null;
    
                        /**
                         * DeleteGlossaryResponse endTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} endTime
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @instance
                         */
                        DeleteGlossaryResponse.prototype.endTime = null;
    
                        /**
                         * Creates a new DeleteGlossaryResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryResponse} DeleteGlossaryResponse instance
                         */
                        DeleteGlossaryResponse.create = function create(properties) {
                            return new DeleteGlossaryResponse(properties);
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryResponse message. Does not implicitly {@link google.cloud.translation.v3beta1.DeleteGlossaryResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryResponse} message DeleteGlossaryResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                $root.google.protobuf.Timestamp.encode(message.endTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DeleteGlossaryResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.DeleteGlossaryResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IDeleteGlossaryResponse} message DeleteGlossaryResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DeleteGlossaryResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DeleteGlossaryResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryResponse} DeleteGlossaryResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.DeleteGlossaryResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                case 2:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                case 3:
                                    message.endTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DeleteGlossaryResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryResponse} DeleteGlossaryResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DeleteGlossaryResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DeleteGlossaryResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DeleteGlossaryResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            if (message.endTime != null && message.hasOwnProperty("endTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.endTime);
                                if (error)
                                    return "endTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a DeleteGlossaryResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.DeleteGlossaryResponse} DeleteGlossaryResponse
                         */
                        DeleteGlossaryResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.DeleteGlossaryResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.DeleteGlossaryResponse();
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.DeleteGlossaryResponse.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            if (object.endTime != null) {
                                if (typeof object.endTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.DeleteGlossaryResponse.endTime: object expected");
                                message.endTime = $root.google.protobuf.Timestamp.fromObject(object.endTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DeleteGlossaryResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.DeleteGlossaryResponse} message DeleteGlossaryResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DeleteGlossaryResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.name = "";
                                object.submitTime = null;
                                object.endTime = null;
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                object.endTime = $root.google.protobuf.Timestamp.toObject(message.endTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this DeleteGlossaryResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.DeleteGlossaryResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DeleteGlossaryResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DeleteGlossaryResponse;
                    })();
    
                    v3beta1.BatchTranslateDocumentRequest = (function() {
    
                        /**
                         * Properties of a BatchTranslateDocumentRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IBatchTranslateDocumentRequest
                         * @property {string|null} [parent] BatchTranslateDocumentRequest parent
                         * @property {string|null} [sourceLanguageCode] BatchTranslateDocumentRequest sourceLanguageCode
                         * @property {Array.<string>|null} [targetLanguageCodes] BatchTranslateDocumentRequest targetLanguageCodes
                         * @property {Array.<google.cloud.translation.v3beta1.IBatchDocumentInputConfig>|null} [inputConfigs] BatchTranslateDocumentRequest inputConfigs
                         * @property {google.cloud.translation.v3beta1.IBatchDocumentOutputConfig|null} [outputConfig] BatchTranslateDocumentRequest outputConfig
                         * @property {Object.<string,string>|null} [models] BatchTranslateDocumentRequest models
                         * @property {Object.<string,google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig>|null} [glossaries] BatchTranslateDocumentRequest glossaries
                         * @property {Object.<string,string>|null} [formatConversions] BatchTranslateDocumentRequest formatConversions
                         */
    
                        /**
                         * Constructs a new BatchTranslateDocumentRequest.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a BatchTranslateDocumentRequest.
                         * @implements IBatchTranslateDocumentRequest
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentRequest=} [properties] Properties to set
                         */
                        function BatchTranslateDocumentRequest(properties) {
                            this.targetLanguageCodes = [];
                            this.inputConfigs = [];
                            this.models = {};
                            this.glossaries = {};
                            this.formatConversions = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateDocumentRequest parent.
                         * @member {string} parent
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.parent = "";
    
                        /**
                         * BatchTranslateDocumentRequest sourceLanguageCode.
                         * @member {string} sourceLanguageCode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.sourceLanguageCode = "";
    
                        /**
                         * BatchTranslateDocumentRequest targetLanguageCodes.
                         * @member {Array.<string>} targetLanguageCodes
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.targetLanguageCodes = $util.emptyArray;
    
                        /**
                         * BatchTranslateDocumentRequest inputConfigs.
                         * @member {Array.<google.cloud.translation.v3beta1.IBatchDocumentInputConfig>} inputConfigs
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.inputConfigs = $util.emptyArray;
    
                        /**
                         * BatchTranslateDocumentRequest outputConfig.
                         * @member {google.cloud.translation.v3beta1.IBatchDocumentOutputConfig|null|undefined} outputConfig
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.outputConfig = null;
    
                        /**
                         * BatchTranslateDocumentRequest models.
                         * @member {Object.<string,string>} models
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.models = $util.emptyObject;
    
                        /**
                         * BatchTranslateDocumentRequest glossaries.
                         * @member {Object.<string,google.cloud.translation.v3beta1.ITranslateTextGlossaryConfig>} glossaries
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.glossaries = $util.emptyObject;
    
                        /**
                         * BatchTranslateDocumentRequest formatConversions.
                         * @member {Object.<string,string>} formatConversions
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @instance
                         */
                        BatchTranslateDocumentRequest.prototype.formatConversions = $util.emptyObject;
    
                        /**
                         * Creates a new BatchTranslateDocumentRequest instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentRequest=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentRequest} BatchTranslateDocumentRequest instance
                         */
                        BatchTranslateDocumentRequest.create = function create(properties) {
                            return new BatchTranslateDocumentRequest(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentRequest message. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateDocumentRequest.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentRequest} message BatchTranslateDocumentRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                            if (message.sourceLanguageCode != null && Object.hasOwnProperty.call(message, "sourceLanguageCode"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.sourceLanguageCode);
                            if (message.targetLanguageCodes != null && message.targetLanguageCodes.length)
                                for (var i = 0; i < message.targetLanguageCodes.length; ++i)
                                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.targetLanguageCodes[i]);
                            if (message.inputConfigs != null && message.inputConfigs.length)
                                for (var i = 0; i < message.inputConfigs.length; ++i)
                                    $root.google.cloud.translation.v3beta1.BatchDocumentInputConfig.encode(message.inputConfigs[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            if (message.outputConfig != null && Object.hasOwnProperty.call(message, "outputConfig"))
                                $root.google.cloud.translation.v3beta1.BatchDocumentOutputConfig.encode(message.outputConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            if (message.models != null && Object.hasOwnProperty.call(message, "models"))
                                for (var keys = Object.keys(message.models), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.models[keys[i]]).ldelim();
                            if (message.glossaries != null && Object.hasOwnProperty.call(message, "glossaries"))
                                for (var keys = Object.keys(message.glossaries), i = 0; i < keys.length; ++i) {
                                    writer.uint32(/* id 7, wireType 2 =*/58).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                                    $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.encode(message.glossaries[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                                }
                            if (message.formatConversions != null && Object.hasOwnProperty.call(message, "formatConversions"))
                                for (var keys = Object.keys(message.formatConversions), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 8, wireType 2 =*/66).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.formatConversions[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentRequest message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateDocumentRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentRequest} message BatchTranslateDocumentRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentRequest} BatchTranslateDocumentRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentRequest.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.BatchTranslateDocumentRequest(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.parent = reader.string();
                                    break;
                                case 2:
                                    message.sourceLanguageCode = reader.string();
                                    break;
                                case 3:
                                    if (!(message.targetLanguageCodes && message.targetLanguageCodes.length))
                                        message.targetLanguageCodes = [];
                                    message.targetLanguageCodes.push(reader.string());
                                    break;
                                case 4:
                                    if (!(message.inputConfigs && message.inputConfigs.length))
                                        message.inputConfigs = [];
                                    message.inputConfigs.push($root.google.cloud.translation.v3beta1.BatchDocumentInputConfig.decode(reader, reader.uint32()));
                                    break;
                                case 5:
                                    message.outputConfig = $root.google.cloud.translation.v3beta1.BatchDocumentOutputConfig.decode(reader, reader.uint32());
                                    break;
                                case 6:
                                    if (message.models === $util.emptyObject)
                                        message.models = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.models[key] = value;
                                    break;
                                case 7:
                                    if (message.glossaries === $util.emptyObject)
                                        message.glossaries = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = null;
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.decode(reader, reader.uint32());
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.glossaries[key] = value;
                                    break;
                                case 8:
                                    if (message.formatConversions === $util.emptyObject)
                                        message.formatConversions = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.formatConversions[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentRequest} BatchTranslateDocumentRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateDocumentRequest message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateDocumentRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                if (!$util.isString(message.parent))
                                    return "parent: string expected";
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                if (!$util.isString(message.sourceLanguageCode))
                                    return "sourceLanguageCode: string expected";
                            if (message.targetLanguageCodes != null && message.hasOwnProperty("targetLanguageCodes")) {
                                if (!Array.isArray(message.targetLanguageCodes))
                                    return "targetLanguageCodes: array expected";
                                for (var i = 0; i < message.targetLanguageCodes.length; ++i)
                                    if (!$util.isString(message.targetLanguageCodes[i]))
                                        return "targetLanguageCodes: string[] expected";
                            }
                            if (message.inputConfigs != null && message.hasOwnProperty("inputConfigs")) {
                                if (!Array.isArray(message.inputConfigs))
                                    return "inputConfigs: array expected";
                                for (var i = 0; i < message.inputConfigs.length; ++i) {
                                    var error = $root.google.cloud.translation.v3beta1.BatchDocumentInputConfig.verify(message.inputConfigs[i]);
                                    if (error)
                                        return "inputConfigs." + error;
                                }
                            }
                            if (message.outputConfig != null && message.hasOwnProperty("outputConfig")) {
                                var error = $root.google.cloud.translation.v3beta1.BatchDocumentOutputConfig.verify(message.outputConfig);
                                if (error)
                                    return "outputConfig." + error;
                            }
                            if (message.models != null && message.hasOwnProperty("models")) {
                                if (!$util.isObject(message.models))
                                    return "models: object expected";
                                var key = Object.keys(message.models);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.models[key[i]]))
                                        return "models: string{k:string} expected";
                            }
                            if (message.glossaries != null && message.hasOwnProperty("glossaries")) {
                                if (!$util.isObject(message.glossaries))
                                    return "glossaries: object expected";
                                var key = Object.keys(message.glossaries);
                                for (var i = 0; i < key.length; ++i) {
                                    var error = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.verify(message.glossaries[key[i]]);
                                    if (error)
                                        return "glossaries." + error;
                                }
                            }
                            if (message.formatConversions != null && message.hasOwnProperty("formatConversions")) {
                                if (!$util.isObject(message.formatConversions))
                                    return "formatConversions: object expected";
                                var key = Object.keys(message.formatConversions);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.formatConversions[key[i]]))
                                        return "formatConversions: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateDocumentRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentRequest} BatchTranslateDocumentRequest
                         */
                        BatchTranslateDocumentRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.BatchTranslateDocumentRequest)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.BatchTranslateDocumentRequest();
                            if (object.parent != null)
                                message.parent = String(object.parent);
                            if (object.sourceLanguageCode != null)
                                message.sourceLanguageCode = String(object.sourceLanguageCode);
                            if (object.targetLanguageCodes) {
                                if (!Array.isArray(object.targetLanguageCodes))
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentRequest.targetLanguageCodes: array expected");
                                message.targetLanguageCodes = [];
                                for (var i = 0; i < object.targetLanguageCodes.length; ++i)
                                    message.targetLanguageCodes[i] = String(object.targetLanguageCodes[i]);
                            }
                            if (object.inputConfigs) {
                                if (!Array.isArray(object.inputConfigs))
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentRequest.inputConfigs: array expected");
                                message.inputConfigs = [];
                                for (var i = 0; i < object.inputConfigs.length; ++i) {
                                    if (typeof object.inputConfigs[i] !== "object")
                                        throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentRequest.inputConfigs: object expected");
                                    message.inputConfigs[i] = $root.google.cloud.translation.v3beta1.BatchDocumentInputConfig.fromObject(object.inputConfigs[i]);
                                }
                            }
                            if (object.outputConfig != null) {
                                if (typeof object.outputConfig !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentRequest.outputConfig: object expected");
                                message.outputConfig = $root.google.cloud.translation.v3beta1.BatchDocumentOutputConfig.fromObject(object.outputConfig);
                            }
                            if (object.models) {
                                if (typeof object.models !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentRequest.models: object expected");
                                message.models = {};
                                for (var keys = Object.keys(object.models), i = 0; i < keys.length; ++i)
                                    message.models[keys[i]] = String(object.models[keys[i]]);
                            }
                            if (object.glossaries) {
                                if (typeof object.glossaries !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentRequest.glossaries: object expected");
                                message.glossaries = {};
                                for (var keys = Object.keys(object.glossaries), i = 0; i < keys.length; ++i) {
                                    if (typeof object.glossaries[keys[i]] !== "object")
                                        throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentRequest.glossaries: object expected");
                                    message.glossaries[keys[i]] = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.fromObject(object.glossaries[keys[i]]);
                                }
                            }
                            if (object.formatConversions) {
                                if (typeof object.formatConversions !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentRequest.formatConversions: object expected");
                                message.formatConversions = {};
                                for (var keys = Object.keys(object.formatConversions), i = 0; i < keys.length; ++i)
                                    message.formatConversions[keys[i]] = String(object.formatConversions[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateDocumentRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @static
                         * @param {google.cloud.translation.v3beta1.BatchTranslateDocumentRequest} message BatchTranslateDocumentRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateDocumentRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.targetLanguageCodes = [];
                                object.inputConfigs = [];
                            }
                            if (options.objects || options.defaults) {
                                object.models = {};
                                object.glossaries = {};
                                object.formatConversions = {};
                            }
                            if (options.defaults) {
                                object.parent = "";
                                object.sourceLanguageCode = "";
                                object.outputConfig = null;
                            }
                            if (message.parent != null && message.hasOwnProperty("parent"))
                                object.parent = message.parent;
                            if (message.sourceLanguageCode != null && message.hasOwnProperty("sourceLanguageCode"))
                                object.sourceLanguageCode = message.sourceLanguageCode;
                            if (message.targetLanguageCodes && message.targetLanguageCodes.length) {
                                object.targetLanguageCodes = [];
                                for (var j = 0; j < message.targetLanguageCodes.length; ++j)
                                    object.targetLanguageCodes[j] = message.targetLanguageCodes[j];
                            }
                            if (message.inputConfigs && message.inputConfigs.length) {
                                object.inputConfigs = [];
                                for (var j = 0; j < message.inputConfigs.length; ++j)
                                    object.inputConfigs[j] = $root.google.cloud.translation.v3beta1.BatchDocumentInputConfig.toObject(message.inputConfigs[j], options);
                            }
                            if (message.outputConfig != null && message.hasOwnProperty("outputConfig"))
                                object.outputConfig = $root.google.cloud.translation.v3beta1.BatchDocumentOutputConfig.toObject(message.outputConfig, options);
                            var keys2;
                            if (message.models && (keys2 = Object.keys(message.models)).length) {
                                object.models = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.models[keys2[j]] = message.models[keys2[j]];
                            }
                            if (message.glossaries && (keys2 = Object.keys(message.glossaries)).length) {
                                object.glossaries = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.glossaries[keys2[j]] = $root.google.cloud.translation.v3beta1.TranslateTextGlossaryConfig.toObject(message.glossaries[keys2[j]], options);
                            }
                            if (message.formatConversions && (keys2 = Object.keys(message.formatConversions)).length) {
                                object.formatConversions = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.formatConversions[keys2[j]] = message.formatConversions[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateDocumentRequest to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateDocumentRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchTranslateDocumentRequest;
                    })();
    
                    v3beta1.BatchDocumentInputConfig = (function() {
    
                        /**
                         * Properties of a BatchDocumentInputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IBatchDocumentInputConfig
                         * @property {google.cloud.translation.v3beta1.IGcsSource|null} [gcsSource] BatchDocumentInputConfig gcsSource
                         */
    
                        /**
                         * Constructs a new BatchDocumentInputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a BatchDocumentInputConfig.
                         * @implements IBatchDocumentInputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IBatchDocumentInputConfig=} [properties] Properties to set
                         */
                        function BatchDocumentInputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchDocumentInputConfig gcsSource.
                         * @member {google.cloud.translation.v3beta1.IGcsSource|null|undefined} gcsSource
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @instance
                         */
                        BatchDocumentInputConfig.prototype.gcsSource = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * BatchDocumentInputConfig source.
                         * @member {"gcsSource"|undefined} source
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @instance
                         */
                        Object.defineProperty(BatchDocumentInputConfig.prototype, "source", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsSource"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new BatchDocumentInputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchDocumentInputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.BatchDocumentInputConfig} BatchDocumentInputConfig instance
                         */
                        BatchDocumentInputConfig.create = function create(properties) {
                            return new BatchDocumentInputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified BatchDocumentInputConfig message. Does not implicitly {@link google.cloud.translation.v3beta1.BatchDocumentInputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchDocumentInputConfig} message BatchDocumentInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchDocumentInputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.gcsSource != null && Object.hasOwnProperty.call(message, "gcsSource"))
                                $root.google.cloud.translation.v3beta1.GcsSource.encode(message.gcsSource, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchDocumentInputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.BatchDocumentInputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchDocumentInputConfig} message BatchDocumentInputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchDocumentInputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchDocumentInputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.BatchDocumentInputConfig} BatchDocumentInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchDocumentInputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.BatchDocumentInputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchDocumentInputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.BatchDocumentInputConfig} BatchDocumentInputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchDocumentInputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchDocumentInputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchDocumentInputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                properties.source = 1;
                                {
                                    var error = $root.google.cloud.translation.v3beta1.GcsSource.verify(message.gcsSource);
                                    if (error)
                                        return "gcsSource." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchDocumentInputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.BatchDocumentInputConfig} BatchDocumentInputConfig
                         */
                        BatchDocumentInputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.BatchDocumentInputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.BatchDocumentInputConfig();
                            if (object.gcsSource != null) {
                                if (typeof object.gcsSource !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchDocumentInputConfig.gcsSource: object expected");
                                message.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.fromObject(object.gcsSource);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchDocumentInputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.BatchDocumentInputConfig} message BatchDocumentInputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchDocumentInputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.gcsSource != null && message.hasOwnProperty("gcsSource")) {
                                object.gcsSource = $root.google.cloud.translation.v3beta1.GcsSource.toObject(message.gcsSource, options);
                                if (options.oneofs)
                                    object.source = "gcsSource";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this BatchDocumentInputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentInputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchDocumentInputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchDocumentInputConfig;
                    })();
    
                    v3beta1.BatchDocumentOutputConfig = (function() {
    
                        /**
                         * Properties of a BatchDocumentOutputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IBatchDocumentOutputConfig
                         * @property {google.cloud.translation.v3beta1.IGcsDestination|null} [gcsDestination] BatchDocumentOutputConfig gcsDestination
                         */
    
                        /**
                         * Constructs a new BatchDocumentOutputConfig.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a BatchDocumentOutputConfig.
                         * @implements IBatchDocumentOutputConfig
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IBatchDocumentOutputConfig=} [properties] Properties to set
                         */
                        function BatchDocumentOutputConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchDocumentOutputConfig gcsDestination.
                         * @member {google.cloud.translation.v3beta1.IGcsDestination|null|undefined} gcsDestination
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @instance
                         */
                        BatchDocumentOutputConfig.prototype.gcsDestination = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * BatchDocumentOutputConfig destination.
                         * @member {"gcsDestination"|undefined} destination
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @instance
                         */
                        Object.defineProperty(BatchDocumentOutputConfig.prototype, "destination", {
                            get: $util.oneOfGetter($oneOfFields = ["gcsDestination"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new BatchDocumentOutputConfig instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchDocumentOutputConfig=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.BatchDocumentOutputConfig} BatchDocumentOutputConfig instance
                         */
                        BatchDocumentOutputConfig.create = function create(properties) {
                            return new BatchDocumentOutputConfig(properties);
                        };
    
                        /**
                         * Encodes the specified BatchDocumentOutputConfig message. Does not implicitly {@link google.cloud.translation.v3beta1.BatchDocumentOutputConfig.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchDocumentOutputConfig} message BatchDocumentOutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchDocumentOutputConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.gcsDestination != null && Object.hasOwnProperty.call(message, "gcsDestination"))
                                $root.google.cloud.translation.v3beta1.GcsDestination.encode(message.gcsDestination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchDocumentOutputConfig message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.BatchDocumentOutputConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchDocumentOutputConfig} message BatchDocumentOutputConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchDocumentOutputConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchDocumentOutputConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.BatchDocumentOutputConfig} BatchDocumentOutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchDocumentOutputConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.BatchDocumentOutputConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.gcsDestination = $root.google.cloud.translation.v3beta1.GcsDestination.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchDocumentOutputConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.BatchDocumentOutputConfig} BatchDocumentOutputConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchDocumentOutputConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchDocumentOutputConfig message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchDocumentOutputConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                properties.destination = 1;
                                {
                                    var error = $root.google.cloud.translation.v3beta1.GcsDestination.verify(message.gcsDestination);
                                    if (error)
                                        return "gcsDestination." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchDocumentOutputConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.BatchDocumentOutputConfig} BatchDocumentOutputConfig
                         */
                        BatchDocumentOutputConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.BatchDocumentOutputConfig)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.BatchDocumentOutputConfig();
                            if (object.gcsDestination != null) {
                                if (typeof object.gcsDestination !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchDocumentOutputConfig.gcsDestination: object expected");
                                message.gcsDestination = $root.google.cloud.translation.v3beta1.GcsDestination.fromObject(object.gcsDestination);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchDocumentOutputConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @static
                         * @param {google.cloud.translation.v3beta1.BatchDocumentOutputConfig} message BatchDocumentOutputConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchDocumentOutputConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.gcsDestination != null && message.hasOwnProperty("gcsDestination")) {
                                object.gcsDestination = $root.google.cloud.translation.v3beta1.GcsDestination.toObject(message.gcsDestination, options);
                                if (options.oneofs)
                                    object.destination = "gcsDestination";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this BatchDocumentOutputConfig to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.BatchDocumentOutputConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchDocumentOutputConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchDocumentOutputConfig;
                    })();
    
                    v3beta1.BatchTranslateDocumentResponse = (function() {
    
                        /**
                         * Properties of a BatchTranslateDocumentResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IBatchTranslateDocumentResponse
                         * @property {number|Long|null} [totalPages] BatchTranslateDocumentResponse totalPages
                         * @property {number|Long|null} [translatedPages] BatchTranslateDocumentResponse translatedPages
                         * @property {number|Long|null} [failedPages] BatchTranslateDocumentResponse failedPages
                         * @property {number|Long|null} [totalBillablePages] BatchTranslateDocumentResponse totalBillablePages
                         * @property {number|Long|null} [totalCharacters] BatchTranslateDocumentResponse totalCharacters
                         * @property {number|Long|null} [translatedCharacters] BatchTranslateDocumentResponse translatedCharacters
                         * @property {number|Long|null} [failedCharacters] BatchTranslateDocumentResponse failedCharacters
                         * @property {number|Long|null} [totalBillableCharacters] BatchTranslateDocumentResponse totalBillableCharacters
                         * @property {google.protobuf.ITimestamp|null} [submitTime] BatchTranslateDocumentResponse submitTime
                         * @property {google.protobuf.ITimestamp|null} [endTime] BatchTranslateDocumentResponse endTime
                         */
    
                        /**
                         * Constructs a new BatchTranslateDocumentResponse.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a BatchTranslateDocumentResponse.
                         * @implements IBatchTranslateDocumentResponse
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentResponse=} [properties] Properties to set
                         */
                        function BatchTranslateDocumentResponse(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateDocumentResponse totalPages.
                         * @member {number|Long} totalPages
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.totalPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse translatedPages.
                         * @member {number|Long} translatedPages
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.translatedPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse failedPages.
                         * @member {number|Long} failedPages
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.failedPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse totalBillablePages.
                         * @member {number|Long} totalBillablePages
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.totalBillablePages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse totalCharacters.
                         * @member {number|Long} totalCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.totalCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse translatedCharacters.
                         * @member {number|Long} translatedCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.translatedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse failedCharacters.
                         * @member {number|Long} failedCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.failedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse totalBillableCharacters.
                         * @member {number|Long} totalBillableCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.totalBillableCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentResponse submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.submitTime = null;
    
                        /**
                         * BatchTranslateDocumentResponse endTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} endTime
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         */
                        BatchTranslateDocumentResponse.prototype.endTime = null;
    
                        /**
                         * Creates a new BatchTranslateDocumentResponse instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentResponse=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentResponse} BatchTranslateDocumentResponse instance
                         */
                        BatchTranslateDocumentResponse.create = function create(properties) {
                            return new BatchTranslateDocumentResponse(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentResponse message. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateDocumentResponse.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentResponse} message BatchTranslateDocumentResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.totalPages != null && Object.hasOwnProperty.call(message, "totalPages"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.totalPages);
                            if (message.translatedPages != null && Object.hasOwnProperty.call(message, "translatedPages"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.translatedPages);
                            if (message.failedPages != null && Object.hasOwnProperty.call(message, "failedPages"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.failedPages);
                            if (message.totalBillablePages != null && Object.hasOwnProperty.call(message, "totalBillablePages"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.totalBillablePages);
                            if (message.totalCharacters != null && Object.hasOwnProperty.call(message, "totalCharacters"))
                                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.totalCharacters);
                            if (message.translatedCharacters != null && Object.hasOwnProperty.call(message, "translatedCharacters"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.translatedCharacters);
                            if (message.failedCharacters != null && Object.hasOwnProperty.call(message, "failedCharacters"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.failedCharacters);
                            if (message.totalBillableCharacters != null && Object.hasOwnProperty.call(message, "totalBillableCharacters"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.totalBillableCharacters);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                $root.google.protobuf.Timestamp.encode(message.endTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentResponse message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateDocumentResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentResponse} message BatchTranslateDocumentResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentResponse} BatchTranslateDocumentResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentResponse.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.BatchTranslateDocumentResponse();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.totalPages = reader.int64();
                                    break;
                                case 2:
                                    message.translatedPages = reader.int64();
                                    break;
                                case 3:
                                    message.failedPages = reader.int64();
                                    break;
                                case 4:
                                    message.totalBillablePages = reader.int64();
                                    break;
                                case 5:
                                    message.totalCharacters = reader.int64();
                                    break;
                                case 6:
                                    message.translatedCharacters = reader.int64();
                                    break;
                                case 7:
                                    message.failedCharacters = reader.int64();
                                    break;
                                case 8:
                                    message.totalBillableCharacters = reader.int64();
                                    break;
                                case 9:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                case 10:
                                    message.endTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentResponse} BatchTranslateDocumentResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateDocumentResponse message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateDocumentResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.totalPages != null && message.hasOwnProperty("totalPages"))
                                if (!$util.isInteger(message.totalPages) && !(message.totalPages && $util.isInteger(message.totalPages.low) && $util.isInteger(message.totalPages.high)))
                                    return "totalPages: integer|Long expected";
                            if (message.translatedPages != null && message.hasOwnProperty("translatedPages"))
                                if (!$util.isInteger(message.translatedPages) && !(message.translatedPages && $util.isInteger(message.translatedPages.low) && $util.isInteger(message.translatedPages.high)))
                                    return "translatedPages: integer|Long expected";
                            if (message.failedPages != null && message.hasOwnProperty("failedPages"))
                                if (!$util.isInteger(message.failedPages) && !(message.failedPages && $util.isInteger(message.failedPages.low) && $util.isInteger(message.failedPages.high)))
                                    return "failedPages: integer|Long expected";
                            if (message.totalBillablePages != null && message.hasOwnProperty("totalBillablePages"))
                                if (!$util.isInteger(message.totalBillablePages) && !(message.totalBillablePages && $util.isInteger(message.totalBillablePages.low) && $util.isInteger(message.totalBillablePages.high)))
                                    return "totalBillablePages: integer|Long expected";
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (!$util.isInteger(message.totalCharacters) && !(message.totalCharacters && $util.isInteger(message.totalCharacters.low) && $util.isInteger(message.totalCharacters.high)))
                                    return "totalCharacters: integer|Long expected";
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (!$util.isInteger(message.translatedCharacters) && !(message.translatedCharacters && $util.isInteger(message.translatedCharacters.low) && $util.isInteger(message.translatedCharacters.high)))
                                    return "translatedCharacters: integer|Long expected";
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (!$util.isInteger(message.failedCharacters) && !(message.failedCharacters && $util.isInteger(message.failedCharacters.low) && $util.isInteger(message.failedCharacters.high)))
                                    return "failedCharacters: integer|Long expected";
                            if (message.totalBillableCharacters != null && message.hasOwnProperty("totalBillableCharacters"))
                                if (!$util.isInteger(message.totalBillableCharacters) && !(message.totalBillableCharacters && $util.isInteger(message.totalBillableCharacters.low) && $util.isInteger(message.totalBillableCharacters.high)))
                                    return "totalBillableCharacters: integer|Long expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            if (message.endTime != null && message.hasOwnProperty("endTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.endTime);
                                if (error)
                                    return "endTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateDocumentResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentResponse} BatchTranslateDocumentResponse
                         */
                        BatchTranslateDocumentResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.BatchTranslateDocumentResponse)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.BatchTranslateDocumentResponse();
                            if (object.totalPages != null)
                                if ($util.Long)
                                    (message.totalPages = $util.Long.fromValue(object.totalPages)).unsigned = false;
                                else if (typeof object.totalPages === "string")
                                    message.totalPages = parseInt(object.totalPages, 10);
                                else if (typeof object.totalPages === "number")
                                    message.totalPages = object.totalPages;
                                else if (typeof object.totalPages === "object")
                                    message.totalPages = new $util.LongBits(object.totalPages.low >>> 0, object.totalPages.high >>> 0).toNumber();
                            if (object.translatedPages != null)
                                if ($util.Long)
                                    (message.translatedPages = $util.Long.fromValue(object.translatedPages)).unsigned = false;
                                else if (typeof object.translatedPages === "string")
                                    message.translatedPages = parseInt(object.translatedPages, 10);
                                else if (typeof object.translatedPages === "number")
                                    message.translatedPages = object.translatedPages;
                                else if (typeof object.translatedPages === "object")
                                    message.translatedPages = new $util.LongBits(object.translatedPages.low >>> 0, object.translatedPages.high >>> 0).toNumber();
                            if (object.failedPages != null)
                                if ($util.Long)
                                    (message.failedPages = $util.Long.fromValue(object.failedPages)).unsigned = false;
                                else if (typeof object.failedPages === "string")
                                    message.failedPages = parseInt(object.failedPages, 10);
                                else if (typeof object.failedPages === "number")
                                    message.failedPages = object.failedPages;
                                else if (typeof object.failedPages === "object")
                                    message.failedPages = new $util.LongBits(object.failedPages.low >>> 0, object.failedPages.high >>> 0).toNumber();
                            if (object.totalBillablePages != null)
                                if ($util.Long)
                                    (message.totalBillablePages = $util.Long.fromValue(object.totalBillablePages)).unsigned = false;
                                else if (typeof object.totalBillablePages === "string")
                                    message.totalBillablePages = parseInt(object.totalBillablePages, 10);
                                else if (typeof object.totalBillablePages === "number")
                                    message.totalBillablePages = object.totalBillablePages;
                                else if (typeof object.totalBillablePages === "object")
                                    message.totalBillablePages = new $util.LongBits(object.totalBillablePages.low >>> 0, object.totalBillablePages.high >>> 0).toNumber();
                            if (object.totalCharacters != null)
                                if ($util.Long)
                                    (message.totalCharacters = $util.Long.fromValue(object.totalCharacters)).unsigned = false;
                                else if (typeof object.totalCharacters === "string")
                                    message.totalCharacters = parseInt(object.totalCharacters, 10);
                                else if (typeof object.totalCharacters === "number")
                                    message.totalCharacters = object.totalCharacters;
                                else if (typeof object.totalCharacters === "object")
                                    message.totalCharacters = new $util.LongBits(object.totalCharacters.low >>> 0, object.totalCharacters.high >>> 0).toNumber();
                            if (object.translatedCharacters != null)
                                if ($util.Long)
                                    (message.translatedCharacters = $util.Long.fromValue(object.translatedCharacters)).unsigned = false;
                                else if (typeof object.translatedCharacters === "string")
                                    message.translatedCharacters = parseInt(object.translatedCharacters, 10);
                                else if (typeof object.translatedCharacters === "number")
                                    message.translatedCharacters = object.translatedCharacters;
                                else if (typeof object.translatedCharacters === "object")
                                    message.translatedCharacters = new $util.LongBits(object.translatedCharacters.low >>> 0, object.translatedCharacters.high >>> 0).toNumber();
                            if (object.failedCharacters != null)
                                if ($util.Long)
                                    (message.failedCharacters = $util.Long.fromValue(object.failedCharacters)).unsigned = false;
                                else if (typeof object.failedCharacters === "string")
                                    message.failedCharacters = parseInt(object.failedCharacters, 10);
                                else if (typeof object.failedCharacters === "number")
                                    message.failedCharacters = object.failedCharacters;
                                else if (typeof object.failedCharacters === "object")
                                    message.failedCharacters = new $util.LongBits(object.failedCharacters.low >>> 0, object.failedCharacters.high >>> 0).toNumber();
                            if (object.totalBillableCharacters != null)
                                if ($util.Long)
                                    (message.totalBillableCharacters = $util.Long.fromValue(object.totalBillableCharacters)).unsigned = false;
                                else if (typeof object.totalBillableCharacters === "string")
                                    message.totalBillableCharacters = parseInt(object.totalBillableCharacters, 10);
                                else if (typeof object.totalBillableCharacters === "number")
                                    message.totalBillableCharacters = object.totalBillableCharacters;
                                else if (typeof object.totalBillableCharacters === "object")
                                    message.totalBillableCharacters = new $util.LongBits(object.totalBillableCharacters.low >>> 0, object.totalBillableCharacters.high >>> 0).toNumber();
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentResponse.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            if (object.endTime != null) {
                                if (typeof object.endTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentResponse.endTime: object expected");
                                message.endTime = $root.google.protobuf.Timestamp.fromObject(object.endTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateDocumentResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @static
                         * @param {google.cloud.translation.v3beta1.BatchTranslateDocumentResponse} message BatchTranslateDocumentResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateDocumentResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalBillablePages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalBillablePages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalBillableCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalBillableCharacters = options.longs === String ? "0" : 0;
                                object.submitTime = null;
                                object.endTime = null;
                            }
                            if (message.totalPages != null && message.hasOwnProperty("totalPages"))
                                if (typeof message.totalPages === "number")
                                    object.totalPages = options.longs === String ? String(message.totalPages) : message.totalPages;
                                else
                                    object.totalPages = options.longs === String ? $util.Long.prototype.toString.call(message.totalPages) : options.longs === Number ? new $util.LongBits(message.totalPages.low >>> 0, message.totalPages.high >>> 0).toNumber() : message.totalPages;
                            if (message.translatedPages != null && message.hasOwnProperty("translatedPages"))
                                if (typeof message.translatedPages === "number")
                                    object.translatedPages = options.longs === String ? String(message.translatedPages) : message.translatedPages;
                                else
                                    object.translatedPages = options.longs === String ? $util.Long.prototype.toString.call(message.translatedPages) : options.longs === Number ? new $util.LongBits(message.translatedPages.low >>> 0, message.translatedPages.high >>> 0).toNumber() : message.translatedPages;
                            if (message.failedPages != null && message.hasOwnProperty("failedPages"))
                                if (typeof message.failedPages === "number")
                                    object.failedPages = options.longs === String ? String(message.failedPages) : message.failedPages;
                                else
                                    object.failedPages = options.longs === String ? $util.Long.prototype.toString.call(message.failedPages) : options.longs === Number ? new $util.LongBits(message.failedPages.low >>> 0, message.failedPages.high >>> 0).toNumber() : message.failedPages;
                            if (message.totalBillablePages != null && message.hasOwnProperty("totalBillablePages"))
                                if (typeof message.totalBillablePages === "number")
                                    object.totalBillablePages = options.longs === String ? String(message.totalBillablePages) : message.totalBillablePages;
                                else
                                    object.totalBillablePages = options.longs === String ? $util.Long.prototype.toString.call(message.totalBillablePages) : options.longs === Number ? new $util.LongBits(message.totalBillablePages.low >>> 0, message.totalBillablePages.high >>> 0).toNumber() : message.totalBillablePages;
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (typeof message.totalCharacters === "number")
                                    object.totalCharacters = options.longs === String ? String(message.totalCharacters) : message.totalCharacters;
                                else
                                    object.totalCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalCharacters) : options.longs === Number ? new $util.LongBits(message.totalCharacters.low >>> 0, message.totalCharacters.high >>> 0).toNumber() : message.totalCharacters;
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (typeof message.translatedCharacters === "number")
                                    object.translatedCharacters = options.longs === String ? String(message.translatedCharacters) : message.translatedCharacters;
                                else
                                    object.translatedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.translatedCharacters) : options.longs === Number ? new $util.LongBits(message.translatedCharacters.low >>> 0, message.translatedCharacters.high >>> 0).toNumber() : message.translatedCharacters;
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (typeof message.failedCharacters === "number")
                                    object.failedCharacters = options.longs === String ? String(message.failedCharacters) : message.failedCharacters;
                                else
                                    object.failedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.failedCharacters) : options.longs === Number ? new $util.LongBits(message.failedCharacters.low >>> 0, message.failedCharacters.high >>> 0).toNumber() : message.failedCharacters;
                            if (message.totalBillableCharacters != null && message.hasOwnProperty("totalBillableCharacters"))
                                if (typeof message.totalBillableCharacters === "number")
                                    object.totalBillableCharacters = options.longs === String ? String(message.totalBillableCharacters) : message.totalBillableCharacters;
                                else
                                    object.totalBillableCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalBillableCharacters) : options.longs === Number ? new $util.LongBits(message.totalBillableCharacters.low >>> 0, message.totalBillableCharacters.high >>> 0).toNumber() : message.totalBillableCharacters;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                object.endTime = $root.google.protobuf.Timestamp.toObject(message.endTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateDocumentResponse to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateDocumentResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return BatchTranslateDocumentResponse;
                    })();
    
                    v3beta1.BatchTranslateDocumentMetadata = (function() {
    
                        /**
                         * Properties of a BatchTranslateDocumentMetadata.
                         * @memberof google.cloud.translation.v3beta1
                         * @interface IBatchTranslateDocumentMetadata
                         * @property {google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata.State|null} [state] BatchTranslateDocumentMetadata state
                         * @property {number|Long|null} [totalPages] BatchTranslateDocumentMetadata totalPages
                         * @property {number|Long|null} [translatedPages] BatchTranslateDocumentMetadata translatedPages
                         * @property {number|Long|null} [failedPages] BatchTranslateDocumentMetadata failedPages
                         * @property {number|Long|null} [totalBillablePages] BatchTranslateDocumentMetadata totalBillablePages
                         * @property {number|Long|null} [totalCharacters] BatchTranslateDocumentMetadata totalCharacters
                         * @property {number|Long|null} [translatedCharacters] BatchTranslateDocumentMetadata translatedCharacters
                         * @property {number|Long|null} [failedCharacters] BatchTranslateDocumentMetadata failedCharacters
                         * @property {number|Long|null} [totalBillableCharacters] BatchTranslateDocumentMetadata totalBillableCharacters
                         * @property {google.protobuf.ITimestamp|null} [submitTime] BatchTranslateDocumentMetadata submitTime
                         */
    
                        /**
                         * Constructs a new BatchTranslateDocumentMetadata.
                         * @memberof google.cloud.translation.v3beta1
                         * @classdesc Represents a BatchTranslateDocumentMetadata.
                         * @implements IBatchTranslateDocumentMetadata
                         * @constructor
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentMetadata=} [properties] Properties to set
                         */
                        function BatchTranslateDocumentMetadata(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BatchTranslateDocumentMetadata state.
                         * @member {google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata.State} state
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.state = 0;
    
                        /**
                         * BatchTranslateDocumentMetadata totalPages.
                         * @member {number|Long} totalPages
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.totalPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata translatedPages.
                         * @member {number|Long} translatedPages
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.translatedPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata failedPages.
                         * @member {number|Long} failedPages
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.failedPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata totalBillablePages.
                         * @member {number|Long} totalBillablePages
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.totalBillablePages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata totalCharacters.
                         * @member {number|Long} totalCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.totalCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata translatedCharacters.
                         * @member {number|Long} translatedCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.translatedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata failedCharacters.
                         * @member {number|Long} failedCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.failedCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata totalBillableCharacters.
                         * @member {number|Long} totalBillableCharacters
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.totalBillableCharacters = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * BatchTranslateDocumentMetadata submitTime.
                         * @member {google.protobuf.ITimestamp|null|undefined} submitTime
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         */
                        BatchTranslateDocumentMetadata.prototype.submitTime = null;
    
                        /**
                         * Creates a new BatchTranslateDocumentMetadata instance using the specified properties.
                         * @function create
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentMetadata=} [properties] Properties to set
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata} BatchTranslateDocumentMetadata instance
                         */
                        BatchTranslateDocumentMetadata.create = function create(properties) {
                            return new BatchTranslateDocumentMetadata(properties);
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentMetadata message. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata.verify|verify} messages.
                         * @function encode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentMetadata} message BatchTranslateDocumentMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentMetadata.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                            if (message.totalPages != null && Object.hasOwnProperty.call(message, "totalPages"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalPages);
                            if (message.translatedPages != null && Object.hasOwnProperty.call(message, "translatedPages"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.translatedPages);
                            if (message.failedPages != null && Object.hasOwnProperty.call(message, "failedPages"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.failedPages);
                            if (message.totalBillablePages != null && Object.hasOwnProperty.call(message, "totalBillablePages"))
                                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.totalBillablePages);
                            if (message.totalCharacters != null && Object.hasOwnProperty.call(message, "totalCharacters"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.totalCharacters);
                            if (message.translatedCharacters != null && Object.hasOwnProperty.call(message, "translatedCharacters"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.translatedCharacters);
                            if (message.failedCharacters != null && Object.hasOwnProperty.call(message, "failedCharacters"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.failedCharacters);
                            if (message.totalBillableCharacters != null && Object.hasOwnProperty.call(message, "totalBillableCharacters"))
                                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.totalBillableCharacters);
                            if (message.submitTime != null && Object.hasOwnProperty.call(message, "submitTime"))
                                $root.google.protobuf.Timestamp.encode(message.submitTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BatchTranslateDocumentMetadata message, length delimited. Does not implicitly {@link google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.IBatchTranslateDocumentMetadata} message BatchTranslateDocumentMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BatchTranslateDocumentMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentMetadata message from the specified reader or buffer.
                         * @function decode
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata} BatchTranslateDocumentMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentMetadata.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.state = reader.int32();
                                    break;
                                case 2:
                                    message.totalPages = reader.int64();
                                    break;
                                case 3:
                                    message.translatedPages = reader.int64();
                                    break;
                                case 4:
                                    message.failedPages = reader.int64();
                                    break;
                                case 5:
                                    message.totalBillablePages = reader.int64();
                                    break;
                                case 6:
                                    message.totalCharacters = reader.int64();
                                    break;
                                case 7:
                                    message.translatedCharacters = reader.int64();
                                    break;
                                case 8:
                                    message.failedCharacters = reader.int64();
                                    break;
                                case 9:
                                    message.totalBillableCharacters = reader.int64();
                                    break;
                                case 10:
                                    message.submitTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BatchTranslateDocumentMetadata message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata} BatchTranslateDocumentMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BatchTranslateDocumentMetadata.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BatchTranslateDocumentMetadata message.
                         * @function verify
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BatchTranslateDocumentMetadata.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.state != null && message.hasOwnProperty("state"))
                                switch (message.state) {
                                default:
                                    return "state: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                            if (message.totalPages != null && message.hasOwnProperty("totalPages"))
                                if (!$util.isInteger(message.totalPages) && !(message.totalPages && $util.isInteger(message.totalPages.low) && $util.isInteger(message.totalPages.high)))
                                    return "totalPages: integer|Long expected";
                            if (message.translatedPages != null && message.hasOwnProperty("translatedPages"))
                                if (!$util.isInteger(message.translatedPages) && !(message.translatedPages && $util.isInteger(message.translatedPages.low) && $util.isInteger(message.translatedPages.high)))
                                    return "translatedPages: integer|Long expected";
                            if (message.failedPages != null && message.hasOwnProperty("failedPages"))
                                if (!$util.isInteger(message.failedPages) && !(message.failedPages && $util.isInteger(message.failedPages.low) && $util.isInteger(message.failedPages.high)))
                                    return "failedPages: integer|Long expected";
                            if (message.totalBillablePages != null && message.hasOwnProperty("totalBillablePages"))
                                if (!$util.isInteger(message.totalBillablePages) && !(message.totalBillablePages && $util.isInteger(message.totalBillablePages.low) && $util.isInteger(message.totalBillablePages.high)))
                                    return "totalBillablePages: integer|Long expected";
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (!$util.isInteger(message.totalCharacters) && !(message.totalCharacters && $util.isInteger(message.totalCharacters.low) && $util.isInteger(message.totalCharacters.high)))
                                    return "totalCharacters: integer|Long expected";
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (!$util.isInteger(message.translatedCharacters) && !(message.translatedCharacters && $util.isInteger(message.translatedCharacters.low) && $util.isInteger(message.translatedCharacters.high)))
                                    return "translatedCharacters: integer|Long expected";
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (!$util.isInteger(message.failedCharacters) && !(message.failedCharacters && $util.isInteger(message.failedCharacters.low) && $util.isInteger(message.failedCharacters.high)))
                                    return "failedCharacters: integer|Long expected";
                            if (message.totalBillableCharacters != null && message.hasOwnProperty("totalBillableCharacters"))
                                if (!$util.isInteger(message.totalBillableCharacters) && !(message.totalBillableCharacters && $util.isInteger(message.totalBillableCharacters.low) && $util.isInteger(message.totalBillableCharacters.high)))
                                    return "totalBillableCharacters: integer|Long expected";
                            if (message.submitTime != null && message.hasOwnProperty("submitTime")) {
                                var error = $root.google.protobuf.Timestamp.verify(message.submitTime);
                                if (error)
                                    return "submitTime." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BatchTranslateDocumentMetadata message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata} BatchTranslateDocumentMetadata
                         */
                        BatchTranslateDocumentMetadata.fromObject = function fromObject(object) {
                            if (object instanceof $root.google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata)
                                return object;
                            var message = new $root.google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata();
                            switch (object.state) {
                            case "STATE_UNSPECIFIED":
                            case 0:
                                message.state = 0;
                                break;
                            case "RUNNING":
                            case 1:
                                message.state = 1;
                                break;
                            case "SUCCEEDED":
                            case 2:
                                message.state = 2;
                                break;
                            case "FAILED":
                            case 3:
                                message.state = 3;
                                break;
                            case "CANCELLING":
                            case 4:
                                message.state = 4;
                                break;
                            case "CANCELLED":
                            case 5:
                                message.state = 5;
                                break;
                            }
                            if (object.totalPages != null)
                                if ($util.Long)
                                    (message.totalPages = $util.Long.fromValue(object.totalPages)).unsigned = false;
                                else if (typeof object.totalPages === "string")
                                    message.totalPages = parseInt(object.totalPages, 10);
                                else if (typeof object.totalPages === "number")
                                    message.totalPages = object.totalPages;
                                else if (typeof object.totalPages === "object")
                                    message.totalPages = new $util.LongBits(object.totalPages.low >>> 0, object.totalPages.high >>> 0).toNumber();
                            if (object.translatedPages != null)
                                if ($util.Long)
                                    (message.translatedPages = $util.Long.fromValue(object.translatedPages)).unsigned = false;
                                else if (typeof object.translatedPages === "string")
                                    message.translatedPages = parseInt(object.translatedPages, 10);
                                else if (typeof object.translatedPages === "number")
                                    message.translatedPages = object.translatedPages;
                                else if (typeof object.translatedPages === "object")
                                    message.translatedPages = new $util.LongBits(object.translatedPages.low >>> 0, object.translatedPages.high >>> 0).toNumber();
                            if (object.failedPages != null)
                                if ($util.Long)
                                    (message.failedPages = $util.Long.fromValue(object.failedPages)).unsigned = false;
                                else if (typeof object.failedPages === "string")
                                    message.failedPages = parseInt(object.failedPages, 10);
                                else if (typeof object.failedPages === "number")
                                    message.failedPages = object.failedPages;
                                else if (typeof object.failedPages === "object")
                                    message.failedPages = new $util.LongBits(object.failedPages.low >>> 0, object.failedPages.high >>> 0).toNumber();
                            if (object.totalBillablePages != null)
                                if ($util.Long)
                                    (message.totalBillablePages = $util.Long.fromValue(object.totalBillablePages)).unsigned = false;
                                else if (typeof object.totalBillablePages === "string")
                                    message.totalBillablePages = parseInt(object.totalBillablePages, 10);
                                else if (typeof object.totalBillablePages === "number")
                                    message.totalBillablePages = object.totalBillablePages;
                                else if (typeof object.totalBillablePages === "object")
                                    message.totalBillablePages = new $util.LongBits(object.totalBillablePages.low >>> 0, object.totalBillablePages.high >>> 0).toNumber();
                            if (object.totalCharacters != null)
                                if ($util.Long)
                                    (message.totalCharacters = $util.Long.fromValue(object.totalCharacters)).unsigned = false;
                                else if (typeof object.totalCharacters === "string")
                                    message.totalCharacters = parseInt(object.totalCharacters, 10);
                                else if (typeof object.totalCharacters === "number")
                                    message.totalCharacters = object.totalCharacters;
                                else if (typeof object.totalCharacters === "object")
                                    message.totalCharacters = new $util.LongBits(object.totalCharacters.low >>> 0, object.totalCharacters.high >>> 0).toNumber();
                            if (object.translatedCharacters != null)
                                if ($util.Long)
                                    (message.translatedCharacters = $util.Long.fromValue(object.translatedCharacters)).unsigned = false;
                                else if (typeof object.translatedCharacters === "string")
                                    message.translatedCharacters = parseInt(object.translatedCharacters, 10);
                                else if (typeof object.translatedCharacters === "number")
                                    message.translatedCharacters = object.translatedCharacters;
                                else if (typeof object.translatedCharacters === "object")
                                    message.translatedCharacters = new $util.LongBits(object.translatedCharacters.low >>> 0, object.translatedCharacters.high >>> 0).toNumber();
                            if (object.failedCharacters != null)
                                if ($util.Long)
                                    (message.failedCharacters = $util.Long.fromValue(object.failedCharacters)).unsigned = false;
                                else if (typeof object.failedCharacters === "string")
                                    message.failedCharacters = parseInt(object.failedCharacters, 10);
                                else if (typeof object.failedCharacters === "number")
                                    message.failedCharacters = object.failedCharacters;
                                else if (typeof object.failedCharacters === "object")
                                    message.failedCharacters = new $util.LongBits(object.failedCharacters.low >>> 0, object.failedCharacters.high >>> 0).toNumber();
                            if (object.totalBillableCharacters != null)
                                if ($util.Long)
                                    (message.totalBillableCharacters = $util.Long.fromValue(object.totalBillableCharacters)).unsigned = false;
                                else if (typeof object.totalBillableCharacters === "string")
                                    message.totalBillableCharacters = parseInt(object.totalBillableCharacters, 10);
                                else if (typeof object.totalBillableCharacters === "number")
                                    message.totalBillableCharacters = object.totalBillableCharacters;
                                else if (typeof object.totalBillableCharacters === "object")
                                    message.totalBillableCharacters = new $util.LongBits(object.totalBillableCharacters.low >>> 0, object.totalBillableCharacters.high >>> 0).toNumber();
                            if (object.submitTime != null) {
                                if (typeof object.submitTime !== "object")
                                    throw TypeError(".google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata.submitTime: object expected");
                                message.submitTime = $root.google.protobuf.Timestamp.fromObject(object.submitTime);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BatchTranslateDocumentMetadata message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @static
                         * @param {google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata} message BatchTranslateDocumentMetadata
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BatchTranslateDocumentMetadata.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedPages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedPages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalBillablePages = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalBillablePages = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.translatedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.translatedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.failedCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.failedCharacters = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.totalBillableCharacters = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.totalBillableCharacters = options.longs === String ? "0" : 0;
                                object.submitTime = null;
                            }
                            if (message.state != null && message.hasOwnProperty("state"))
                                object.state = options.enums === String ? $root.google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata.State[message.state] : message.state;
                            if (message.totalPages != null && message.hasOwnProperty("totalPages"))
                                if (typeof message.totalPages === "number")
                                    object.totalPages = options.longs === String ? String(message.totalPages) : message.totalPages;
                                else
                                    object.totalPages = options.longs === String ? $util.Long.prototype.toString.call(message.totalPages) : options.longs === Number ? new $util.LongBits(message.totalPages.low >>> 0, message.totalPages.high >>> 0).toNumber() : message.totalPages;
                            if (message.translatedPages != null && message.hasOwnProperty("translatedPages"))
                                if (typeof message.translatedPages === "number")
                                    object.translatedPages = options.longs === String ? String(message.translatedPages) : message.translatedPages;
                                else
                                    object.translatedPages = options.longs === String ? $util.Long.prototype.toString.call(message.translatedPages) : options.longs === Number ? new $util.LongBits(message.translatedPages.low >>> 0, message.translatedPages.high >>> 0).toNumber() : message.translatedPages;
                            if (message.failedPages != null && message.hasOwnProperty("failedPages"))
                                if (typeof message.failedPages === "number")
                                    object.failedPages = options.longs === String ? String(message.failedPages) : message.failedPages;
                                else
                                    object.failedPages = options.longs === String ? $util.Long.prototype.toString.call(message.failedPages) : options.longs === Number ? new $util.LongBits(message.failedPages.low >>> 0, message.failedPages.high >>> 0).toNumber() : message.failedPages;
                            if (message.totalBillablePages != null && message.hasOwnProperty("totalBillablePages"))
                                if (typeof message.totalBillablePages === "number")
                                    object.totalBillablePages = options.longs === String ? String(message.totalBillablePages) : message.totalBillablePages;
                                else
                                    object.totalBillablePages = options.longs === String ? $util.Long.prototype.toString.call(message.totalBillablePages) : options.longs === Number ? new $util.LongBits(message.totalBillablePages.low >>> 0, message.totalBillablePages.high >>> 0).toNumber() : message.totalBillablePages;
                            if (message.totalCharacters != null && message.hasOwnProperty("totalCharacters"))
                                if (typeof message.totalCharacters === "number")
                                    object.totalCharacters = options.longs === String ? String(message.totalCharacters) : message.totalCharacters;
                                else
                                    object.totalCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalCharacters) : options.longs === Number ? new $util.LongBits(message.totalCharacters.low >>> 0, message.totalCharacters.high >>> 0).toNumber() : message.totalCharacters;
                            if (message.translatedCharacters != null && message.hasOwnProperty("translatedCharacters"))
                                if (typeof message.translatedCharacters === "number")
                                    object.translatedCharacters = options.longs === String ? String(message.translatedCharacters) : message.translatedCharacters;
                                else
                                    object.translatedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.translatedCharacters) : options.longs === Number ? new $util.LongBits(message.translatedCharacters.low >>> 0, message.translatedCharacters.high >>> 0).toNumber() : message.translatedCharacters;
                            if (message.failedCharacters != null && message.hasOwnProperty("failedCharacters"))
                                if (typeof message.failedCharacters === "number")
                                    object.failedCharacters = options.longs === String ? String(message.failedCharacters) : message.failedCharacters;
                                else
                                    object.failedCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.failedCharacters) : options.longs === Number ? new $util.LongBits(message.failedCharacters.low >>> 0, message.failedCharacters.high >>> 0).toNumber() : message.failedCharacters;
                            if (message.totalBillableCharacters != null && message.hasOwnProperty("totalBillableCharacters"))
                                if (typeof message.totalBillableCharacters === "number")
                                    object.totalBillableCharacters = options.longs === String ? String(message.totalBillableCharacters) : message.totalBillableCharacters;
                                else
                                    object.totalBillableCharacters = options.longs === String ? $util.Long.prototype.toString.call(message.totalBillableCharacters) : options.longs === Number ? new $util.LongBits(message.totalBillableCharacters.low >>> 0, message.totalBillableCharacters.high >>> 0).toNumber() : message.totalBillableCharacters;
                            if (message.submitTime != null && message.hasOwnProperty("submitTime"))
                                object.submitTime = $root.google.protobuf.Timestamp.toObject(message.submitTime, options);
                            return object;
                        };
    
                        /**
                         * Converts this BatchTranslateDocumentMetadata to JSON.
                         * @function toJSON
                         * @memberof google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BatchTranslateDocumentMetadata.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * State enum.
                         * @name google.cloud.translation.v3beta1.BatchTranslateDocumentMetadata.State
                         * @enum {number}
                         * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                         * @property {number} RUNNING=1 RUNNING value
                         * @property {number} SUCCEEDED=2 SUCCEEDED value
                         * @property {number} FAILED=3 FAILED value
                         * @property {number} CANCELLING=4 CANCELLING value
                         * @property {number} CANCELLED=5 CANCELLED value
                         */
                        BatchTranslateDocumentMetadata.State = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "RUNNING"] = 1;
                            values[valuesById[2] = "SUCCEEDED"] = 2;
                            values[valuesById[3] = "FAILED"] = 3;
                            values[valuesById[4] = "CANCELLING"] = 4;
                            values[valuesById[5] = "CANCELLED"] = 5;
                            return values;
                        })();
    
                        return BatchTranslateDocumentMetadata;
                    })();
    
                    return v3beta1;
                })();
    
                return translation;
            })();
    
            return cloud;
        })();
    
        google.api = (function() {
    
            /**
             * Namespace api.
             * @memberof google
             * @namespace
             */
            var api = {};
    
            api.Http = (function() {
    
                /**
                 * Properties of a Http.
                 * @memberof google.api
                 * @interface IHttp
                 * @property {Array.<google.api.IHttpRule>|null} [rules] Http rules
                 * @property {boolean|null} [fullyDecodeReservedExpansion] Http fullyDecodeReservedExpansion
                 */
    
                /**
                 * Constructs a new Http.
                 * @memberof google.api
                 * @classdesc Represents a Http.
                 * @implements IHttp
                 * @constructor
                 * @param {google.api.IHttp=} [properties] Properties to set
                 */
                function Http(properties) {
                    this.rules = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Http rules.
                 * @member {Array.<google.api.IHttpRule>} rules
                 * @memberof google.api.Http
                 * @instance
                 */
                Http.prototype.rules = $util.emptyArray;
    
                /**
                 * Http fullyDecodeReservedExpansion.
                 * @member {boolean} fullyDecodeReservedExpansion
                 * @memberof google.api.Http
                 * @instance
                 */
                Http.prototype.fullyDecodeReservedExpansion = false;
    
                /**
                 * Creates a new Http instance using the specified properties.
                 * @function create
                 * @memberof google.api.Http
                 * @static
                 * @param {google.api.IHttp=} [properties] Properties to set
                 * @returns {google.api.Http} Http instance
                 */
                Http.create = function create(properties) {
                    return new Http(properties);
                };
    
                /**
                 * Encodes the specified Http message. Does not implicitly {@link google.api.Http.verify|verify} messages.
                 * @function encode
                 * @memberof google.api.Http
                 * @static
                 * @param {google.api.IHttp} message Http message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Http.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.rules != null && message.rules.length)
                        for (var i = 0; i < message.rules.length; ++i)
                            $root.google.api.HttpRule.encode(message.rules[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.fullyDecodeReservedExpansion != null && Object.hasOwnProperty.call(message, "fullyDecodeReservedExpansion"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.fullyDecodeReservedExpansion);
                    return writer;
                };
    
                /**
                 * Encodes the specified Http message, length delimited. Does not implicitly {@link google.api.Http.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.api.Http
                 * @static
                 * @param {google.api.IHttp} message Http message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Http.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a Http message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.api.Http
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.api.Http} Http
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Http.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.Http();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.rules && message.rules.length))
                                message.rules = [];
                            message.rules.push($root.google.api.HttpRule.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            message.fullyDecodeReservedExpansion = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a Http message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.api.Http
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.api.Http} Http
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Http.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a Http message.
                 * @function verify
                 * @memberof google.api.Http
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Http.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.rules != null && message.hasOwnProperty("rules")) {
                        if (!Array.isArray(message.rules))
                            return "rules: array expected";
                        for (var i = 0; i < message.rules.length; ++i) {
                            var error = $root.google.api.HttpRule.verify(message.rules[i]);
                            if (error)
                                return "rules." + error;
                        }
                    }
                    if (message.fullyDecodeReservedExpansion != null && message.hasOwnProperty("fullyDecodeReservedExpansion"))
                        if (typeof message.fullyDecodeReservedExpansion !== "boolean")
                            return "fullyDecodeReservedExpansion: boolean expected";
                    return null;
                };
    
                /**
                 * Creates a Http message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.api.Http
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.api.Http} Http
                 */
                Http.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.api.Http)
                        return object;
                    var message = new $root.google.api.Http();
                    if (object.rules) {
                        if (!Array.isArray(object.rules))
                            throw TypeError(".google.api.Http.rules: array expected");
                        message.rules = [];
                        for (var i = 0; i < object.rules.length; ++i) {
                            if (typeof object.rules[i] !== "object")
                                throw TypeError(".google.api.Http.rules: object expected");
                            message.rules[i] = $root.google.api.HttpRule.fromObject(object.rules[i]);
                        }
                    }
                    if (object.fullyDecodeReservedExpansion != null)
                        message.fullyDecodeReservedExpansion = Boolean(object.fullyDecodeReservedExpansion);
                    return message;
                };
    
                /**
                 * Creates a plain object from a Http message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.api.Http
                 * @static
                 * @param {google.api.Http} message Http
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Http.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.rules = [];
                    if (options.defaults)
                        object.fullyDecodeReservedExpansion = false;
                    if (message.rules && message.rules.length) {
                        object.rules = [];
                        for (var j = 0; j < message.rules.length; ++j)
                            object.rules[j] = $root.google.api.HttpRule.toObject(message.rules[j], options);
                    }
                    if (message.fullyDecodeReservedExpansion != null && message.hasOwnProperty("fullyDecodeReservedExpansion"))
                        object.fullyDecodeReservedExpansion = message.fullyDecodeReservedExpansion;
                    return object;
                };
    
                /**
                 * Converts this Http to JSON.
                 * @function toJSON
                 * @memberof google.api.Http
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Http.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Http;
            })();
    
            api.HttpRule = (function() {
    
                /**
                 * Properties of a HttpRule.
                 * @memberof google.api
                 * @interface IHttpRule
                 * @property {string|null} [selector] HttpRule selector
                 * @property {string|null} [get] HttpRule get
                 * @property {string|null} [put] HttpRule put
                 * @property {string|null} [post] HttpRule post
                 * @property {string|null} ["delete"] HttpRule delete
                 * @property {string|null} [patch] HttpRule patch
                 * @property {google.api.ICustomHttpPattern|null} [custom] HttpRule custom
                 * @property {string|null} [body] HttpRule body
                 * @property {string|null} [responseBody] HttpRule responseBody
                 * @property {Array.<google.api.IHttpRule>|null} [additionalBindings] HttpRule additionalBindings
                 */
    
                /**
                 * Constructs a new HttpRule.
                 * @memberof google.api
                 * @classdesc Represents a HttpRule.
                 * @implements IHttpRule
                 * @constructor
                 * @param {google.api.IHttpRule=} [properties] Properties to set
                 */
                function HttpRule(properties) {
                    this.additionalBindings = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * HttpRule selector.
                 * @member {string} selector
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.selector = "";
    
                /**
                 * HttpRule get.
                 * @member {string|null|undefined} get
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.get = null;
    
                /**
                 * HttpRule put.
                 * @member {string|null|undefined} put
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.put = null;
    
                /**
                 * HttpRule post.
                 * @member {string|null|undefined} post
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.post = null;
    
                /**
                 * HttpRule delete.
                 * @member {string|null|undefined} delete
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype["delete"] = null;
    
                /**
                 * HttpRule patch.
                 * @member {string|null|undefined} patch
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.patch = null;
    
                /**
                 * HttpRule custom.
                 * @member {google.api.ICustomHttpPattern|null|undefined} custom
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.custom = null;
    
                /**
                 * HttpRule body.
                 * @member {string} body
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.body = "";
    
                /**
                 * HttpRule responseBody.
                 * @member {string} responseBody
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.responseBody = "";
    
                /**
                 * HttpRule additionalBindings.
                 * @member {Array.<google.api.IHttpRule>} additionalBindings
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.additionalBindings = $util.emptyArray;
    
                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;
    
                /**
                 * HttpRule pattern.
                 * @member {"get"|"put"|"post"|"delete"|"patch"|"custom"|undefined} pattern
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                Object.defineProperty(HttpRule.prototype, "pattern", {
                    get: $util.oneOfGetter($oneOfFields = ["get", "put", "post", "delete", "patch", "custom"]),
                    set: $util.oneOfSetter($oneOfFields)
                });
    
                /**
                 * Creates a new HttpRule instance using the specified properties.
                 * @function create
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {google.api.IHttpRule=} [properties] Properties to set
                 * @returns {google.api.HttpRule} HttpRule instance
                 */
                HttpRule.create = function create(properties) {
                    return new HttpRule(properties);
                };
    
                /**
                 * Encodes the specified HttpRule message. Does not implicitly {@link google.api.HttpRule.verify|verify} messages.
                 * @function encode
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {google.api.IHttpRule} message HttpRule message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HttpRule.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.selector != null && Object.hasOwnProperty.call(message, "selector"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.selector);
                    if (message.get != null && Object.hasOwnProperty.call(message, "get"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.get);
                    if (message.put != null && Object.hasOwnProperty.call(message, "put"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.put);
                    if (message.post != null && Object.hasOwnProperty.call(message, "post"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.post);
                    if (message["delete"] != null && Object.hasOwnProperty.call(message, "delete"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message["delete"]);
                    if (message.patch != null && Object.hasOwnProperty.call(message, "patch"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.patch);
                    if (message.body != null && Object.hasOwnProperty.call(message, "body"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.body);
                    if (message.custom != null && Object.hasOwnProperty.call(message, "custom"))
                        $root.google.api.CustomHttpPattern.encode(message.custom, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.additionalBindings != null && message.additionalBindings.length)
                        for (var i = 0; i < message.additionalBindings.length; ++i)
                            $root.google.api.HttpRule.encode(message.additionalBindings[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.responseBody != null && Object.hasOwnProperty.call(message, "responseBody"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.responseBody);
                    return writer;
                };
    
                /**
                 * Encodes the specified HttpRule message, length delimited. Does not implicitly {@link google.api.HttpRule.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {google.api.IHttpRule} message HttpRule message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HttpRule.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a HttpRule message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.api.HttpRule} HttpRule
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HttpRule.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.HttpRule();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.selector = reader.string();
                            break;
                        case 2:
                            message.get = reader.string();
                            break;
                        case 3:
                            message.put = reader.string();
                            break;
                        case 4:
                            message.post = reader.string();
                            break;
                        case 5:
                            message["delete"] = reader.string();
                            break;
                        case 6:
                            message.patch = reader.string();
                            break;
                        case 8:
                            message.custom = $root.google.api.CustomHttpPattern.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.body = reader.string();
                            break;
                        case 12:
                            message.responseBody = reader.string();
                            break;
                        case 11:
                            if (!(message.additionalBindings && message.additionalBindings.length))
                                message.additionalBindings = [];
                            message.additionalBindings.push($root.google.api.HttpRule.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a HttpRule message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.api.HttpRule} HttpRule
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HttpRule.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a HttpRule message.
                 * @function verify
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HttpRule.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.selector != null && message.hasOwnProperty("selector"))
                        if (!$util.isString(message.selector))
                            return "selector: string expected";
                    if (message.get != null && message.hasOwnProperty("get")) {
                        properties.pattern = 1;
                        if (!$util.isString(message.get))
                            return "get: string expected";
                    }
                    if (message.put != null && message.hasOwnProperty("put")) {
                        if (properties.pattern === 1)
                            return "pattern: multiple values";
                        properties.pattern = 1;
                        if (!$util.isString(message.put))
                            return "put: string expected";
                    }
                    if (message.post != null && message.hasOwnProperty("post")) {
                        if (properties.pattern === 1)
                            return "pattern: multiple values";
                        properties.pattern = 1;
                        if (!$util.isString(message.post))
                            return "post: string expected";
                    }
                    if (message["delete"] != null && message.hasOwnProperty("delete")) {
                        if (properties.pattern === 1)
                            return "pattern: multiple values";
                        properties.pattern = 1;
                        if (!$util.isString(message["delete"]))
                            return "delete: string expected";
                    }
                    if (message.patch != null && message.hasOwnProperty("patch")) {
                        if (properties.pattern === 1)
                            return "pattern: multiple values";
                        properties.pattern = 1;
                        if (!$util.isString(message.patch))
                            return "patch: string expected";
                    }
                    if (message.custom != null && message.hasOwnProperty("custom")) {
                        if (properties.pattern === 1)
                            return "pattern: multiple values";
                        properties.pattern = 1;
                        {
                            var error = $root.google.api.CustomHttpPattern.verify(message.custom);
                            if (error)
                                return "custom." + error;
                        }
                    }
                    if (message.body != null && message.hasOwnProperty("body"))
                        if (!$util.isString(message.body))
                            return "body: string expected";
                    if (message.responseBody != null && message.hasOwnProperty("responseBody"))
                        if (!$util.isString(message.responseBody))
                            return "responseBody: string expected";
                    if (message.additionalBindings != null && message.hasOwnProperty("additionalBindings")) {
                        if (!Array.isArray(message.additionalBindings))
                            return "additionalBindings: array expected";
                        for (var i = 0; i < message.additionalBindings.length; ++i) {
                            var error = $root.google.api.HttpRule.verify(message.additionalBindings[i]);
                            if (error)
                                return "additionalBindings." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a HttpRule message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.api.HttpRule} HttpRule
                 */
                HttpRule.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.api.HttpRule)
                        return object;
                    var message = new $root.google.api.HttpRule();
                    if (object.selector != null)
                        message.selector = String(object.selector);
                    if (object.get != null)
                        message.get = String(object.get);
                    if (object.put != null)
                        message.put = String(object.put);
                    if (object.post != null)
                        message.post = String(object.post);
                    if (object["delete"] != null)
                        message["delete"] = String(object["delete"]);
                    if (object.patch != null)
                        message.patch = String(object.patch);
                    if (object.custom != null) {
                        if (typeof object.custom !== "object")
                            throw TypeError(".google.api.HttpRule.custom: object expected");
                        message.custom = $root.google.api.CustomHttpPattern.fromObject(object.custom);
                    }
                    if (object.body != null)
                        message.body = String(object.body);
                    if (object.responseBody != null)
                        message.responseBody = String(object.responseBody);
                    if (object.additionalBindings) {
                        if (!Array.isArray(object.additionalBindings))
                            throw TypeError(".google.api.HttpRule.additionalBindings: array expected");
                        message.additionalBindings = [];
                        for (var i = 0; i < object.additionalBindings.length; ++i) {
                            if (typeof object.additionalBindings[i] !== "object")
                                throw TypeError(".google.api.HttpRule.additionalBindings: object expected");
                            message.additionalBindings[i] = $root.google.api.HttpRule.fromObject(object.additionalBindings[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a HttpRule message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {google.api.HttpRule} message HttpRule
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HttpRule.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.additionalBindings = [];
                    if (options.defaults) {
                        object.selector = "";
                        object.body = "";
                        object.responseBody = "";
                    }
                    if (message.selector != null && message.hasOwnProperty("selector"))
                        object.selector = message.selector;
                    if (message.get != null && message.hasOwnProperty("get")) {
                        object.get = message.get;
                        if (options.oneofs)
                            object.pattern = "get";
                    }
                    if (message.put != null && message.hasOwnProperty("put")) {
                        object.put = message.put;
                        if (options.oneofs)
                            object.pattern = "put";
                    }
                    if (message.post != null && message.hasOwnProperty("post")) {
                        object.post = message.post;
                        if (options.oneofs)
                            object.pattern = "post";
                    }
                    if (message["delete"] != null && message.hasOwnProperty("delete")) {
                        object["delete"] = message["delete"];
                        if (options.oneofs)
                            object.pattern = "delete";
                    }
                    if (message.patch != null && message.hasOwnProperty("patch")) {
                        object.patch = message.patch;
                        if (options.oneofs)
                            object.pattern = "patch";
                    }
                    if (message.body != null && message.hasOwnProperty("body"))
                        object.body = message.body;
                    if (message.custom != null && message.hasOwnProperty("custom")) {
                        object.custom = $root.google.api.CustomHttpPattern.toObject(message.custom, options);
                        if (options.oneofs)
                            object.pattern = "custom";
                    }
                    if (message.additionalBindings && message.additionalBindings.length) {
                        object.additionalBindings = [];
                        for (var j = 0; j < message.additionalBindings.length; ++j)
                            object.additionalBindings[j] = $root.google.api.HttpRule.toObject(message.additionalBindings[j], options);
                    }
                    if (message.responseBody != null && message.hasOwnProperty("responseBody"))
                        object.responseBody = message.responseBody;
                    return object;
                };
    
                /**
                 * Converts this HttpRule to JSON.
                 * @function toJSON
                 * @memberof google.api.HttpRule
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HttpRule.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return HttpRule;
            })();
    
            api.CustomHttpPattern = (function() {
    
                /**
                 * Properties of a CustomHttpPattern.
                 * @memberof google.api
                 * @interface ICustomHttpPattern
                 * @property {string|null} [kind] CustomHttpPattern kind
                 * @property {string|null} [path] CustomHttpPattern path
                 */
    
                /**
                 * Constructs a new CustomHttpPattern.
                 * @memberof google.api
                 * @classdesc Represents a CustomHttpPattern.
                 * @implements ICustomHttpPattern
                 * @constructor
                 * @param {google.api.ICustomHttpPattern=} [properties] Properties to set
                 */
                function CustomHttpPattern(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * CustomHttpPattern kind.
                 * @member {string} kind
                 * @memberof google.api.CustomHttpPattern
                 * @instance
                 */
                CustomHttpPattern.prototype.kind = "";
    
                /**
                 * CustomHttpPattern path.
                 * @member {string} path
                 * @memberof google.api.CustomHttpPattern
                 * @instance
                 */
                CustomHttpPattern.prototype.path = "";
    
                /**
                 * Creates a new CustomHttpPattern instance using the specified properties.
                 * @function create
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {google.api.ICustomHttpPattern=} [properties] Properties to set
                 * @returns {google.api.CustomHttpPattern} CustomHttpPattern instance
                 */
                CustomHttpPattern.create = function create(properties) {
                    return new CustomHttpPattern(properties);
                };
    
                /**
                 * Encodes the specified CustomHttpPattern message. Does not implicitly {@link google.api.CustomHttpPattern.verify|verify} messages.
                 * @function encode
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {google.api.ICustomHttpPattern} message CustomHttpPattern message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CustomHttpPattern.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.kind);
                    if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
                    return writer;
                };
    
                /**
                 * Encodes the specified CustomHttpPattern message, length delimited. Does not implicitly {@link google.api.CustomHttpPattern.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {google.api.ICustomHttpPattern} message CustomHttpPattern message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CustomHttpPattern.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a CustomHttpPattern message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.api.CustomHttpPattern} CustomHttpPattern
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CustomHttpPattern.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.CustomHttpPattern();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.kind = reader.string();
                            break;
                        case 2:
                            message.path = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a CustomHttpPattern message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.api.CustomHttpPattern} CustomHttpPattern
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CustomHttpPattern.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a CustomHttpPattern message.
                 * @function verify
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CustomHttpPattern.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.kind != null && message.hasOwnProperty("kind"))
                        if (!$util.isString(message.kind))
                            return "kind: string expected";
                    if (message.path != null && message.hasOwnProperty("path"))
                        if (!$util.isString(message.path))
                            return "path: string expected";
                    return null;
                };
    
                /**
                 * Creates a CustomHttpPattern message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.api.CustomHttpPattern} CustomHttpPattern
                 */
                CustomHttpPattern.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.api.CustomHttpPattern)
                        return object;
                    var message = new $root.google.api.CustomHttpPattern();
                    if (object.kind != null)
                        message.kind = String(object.kind);
                    if (object.path != null)
                        message.path = String(object.path);
                    return message;
                };
    
                /**
                 * Creates a plain object from a CustomHttpPattern message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {google.api.CustomHttpPattern} message CustomHttpPattern
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CustomHttpPattern.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.kind = "";
                        object.path = "";
                    }
                    if (message.kind != null && message.hasOwnProperty("kind"))
                        object.kind = message.kind;
                    if (message.path != null && message.hasOwnProperty("path"))
                        object.path = message.path;
                    return object;
                };
    
                /**
                 * Converts this CustomHttpPattern to JSON.
                 * @function toJSON
                 * @memberof google.api.CustomHttpPattern
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CustomHttpPattern.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return CustomHttpPattern;
            })();
    
            /**
             * FieldBehavior enum.
             * @name google.api.FieldBehavior
             * @enum {number}
             * @property {number} FIELD_BEHAVIOR_UNSPECIFIED=0 FIELD_BEHAVIOR_UNSPECIFIED value
             * @property {number} OPTIONAL=1 OPTIONAL value
             * @property {number} REQUIRED=2 REQUIRED value
             * @property {number} OUTPUT_ONLY=3 OUTPUT_ONLY value
             * @property {number} INPUT_ONLY=4 INPUT_ONLY value
             * @property {number} IMMUTABLE=5 IMMUTABLE value
             * @property {number} UNORDERED_LIST=6 UNORDERED_LIST value
             * @property {number} NON_EMPTY_DEFAULT=7 NON_EMPTY_DEFAULT value
             */
            api.FieldBehavior = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "FIELD_BEHAVIOR_UNSPECIFIED"] = 0;
                values[valuesById[1] = "OPTIONAL"] = 1;
                values[valuesById[2] = "REQUIRED"] = 2;
                values[valuesById[3] = "OUTPUT_ONLY"] = 3;
                values[valuesById[4] = "INPUT_ONLY"] = 4;
                values[valuesById[5] = "IMMUTABLE"] = 5;
                values[valuesById[6] = "UNORDERED_LIST"] = 6;
                values[valuesById[7] = "NON_EMPTY_DEFAULT"] = 7;
                return values;
            })();
    
            api.ResourceDescriptor = (function() {
    
                /**
                 * Properties of a ResourceDescriptor.
                 * @memberof google.api
                 * @interface IResourceDescriptor
                 * @property {string|null} [type] ResourceDescriptor type
                 * @property {Array.<string>|null} [pattern] ResourceDescriptor pattern
                 * @property {string|null} [nameField] ResourceDescriptor nameField
                 * @property {google.api.ResourceDescriptor.History|null} [history] ResourceDescriptor history
                 * @property {string|null} [plural] ResourceDescriptor plural
                 * @property {string|null} [singular] ResourceDescriptor singular
                 * @property {Array.<google.api.ResourceDescriptor.Style>|null} [style] ResourceDescriptor style
                 */
    
                /**
                 * Constructs a new ResourceDescriptor.
                 * @memberof google.api
                 * @classdesc Represents a ResourceDescriptor.
                 * @implements IResourceDescriptor
                 * @constructor
                 * @param {google.api.IResourceDescriptor=} [properties] Properties to set
                 */
                function ResourceDescriptor(properties) {
                    this.pattern = [];
                    this.style = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ResourceDescriptor type.
                 * @member {string} type
                 * @memberof google.api.ResourceDescriptor
                 * @instance
                 */
                ResourceDescriptor.prototype.type = "";
    
                /**
                 * ResourceDescriptor pattern.
                 * @member {Array.<string>} pattern
                 * @memberof google.api.ResourceDescriptor
                 * @instance
                 */
                ResourceDescriptor.prototype.pattern = $util.emptyArray;
    
                /**
                 * ResourceDescriptor nameField.
                 * @member {string} nameField
                 * @memberof google.api.ResourceDescriptor
                 * @instance
                 */
                ResourceDescriptor.prototype.nameField = "";
    
                /**
                 * ResourceDescriptor history.
                 * @member {google.api.ResourceDescriptor.History} history
                 * @memberof google.api.ResourceDescriptor
                 * @instance
                 */
                ResourceDescriptor.prototype.history = 0;
    
                /**
                 * ResourceDescriptor plural.
                 * @member {string} plural
                 * @memberof google.api.ResourceDescriptor
                 * @instance
                 */
                ResourceDescriptor.prototype.plural = "";
    
                /**
                 * ResourceDescriptor singular.
                 * @member {string} singular
                 * @memberof google.api.ResourceDescriptor
                 * @instance
                 */
                ResourceDescriptor.prototype.singular = "";
    
                /**
                 * ResourceDescriptor style.
                 * @member {Array.<google.api.ResourceDescriptor.Style>} style
                 * @memberof google.api.ResourceDescriptor
                 * @instance
                 */
                ResourceDescriptor.prototype.style = $util.emptyArray;
    
                /**
                 * Creates a new ResourceDescriptor instance using the specified properties.
                 * @function create
                 * @memberof google.api.ResourceDescriptor
                 * @static
                 * @param {google.api.IResourceDescriptor=} [properties] Properties to set
                 * @returns {google.api.ResourceDescriptor} ResourceDescriptor instance
                 */
                ResourceDescriptor.create = function create(properties) {
                    return new ResourceDescriptor(properties);
                };
    
                /**
                 * Encodes the specified ResourceDescriptor message. Does not implicitly {@link google.api.ResourceDescriptor.verify|verify} messages.
                 * @function encode
                 * @memberof google.api.ResourceDescriptor
                 * @static
                 * @param {google.api.IResourceDescriptor} message ResourceDescriptor message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResourceDescriptor.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                    if (message.pattern != null && message.pattern.length)
                        for (var i = 0; i < message.pattern.length; ++i)
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pattern[i]);
                    if (message.nameField != null && Object.hasOwnProperty.call(message, "nameField"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.nameField);
                    if (message.history != null && Object.hasOwnProperty.call(message, "history"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.history);
                    if (message.plural != null && Object.hasOwnProperty.call(message, "plural"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.plural);
                    if (message.singular != null && Object.hasOwnProperty.call(message, "singular"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.singular);
                    if (message.style != null && message.style.length) {
                        writer.uint32(/* id 10, wireType 2 =*/82).fork();
                        for (var i = 0; i < message.style.length; ++i)
                            writer.int32(message.style[i]);
                        writer.ldelim();
                    }
                    return writer;
                };
    
                /**
                 * Encodes the specified ResourceDescriptor message, length delimited. Does not implicitly {@link google.api.ResourceDescriptor.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.api.ResourceDescriptor
                 * @static
                 * @param {google.api.IResourceDescriptor} message ResourceDescriptor message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResourceDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ResourceDescriptor message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.api.ResourceDescriptor
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.api.ResourceDescriptor} ResourceDescriptor
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResourceDescriptor.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.ResourceDescriptor();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.type = reader.string();
                            break;
                        case 2:
                            if (!(message.pattern && message.pattern.length))
                                message.pattern = [];
                            message.pattern.push(reader.string());
                            break;
                        case 3:
                            message.nameField = reader.string();
                            break;
                        case 4:
                            message.history = reader.int32();
                            break;
                        case 5:
                            message.plural = reader.string();
                            break;
                        case 6:
                            message.singular = reader.string();
                            break;
                        case 10:
                            if (!(message.style && message.style.length))
                                message.style = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.style.push(reader.int32());
                            } else
                                message.style.push(reader.int32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ResourceDescriptor message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.api.ResourceDescriptor
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.api.ResourceDescriptor} ResourceDescriptor
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResourceDescriptor.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ResourceDescriptor message.
                 * @function verify
                 * @memberof google.api.ResourceDescriptor
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ResourceDescriptor.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        if (!$util.isString(message.type))
                            return "type: string expected";
                    if (message.pattern != null && message.hasOwnProperty("pattern")) {
                        if (!Array.isArray(message.pattern))
                            return "pattern: array expected";
                        for (var i = 0; i < message.pattern.length; ++i)
                            if (!$util.isString(message.pattern[i]))
                                return "pattern: string[] expected";
                    }
                    if (message.nameField != null && message.hasOwnProperty("nameField"))
                        if (!$util.isString(message.nameField))
                            return "nameField: string expected";
                    if (message.history != null && message.hasOwnProperty("history"))
                        switch (message.history) {
                        default:
                            return "history: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.plural != null && message.hasOwnProperty("plural"))
                        if (!$util.isString(message.plural))
                            return "plural: string expected";
                    if (message.singular != null && message.hasOwnProperty("singular"))
                        if (!$util.isString(message.singular))
                            return "singular: string expected";
                    if (message.style != null && message.hasOwnProperty("style")) {
                        if (!Array.isArray(message.style))
                            return "style: array expected";
                        for (var i = 0; i < message.style.length; ++i)
                            switch (message.style[i]) {
                            default:
                                return "style: enum value[] expected";
                            case 0:
                            case 1:
                                break;
                            }
                    }
                    return null;
                };
    
                /**
                 * Creates a ResourceDescriptor message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.api.ResourceDescriptor
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.api.ResourceDescriptor} ResourceDescriptor
                 */
                ResourceDescriptor.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.api.ResourceDescriptor)
                        return object;
                    var message = new $root.google.api.ResourceDescriptor();
                    if (object.type != null)
                        message.type = String(object.type);
                    if (object.pattern) {
                        if (!Array.isArray(object.pattern))
                            throw TypeError(".google.api.ResourceDescriptor.pattern: array expected");
                        message.pattern = [];
                        for (var i = 0; i < object.pattern.length; ++i)
                            message.pattern[i] = String(object.pattern[i]);
                    }
                    if (object.nameField != null)
                        message.nameField = String(object.nameField);
                    switch (object.history) {
                    case "HISTORY_UNSPECIFIED":
                    case 0:
                        message.history = 0;
                        break;
                    case "ORIGINALLY_SINGLE_PATTERN":
                    case 1:
                        message.history = 1;
                        break;
                    case "FUTURE_MULTI_PATTERN":
                    case 2:
                        message.history = 2;
                        break;
                    }
                    if (object.plural != null)
                        message.plural = String(object.plural);
                    if (object.singular != null)
                        message.singular = String(object.singular);
                    if (object.style) {
                        if (!Array.isArray(object.style))
                            throw TypeError(".google.api.ResourceDescriptor.style: array expected");
                        message.style = [];
                        for (var i = 0; i < object.style.length; ++i)
                            switch (object.style[i]) {
                            default:
                            case "STYLE_UNSPECIFIED":
                            case 0:
                                message.style[i] = 0;
                                break;
                            case "DECLARATIVE_FRIENDLY":
                            case 1:
                                message.style[i] = 1;
                                break;
                            }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a ResourceDescriptor message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.api.ResourceDescriptor
                 * @static
                 * @param {google.api.ResourceDescriptor} message ResourceDescriptor
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ResourceDescriptor.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.pattern = [];
                        object.style = [];
                    }
                    if (options.defaults) {
                        object.type = "";
                        object.nameField = "";
                        object.history = options.enums === String ? "HISTORY_UNSPECIFIED" : 0;
                        object.plural = "";
                        object.singular = "";
                    }
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = message.type;
                    if (message.pattern && message.pattern.length) {
                        object.pattern = [];
                        for (var j = 0; j < message.pattern.length; ++j)
                            object.pattern[j] = message.pattern[j];
                    }
                    if (message.nameField != null && message.hasOwnProperty("nameField"))
                        object.nameField = message.nameField;
                    if (message.history != null && message.hasOwnProperty("history"))
                        object.history = options.enums === String ? $root.google.api.ResourceDescriptor.History[message.history] : message.history;
                    if (message.plural != null && message.hasOwnProperty("plural"))
                        object.plural = message.plural;
                    if (message.singular != null && message.hasOwnProperty("singular"))
                        object.singular = message.singular;
                    if (message.style && message.style.length) {
                        object.style = [];
                        for (var j = 0; j < message.style.length; ++j)
                            object.style[j] = options.enums === String ? $root.google.api.ResourceDescriptor.Style[message.style[j]] : message.style[j];
                    }
                    return object;
                };
    
                /**
                 * Converts this ResourceDescriptor to JSON.
                 * @function toJSON
                 * @memberof google.api.ResourceDescriptor
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ResourceDescriptor.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * History enum.
                 * @name google.api.ResourceDescriptor.History
                 * @enum {number}
                 * @property {number} HISTORY_UNSPECIFIED=0 HISTORY_UNSPECIFIED value
                 * @property {number} ORIGINALLY_SINGLE_PATTERN=1 ORIGINALLY_SINGLE_PATTERN value
                 * @property {number} FUTURE_MULTI_PATTERN=2 FUTURE_MULTI_PATTERN value
                 */
                ResourceDescriptor.History = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "HISTORY_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "ORIGINALLY_SINGLE_PATTERN"] = 1;
                    values[valuesById[2] = "FUTURE_MULTI_PATTERN"] = 2;
                    return values;
                })();
    
                /**
                 * Style enum.
                 * @name google.api.ResourceDescriptor.Style
                 * @enum {number}
                 * @property {number} STYLE_UNSPECIFIED=0 STYLE_UNSPECIFIED value
                 * @property {number} DECLARATIVE_FRIENDLY=1 DECLARATIVE_FRIENDLY value
                 */
                ResourceDescriptor.Style = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STYLE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "DECLARATIVE_FRIENDLY"] = 1;
                    return values;
                })();
    
                return ResourceDescriptor;
            })();
    
            api.ResourceReference = (function() {
    
                /**
                 * Properties of a ResourceReference.
                 * @memberof google.api
                 * @interface IResourceReference
                 * @property {string|null} [type] ResourceReference type
                 * @property {string|null} [childType] ResourceReference childType
                 */
    
                /**
                 * Constructs a new ResourceReference.
                 * @memberof google.api
                 * @classdesc Represents a ResourceReference.
                 * @implements IResourceReference
                 * @constructor
                 * @param {google.api.IResourceReference=} [properties] Properties to set
                 */
                function ResourceReference(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ResourceReference type.
                 * @member {string} type
                 * @memberof google.api.ResourceReference
                 * @instance
                 */
                ResourceReference.prototype.type = "";
    
                /**
                 * ResourceReference childType.
                 * @member {string} childType
                 * @memberof google.api.ResourceReference
                 * @instance
                 */
                ResourceReference.prototype.childType = "";
    
                /**
                 * Creates a new ResourceReference instance using the specified properties.
                 * @function create
                 * @memberof google.api.ResourceReference
                 * @static
                 * @param {google.api.IResourceReference=} [properties] Properties to set
                 * @returns {google.api.ResourceReference} ResourceReference instance
                 */
                ResourceReference.create = function create(properties) {
                    return new ResourceReference(properties);
                };
    
                /**
                 * Encodes the specified ResourceReference message. Does not implicitly {@link google.api.ResourceReference.verify|verify} messages.
                 * @function encode
                 * @memberof google.api.ResourceReference
                 * @static
                 * @param {google.api.IResourceReference} message ResourceReference message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResourceReference.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                    if (message.childType != null && Object.hasOwnProperty.call(message, "childType"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.childType);
                    return writer;
                };
    
                /**
                 * Encodes the specified ResourceReference message, length delimited. Does not implicitly {@link google.api.ResourceReference.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.api.ResourceReference
                 * @static
                 * @param {google.api.IResourceReference} message ResourceReference message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResourceReference.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ResourceReference message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.api.ResourceReference
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.api.ResourceReference} ResourceReference
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResourceReference.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.ResourceReference();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.type = reader.string();
                            break;
                        case 2:
                            message.childType = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ResourceReference message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.api.ResourceReference
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.api.ResourceReference} ResourceReference
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResourceReference.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ResourceReference message.
                 * @function verify
                 * @memberof google.api.ResourceReference
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ResourceReference.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        if (!$util.isString(message.type))
                            return "type: string expected";
                    if (message.childType != null && message.hasOwnProperty("childType"))
                        if (!$util.isString(message.childType))
                            return "childType: string expected";
                    return null;
                };
    
                /**
                 * Creates a ResourceReference message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.api.ResourceReference
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.api.ResourceReference} ResourceReference
                 */
                ResourceReference.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.api.ResourceReference)
                        return object;
                    var message = new $root.google.api.ResourceReference();
                    if (object.type != null)
                        message.type = String(object.type);
                    if (object.childType != null)
                        message.childType = String(object.childType);
                    return message;
                };
    
                /**
                 * Creates a plain object from a ResourceReference message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.api.ResourceReference
                 * @static
                 * @param {google.api.ResourceReference} message ResourceReference
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ResourceReference.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.type = "";
                        object.childType = "";
                    }
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = message.type;
                    if (message.childType != null && message.hasOwnProperty("childType"))
                        object.childType = message.childType;
                    return object;
                };
    
                /**
                 * Converts this ResourceReference to JSON.
                 * @function toJSON
                 * @memberof google.api.ResourceReference
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ResourceReference.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ResourceReference;
            })();
    
            return api;
        })();
    
        google.protobuf = (function() {
    
            /**
             * Namespace protobuf.
             * @memberof google
             * @namespace
             */
            var protobuf = {};
    
            protobuf.FileDescriptorSet = (function() {
    
                /**
                 * Properties of a FileDescriptorSet.
                 * @memberof google.protobuf
                 * @interface IFileDescriptorSet
                 * @property {Array.<google.protobuf.IFileDescriptorProto>|null} [file] FileDescriptorSet file
                 */
    
                /**
                 * Constructs a new FileDescriptorSet.
                 * @memberof google.protobuf
                 * @classdesc Represents a FileDescriptorSet.
                 * @implements IFileDescriptorSet
                 * @constructor
                 * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
                 */
                function FileDescriptorSet(properties) {
                    this.file = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FileDescriptorSet file.
                 * @member {Array.<google.protobuf.IFileDescriptorProto>} file
                 * @memberof google.protobuf.FileDescriptorSet
                 * @instance
                 */
                FileDescriptorSet.prototype.file = $util.emptyArray;
    
                /**
                 * Creates a new FileDescriptorSet instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
                 * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet instance
                 */
                FileDescriptorSet.create = function create(properties) {
                    return new FileDescriptorSet(properties);
                };
    
                /**
                 * Encodes the specified FileDescriptorSet message. Does not implicitly {@link google.protobuf.FileDescriptorSet.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {google.protobuf.IFileDescriptorSet} message FileDescriptorSet message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileDescriptorSet.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.file != null && message.file.length)
                        for (var i = 0; i < message.file.length; ++i)
                            $root.google.protobuf.FileDescriptorProto.encode(message.file[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified FileDescriptorSet message, length delimited. Does not implicitly {@link google.protobuf.FileDescriptorSet.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {google.protobuf.IFileDescriptorSet} message FileDescriptorSet message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileDescriptorSet.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FileDescriptorSet message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileDescriptorSet.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorSet();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.file && message.file.length))
                                message.file = [];
                            message.file.push($root.google.protobuf.FileDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FileDescriptorSet message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileDescriptorSet.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FileDescriptorSet message.
                 * @function verify
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FileDescriptorSet.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.file != null && message.hasOwnProperty("file")) {
                        if (!Array.isArray(message.file))
                            return "file: array expected";
                        for (var i = 0; i < message.file.length; ++i) {
                            var error = $root.google.protobuf.FileDescriptorProto.verify(message.file[i]);
                            if (error)
                                return "file." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a FileDescriptorSet message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
                 */
                FileDescriptorSet.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FileDescriptorSet)
                        return object;
                    var message = new $root.google.protobuf.FileDescriptorSet();
                    if (object.file) {
                        if (!Array.isArray(object.file))
                            throw TypeError(".google.protobuf.FileDescriptorSet.file: array expected");
                        message.file = [];
                        for (var i = 0; i < object.file.length; ++i) {
                            if (typeof object.file[i] !== "object")
                                throw TypeError(".google.protobuf.FileDescriptorSet.file: object expected");
                            message.file[i] = $root.google.protobuf.FileDescriptorProto.fromObject(object.file[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a FileDescriptorSet message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {google.protobuf.FileDescriptorSet} message FileDescriptorSet
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FileDescriptorSet.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.file = [];
                    if (message.file && message.file.length) {
                        object.file = [];
                        for (var j = 0; j < message.file.length; ++j)
                            object.file[j] = $root.google.protobuf.FileDescriptorProto.toObject(message.file[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this FileDescriptorSet to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FileDescriptorSet
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FileDescriptorSet.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return FileDescriptorSet;
            })();
    
            protobuf.FileDescriptorProto = (function() {
    
                /**
                 * Properties of a FileDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IFileDescriptorProto
                 * @property {string|null} [name] FileDescriptorProto name
                 * @property {string|null} ["package"] FileDescriptorProto package
                 * @property {Array.<string>|null} [dependency] FileDescriptorProto dependency
                 * @property {Array.<number>|null} [publicDependency] FileDescriptorProto publicDependency
                 * @property {Array.<number>|null} [weakDependency] FileDescriptorProto weakDependency
                 * @property {Array.<google.protobuf.IDescriptorProto>|null} [messageType] FileDescriptorProto messageType
                 * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] FileDescriptorProto enumType
                 * @property {Array.<google.protobuf.IServiceDescriptorProto>|null} [service] FileDescriptorProto service
                 * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] FileDescriptorProto extension
                 * @property {google.protobuf.IFileOptions|null} [options] FileDescriptorProto options
                 * @property {google.protobuf.ISourceCodeInfo|null} [sourceCodeInfo] FileDescriptorProto sourceCodeInfo
                 * @property {string|null} [syntax] FileDescriptorProto syntax
                 */
    
                /**
                 * Constructs a new FileDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents a FileDescriptorProto.
                 * @implements IFileDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
                 */
                function FileDescriptorProto(properties) {
                    this.dependency = [];
                    this.publicDependency = [];
                    this.weakDependency = [];
                    this.messageType = [];
                    this.enumType = [];
                    this.service = [];
                    this.extension = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FileDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.name = "";
    
                /**
                 * FileDescriptorProto package.
                 * @member {string} package
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype["package"] = "";
    
                /**
                 * FileDescriptorProto dependency.
                 * @member {Array.<string>} dependency
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.dependency = $util.emptyArray;
    
                /**
                 * FileDescriptorProto publicDependency.
                 * @member {Array.<number>} publicDependency
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.publicDependency = $util.emptyArray;
    
                /**
                 * FileDescriptorProto weakDependency.
                 * @member {Array.<number>} weakDependency
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.weakDependency = $util.emptyArray;
    
                /**
                 * FileDescriptorProto messageType.
                 * @member {Array.<google.protobuf.IDescriptorProto>} messageType
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.messageType = $util.emptyArray;
    
                /**
                 * FileDescriptorProto enumType.
                 * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.enumType = $util.emptyArray;
    
                /**
                 * FileDescriptorProto service.
                 * @member {Array.<google.protobuf.IServiceDescriptorProto>} service
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.service = $util.emptyArray;
    
                /**
                 * FileDescriptorProto extension.
                 * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.extension = $util.emptyArray;
    
                /**
                 * FileDescriptorProto options.
                 * @member {google.protobuf.IFileOptions|null|undefined} options
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.options = null;
    
                /**
                 * FileDescriptorProto sourceCodeInfo.
                 * @member {google.protobuf.ISourceCodeInfo|null|undefined} sourceCodeInfo
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.sourceCodeInfo = null;
    
                /**
                 * FileDescriptorProto syntax.
                 * @member {string} syntax
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.syntax = "";
    
                /**
                 * Creates a new FileDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto instance
                 */
                FileDescriptorProto.create = function create(properties) {
                    return new FileDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified FileDescriptorProto message. Does not implicitly {@link google.protobuf.FileDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {google.protobuf.IFileDescriptorProto} message FileDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message["package"] != null && Object.hasOwnProperty.call(message, "package"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message["package"]);
                    if (message.dependency != null && message.dependency.length)
                        for (var i = 0; i < message.dependency.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.dependency[i]);
                    if (message.messageType != null && message.messageType.length)
                        for (var i = 0; i < message.messageType.length; ++i)
                            $root.google.protobuf.DescriptorProto.encode(message.messageType[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.enumType != null && message.enumType.length)
                        for (var i = 0; i < message.enumType.length; ++i)
                            $root.google.protobuf.EnumDescriptorProto.encode(message.enumType[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.service != null && message.service.length)
                        for (var i = 0; i < message.service.length; ++i)
                            $root.google.protobuf.ServiceDescriptorProto.encode(message.service[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.extension != null && message.extension.length)
                        for (var i = 0; i < message.extension.length; ++i)
                            $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.FileOptions.encode(message.options, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.sourceCodeInfo != null && Object.hasOwnProperty.call(message, "sourceCodeInfo"))
                        $root.google.protobuf.SourceCodeInfo.encode(message.sourceCodeInfo, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.publicDependency != null && message.publicDependency.length)
                        for (var i = 0; i < message.publicDependency.length; ++i)
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.publicDependency[i]);
                    if (message.weakDependency != null && message.weakDependency.length)
                        for (var i = 0; i < message.weakDependency.length; ++i)
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.weakDependency[i]);
                    if (message.syntax != null && Object.hasOwnProperty.call(message, "syntax"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.syntax);
                    return writer;
                };
    
                /**
                 * Encodes the specified FileDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.FileDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {google.protobuf.IFileDescriptorProto} message FileDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FileDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            message["package"] = reader.string();
                            break;
                        case 3:
                            if (!(message.dependency && message.dependency.length))
                                message.dependency = [];
                            message.dependency.push(reader.string());
                            break;
                        case 10:
                            if (!(message.publicDependency && message.publicDependency.length))
                                message.publicDependency = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.publicDependency.push(reader.int32());
                            } else
                                message.publicDependency.push(reader.int32());
                            break;
                        case 11:
                            if (!(message.weakDependency && message.weakDependency.length))
                                message.weakDependency = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.weakDependency.push(reader.int32());
                            } else
                                message.weakDependency.push(reader.int32());
                            break;
                        case 4:
                            if (!(message.messageType && message.messageType.length))
                                message.messageType = [];
                            message.messageType.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 5:
                            if (!(message.enumType && message.enumType.length))
                                message.enumType = [];
                            message.enumType.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 6:
                            if (!(message.service && message.service.length))
                                message.service = [];
                            message.service.push($root.google.protobuf.ServiceDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 7:
                            if (!(message.extension && message.extension.length))
                                message.extension = [];
                            message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 8:
                            message.options = $root.google.protobuf.FileOptions.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.syntax = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FileDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FileDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FileDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message["package"] != null && message.hasOwnProperty("package"))
                        if (!$util.isString(message["package"]))
                            return "package: string expected";
                    if (message.dependency != null && message.hasOwnProperty("dependency")) {
                        if (!Array.isArray(message.dependency))
                            return "dependency: array expected";
                        for (var i = 0; i < message.dependency.length; ++i)
                            if (!$util.isString(message.dependency[i]))
                                return "dependency: string[] expected";
                    }
                    if (message.publicDependency != null && message.hasOwnProperty("publicDependency")) {
                        if (!Array.isArray(message.publicDependency))
                            return "publicDependency: array expected";
                        for (var i = 0; i < message.publicDependency.length; ++i)
                            if (!$util.isInteger(message.publicDependency[i]))
                                return "publicDependency: integer[] expected";
                    }
                    if (message.weakDependency != null && message.hasOwnProperty("weakDependency")) {
                        if (!Array.isArray(message.weakDependency))
                            return "weakDependency: array expected";
                        for (var i = 0; i < message.weakDependency.length; ++i)
                            if (!$util.isInteger(message.weakDependency[i]))
                                return "weakDependency: integer[] expected";
                    }
                    if (message.messageType != null && message.hasOwnProperty("messageType")) {
                        if (!Array.isArray(message.messageType))
                            return "messageType: array expected";
                        for (var i = 0; i < message.messageType.length; ++i) {
                            var error = $root.google.protobuf.DescriptorProto.verify(message.messageType[i]);
                            if (error)
                                return "messageType." + error;
                        }
                    }
                    if (message.enumType != null && message.hasOwnProperty("enumType")) {
                        if (!Array.isArray(message.enumType))
                            return "enumType: array expected";
                        for (var i = 0; i < message.enumType.length; ++i) {
                            var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enumType[i]);
                            if (error)
                                return "enumType." + error;
                        }
                    }
                    if (message.service != null && message.hasOwnProperty("service")) {
                        if (!Array.isArray(message.service))
                            return "service: array expected";
                        for (var i = 0; i < message.service.length; ++i) {
                            var error = $root.google.protobuf.ServiceDescriptorProto.verify(message.service[i]);
                            if (error)
                                return "service." + error;
                        }
                    }
                    if (message.extension != null && message.hasOwnProperty("extension")) {
                        if (!Array.isArray(message.extension))
                            return "extension: array expected";
                        for (var i = 0; i < message.extension.length; ++i) {
                            var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                            if (error)
                                return "extension." + error;
                        }
                    }
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.FileOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    if (message.sourceCodeInfo != null && message.hasOwnProperty("sourceCodeInfo")) {
                        var error = $root.google.protobuf.SourceCodeInfo.verify(message.sourceCodeInfo);
                        if (error)
                            return "sourceCodeInfo." + error;
                    }
                    if (message.syntax != null && message.hasOwnProperty("syntax"))
                        if (!$util.isString(message.syntax))
                            return "syntax: string expected";
                    return null;
                };
    
                /**
                 * Creates a FileDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
                 */
                FileDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FileDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.FileDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object["package"] != null)
                        message["package"] = String(object["package"]);
                    if (object.dependency) {
                        if (!Array.isArray(object.dependency))
                            throw TypeError(".google.protobuf.FileDescriptorProto.dependency: array expected");
                        message.dependency = [];
                        for (var i = 0; i < object.dependency.length; ++i)
                            message.dependency[i] = String(object.dependency[i]);
                    }
                    if (object.publicDependency) {
                        if (!Array.isArray(object.publicDependency))
                            throw TypeError(".google.protobuf.FileDescriptorProto.publicDependency: array expected");
                        message.publicDependency = [];
                        for (var i = 0; i < object.publicDependency.length; ++i)
                            message.publicDependency[i] = object.publicDependency[i] | 0;
                    }
                    if (object.weakDependency) {
                        if (!Array.isArray(object.weakDependency))
                            throw TypeError(".google.protobuf.FileDescriptorProto.weakDependency: array expected");
                        message.weakDependency = [];
                        for (var i = 0; i < object.weakDependency.length; ++i)
                            message.weakDependency[i] = object.weakDependency[i] | 0;
                    }
                    if (object.messageType) {
                        if (!Array.isArray(object.messageType))
                            throw TypeError(".google.protobuf.FileDescriptorProto.messageType: array expected");
                        message.messageType = [];
                        for (var i = 0; i < object.messageType.length; ++i) {
                            if (typeof object.messageType[i] !== "object")
                                throw TypeError(".google.protobuf.FileDescriptorProto.messageType: object expected");
                            message.messageType[i] = $root.google.protobuf.DescriptorProto.fromObject(object.messageType[i]);
                        }
                    }
                    if (object.enumType) {
                        if (!Array.isArray(object.enumType))
                            throw TypeError(".google.protobuf.FileDescriptorProto.enumType: array expected");
                        message.enumType = [];
                        for (var i = 0; i < object.enumType.length; ++i) {
                            if (typeof object.enumType[i] !== "object")
                                throw TypeError(".google.protobuf.FileDescriptorProto.enumType: object expected");
                            message.enumType[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enumType[i]);
                        }
                    }
                    if (object.service) {
                        if (!Array.isArray(object.service))
                            throw TypeError(".google.protobuf.FileDescriptorProto.service: array expected");
                        message.service = [];
                        for (var i = 0; i < object.service.length; ++i) {
                            if (typeof object.service[i] !== "object")
                                throw TypeError(".google.protobuf.FileDescriptorProto.service: object expected");
                            message.service[i] = $root.google.protobuf.ServiceDescriptorProto.fromObject(object.service[i]);
                        }
                    }
                    if (object.extension) {
                        if (!Array.isArray(object.extension))
                            throw TypeError(".google.protobuf.FileDescriptorProto.extension: array expected");
                        message.extension = [];
                        for (var i = 0; i < object.extension.length; ++i) {
                            if (typeof object.extension[i] !== "object")
                                throw TypeError(".google.protobuf.FileDescriptorProto.extension: object expected");
                            message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                        }
                    }
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.FileOptions.fromObject(object.options);
                    }
                    if (object.sourceCodeInfo != null) {
                        if (typeof object.sourceCodeInfo !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.sourceCodeInfo: object expected");
                        message.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.fromObject(object.sourceCodeInfo);
                    }
                    if (object.syntax != null)
                        message.syntax = String(object.syntax);
                    return message;
                };
    
                /**
                 * Creates a plain object from a FileDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {google.protobuf.FileDescriptorProto} message FileDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FileDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.dependency = [];
                        object.messageType = [];
                        object.enumType = [];
                        object.service = [];
                        object.extension = [];
                        object.publicDependency = [];
                        object.weakDependency = [];
                    }
                    if (options.defaults) {
                        object.name = "";
                        object["package"] = "";
                        object.options = null;
                        object.sourceCodeInfo = null;
                        object.syntax = "";
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message["package"] != null && message.hasOwnProperty("package"))
                        object["package"] = message["package"];
                    if (message.dependency && message.dependency.length) {
                        object.dependency = [];
                        for (var j = 0; j < message.dependency.length; ++j)
                            object.dependency[j] = message.dependency[j];
                    }
                    if (message.messageType && message.messageType.length) {
                        object.messageType = [];
                        for (var j = 0; j < message.messageType.length; ++j)
                            object.messageType[j] = $root.google.protobuf.DescriptorProto.toObject(message.messageType[j], options);
                    }
                    if (message.enumType && message.enumType.length) {
                        object.enumType = [];
                        for (var j = 0; j < message.enumType.length; ++j)
                            object.enumType[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enumType[j], options);
                    }
                    if (message.service && message.service.length) {
                        object.service = [];
                        for (var j = 0; j < message.service.length; ++j)
                            object.service[j] = $root.google.protobuf.ServiceDescriptorProto.toObject(message.service[j], options);
                    }
                    if (message.extension && message.extension.length) {
                        object.extension = [];
                        for (var j = 0; j < message.extension.length; ++j)
                            object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                    }
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.FileOptions.toObject(message.options, options);
                    if (message.sourceCodeInfo != null && message.hasOwnProperty("sourceCodeInfo"))
                        object.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.toObject(message.sourceCodeInfo, options);
                    if (message.publicDependency && message.publicDependency.length) {
                        object.publicDependency = [];
                        for (var j = 0; j < message.publicDependency.length; ++j)
                            object.publicDependency[j] = message.publicDependency[j];
                    }
                    if (message.weakDependency && message.weakDependency.length) {
                        object.weakDependency = [];
                        for (var j = 0; j < message.weakDependency.length; ++j)
                            object.weakDependency[j] = message.weakDependency[j];
                    }
                    if (message.syntax != null && message.hasOwnProperty("syntax"))
                        object.syntax = message.syntax;
                    return object;
                };
    
                /**
                 * Converts this FileDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FileDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return FileDescriptorProto;
            })();
    
            protobuf.DescriptorProto = (function() {
    
                /**
                 * Properties of a DescriptorProto.
                 * @memberof google.protobuf
                 * @interface IDescriptorProto
                 * @property {string|null} [name] DescriptorProto name
                 * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [field] DescriptorProto field
                 * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] DescriptorProto extension
                 * @property {Array.<google.protobuf.IDescriptorProto>|null} [nestedType] DescriptorProto nestedType
                 * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] DescriptorProto enumType
                 * @property {Array.<google.protobuf.DescriptorProto.IExtensionRange>|null} [extensionRange] DescriptorProto extensionRange
                 * @property {Array.<google.protobuf.IOneofDescriptorProto>|null} [oneofDecl] DescriptorProto oneofDecl
                 * @property {google.protobuf.IMessageOptions|null} [options] DescriptorProto options
                 * @property {Array.<google.protobuf.DescriptorProto.IReservedRange>|null} [reservedRange] DescriptorProto reservedRange
                 * @property {Array.<string>|null} [reservedName] DescriptorProto reservedName
                 */
    
                /**
                 * Constructs a new DescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents a DescriptorProto.
                 * @implements IDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
                 */
                function DescriptorProto(properties) {
                    this.field = [];
                    this.extension = [];
                    this.nestedType = [];
                    this.enumType = [];
                    this.extensionRange = [];
                    this.oneofDecl = [];
                    this.reservedRange = [];
                    this.reservedName = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * DescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.name = "";
    
                /**
                 * DescriptorProto field.
                 * @member {Array.<google.protobuf.IFieldDescriptorProto>} field
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.field = $util.emptyArray;
    
                /**
                 * DescriptorProto extension.
                 * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.extension = $util.emptyArray;
    
                /**
                 * DescriptorProto nestedType.
                 * @member {Array.<google.protobuf.IDescriptorProto>} nestedType
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.nestedType = $util.emptyArray;
    
                /**
                 * DescriptorProto enumType.
                 * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.enumType = $util.emptyArray;
    
                /**
                 * DescriptorProto extensionRange.
                 * @member {Array.<google.protobuf.DescriptorProto.IExtensionRange>} extensionRange
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.extensionRange = $util.emptyArray;
    
                /**
                 * DescriptorProto oneofDecl.
                 * @member {Array.<google.protobuf.IOneofDescriptorProto>} oneofDecl
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.oneofDecl = $util.emptyArray;
    
                /**
                 * DescriptorProto options.
                 * @member {google.protobuf.IMessageOptions|null|undefined} options
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.options = null;
    
                /**
                 * DescriptorProto reservedRange.
                 * @member {Array.<google.protobuf.DescriptorProto.IReservedRange>} reservedRange
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.reservedRange = $util.emptyArray;
    
                /**
                 * DescriptorProto reservedName.
                 * @member {Array.<string>} reservedName
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.reservedName = $util.emptyArray;
    
                /**
                 * Creates a new DescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.DescriptorProto} DescriptorProto instance
                 */
                DescriptorProto.create = function create(properties) {
                    return new DescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified DescriptorProto message. Does not implicitly {@link google.protobuf.DescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {google.protobuf.IDescriptorProto} message DescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.field != null && message.field.length)
                        for (var i = 0; i < message.field.length; ++i)
                            $root.google.protobuf.FieldDescriptorProto.encode(message.field[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.nestedType != null && message.nestedType.length)
                        for (var i = 0; i < message.nestedType.length; ++i)
                            $root.google.protobuf.DescriptorProto.encode(message.nestedType[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.enumType != null && message.enumType.length)
                        for (var i = 0; i < message.enumType.length; ++i)
                            $root.google.protobuf.EnumDescriptorProto.encode(message.enumType[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.extensionRange != null && message.extensionRange.length)
                        for (var i = 0; i < message.extensionRange.length; ++i)
                            $root.google.protobuf.DescriptorProto.ExtensionRange.encode(message.extensionRange[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.extension != null && message.extension.length)
                        for (var i = 0; i < message.extension.length; ++i)
                            $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.MessageOptions.encode(message.options, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.oneofDecl != null && message.oneofDecl.length)
                        for (var i = 0; i < message.oneofDecl.length; ++i)
                            $root.google.protobuf.OneofDescriptorProto.encode(message.oneofDecl[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.reservedRange != null && message.reservedRange.length)
                        for (var i = 0; i < message.reservedRange.length; ++i)
                            $root.google.protobuf.DescriptorProto.ReservedRange.encode(message.reservedRange[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.reservedName != null && message.reservedName.length)
                        for (var i = 0; i < message.reservedName.length; ++i)
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.reservedName[i]);
                    return writer;
                };
    
                /**
                 * Encodes the specified DescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.DescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {google.protobuf.IDescriptorProto} message DescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a DescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.DescriptorProto} DescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            if (!(message.field && message.field.length))
                                message.field = [];
                            message.field.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 6:
                            if (!(message.extension && message.extension.length))
                                message.extension = [];
                            message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.nestedType && message.nestedType.length))
                                message.nestedType = [];
                            message.nestedType.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            if (!(message.enumType && message.enumType.length))
                                message.enumType = [];
                            message.enumType.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 5:
                            if (!(message.extensionRange && message.extensionRange.length))
                                message.extensionRange = [];
                            message.extensionRange.push($root.google.protobuf.DescriptorProto.ExtensionRange.decode(reader, reader.uint32()));
                            break;
                        case 8:
                            if (!(message.oneofDecl && message.oneofDecl.length))
                                message.oneofDecl = [];
                            message.oneofDecl.push($root.google.protobuf.OneofDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 7:
                            message.options = $root.google.protobuf.MessageOptions.decode(reader, reader.uint32());
                            break;
                        case 9:
                            if (!(message.reservedRange && message.reservedRange.length))
                                message.reservedRange = [];
                            message.reservedRange.push($root.google.protobuf.DescriptorProto.ReservedRange.decode(reader, reader.uint32()));
                            break;
                        case 10:
                            if (!(message.reservedName && message.reservedName.length))
                                message.reservedName = [];
                            message.reservedName.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a DescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.DescriptorProto} DescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a DescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.field != null && message.hasOwnProperty("field")) {
                        if (!Array.isArray(message.field))
                            return "field: array expected";
                        for (var i = 0; i < message.field.length; ++i) {
                            var error = $root.google.protobuf.FieldDescriptorProto.verify(message.field[i]);
                            if (error)
                                return "field." + error;
                        }
                    }
                    if (message.extension != null && message.hasOwnProperty("extension")) {
                        if (!Array.isArray(message.extension))
                            return "extension: array expected";
                        for (var i = 0; i < message.extension.length; ++i) {
                            var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                            if (error)
                                return "extension." + error;
                        }
                    }
                    if (message.nestedType != null && message.hasOwnProperty("nestedType")) {
                        if (!Array.isArray(message.nestedType))
                            return "nestedType: array expected";
                        for (var i = 0; i < message.nestedType.length; ++i) {
                            var error = $root.google.protobuf.DescriptorProto.verify(message.nestedType[i]);
                            if (error)
                                return "nestedType." + error;
                        }
                    }
                    if (message.enumType != null && message.hasOwnProperty("enumType")) {
                        if (!Array.isArray(message.enumType))
                            return "enumType: array expected";
                        for (var i = 0; i < message.enumType.length; ++i) {
                            var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enumType[i]);
                            if (error)
                                return "enumType." + error;
                        }
                    }
                    if (message.extensionRange != null && message.hasOwnProperty("extensionRange")) {
                        if (!Array.isArray(message.extensionRange))
                            return "extensionRange: array expected";
                        for (var i = 0; i < message.extensionRange.length; ++i) {
                            var error = $root.google.protobuf.DescriptorProto.ExtensionRange.verify(message.extensionRange[i]);
                            if (error)
                                return "extensionRange." + error;
                        }
                    }
                    if (message.oneofDecl != null && message.hasOwnProperty("oneofDecl")) {
                        if (!Array.isArray(message.oneofDecl))
                            return "oneofDecl: array expected";
                        for (var i = 0; i < message.oneofDecl.length; ++i) {
                            var error = $root.google.protobuf.OneofDescriptorProto.verify(message.oneofDecl[i]);
                            if (error)
                                return "oneofDecl." + error;
                        }
                    }
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.MessageOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    if (message.reservedRange != null && message.hasOwnProperty("reservedRange")) {
                        if (!Array.isArray(message.reservedRange))
                            return "reservedRange: array expected";
                        for (var i = 0; i < message.reservedRange.length; ++i) {
                            var error = $root.google.protobuf.DescriptorProto.ReservedRange.verify(message.reservedRange[i]);
                            if (error)
                                return "reservedRange." + error;
                        }
                    }
                    if (message.reservedName != null && message.hasOwnProperty("reservedName")) {
                        if (!Array.isArray(message.reservedName))
                            return "reservedName: array expected";
                        for (var i = 0; i < message.reservedName.length; ++i)
                            if (!$util.isString(message.reservedName[i]))
                                return "reservedName: string[] expected";
                    }
                    return null;
                };
    
                /**
                 * Creates a DescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.DescriptorProto} DescriptorProto
                 */
                DescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.DescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.field) {
                        if (!Array.isArray(object.field))
                            throw TypeError(".google.protobuf.DescriptorProto.field: array expected");
                        message.field = [];
                        for (var i = 0; i < object.field.length; ++i) {
                            if (typeof object.field[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.field: object expected");
                            message.field[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.field[i]);
                        }
                    }
                    if (object.extension) {
                        if (!Array.isArray(object.extension))
                            throw TypeError(".google.protobuf.DescriptorProto.extension: array expected");
                        message.extension = [];
                        for (var i = 0; i < object.extension.length; ++i) {
                            if (typeof object.extension[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.extension: object expected");
                            message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                        }
                    }
                    if (object.nestedType) {
                        if (!Array.isArray(object.nestedType))
                            throw TypeError(".google.protobuf.DescriptorProto.nestedType: array expected");
                        message.nestedType = [];
                        for (var i = 0; i < object.nestedType.length; ++i) {
                            if (typeof object.nestedType[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.nestedType: object expected");
                            message.nestedType[i] = $root.google.protobuf.DescriptorProto.fromObject(object.nestedType[i]);
                        }
                    }
                    if (object.enumType) {
                        if (!Array.isArray(object.enumType))
                            throw TypeError(".google.protobuf.DescriptorProto.enumType: array expected");
                        message.enumType = [];
                        for (var i = 0; i < object.enumType.length; ++i) {
                            if (typeof object.enumType[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.enumType: object expected");
                            message.enumType[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enumType[i]);
                        }
                    }
                    if (object.extensionRange) {
                        if (!Array.isArray(object.extensionRange))
                            throw TypeError(".google.protobuf.DescriptorProto.extensionRange: array expected");
                        message.extensionRange = [];
                        for (var i = 0; i < object.extensionRange.length; ++i) {
                            if (typeof object.extensionRange[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.extensionRange: object expected");
                            message.extensionRange[i] = $root.google.protobuf.DescriptorProto.ExtensionRange.fromObject(object.extensionRange[i]);
                        }
                    }
                    if (object.oneofDecl) {
                        if (!Array.isArray(object.oneofDecl))
                            throw TypeError(".google.protobuf.DescriptorProto.oneofDecl: array expected");
                        message.oneofDecl = [];
                        for (var i = 0; i < object.oneofDecl.length; ++i) {
                            if (typeof object.oneofDecl[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.oneofDecl: object expected");
                            message.oneofDecl[i] = $root.google.protobuf.OneofDescriptorProto.fromObject(object.oneofDecl[i]);
                        }
                    }
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.MessageOptions.fromObject(object.options);
                    }
                    if (object.reservedRange) {
                        if (!Array.isArray(object.reservedRange))
                            throw TypeError(".google.protobuf.DescriptorProto.reservedRange: array expected");
                        message.reservedRange = [];
                        for (var i = 0; i < object.reservedRange.length; ++i) {
                            if (typeof object.reservedRange[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.reservedRange: object expected");
                            message.reservedRange[i] = $root.google.protobuf.DescriptorProto.ReservedRange.fromObject(object.reservedRange[i]);
                        }
                    }
                    if (object.reservedName) {
                        if (!Array.isArray(object.reservedName))
                            throw TypeError(".google.protobuf.DescriptorProto.reservedName: array expected");
                        message.reservedName = [];
                        for (var i = 0; i < object.reservedName.length; ++i)
                            message.reservedName[i] = String(object.reservedName[i]);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a DescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {google.protobuf.DescriptorProto} message DescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.field = [];
                        object.nestedType = [];
                        object.enumType = [];
                        object.extensionRange = [];
                        object.extension = [];
                        object.oneofDecl = [];
                        object.reservedRange = [];
                        object.reservedName = [];
                    }
                    if (options.defaults) {
                        object.name = "";
                        object.options = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.field && message.field.length) {
                        object.field = [];
                        for (var j = 0; j < message.field.length; ++j)
                            object.field[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.field[j], options);
                    }
                    if (message.nestedType && message.nestedType.length) {
                        object.nestedType = [];
                        for (var j = 0; j < message.nestedType.length; ++j)
                            object.nestedType[j] = $root.google.protobuf.DescriptorProto.toObject(message.nestedType[j], options);
                    }
                    if (message.enumType && message.enumType.length) {
                        object.enumType = [];
                        for (var j = 0; j < message.enumType.length; ++j)
                            object.enumType[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enumType[j], options);
                    }
                    if (message.extensionRange && message.extensionRange.length) {
                        object.extensionRange = [];
                        for (var j = 0; j < message.extensionRange.length; ++j)
                            object.extensionRange[j] = $root.google.protobuf.DescriptorProto.ExtensionRange.toObject(message.extensionRange[j], options);
                    }
                    if (message.extension && message.extension.length) {
                        object.extension = [];
                        for (var j = 0; j < message.extension.length; ++j)
                            object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                    }
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.MessageOptions.toObject(message.options, options);
                    if (message.oneofDecl && message.oneofDecl.length) {
                        object.oneofDecl = [];
                        for (var j = 0; j < message.oneofDecl.length; ++j)
                            object.oneofDecl[j] = $root.google.protobuf.OneofDescriptorProto.toObject(message.oneofDecl[j], options);
                    }
                    if (message.reservedRange && message.reservedRange.length) {
                        object.reservedRange = [];
                        for (var j = 0; j < message.reservedRange.length; ++j)
                            object.reservedRange[j] = $root.google.protobuf.DescriptorProto.ReservedRange.toObject(message.reservedRange[j], options);
                    }
                    if (message.reservedName && message.reservedName.length) {
                        object.reservedName = [];
                        for (var j = 0; j < message.reservedName.length; ++j)
                            object.reservedName[j] = message.reservedName[j];
                    }
                    return object;
                };
    
                /**
                 * Converts this DescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                DescriptorProto.ExtensionRange = (function() {
    
                    /**
                     * Properties of an ExtensionRange.
                     * @memberof google.protobuf.DescriptorProto
                     * @interface IExtensionRange
                     * @property {number|null} [start] ExtensionRange start
                     * @property {number|null} [end] ExtensionRange end
                     * @property {google.protobuf.IExtensionRangeOptions|null} [options] ExtensionRange options
                     */
    
                    /**
                     * Constructs a new ExtensionRange.
                     * @memberof google.protobuf.DescriptorProto
                     * @classdesc Represents an ExtensionRange.
                     * @implements IExtensionRange
                     * @constructor
                     * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
                     */
                    function ExtensionRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExtensionRange start.
                     * @member {number} start
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @instance
                     */
                    ExtensionRange.prototype.start = 0;
    
                    /**
                     * ExtensionRange end.
                     * @member {number} end
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @instance
                     */
                    ExtensionRange.prototype.end = 0;
    
                    /**
                     * ExtensionRange options.
                     * @member {google.protobuf.IExtensionRangeOptions|null|undefined} options
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @instance
                     */
                    ExtensionRange.prototype.options = null;
    
                    /**
                     * Creates a new ExtensionRange instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
                     * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange instance
                     */
                    ExtensionRange.create = function create(properties) {
                        return new ExtensionRange(properties);
                    };
    
                    /**
                     * Encodes the specified ExtensionRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ExtensionRange.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IExtensionRange} message ExtensionRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExtensionRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.start);
                        if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.end);
                        if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                            $root.google.protobuf.ExtensionRangeOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExtensionRange message, length delimited. Does not implicitly {@link google.protobuf.DescriptorProto.ExtensionRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IExtensionRange} message ExtensionRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExtensionRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExtensionRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExtensionRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.start = reader.int32();
                                break;
                            case 2:
                                message.end = reader.int32();
                                break;
                            case 3:
                                message.options = $root.google.protobuf.ExtensionRangeOptions.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExtensionRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExtensionRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExtensionRange message.
                     * @function verify
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExtensionRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.start != null && message.hasOwnProperty("start"))
                            if (!$util.isInteger(message.start))
                                return "start: integer expected";
                        if (message.end != null && message.hasOwnProperty("end"))
                            if (!$util.isInteger(message.end))
                                return "end: integer expected";
                        if (message.options != null && message.hasOwnProperty("options")) {
                            var error = $root.google.protobuf.ExtensionRangeOptions.verify(message.options);
                            if (error)
                                return "options." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ExtensionRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                     */
                    ExtensionRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.DescriptorProto.ExtensionRange)
                            return object;
                        var message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                        if (object.start != null)
                            message.start = object.start | 0;
                        if (object.end != null)
                            message.end = object.end | 0;
                        if (object.options != null) {
                            if (typeof object.options !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.ExtensionRange.options: object expected");
                            message.options = $root.google.protobuf.ExtensionRangeOptions.fromObject(object.options);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExtensionRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.ExtensionRange} message ExtensionRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExtensionRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.start = 0;
                            object.end = 0;
                            object.options = null;
                        }
                        if (message.start != null && message.hasOwnProperty("start"))
                            object.start = message.start;
                        if (message.end != null && message.hasOwnProperty("end"))
                            object.end = message.end;
                        if (message.options != null && message.hasOwnProperty("options"))
                            object.options = $root.google.protobuf.ExtensionRangeOptions.toObject(message.options, options);
                        return object;
                    };
    
                    /**
                     * Converts this ExtensionRange to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExtensionRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExtensionRange;
                })();
    
                DescriptorProto.ReservedRange = (function() {
    
                    /**
                     * Properties of a ReservedRange.
                     * @memberof google.protobuf.DescriptorProto
                     * @interface IReservedRange
                     * @property {number|null} [start] ReservedRange start
                     * @property {number|null} [end] ReservedRange end
                     */
    
                    /**
                     * Constructs a new ReservedRange.
                     * @memberof google.protobuf.DescriptorProto
                     * @classdesc Represents a ReservedRange.
                     * @implements IReservedRange
                     * @constructor
                     * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
                     */
                    function ReservedRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReservedRange start.
                     * @member {number} start
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @instance
                     */
                    ReservedRange.prototype.start = 0;
    
                    /**
                     * ReservedRange end.
                     * @member {number} end
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @instance
                     */
                    ReservedRange.prototype.end = 0;
    
                    /**
                     * Creates a new ReservedRange instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
                     * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange instance
                     */
                    ReservedRange.create = function create(properties) {
                        return new ReservedRange(properties);
                    };
    
                    /**
                     * Encodes the specified ReservedRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ReservedRange.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IReservedRange} message ReservedRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReservedRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.start);
                        if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.end);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReservedRange message, length delimited. Does not implicitly {@link google.protobuf.DescriptorProto.ReservedRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IReservedRange} message ReservedRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReservedRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReservedRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReservedRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.start = reader.int32();
                                break;
                            case 2:
                                message.end = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReservedRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReservedRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReservedRange message.
                     * @function verify
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReservedRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.start != null && message.hasOwnProperty("start"))
                            if (!$util.isInteger(message.start))
                                return "start: integer expected";
                        if (message.end != null && message.hasOwnProperty("end"))
                            if (!$util.isInteger(message.end))
                                return "end: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ReservedRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                     */
                    ReservedRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.DescriptorProto.ReservedRange)
                            return object;
                        var message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                        if (object.start != null)
                            message.start = object.start | 0;
                        if (object.end != null)
                            message.end = object.end | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReservedRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.ReservedRange} message ReservedRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReservedRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.start = 0;
                            object.end = 0;
                        }
                        if (message.start != null && message.hasOwnProperty("start"))
                            object.start = message.start;
                        if (message.end != null && message.hasOwnProperty("end"))
                            object.end = message.end;
                        return object;
                    };
    
                    /**
                     * Converts this ReservedRange to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReservedRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReservedRange;
                })();
    
                return DescriptorProto;
            })();
    
            protobuf.ExtensionRangeOptions = (function() {
    
                /**
                 * Properties of an ExtensionRangeOptions.
                 * @memberof google.protobuf
                 * @interface IExtensionRangeOptions
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] ExtensionRangeOptions uninterpretedOption
                 */
    
                /**
                 * Constructs a new ExtensionRangeOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents an ExtensionRangeOptions.
                 * @implements IExtensionRangeOptions
                 * @constructor
                 * @param {google.protobuf.IExtensionRangeOptions=} [properties] Properties to set
                 */
                function ExtensionRangeOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ExtensionRangeOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.ExtensionRangeOptions
                 * @instance
                 */
                ExtensionRangeOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * Creates a new ExtensionRangeOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.ExtensionRangeOptions
                 * @static
                 * @param {google.protobuf.IExtensionRangeOptions=} [properties] Properties to set
                 * @returns {google.protobuf.ExtensionRangeOptions} ExtensionRangeOptions instance
                 */
                ExtensionRangeOptions.create = function create(properties) {
                    return new ExtensionRangeOptions(properties);
                };
    
                /**
                 * Encodes the specified ExtensionRangeOptions message. Does not implicitly {@link google.protobuf.ExtensionRangeOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.ExtensionRangeOptions
                 * @static
                 * @param {google.protobuf.IExtensionRangeOptions} message ExtensionRangeOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExtensionRangeOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified ExtensionRangeOptions message, length delimited. Does not implicitly {@link google.protobuf.ExtensionRangeOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.ExtensionRangeOptions
                 * @static
                 * @param {google.protobuf.IExtensionRangeOptions} message ExtensionRangeOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExtensionRangeOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an ExtensionRangeOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.ExtensionRangeOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.ExtensionRangeOptions} ExtensionRangeOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExtensionRangeOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ExtensionRangeOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an ExtensionRangeOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.ExtensionRangeOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.ExtensionRangeOptions} ExtensionRangeOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExtensionRangeOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an ExtensionRangeOptions message.
                 * @function verify
                 * @memberof google.protobuf.ExtensionRangeOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ExtensionRangeOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates an ExtensionRangeOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.ExtensionRangeOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.ExtensionRangeOptions} ExtensionRangeOptions
                 */
                ExtensionRangeOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.ExtensionRangeOptions)
                        return object;
                    var message = new $root.google.protobuf.ExtensionRangeOptions();
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.ExtensionRangeOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.ExtensionRangeOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an ExtensionRangeOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.ExtensionRangeOptions
                 * @static
                 * @param {google.protobuf.ExtensionRangeOptions} message ExtensionRangeOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ExtensionRangeOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this ExtensionRangeOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.ExtensionRangeOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ExtensionRangeOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ExtensionRangeOptions;
            })();
    
            protobuf.FieldDescriptorProto = (function() {
    
                /**
                 * Properties of a FieldDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IFieldDescriptorProto
                 * @property {string|null} [name] FieldDescriptorProto name
                 * @property {number|null} [number] FieldDescriptorProto number
                 * @property {google.protobuf.FieldDescriptorProto.Label|null} [label] FieldDescriptorProto label
                 * @property {google.protobuf.FieldDescriptorProto.Type|null} [type] FieldDescriptorProto type
                 * @property {string|null} [typeName] FieldDescriptorProto typeName
                 * @property {string|null} [extendee] FieldDescriptorProto extendee
                 * @property {string|null} [defaultValue] FieldDescriptorProto defaultValue
                 * @property {number|null} [oneofIndex] FieldDescriptorProto oneofIndex
                 * @property {string|null} [jsonName] FieldDescriptorProto jsonName
                 * @property {google.protobuf.IFieldOptions|null} [options] FieldDescriptorProto options
                 * @property {boolean|null} [proto3Optional] FieldDescriptorProto proto3Optional
                 */
    
                /**
                 * Constructs a new FieldDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents a FieldDescriptorProto.
                 * @implements IFieldDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
                 */
                function FieldDescriptorProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FieldDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.name = "";
    
                /**
                 * FieldDescriptorProto number.
                 * @member {number} number
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.number = 0;
    
                /**
                 * FieldDescriptorProto label.
                 * @member {google.protobuf.FieldDescriptorProto.Label} label
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.label = 1;
    
                /**
                 * FieldDescriptorProto type.
                 * @member {google.protobuf.FieldDescriptorProto.Type} type
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.type = 1;
    
                /**
                 * FieldDescriptorProto typeName.
                 * @member {string} typeName
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.typeName = "";
    
                /**
                 * FieldDescriptorProto extendee.
                 * @member {string} extendee
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.extendee = "";
    
                /**
                 * FieldDescriptorProto defaultValue.
                 * @member {string} defaultValue
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.defaultValue = "";
    
                /**
                 * FieldDescriptorProto oneofIndex.
                 * @member {number} oneofIndex
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.oneofIndex = 0;
    
                /**
                 * FieldDescriptorProto jsonName.
                 * @member {string} jsonName
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.jsonName = "";
    
                /**
                 * FieldDescriptorProto options.
                 * @member {google.protobuf.IFieldOptions|null|undefined} options
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.options = null;
    
                /**
                 * FieldDescriptorProto proto3Optional.
                 * @member {boolean} proto3Optional
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.proto3Optional = false;
    
                /**
                 * Creates a new FieldDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto instance
                 */
                FieldDescriptorProto.create = function create(properties) {
                    return new FieldDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified FieldDescriptorProto message. Does not implicitly {@link google.protobuf.FieldDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {google.protobuf.IFieldDescriptorProto} message FieldDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.extendee != null && Object.hasOwnProperty.call(message, "extendee"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.extendee);
                    if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.number);
                    if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.label);
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
                    if (message.typeName != null && Object.hasOwnProperty.call(message, "typeName"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.typeName);
                    if (message.defaultValue != null && Object.hasOwnProperty.call(message, "defaultValue"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.defaultValue);
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.FieldOptions.encode(message.options, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.oneofIndex != null && Object.hasOwnProperty.call(message, "oneofIndex"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int32(message.oneofIndex);
                    if (message.jsonName != null && Object.hasOwnProperty.call(message, "jsonName"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.jsonName);
                    if (message.proto3Optional != null && Object.hasOwnProperty.call(message, "proto3Optional"))
                        writer.uint32(/* id 17, wireType 0 =*/136).bool(message.proto3Optional);
                    return writer;
                };
    
                /**
                 * Encodes the specified FieldDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.FieldDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {google.protobuf.IFieldDescriptorProto} message FieldDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FieldDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 3:
                            message.number = reader.int32();
                            break;
                        case 4:
                            message.label = reader.int32();
                            break;
                        case 5:
                            message.type = reader.int32();
                            break;
                        case 6:
                            message.typeName = reader.string();
                            break;
                        case 2:
                            message.extendee = reader.string();
                            break;
                        case 7:
                            message.defaultValue = reader.string();
                            break;
                        case 9:
                            message.oneofIndex = reader.int32();
                            break;
                        case 10:
                            message.jsonName = reader.string();
                            break;
                        case 8:
                            message.options = $root.google.protobuf.FieldOptions.decode(reader, reader.uint32());
                            break;
                        case 17:
                            message.proto3Optional = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FieldDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FieldDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.number != null && message.hasOwnProperty("number"))
                        if (!$util.isInteger(message.number))
                            return "number: integer expected";
                    if (message.label != null && message.hasOwnProperty("label"))
                        switch (message.label) {
                        default:
                            return "label: enum value expected";
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                        case 15:
                        case 16:
                        case 17:
                        case 18:
                            break;
                        }
                    if (message.typeName != null && message.hasOwnProperty("typeName"))
                        if (!$util.isString(message.typeName))
                            return "typeName: string expected";
                    if (message.extendee != null && message.hasOwnProperty("extendee"))
                        if (!$util.isString(message.extendee))
                            return "extendee: string expected";
                    if (message.defaultValue != null && message.hasOwnProperty("defaultValue"))
                        if (!$util.isString(message.defaultValue))
                            return "defaultValue: string expected";
                    if (message.oneofIndex != null && message.hasOwnProperty("oneofIndex"))
                        if (!$util.isInteger(message.oneofIndex))
                            return "oneofIndex: integer expected";
                    if (message.jsonName != null && message.hasOwnProperty("jsonName"))
                        if (!$util.isString(message.jsonName))
                            return "jsonName: string expected";
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.FieldOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    if (message.proto3Optional != null && message.hasOwnProperty("proto3Optional"))
                        if (typeof message.proto3Optional !== "boolean")
                            return "proto3Optional: boolean expected";
                    return null;
                };
    
                /**
                 * Creates a FieldDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
                 */
                FieldDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FieldDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.FieldDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.number != null)
                        message.number = object.number | 0;
                    switch (object.label) {
                    case "LABEL_OPTIONAL":
                    case 1:
                        message.label = 1;
                        break;
                    case "LABEL_REQUIRED":
                    case 2:
                        message.label = 2;
                        break;
                    case "LABEL_REPEATED":
                    case 3:
                        message.label = 3;
                        break;
                    }
                    switch (object.type) {
                    case "TYPE_DOUBLE":
                    case 1:
                        message.type = 1;
                        break;
                    case "TYPE_FLOAT":
                    case 2:
                        message.type = 2;
                        break;
                    case "TYPE_INT64":
                    case 3:
                        message.type = 3;
                        break;
                    case "TYPE_UINT64":
                    case 4:
                        message.type = 4;
                        break;
                    case "TYPE_INT32":
                    case 5:
                        message.type = 5;
                        break;
                    case "TYPE_FIXED64":
                    case 6:
                        message.type = 6;
                        break;
                    case "TYPE_FIXED32":
                    case 7:
                        message.type = 7;
                        break;
                    case "TYPE_BOOL":
                    case 8:
                        message.type = 8;
                        break;
                    case "TYPE_STRING":
                    case 9:
                        message.type = 9;
                        break;
                    case "TYPE_GROUP":
                    case 10:
                        message.type = 10;
                        break;
                    case "TYPE_MESSAGE":
                    case 11:
                        message.type = 11;
                        break;
                    case "TYPE_BYTES":
                    case 12:
                        message.type = 12;
                        break;
                    case "TYPE_UINT32":
                    case 13:
                        message.type = 13;
                        break;
                    case "TYPE_ENUM":
                    case 14:
                        message.type = 14;
                        break;
                    case "TYPE_SFIXED32":
                    case 15:
                        message.type = 15;
                        break;
                    case "TYPE_SFIXED64":
                    case 16:
                        message.type = 16;
                        break;
                    case "TYPE_SINT32":
                    case 17:
                        message.type = 17;
                        break;
                    case "TYPE_SINT64":
                    case 18:
                        message.type = 18;
                        break;
                    }
                    if (object.typeName != null)
                        message.typeName = String(object.typeName);
                    if (object.extendee != null)
                        message.extendee = String(object.extendee);
                    if (object.defaultValue != null)
                        message.defaultValue = String(object.defaultValue);
                    if (object.oneofIndex != null)
                        message.oneofIndex = object.oneofIndex | 0;
                    if (object.jsonName != null)
                        message.jsonName = String(object.jsonName);
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.FieldDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.FieldOptions.fromObject(object.options);
                    }
                    if (object.proto3Optional != null)
                        message.proto3Optional = Boolean(object.proto3Optional);
                    return message;
                };
    
                /**
                 * Creates a plain object from a FieldDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {google.protobuf.FieldDescriptorProto} message FieldDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = "";
                        object.extendee = "";
                        object.number = 0;
                        object.label = options.enums === String ? "LABEL_OPTIONAL" : 1;
                        object.type = options.enums === String ? "TYPE_DOUBLE" : 1;
                        object.typeName = "";
                        object.defaultValue = "";
                        object.options = null;
                        object.oneofIndex = 0;
                        object.jsonName = "";
                        object.proto3Optional = false;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.extendee != null && message.hasOwnProperty("extendee"))
                        object.extendee = message.extendee;
                    if (message.number != null && message.hasOwnProperty("number"))
                        object.number = message.number;
                    if (message.label != null && message.hasOwnProperty("label"))
                        object.label = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Label[message.label] : message.label;
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Type[message.type] : message.type;
                    if (message.typeName != null && message.hasOwnProperty("typeName"))
                        object.typeName = message.typeName;
                    if (message.defaultValue != null && message.hasOwnProperty("defaultValue"))
                        object.defaultValue = message.defaultValue;
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.FieldOptions.toObject(message.options, options);
                    if (message.oneofIndex != null && message.hasOwnProperty("oneofIndex"))
                        object.oneofIndex = message.oneofIndex;
                    if (message.jsonName != null && message.hasOwnProperty("jsonName"))
                        object.jsonName = message.jsonName;
                    if (message.proto3Optional != null && message.hasOwnProperty("proto3Optional"))
                        object.proto3Optional = message.proto3Optional;
                    return object;
                };
    
                /**
                 * Converts this FieldDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * Type enum.
                 * @name google.protobuf.FieldDescriptorProto.Type
                 * @enum {number}
                 * @property {number} TYPE_DOUBLE=1 TYPE_DOUBLE value
                 * @property {number} TYPE_FLOAT=2 TYPE_FLOAT value
                 * @property {number} TYPE_INT64=3 TYPE_INT64 value
                 * @property {number} TYPE_UINT64=4 TYPE_UINT64 value
                 * @property {number} TYPE_INT32=5 TYPE_INT32 value
                 * @property {number} TYPE_FIXED64=6 TYPE_FIXED64 value
                 * @property {number} TYPE_FIXED32=7 TYPE_FIXED32 value
                 * @property {number} TYPE_BOOL=8 TYPE_BOOL value
                 * @property {number} TYPE_STRING=9 TYPE_STRING value
                 * @property {number} TYPE_GROUP=10 TYPE_GROUP value
                 * @property {number} TYPE_MESSAGE=11 TYPE_MESSAGE value
                 * @property {number} TYPE_BYTES=12 TYPE_BYTES value
                 * @property {number} TYPE_UINT32=13 TYPE_UINT32 value
                 * @property {number} TYPE_ENUM=14 TYPE_ENUM value
                 * @property {number} TYPE_SFIXED32=15 TYPE_SFIXED32 value
                 * @property {number} TYPE_SFIXED64=16 TYPE_SFIXED64 value
                 * @property {number} TYPE_SINT32=17 TYPE_SINT32 value
                 * @property {number} TYPE_SINT64=18 TYPE_SINT64 value
                 */
                FieldDescriptorProto.Type = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[1] = "TYPE_DOUBLE"] = 1;
                    values[valuesById[2] = "TYPE_FLOAT"] = 2;
                    values[valuesById[3] = "TYPE_INT64"] = 3;
                    values[valuesById[4] = "TYPE_UINT64"] = 4;
                    values[valuesById[5] = "TYPE_INT32"] = 5;
                    values[valuesById[6] = "TYPE_FIXED64"] = 6;
                    values[valuesById[7] = "TYPE_FIXED32"] = 7;
                    values[valuesById[8] = "TYPE_BOOL"] = 8;
                    values[valuesById[9] = "TYPE_STRING"] = 9;
                    values[valuesById[10] = "TYPE_GROUP"] = 10;
                    values[valuesById[11] = "TYPE_MESSAGE"] = 11;
                    values[valuesById[12] = "TYPE_BYTES"] = 12;
                    values[valuesById[13] = "TYPE_UINT32"] = 13;
                    values[valuesById[14] = "TYPE_ENUM"] = 14;
                    values[valuesById[15] = "TYPE_SFIXED32"] = 15;
                    values[valuesById[16] = "TYPE_SFIXED64"] = 16;
                    values[valuesById[17] = "TYPE_SINT32"] = 17;
                    values[valuesById[18] = "TYPE_SINT64"] = 18;
                    return values;
                })();
    
                /**
                 * Label enum.
                 * @name google.protobuf.FieldDescriptorProto.Label
                 * @enum {number}
                 * @property {number} LABEL_OPTIONAL=1 LABEL_OPTIONAL value
                 * @property {number} LABEL_REQUIRED=2 LABEL_REQUIRED value
                 * @property {number} LABEL_REPEATED=3 LABEL_REPEATED value
                 */
                FieldDescriptorProto.Label = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[1] = "LABEL_OPTIONAL"] = 1;
                    values[valuesById[2] = "LABEL_REQUIRED"] = 2;
                    values[valuesById[3] = "LABEL_REPEATED"] = 3;
                    return values;
                })();
    
                return FieldDescriptorProto;
            })();
    
            protobuf.OneofDescriptorProto = (function() {
    
                /**
                 * Properties of an OneofDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IOneofDescriptorProto
                 * @property {string|null} [name] OneofDescriptorProto name
                 * @property {google.protobuf.IOneofOptions|null} [options] OneofDescriptorProto options
                 */
    
                /**
                 * Constructs a new OneofDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents an OneofDescriptorProto.
                 * @implements IOneofDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
                 */
                function OneofDescriptorProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * OneofDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @instance
                 */
                OneofDescriptorProto.prototype.name = "";
    
                /**
                 * OneofDescriptorProto options.
                 * @member {google.protobuf.IOneofOptions|null|undefined} options
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @instance
                 */
                OneofDescriptorProto.prototype.options = null;
    
                /**
                 * Creates a new OneofDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto instance
                 */
                OneofDescriptorProto.create = function create(properties) {
                    return new OneofDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified OneofDescriptorProto message. Does not implicitly {@link google.protobuf.OneofDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {google.protobuf.IOneofDescriptorProto} message OneofDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OneofDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.OneofOptions.encode(message.options, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified OneofDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.OneofDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {google.protobuf.IOneofDescriptorProto} message OneofDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OneofDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an OneofDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OneofDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            message.options = $root.google.protobuf.OneofOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an OneofDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OneofDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an OneofDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OneofDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.OneofOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates an OneofDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
                 */
                OneofDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.OneofDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.OneofDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.OneofDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.OneofOptions.fromObject(object.options);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an OneofDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {google.protobuf.OneofDescriptorProto} message OneofDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OneofDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = "";
                        object.options = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.OneofOptions.toObject(message.options, options);
                    return object;
                };
    
                /**
                 * Converts this OneofDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OneofDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return OneofDescriptorProto;
            })();
    
            protobuf.EnumDescriptorProto = (function() {
    
                /**
                 * Properties of an EnumDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IEnumDescriptorProto
                 * @property {string|null} [name] EnumDescriptorProto name
                 * @property {Array.<google.protobuf.IEnumValueDescriptorProto>|null} [value] EnumDescriptorProto value
                 * @property {google.protobuf.IEnumOptions|null} [options] EnumDescriptorProto options
                 * @property {Array.<google.protobuf.EnumDescriptorProto.IEnumReservedRange>|null} [reservedRange] EnumDescriptorProto reservedRange
                 * @property {Array.<string>|null} [reservedName] EnumDescriptorProto reservedName
                 */
    
                /**
                 * Constructs a new EnumDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents an EnumDescriptorProto.
                 * @implements IEnumDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
                 */
                function EnumDescriptorProto(properties) {
                    this.value = [];
                    this.reservedRange = [];
                    this.reservedName = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * EnumDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @instance
                 */
                EnumDescriptorProto.prototype.name = "";
    
                /**
                 * EnumDescriptorProto value.
                 * @member {Array.<google.protobuf.IEnumValueDescriptorProto>} value
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @instance
                 */
                EnumDescriptorProto.prototype.value = $util.emptyArray;
    
                /**
                 * EnumDescriptorProto options.
                 * @member {google.protobuf.IEnumOptions|null|undefined} options
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @instance
                 */
                EnumDescriptorProto.prototype.options = null;
    
                /**
                 * EnumDescriptorProto reservedRange.
                 * @member {Array.<google.protobuf.EnumDescriptorProto.IEnumReservedRange>} reservedRange
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @instance
                 */
                EnumDescriptorProto.prototype.reservedRange = $util.emptyArray;
    
                /**
                 * EnumDescriptorProto reservedName.
                 * @member {Array.<string>} reservedName
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @instance
                 */
                EnumDescriptorProto.prototype.reservedName = $util.emptyArray;
    
                /**
                 * Creates a new EnumDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto instance
                 */
                EnumDescriptorProto.create = function create(properties) {
                    return new EnumDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified EnumDescriptorProto message. Does not implicitly {@link google.protobuf.EnumDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumDescriptorProto} message EnumDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.value != null && message.value.length)
                        for (var i = 0; i < message.value.length; ++i)
                            $root.google.protobuf.EnumValueDescriptorProto.encode(message.value[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.EnumOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.reservedRange != null && message.reservedRange.length)
                        for (var i = 0; i < message.reservedRange.length; ++i)
                            $root.google.protobuf.EnumDescriptorProto.EnumReservedRange.encode(message.reservedRange[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.reservedName != null && message.reservedName.length)
                        for (var i = 0; i < message.reservedName.length; ++i)
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.reservedName[i]);
                    return writer;
                };
    
                /**
                 * Encodes the specified EnumDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.EnumDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumDescriptorProto} message EnumDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an EnumDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            if (!(message.value && message.value.length))
                                message.value = [];
                            message.value.push($root.google.protobuf.EnumValueDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.options = $root.google.protobuf.EnumOptions.decode(reader, reader.uint32());
                            break;
                        case 4:
                            if (!(message.reservedRange && message.reservedRange.length))
                                message.reservedRange = [];
                            message.reservedRange.push($root.google.protobuf.EnumDescriptorProto.EnumReservedRange.decode(reader, reader.uint32()));
                            break;
                        case 5:
                            if (!(message.reservedName && message.reservedName.length))
                                message.reservedName = [];
                            message.reservedName.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an EnumDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an EnumDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EnumDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.value != null && message.hasOwnProperty("value")) {
                        if (!Array.isArray(message.value))
                            return "value: array expected";
                        for (var i = 0; i < message.value.length; ++i) {
                            var error = $root.google.protobuf.EnumValueDescriptorProto.verify(message.value[i]);
                            if (error)
                                return "value." + error;
                        }
                    }
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.EnumOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    if (message.reservedRange != null && message.hasOwnProperty("reservedRange")) {
                        if (!Array.isArray(message.reservedRange))
                            return "reservedRange: array expected";
                        for (var i = 0; i < message.reservedRange.length; ++i) {
                            var error = $root.google.protobuf.EnumDescriptorProto.EnumReservedRange.verify(message.reservedRange[i]);
                            if (error)
                                return "reservedRange." + error;
                        }
                    }
                    if (message.reservedName != null && message.hasOwnProperty("reservedName")) {
                        if (!Array.isArray(message.reservedName))
                            return "reservedName: array expected";
                        for (var i = 0; i < message.reservedName.length; ++i)
                            if (!$util.isString(message.reservedName[i]))
                                return "reservedName: string[] expected";
                    }
                    return null;
                };
    
                /**
                 * Creates an EnumDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
                 */
                EnumDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.EnumDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.EnumDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.value) {
                        if (!Array.isArray(object.value))
                            throw TypeError(".google.protobuf.EnumDescriptorProto.value: array expected");
                        message.value = [];
                        for (var i = 0; i < object.value.length; ++i) {
                            if (typeof object.value[i] !== "object")
                                throw TypeError(".google.protobuf.EnumDescriptorProto.value: object expected");
                            message.value[i] = $root.google.protobuf.EnumValueDescriptorProto.fromObject(object.value[i]);
                        }
                    }
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.EnumDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.EnumOptions.fromObject(object.options);
                    }
                    if (object.reservedRange) {
                        if (!Array.isArray(object.reservedRange))
                            throw TypeError(".google.protobuf.EnumDescriptorProto.reservedRange: array expected");
                        message.reservedRange = [];
                        for (var i = 0; i < object.reservedRange.length; ++i) {
                            if (typeof object.reservedRange[i] !== "object")
                                throw TypeError(".google.protobuf.EnumDescriptorProto.reservedRange: object expected");
                            message.reservedRange[i] = $root.google.protobuf.EnumDescriptorProto.EnumReservedRange.fromObject(object.reservedRange[i]);
                        }
                    }
                    if (object.reservedName) {
                        if (!Array.isArray(object.reservedName))
                            throw TypeError(".google.protobuf.EnumDescriptorProto.reservedName: array expected");
                        message.reservedName = [];
                        for (var i = 0; i < object.reservedName.length; ++i)
                            message.reservedName[i] = String(object.reservedName[i]);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an EnumDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {google.protobuf.EnumDescriptorProto} message EnumDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EnumDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.value = [];
                        object.reservedRange = [];
                        object.reservedName = [];
                    }
                    if (options.defaults) {
                        object.name = "";
                        object.options = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.value && message.value.length) {
                        object.value = [];
                        for (var j = 0; j < message.value.length; ++j)
                            object.value[j] = $root.google.protobuf.EnumValueDescriptorProto.toObject(message.value[j], options);
                    }
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.EnumOptions.toObject(message.options, options);
                    if (message.reservedRange && message.reservedRange.length) {
                        object.reservedRange = [];
                        for (var j = 0; j < message.reservedRange.length; ++j)
                            object.reservedRange[j] = $root.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject(message.reservedRange[j], options);
                    }
                    if (message.reservedName && message.reservedName.length) {
                        object.reservedName = [];
                        for (var j = 0; j < message.reservedName.length; ++j)
                            object.reservedName[j] = message.reservedName[j];
                    }
                    return object;
                };
    
                /**
                 * Converts this EnumDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EnumDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                EnumDescriptorProto.EnumReservedRange = (function() {
    
                    /**
                     * Properties of an EnumReservedRange.
                     * @memberof google.protobuf.EnumDescriptorProto
                     * @interface IEnumReservedRange
                     * @property {number|null} [start] EnumReservedRange start
                     * @property {number|null} [end] EnumReservedRange end
                     */
    
                    /**
                     * Constructs a new EnumReservedRange.
                     * @memberof google.protobuf.EnumDescriptorProto
                     * @classdesc Represents an EnumReservedRange.
                     * @implements IEnumReservedRange
                     * @constructor
                     * @param {google.protobuf.EnumDescriptorProto.IEnumReservedRange=} [properties] Properties to set
                     */
                    function EnumReservedRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EnumReservedRange start.
                     * @member {number} start
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @instance
                     */
                    EnumReservedRange.prototype.start = 0;
    
                    /**
                     * EnumReservedRange end.
                     * @member {number} end
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @instance
                     */
                    EnumReservedRange.prototype.end = 0;
    
                    /**
                     * Creates a new EnumReservedRange instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @static
                     * @param {google.protobuf.EnumDescriptorProto.IEnumReservedRange=} [properties] Properties to set
                     * @returns {google.protobuf.EnumDescriptorProto.EnumReservedRange} EnumReservedRange instance
                     */
                    EnumReservedRange.create = function create(properties) {
                        return new EnumReservedRange(properties);
                    };
    
                    /**
                     * Encodes the specified EnumReservedRange message. Does not implicitly {@link google.protobuf.EnumDescriptorProto.EnumReservedRange.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @static
                     * @param {google.protobuf.EnumDescriptorProto.IEnumReservedRange} message EnumReservedRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EnumReservedRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.start);
                        if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.end);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EnumReservedRange message, length delimited. Does not implicitly {@link google.protobuf.EnumDescriptorProto.EnumReservedRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @static
                     * @param {google.protobuf.EnumDescriptorProto.IEnumReservedRange} message EnumReservedRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EnumReservedRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EnumReservedRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.EnumDescriptorProto.EnumReservedRange} EnumReservedRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EnumReservedRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumDescriptorProto.EnumReservedRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.start = reader.int32();
                                break;
                            case 2:
                                message.end = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EnumReservedRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.EnumDescriptorProto.EnumReservedRange} EnumReservedRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EnumReservedRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EnumReservedRange message.
                     * @function verify
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EnumReservedRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.start != null && message.hasOwnProperty("start"))
                            if (!$util.isInteger(message.start))
                                return "start: integer expected";
                        if (message.end != null && message.hasOwnProperty("end"))
                            if (!$util.isInteger(message.end))
                                return "end: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an EnumReservedRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.EnumDescriptorProto.EnumReservedRange} EnumReservedRange
                     */
                    EnumReservedRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.EnumDescriptorProto.EnumReservedRange)
                            return object;
                        var message = new $root.google.protobuf.EnumDescriptorProto.EnumReservedRange();
                        if (object.start != null)
                            message.start = object.start | 0;
                        if (object.end != null)
                            message.end = object.end | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EnumReservedRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @static
                     * @param {google.protobuf.EnumDescriptorProto.EnumReservedRange} message EnumReservedRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EnumReservedRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.start = 0;
                            object.end = 0;
                        }
                        if (message.start != null && message.hasOwnProperty("start"))
                            object.start = message.start;
                        if (message.end != null && message.hasOwnProperty("end"))
                            object.end = message.end;
                        return object;
                    };
    
                    /**
                     * Converts this EnumReservedRange to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.EnumDescriptorProto.EnumReservedRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EnumReservedRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EnumReservedRange;
                })();
    
                return EnumDescriptorProto;
            })();
    
            protobuf.EnumValueDescriptorProto = (function() {
    
                /**
                 * Properties of an EnumValueDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IEnumValueDescriptorProto
                 * @property {string|null} [name] EnumValueDescriptorProto name
                 * @property {number|null} [number] EnumValueDescriptorProto number
                 * @property {google.protobuf.IEnumValueOptions|null} [options] EnumValueDescriptorProto options
                 */
    
                /**
                 * Constructs a new EnumValueDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents an EnumValueDescriptorProto.
                 * @implements IEnumValueDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
                 */
                function EnumValueDescriptorProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * EnumValueDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @instance
                 */
                EnumValueDescriptorProto.prototype.name = "";
    
                /**
                 * EnumValueDescriptorProto number.
                 * @member {number} number
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @instance
                 */
                EnumValueDescriptorProto.prototype.number = 0;
    
                /**
                 * EnumValueDescriptorProto options.
                 * @member {google.protobuf.IEnumValueOptions|null|undefined} options
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @instance
                 */
                EnumValueDescriptorProto.prototype.options = null;
    
                /**
                 * Creates a new EnumValueDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto instance
                 */
                EnumValueDescriptorProto.create = function create(properties) {
                    return new EnumValueDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified EnumValueDescriptorProto message. Does not implicitly {@link google.protobuf.EnumValueDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumValueDescriptorProto} message EnumValueDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumValueDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.number);
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.EnumValueOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified EnumValueDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.EnumValueDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumValueDescriptorProto} message EnumValueDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumValueDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an EnumValueDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumValueDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            message.number = reader.int32();
                            break;
                        case 3:
                            message.options = $root.google.protobuf.EnumValueOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an EnumValueDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumValueDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an EnumValueDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EnumValueDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.number != null && message.hasOwnProperty("number"))
                        if (!$util.isInteger(message.number))
                            return "number: integer expected";
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.EnumValueOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates an EnumValueDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
                 */
                EnumValueDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.EnumValueDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.EnumValueDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.number != null)
                        message.number = object.number | 0;
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.EnumValueDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.EnumValueOptions.fromObject(object.options);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an EnumValueDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {google.protobuf.EnumValueDescriptorProto} message EnumValueDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EnumValueDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = "";
                        object.number = 0;
                        object.options = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.number != null && message.hasOwnProperty("number"))
                        object.number = message.number;
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.EnumValueOptions.toObject(message.options, options);
                    return object;
                };
    
                /**
                 * Converts this EnumValueDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EnumValueDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return EnumValueDescriptorProto;
            })();
    
            protobuf.ServiceDescriptorProto = (function() {
    
                /**
                 * Properties of a ServiceDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IServiceDescriptorProto
                 * @property {string|null} [name] ServiceDescriptorProto name
                 * @property {Array.<google.protobuf.IMethodDescriptorProto>|null} [method] ServiceDescriptorProto method
                 * @property {google.protobuf.IServiceOptions|null} [options] ServiceDescriptorProto options
                 */
    
                /**
                 * Constructs a new ServiceDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents a ServiceDescriptorProto.
                 * @implements IServiceDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
                 */
                function ServiceDescriptorProto(properties) {
                    this.method = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ServiceDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @instance
                 */
                ServiceDescriptorProto.prototype.name = "";
    
                /**
                 * ServiceDescriptorProto method.
                 * @member {Array.<google.protobuf.IMethodDescriptorProto>} method
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @instance
                 */
                ServiceDescriptorProto.prototype.method = $util.emptyArray;
    
                /**
                 * ServiceDescriptorProto options.
                 * @member {google.protobuf.IServiceOptions|null|undefined} options
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @instance
                 */
                ServiceDescriptorProto.prototype.options = null;
    
                /**
                 * Creates a new ServiceDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto instance
                 */
                ServiceDescriptorProto.create = function create(properties) {
                    return new ServiceDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified ServiceDescriptorProto message. Does not implicitly {@link google.protobuf.ServiceDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {google.protobuf.IServiceDescriptorProto} message ServiceDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.method != null && message.method.length)
                        for (var i = 0; i < message.method.length; ++i)
                            $root.google.protobuf.MethodDescriptorProto.encode(message.method[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.ServiceOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified ServiceDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.ServiceDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {google.protobuf.IServiceDescriptorProto} message ServiceDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ServiceDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            if (!(message.method && message.method.length))
                                message.method = [];
                            message.method.push($root.google.protobuf.MethodDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.options = $root.google.protobuf.ServiceOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ServiceDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ServiceDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ServiceDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.method != null && message.hasOwnProperty("method")) {
                        if (!Array.isArray(message.method))
                            return "method: array expected";
                        for (var i = 0; i < message.method.length; ++i) {
                            var error = $root.google.protobuf.MethodDescriptorProto.verify(message.method[i]);
                            if (error)
                                return "method." + error;
                        }
                    }
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.ServiceOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates a ServiceDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
                 */
                ServiceDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.ServiceDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.ServiceDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.method) {
                        if (!Array.isArray(object.method))
                            throw TypeError(".google.protobuf.ServiceDescriptorProto.method: array expected");
                        message.method = [];
                        for (var i = 0; i < object.method.length; ++i) {
                            if (typeof object.method[i] !== "object")
                                throw TypeError(".google.protobuf.ServiceDescriptorProto.method: object expected");
                            message.method[i] = $root.google.protobuf.MethodDescriptorProto.fromObject(object.method[i]);
                        }
                    }
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.ServiceDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.ServiceOptions.fromObject(object.options);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a ServiceDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {google.protobuf.ServiceDescriptorProto} message ServiceDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ServiceDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.method = [];
                    if (options.defaults) {
                        object.name = "";
                        object.options = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.method && message.method.length) {
                        object.method = [];
                        for (var j = 0; j < message.method.length; ++j)
                            object.method[j] = $root.google.protobuf.MethodDescriptorProto.toObject(message.method[j], options);
                    }
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.ServiceOptions.toObject(message.options, options);
                    return object;
                };
    
                /**
                 * Converts this ServiceDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ServiceDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ServiceDescriptorProto;
            })();
    
            protobuf.MethodDescriptorProto = (function() {
    
                /**
                 * Properties of a MethodDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IMethodDescriptorProto
                 * @property {string|null} [name] MethodDescriptorProto name
                 * @property {string|null} [inputType] MethodDescriptorProto inputType
                 * @property {string|null} [outputType] MethodDescriptorProto outputType
                 * @property {google.protobuf.IMethodOptions|null} [options] MethodDescriptorProto options
                 * @property {boolean|null} [clientStreaming] MethodDescriptorProto clientStreaming
                 * @property {boolean|null} [serverStreaming] MethodDescriptorProto serverStreaming
                 */
    
                /**
                 * Constructs a new MethodDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents a MethodDescriptorProto.
                 * @implements IMethodDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
                 */
                function MethodDescriptorProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * MethodDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.name = "";
    
                /**
                 * MethodDescriptorProto inputType.
                 * @member {string} inputType
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.inputType = "";
    
                /**
                 * MethodDescriptorProto outputType.
                 * @member {string} outputType
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.outputType = "";
    
                /**
                 * MethodDescriptorProto options.
                 * @member {google.protobuf.IMethodOptions|null|undefined} options
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.options = null;
    
                /**
                 * MethodDescriptorProto clientStreaming.
                 * @member {boolean} clientStreaming
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.clientStreaming = false;
    
                /**
                 * MethodDescriptorProto serverStreaming.
                 * @member {boolean} serverStreaming
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.serverStreaming = false;
    
                /**
                 * Creates a new MethodDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto instance
                 */
                MethodDescriptorProto.create = function create(properties) {
                    return new MethodDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified MethodDescriptorProto message. Does not implicitly {@link google.protobuf.MethodDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {google.protobuf.IMethodDescriptorProto} message MethodDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MethodDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.inputType != null && Object.hasOwnProperty.call(message, "inputType"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.inputType);
                    if (message.outputType != null && Object.hasOwnProperty.call(message, "outputType"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.outputType);
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.MethodOptions.encode(message.options, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.clientStreaming != null && Object.hasOwnProperty.call(message, "clientStreaming"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.clientStreaming);
                    if (message.serverStreaming != null && Object.hasOwnProperty.call(message, "serverStreaming"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.serverStreaming);
                    return writer;
                };
    
                /**
                 * Encodes the specified MethodDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.MethodDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {google.protobuf.IMethodDescriptorProto} message MethodDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MethodDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a MethodDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MethodDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            message.inputType = reader.string();
                            break;
                        case 3:
                            message.outputType = reader.string();
                            break;
                        case 4:
                            message.options = $root.google.protobuf.MethodOptions.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.clientStreaming = reader.bool();
                            break;
                        case 6:
                            message.serverStreaming = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a MethodDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MethodDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a MethodDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MethodDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.inputType != null && message.hasOwnProperty("inputType"))
                        if (!$util.isString(message.inputType))
                            return "inputType: string expected";
                    if (message.outputType != null && message.hasOwnProperty("outputType"))
                        if (!$util.isString(message.outputType))
                            return "outputType: string expected";
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.MethodOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    if (message.clientStreaming != null && message.hasOwnProperty("clientStreaming"))
                        if (typeof message.clientStreaming !== "boolean")
                            return "clientStreaming: boolean expected";
                    if (message.serverStreaming != null && message.hasOwnProperty("serverStreaming"))
                        if (typeof message.serverStreaming !== "boolean")
                            return "serverStreaming: boolean expected";
                    return null;
                };
    
                /**
                 * Creates a MethodDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
                 */
                MethodDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.MethodDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.MethodDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.inputType != null)
                        message.inputType = String(object.inputType);
                    if (object.outputType != null)
                        message.outputType = String(object.outputType);
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.MethodDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.MethodOptions.fromObject(object.options);
                    }
                    if (object.clientStreaming != null)
                        message.clientStreaming = Boolean(object.clientStreaming);
                    if (object.serverStreaming != null)
                        message.serverStreaming = Boolean(object.serverStreaming);
                    return message;
                };
    
                /**
                 * Creates a plain object from a MethodDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {google.protobuf.MethodDescriptorProto} message MethodDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MethodDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = "";
                        object.inputType = "";
                        object.outputType = "";
                        object.options = null;
                        object.clientStreaming = false;
                        object.serverStreaming = false;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.inputType != null && message.hasOwnProperty("inputType"))
                        object.inputType = message.inputType;
                    if (message.outputType != null && message.hasOwnProperty("outputType"))
                        object.outputType = message.outputType;
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.MethodOptions.toObject(message.options, options);
                    if (message.clientStreaming != null && message.hasOwnProperty("clientStreaming"))
                        object.clientStreaming = message.clientStreaming;
                    if (message.serverStreaming != null && message.hasOwnProperty("serverStreaming"))
                        object.serverStreaming = message.serverStreaming;
                    return object;
                };
    
                /**
                 * Converts this MethodDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MethodDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return MethodDescriptorProto;
            })();
    
            protobuf.FileOptions = (function() {
    
                /**
                 * Properties of a FileOptions.
                 * @memberof google.protobuf
                 * @interface IFileOptions
                 * @property {string|null} [javaPackage] FileOptions javaPackage
                 * @property {string|null} [javaOuterClassname] FileOptions javaOuterClassname
                 * @property {boolean|null} [javaMultipleFiles] FileOptions javaMultipleFiles
                 * @property {boolean|null} [javaGenerateEqualsAndHash] FileOptions javaGenerateEqualsAndHash
                 * @property {boolean|null} [javaStringCheckUtf8] FileOptions javaStringCheckUtf8
                 * @property {google.protobuf.FileOptions.OptimizeMode|null} [optimizeFor] FileOptions optimizeFor
                 * @property {string|null} [goPackage] FileOptions goPackage
                 * @property {boolean|null} [ccGenericServices] FileOptions ccGenericServices
                 * @property {boolean|null} [javaGenericServices] FileOptions javaGenericServices
                 * @property {boolean|null} [pyGenericServices] FileOptions pyGenericServices
                 * @property {boolean|null} [phpGenericServices] FileOptions phpGenericServices
                 * @property {boolean|null} [deprecated] FileOptions deprecated
                 * @property {boolean|null} [ccEnableArenas] FileOptions ccEnableArenas
                 * @property {string|null} [objcClassPrefix] FileOptions objcClassPrefix
                 * @property {string|null} [csharpNamespace] FileOptions csharpNamespace
                 * @property {string|null} [swiftPrefix] FileOptions swiftPrefix
                 * @property {string|null} [phpClassPrefix] FileOptions phpClassPrefix
                 * @property {string|null} [phpNamespace] FileOptions phpNamespace
                 * @property {string|null} [phpMetadataNamespace] FileOptions phpMetadataNamespace
                 * @property {string|null} [rubyPackage] FileOptions rubyPackage
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FileOptions uninterpretedOption
                 * @property {Array.<google.api.IResourceDescriptor>|null} [".google.api.resourceDefinition"] FileOptions .google.api.resourceDefinition
                 */
    
                /**
                 * Constructs a new FileOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents a FileOptions.
                 * @implements IFileOptions
                 * @constructor
                 * @param {google.protobuf.IFileOptions=} [properties] Properties to set
                 */
                function FileOptions(properties) {
                    this.uninterpretedOption = [];
                    this[".google.api.resourceDefinition"] = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FileOptions javaPackage.
                 * @member {string} javaPackage
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaPackage = "";
    
                /**
                 * FileOptions javaOuterClassname.
                 * @member {string} javaOuterClassname
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaOuterClassname = "";
    
                /**
                 * FileOptions javaMultipleFiles.
                 * @member {boolean} javaMultipleFiles
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaMultipleFiles = false;
    
                /**
                 * FileOptions javaGenerateEqualsAndHash.
                 * @member {boolean} javaGenerateEqualsAndHash
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaGenerateEqualsAndHash = false;
    
                /**
                 * FileOptions javaStringCheckUtf8.
                 * @member {boolean} javaStringCheckUtf8
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaStringCheckUtf8 = false;
    
                /**
                 * FileOptions optimizeFor.
                 * @member {google.protobuf.FileOptions.OptimizeMode} optimizeFor
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.optimizeFor = 1;
    
                /**
                 * FileOptions goPackage.
                 * @member {string} goPackage
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.goPackage = "";
    
                /**
                 * FileOptions ccGenericServices.
                 * @member {boolean} ccGenericServices
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.ccGenericServices = false;
    
                /**
                 * FileOptions javaGenericServices.
                 * @member {boolean} javaGenericServices
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaGenericServices = false;
    
                /**
                 * FileOptions pyGenericServices.
                 * @member {boolean} pyGenericServices
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.pyGenericServices = false;
    
                /**
                 * FileOptions phpGenericServices.
                 * @member {boolean} phpGenericServices
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.phpGenericServices = false;
    
                /**
                 * FileOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.deprecated = false;
    
                /**
                 * FileOptions ccEnableArenas.
                 * @member {boolean} ccEnableArenas
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.ccEnableArenas = true;
    
                /**
                 * FileOptions objcClassPrefix.
                 * @member {string} objcClassPrefix
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.objcClassPrefix = "";
    
                /**
                 * FileOptions csharpNamespace.
                 * @member {string} csharpNamespace
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.csharpNamespace = "";
    
                /**
                 * FileOptions swiftPrefix.
                 * @member {string} swiftPrefix
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.swiftPrefix = "";
    
                /**
                 * FileOptions phpClassPrefix.
                 * @member {string} phpClassPrefix
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.phpClassPrefix = "";
    
                /**
                 * FileOptions phpNamespace.
                 * @member {string} phpNamespace
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.phpNamespace = "";
    
                /**
                 * FileOptions phpMetadataNamespace.
                 * @member {string} phpMetadataNamespace
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.phpMetadataNamespace = "";
    
                /**
                 * FileOptions rubyPackage.
                 * @member {string} rubyPackage
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.rubyPackage = "";
    
                /**
                 * FileOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * FileOptions .google.api.resourceDefinition.
                 * @member {Array.<google.api.IResourceDescriptor>} .google.api.resourceDefinition
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype[".google.api.resourceDefinition"] = $util.emptyArray;
    
                /**
                 * Creates a new FileOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {google.protobuf.IFileOptions=} [properties] Properties to set
                 * @returns {google.protobuf.FileOptions} FileOptions instance
                 */
                FileOptions.create = function create(properties) {
                    return new FileOptions(properties);
                };
    
                /**
                 * Encodes the specified FileOptions message. Does not implicitly {@link google.protobuf.FileOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {google.protobuf.IFileOptions} message FileOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.javaPackage != null && Object.hasOwnProperty.call(message, "javaPackage"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.javaPackage);
                    if (message.javaOuterClassname != null && Object.hasOwnProperty.call(message, "javaOuterClassname"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.javaOuterClassname);
                    if (message.optimizeFor != null && Object.hasOwnProperty.call(message, "optimizeFor"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int32(message.optimizeFor);
                    if (message.javaMultipleFiles != null && Object.hasOwnProperty.call(message, "javaMultipleFiles"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.javaMultipleFiles);
                    if (message.goPackage != null && Object.hasOwnProperty.call(message, "goPackage"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.goPackage);
                    if (message.ccGenericServices != null && Object.hasOwnProperty.call(message, "ccGenericServices"))
                        writer.uint32(/* id 16, wireType 0 =*/128).bool(message.ccGenericServices);
                    if (message.javaGenericServices != null && Object.hasOwnProperty.call(message, "javaGenericServices"))
                        writer.uint32(/* id 17, wireType 0 =*/136).bool(message.javaGenericServices);
                    if (message.pyGenericServices != null && Object.hasOwnProperty.call(message, "pyGenericServices"))
                        writer.uint32(/* id 18, wireType 0 =*/144).bool(message.pyGenericServices);
                    if (message.javaGenerateEqualsAndHash != null && Object.hasOwnProperty.call(message, "javaGenerateEqualsAndHash"))
                        writer.uint32(/* id 20, wireType 0 =*/160).bool(message.javaGenerateEqualsAndHash);
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 23, wireType 0 =*/184).bool(message.deprecated);
                    if (message.javaStringCheckUtf8 != null && Object.hasOwnProperty.call(message, "javaStringCheckUtf8"))
                        writer.uint32(/* id 27, wireType 0 =*/216).bool(message.javaStringCheckUtf8);
                    if (message.ccEnableArenas != null && Object.hasOwnProperty.call(message, "ccEnableArenas"))
                        writer.uint32(/* id 31, wireType 0 =*/248).bool(message.ccEnableArenas);
                    if (message.objcClassPrefix != null && Object.hasOwnProperty.call(message, "objcClassPrefix"))
                        writer.uint32(/* id 36, wireType 2 =*/290).string(message.objcClassPrefix);
                    if (message.csharpNamespace != null && Object.hasOwnProperty.call(message, "csharpNamespace"))
                        writer.uint32(/* id 37, wireType 2 =*/298).string(message.csharpNamespace);
                    if (message.swiftPrefix != null && Object.hasOwnProperty.call(message, "swiftPrefix"))
                        writer.uint32(/* id 39, wireType 2 =*/314).string(message.swiftPrefix);
                    if (message.phpClassPrefix != null && Object.hasOwnProperty.call(message, "phpClassPrefix"))
                        writer.uint32(/* id 40, wireType 2 =*/322).string(message.phpClassPrefix);
                    if (message.phpNamespace != null && Object.hasOwnProperty.call(message, "phpNamespace"))
                        writer.uint32(/* id 41, wireType 2 =*/330).string(message.phpNamespace);
                    if (message.phpGenericServices != null && Object.hasOwnProperty.call(message, "phpGenericServices"))
                        writer.uint32(/* id 42, wireType 0 =*/336).bool(message.phpGenericServices);
                    if (message.phpMetadataNamespace != null && Object.hasOwnProperty.call(message, "phpMetadataNamespace"))
                        writer.uint32(/* id 44, wireType 2 =*/354).string(message.phpMetadataNamespace);
                    if (message.rubyPackage != null && Object.hasOwnProperty.call(message, "rubyPackage"))
                        writer.uint32(/* id 45, wireType 2 =*/362).string(message.rubyPackage);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    if (message[".google.api.resourceDefinition"] != null && message[".google.api.resourceDefinition"].length)
                        for (var i = 0; i < message[".google.api.resourceDefinition"].length; ++i)
                            $root.google.api.ResourceDescriptor.encode(message[".google.api.resourceDefinition"][i], writer.uint32(/* id 1053, wireType 2 =*/8426).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified FileOptions message, length delimited. Does not implicitly {@link google.protobuf.FileOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {google.protobuf.IFileOptions} message FileOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FileOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FileOptions} FileOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.javaPackage = reader.string();
                            break;
                        case 8:
                            message.javaOuterClassname = reader.string();
                            break;
                        case 10:
                            message.javaMultipleFiles = reader.bool();
                            break;
                        case 20:
                            message.javaGenerateEqualsAndHash = reader.bool();
                            break;
                        case 27:
                            message.javaStringCheckUtf8 = reader.bool();
                            break;
                        case 9:
                            message.optimizeFor = reader.int32();
                            break;
                        case 11:
                            message.goPackage = reader.string();
                            break;
                        case 16:
                            message.ccGenericServices = reader.bool();
                            break;
                        case 17:
                            message.javaGenericServices = reader.bool();
                            break;
                        case 18:
                            message.pyGenericServices = reader.bool();
                            break;
                        case 42:
                            message.phpGenericServices = reader.bool();
                            break;
                        case 23:
                            message.deprecated = reader.bool();
                            break;
                        case 31:
                            message.ccEnableArenas = reader.bool();
                            break;
                        case 36:
                            message.objcClassPrefix = reader.string();
                            break;
                        case 37:
                            message.csharpNamespace = reader.string();
                            break;
                        case 39:
                            message.swiftPrefix = reader.string();
                            break;
                        case 40:
                            message.phpClassPrefix = reader.string();
                            break;
                        case 41:
                            message.phpNamespace = reader.string();
                            break;
                        case 44:
                            message.phpMetadataNamespace = reader.string();
                            break;
                        case 45:
                            message.rubyPackage = reader.string();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        case 1053:
                            if (!(message[".google.api.resourceDefinition"] && message[".google.api.resourceDefinition"].length))
                                message[".google.api.resourceDefinition"] = [];
                            message[".google.api.resourceDefinition"].push($root.google.api.ResourceDescriptor.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FileOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FileOptions} FileOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FileOptions message.
                 * @function verify
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FileOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.javaPackage != null && message.hasOwnProperty("javaPackage"))
                        if (!$util.isString(message.javaPackage))
                            return "javaPackage: string expected";
                    if (message.javaOuterClassname != null && message.hasOwnProperty("javaOuterClassname"))
                        if (!$util.isString(message.javaOuterClassname))
                            return "javaOuterClassname: string expected";
                    if (message.javaMultipleFiles != null && message.hasOwnProperty("javaMultipleFiles"))
                        if (typeof message.javaMultipleFiles !== "boolean")
                            return "javaMultipleFiles: boolean expected";
                    if (message.javaGenerateEqualsAndHash != null && message.hasOwnProperty("javaGenerateEqualsAndHash"))
                        if (typeof message.javaGenerateEqualsAndHash !== "boolean")
                            return "javaGenerateEqualsAndHash: boolean expected";
                    if (message.javaStringCheckUtf8 != null && message.hasOwnProperty("javaStringCheckUtf8"))
                        if (typeof message.javaStringCheckUtf8 !== "boolean")
                            return "javaStringCheckUtf8: boolean expected";
                    if (message.optimizeFor != null && message.hasOwnProperty("optimizeFor"))
                        switch (message.optimizeFor) {
                        default:
                            return "optimizeFor: enum value expected";
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.goPackage != null && message.hasOwnProperty("goPackage"))
                        if (!$util.isString(message.goPackage))
                            return "goPackage: string expected";
                    if (message.ccGenericServices != null && message.hasOwnProperty("ccGenericServices"))
                        if (typeof message.ccGenericServices !== "boolean")
                            return "ccGenericServices: boolean expected";
                    if (message.javaGenericServices != null && message.hasOwnProperty("javaGenericServices"))
                        if (typeof message.javaGenericServices !== "boolean")
                            return "javaGenericServices: boolean expected";
                    if (message.pyGenericServices != null && message.hasOwnProperty("pyGenericServices"))
                        if (typeof message.pyGenericServices !== "boolean")
                            return "pyGenericServices: boolean expected";
                    if (message.phpGenericServices != null && message.hasOwnProperty("phpGenericServices"))
                        if (typeof message.phpGenericServices !== "boolean")
                            return "phpGenericServices: boolean expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.ccEnableArenas != null && message.hasOwnProperty("ccEnableArenas"))
                        if (typeof message.ccEnableArenas !== "boolean")
                            return "ccEnableArenas: boolean expected";
                    if (message.objcClassPrefix != null && message.hasOwnProperty("objcClassPrefix"))
                        if (!$util.isString(message.objcClassPrefix))
                            return "objcClassPrefix: string expected";
                    if (message.csharpNamespace != null && message.hasOwnProperty("csharpNamespace"))
                        if (!$util.isString(message.csharpNamespace))
                            return "csharpNamespace: string expected";
                    if (message.swiftPrefix != null && message.hasOwnProperty("swiftPrefix"))
                        if (!$util.isString(message.swiftPrefix))
                            return "swiftPrefix: string expected";
                    if (message.phpClassPrefix != null && message.hasOwnProperty("phpClassPrefix"))
                        if (!$util.isString(message.phpClassPrefix))
                            return "phpClassPrefix: string expected";
                    if (message.phpNamespace != null && message.hasOwnProperty("phpNamespace"))
                        if (!$util.isString(message.phpNamespace))
                            return "phpNamespace: string expected";
                    if (message.phpMetadataNamespace != null && message.hasOwnProperty("phpMetadataNamespace"))
                        if (!$util.isString(message.phpMetadataNamespace))
                            return "phpMetadataNamespace: string expected";
                    if (message.rubyPackage != null && message.hasOwnProperty("rubyPackage"))
                        if (!$util.isString(message.rubyPackage))
                            return "rubyPackage: string expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    if (message[".google.api.resourceDefinition"] != null && message.hasOwnProperty(".google.api.resourceDefinition")) {
                        if (!Array.isArray(message[".google.api.resourceDefinition"]))
                            return ".google.api.resourceDefinition: array expected";
                        for (var i = 0; i < message[".google.api.resourceDefinition"].length; ++i) {
                            var error = $root.google.api.ResourceDescriptor.verify(message[".google.api.resourceDefinition"][i]);
                            if (error)
                                return ".google.api.resourceDefinition." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a FileOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FileOptions} FileOptions
                 */
                FileOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FileOptions)
                        return object;
                    var message = new $root.google.protobuf.FileOptions();
                    if (object.javaPackage != null)
                        message.javaPackage = String(object.javaPackage);
                    if (object.javaOuterClassname != null)
                        message.javaOuterClassname = String(object.javaOuterClassname);
                    if (object.javaMultipleFiles != null)
                        message.javaMultipleFiles = Boolean(object.javaMultipleFiles);
                    if (object.javaGenerateEqualsAndHash != null)
                        message.javaGenerateEqualsAndHash = Boolean(object.javaGenerateEqualsAndHash);
                    if (object.javaStringCheckUtf8 != null)
                        message.javaStringCheckUtf8 = Boolean(object.javaStringCheckUtf8);
                    switch (object.optimizeFor) {
                    case "SPEED":
                    case 1:
                        message.optimizeFor = 1;
                        break;
                    case "CODE_SIZE":
                    case 2:
                        message.optimizeFor = 2;
                        break;
                    case "LITE_RUNTIME":
                    case 3:
                        message.optimizeFor = 3;
                        break;
                    }
                    if (object.goPackage != null)
                        message.goPackage = String(object.goPackage);
                    if (object.ccGenericServices != null)
                        message.ccGenericServices = Boolean(object.ccGenericServices);
                    if (object.javaGenericServices != null)
                        message.javaGenericServices = Boolean(object.javaGenericServices);
                    if (object.pyGenericServices != null)
                        message.pyGenericServices = Boolean(object.pyGenericServices);
                    if (object.phpGenericServices != null)
                        message.phpGenericServices = Boolean(object.phpGenericServices);
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.ccEnableArenas != null)
                        message.ccEnableArenas = Boolean(object.ccEnableArenas);
                    if (object.objcClassPrefix != null)
                        message.objcClassPrefix = String(object.objcClassPrefix);
                    if (object.csharpNamespace != null)
                        message.csharpNamespace = String(object.csharpNamespace);
                    if (object.swiftPrefix != null)
                        message.swiftPrefix = String(object.swiftPrefix);
                    if (object.phpClassPrefix != null)
                        message.phpClassPrefix = String(object.phpClassPrefix);
                    if (object.phpNamespace != null)
                        message.phpNamespace = String(object.phpNamespace);
                    if (object.phpMetadataNamespace != null)
                        message.phpMetadataNamespace = String(object.phpMetadataNamespace);
                    if (object.rubyPackage != null)
                        message.rubyPackage = String(object.rubyPackage);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.FileOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.FileOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    if (object[".google.api.resourceDefinition"]) {
                        if (!Array.isArray(object[".google.api.resourceDefinition"]))
                            throw TypeError(".google.protobuf.FileOptions..google.api.resourceDefinition: array expected");
                        message[".google.api.resourceDefinition"] = [];
                        for (var i = 0; i < object[".google.api.resourceDefinition"].length; ++i) {
                            if (typeof object[".google.api.resourceDefinition"][i] !== "object")
                                throw TypeError(".google.protobuf.FileOptions..google.api.resourceDefinition: object expected");
                            message[".google.api.resourceDefinition"][i] = $root.google.api.ResourceDescriptor.fromObject(object[".google.api.resourceDefinition"][i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a FileOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {google.protobuf.FileOptions} message FileOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FileOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.uninterpretedOption = [];
                        object[".google.api.resourceDefinition"] = [];
                    }
                    if (options.defaults) {
                        object.javaPackage = "";
                        object.javaOuterClassname = "";
                        object.optimizeFor = options.enums === String ? "SPEED" : 1;
                        object.javaMultipleFiles = false;
                        object.goPackage = "";
                        object.ccGenericServices = false;
                        object.javaGenericServices = false;
                        object.pyGenericServices = false;
                        object.javaGenerateEqualsAndHash = false;
                        object.deprecated = false;
                        object.javaStringCheckUtf8 = false;
                        object.ccEnableArenas = true;
                        object.objcClassPrefix = "";
                        object.csharpNamespace = "";
                        object.swiftPrefix = "";
                        object.phpClassPrefix = "";
                        object.phpNamespace = "";
                        object.phpGenericServices = false;
                        object.phpMetadataNamespace = "";
                        object.rubyPackage = "";
                    }
                    if (message.javaPackage != null && message.hasOwnProperty("javaPackage"))
                        object.javaPackage = message.javaPackage;
                    if (message.javaOuterClassname != null && message.hasOwnProperty("javaOuterClassname"))
                        object.javaOuterClassname = message.javaOuterClassname;
                    if (message.optimizeFor != null && message.hasOwnProperty("optimizeFor"))
                        object.optimizeFor = options.enums === String ? $root.google.protobuf.FileOptions.OptimizeMode[message.optimizeFor] : message.optimizeFor;
                    if (message.javaMultipleFiles != null && message.hasOwnProperty("javaMultipleFiles"))
                        object.javaMultipleFiles = message.javaMultipleFiles;
                    if (message.goPackage != null && message.hasOwnProperty("goPackage"))
                        object.goPackage = message.goPackage;
                    if (message.ccGenericServices != null && message.hasOwnProperty("ccGenericServices"))
                        object.ccGenericServices = message.ccGenericServices;
                    if (message.javaGenericServices != null && message.hasOwnProperty("javaGenericServices"))
                        object.javaGenericServices = message.javaGenericServices;
                    if (message.pyGenericServices != null && message.hasOwnProperty("pyGenericServices"))
                        object.pyGenericServices = message.pyGenericServices;
                    if (message.javaGenerateEqualsAndHash != null && message.hasOwnProperty("javaGenerateEqualsAndHash"))
                        object.javaGenerateEqualsAndHash = message.javaGenerateEqualsAndHash;
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.javaStringCheckUtf8 != null && message.hasOwnProperty("javaStringCheckUtf8"))
                        object.javaStringCheckUtf8 = message.javaStringCheckUtf8;
                    if (message.ccEnableArenas != null && message.hasOwnProperty("ccEnableArenas"))
                        object.ccEnableArenas = message.ccEnableArenas;
                    if (message.objcClassPrefix != null && message.hasOwnProperty("objcClassPrefix"))
                        object.objcClassPrefix = message.objcClassPrefix;
                    if (message.csharpNamespace != null && message.hasOwnProperty("csharpNamespace"))
                        object.csharpNamespace = message.csharpNamespace;
                    if (message.swiftPrefix != null && message.hasOwnProperty("swiftPrefix"))
                        object.swiftPrefix = message.swiftPrefix;
                    if (message.phpClassPrefix != null && message.hasOwnProperty("phpClassPrefix"))
                        object.phpClassPrefix = message.phpClassPrefix;
                    if (message.phpNamespace != null && message.hasOwnProperty("phpNamespace"))
                        object.phpNamespace = message.phpNamespace;
                    if (message.phpGenericServices != null && message.hasOwnProperty("phpGenericServices"))
                        object.phpGenericServices = message.phpGenericServices;
                    if (message.phpMetadataNamespace != null && message.hasOwnProperty("phpMetadataNamespace"))
                        object.phpMetadataNamespace = message.phpMetadataNamespace;
                    if (message.rubyPackage != null && message.hasOwnProperty("rubyPackage"))
                        object.rubyPackage = message.rubyPackage;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    if (message[".google.api.resourceDefinition"] && message[".google.api.resourceDefinition"].length) {
                        object[".google.api.resourceDefinition"] = [];
                        for (var j = 0; j < message[".google.api.resourceDefinition"].length; ++j)
                            object[".google.api.resourceDefinition"][j] = $root.google.api.ResourceDescriptor.toObject(message[".google.api.resourceDefinition"][j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this FileOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FileOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * OptimizeMode enum.
                 * @name google.protobuf.FileOptions.OptimizeMode
                 * @enum {number}
                 * @property {number} SPEED=1 SPEED value
                 * @property {number} CODE_SIZE=2 CODE_SIZE value
                 * @property {number} LITE_RUNTIME=3 LITE_RUNTIME value
                 */
                FileOptions.OptimizeMode = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[1] = "SPEED"] = 1;
                    values[valuesById[2] = "CODE_SIZE"] = 2;
                    values[valuesById[3] = "LITE_RUNTIME"] = 3;
                    return values;
                })();
    
                return FileOptions;
            })();
    
            protobuf.MessageOptions = (function() {
    
                /**
                 * Properties of a MessageOptions.
                 * @memberof google.protobuf
                 * @interface IMessageOptions
                 * @property {boolean|null} [messageSetWireFormat] MessageOptions messageSetWireFormat
                 * @property {boolean|null} [noStandardDescriptorAccessor] MessageOptions noStandardDescriptorAccessor
                 * @property {boolean|null} [deprecated] MessageOptions deprecated
                 * @property {boolean|null} [mapEntry] MessageOptions mapEntry
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MessageOptions uninterpretedOption
                 * @property {google.api.IResourceDescriptor|null} [".google.api.resource"] MessageOptions .google.api.resource
                 */
    
                /**
                 * Constructs a new MessageOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents a MessageOptions.
                 * @implements IMessageOptions
                 * @constructor
                 * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
                 */
                function MessageOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * MessageOptions messageSetWireFormat.
                 * @member {boolean} messageSetWireFormat
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype.messageSetWireFormat = false;
    
                /**
                 * MessageOptions noStandardDescriptorAccessor.
                 * @member {boolean} noStandardDescriptorAccessor
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype.noStandardDescriptorAccessor = false;
    
                /**
                 * MessageOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype.deprecated = false;
    
                /**
                 * MessageOptions mapEntry.
                 * @member {boolean} mapEntry
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype.mapEntry = false;
    
                /**
                 * MessageOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * MessageOptions .google.api.resource.
                 * @member {google.api.IResourceDescriptor|null|undefined} .google.api.resource
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype[".google.api.resource"] = null;
    
                /**
                 * Creates a new MessageOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
                 * @returns {google.protobuf.MessageOptions} MessageOptions instance
                 */
                MessageOptions.create = function create(properties) {
                    return new MessageOptions(properties);
                };
    
                /**
                 * Encodes the specified MessageOptions message. Does not implicitly {@link google.protobuf.MessageOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {google.protobuf.IMessageOptions} message MessageOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MessageOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.messageSetWireFormat != null && Object.hasOwnProperty.call(message, "messageSetWireFormat"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.messageSetWireFormat);
                    if (message.noStandardDescriptorAccessor != null && Object.hasOwnProperty.call(message, "noStandardDescriptorAccessor"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.noStandardDescriptorAccessor);
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.deprecated);
                    if (message.mapEntry != null && Object.hasOwnProperty.call(message, "mapEntry"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.mapEntry);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    if (message[".google.api.resource"] != null && Object.hasOwnProperty.call(message, ".google.api.resource"))
                        $root.google.api.ResourceDescriptor.encode(message[".google.api.resource"], writer.uint32(/* id 1053, wireType 2 =*/8426).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified MessageOptions message, length delimited. Does not implicitly {@link google.protobuf.MessageOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {google.protobuf.IMessageOptions} message MessageOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MessageOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a MessageOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.MessageOptions} MessageOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MessageOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MessageOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.messageSetWireFormat = reader.bool();
                            break;
                        case 2:
                            message.noStandardDescriptorAccessor = reader.bool();
                            break;
                        case 3:
                            message.deprecated = reader.bool();
                            break;
                        case 7:
                            message.mapEntry = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        case 1053:
                            message[".google.api.resource"] = $root.google.api.ResourceDescriptor.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a MessageOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.MessageOptions} MessageOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MessageOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a MessageOptions message.
                 * @function verify
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MessageOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.messageSetWireFormat != null && message.hasOwnProperty("messageSetWireFormat"))
                        if (typeof message.messageSetWireFormat !== "boolean")
                            return "messageSetWireFormat: boolean expected";
                    if (message.noStandardDescriptorAccessor != null && message.hasOwnProperty("noStandardDescriptorAccessor"))
                        if (typeof message.noStandardDescriptorAccessor !== "boolean")
                            return "noStandardDescriptorAccessor: boolean expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.mapEntry != null && message.hasOwnProperty("mapEntry"))
                        if (typeof message.mapEntry !== "boolean")
                            return "mapEntry: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    if (message[".google.api.resource"] != null && message.hasOwnProperty(".google.api.resource")) {
                        var error = $root.google.api.ResourceDescriptor.verify(message[".google.api.resource"]);
                        if (error)
                            return ".google.api.resource." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates a MessageOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.MessageOptions} MessageOptions
                 */
                MessageOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.MessageOptions)
                        return object;
                    var message = new $root.google.protobuf.MessageOptions();
                    if (object.messageSetWireFormat != null)
                        message.messageSetWireFormat = Boolean(object.messageSetWireFormat);
                    if (object.noStandardDescriptorAccessor != null)
                        message.noStandardDescriptorAccessor = Boolean(object.noStandardDescriptorAccessor);
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.mapEntry != null)
                        message.mapEntry = Boolean(object.mapEntry);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.MessageOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.MessageOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    if (object[".google.api.resource"] != null) {
                        if (typeof object[".google.api.resource"] !== "object")
                            throw TypeError(".google.protobuf.MessageOptions..google.api.resource: object expected");
                        message[".google.api.resource"] = $root.google.api.ResourceDescriptor.fromObject(object[".google.api.resource"]);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a MessageOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {google.protobuf.MessageOptions} message MessageOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MessageOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults) {
                        object.messageSetWireFormat = false;
                        object.noStandardDescriptorAccessor = false;
                        object.deprecated = false;
                        object.mapEntry = false;
                        object[".google.api.resource"] = null;
                    }
                    if (message.messageSetWireFormat != null && message.hasOwnProperty("messageSetWireFormat"))
                        object.messageSetWireFormat = message.messageSetWireFormat;
                    if (message.noStandardDescriptorAccessor != null && message.hasOwnProperty("noStandardDescriptorAccessor"))
                        object.noStandardDescriptorAccessor = message.noStandardDescriptorAccessor;
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.mapEntry != null && message.hasOwnProperty("mapEntry"))
                        object.mapEntry = message.mapEntry;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    if (message[".google.api.resource"] != null && message.hasOwnProperty(".google.api.resource"))
                        object[".google.api.resource"] = $root.google.api.ResourceDescriptor.toObject(message[".google.api.resource"], options);
                    return object;
                };
    
                /**
                 * Converts this MessageOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MessageOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return MessageOptions;
            })();
    
            protobuf.FieldOptions = (function() {
    
                /**
                 * Properties of a FieldOptions.
                 * @memberof google.protobuf
                 * @interface IFieldOptions
                 * @property {google.protobuf.FieldOptions.CType|null} [ctype] FieldOptions ctype
                 * @property {boolean|null} [packed] FieldOptions packed
                 * @property {google.protobuf.FieldOptions.JSType|null} [jstype] FieldOptions jstype
                 * @property {boolean|null} [lazy] FieldOptions lazy
                 * @property {boolean|null} [deprecated] FieldOptions deprecated
                 * @property {boolean|null} [weak] FieldOptions weak
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FieldOptions uninterpretedOption
                 * @property {Array.<google.api.FieldBehavior>|null} [".google.api.fieldBehavior"] FieldOptions .google.api.fieldBehavior
                 * @property {google.api.IResourceReference|null} [".google.api.resourceReference"] FieldOptions .google.api.resourceReference
                 */
    
                /**
                 * Constructs a new FieldOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents a FieldOptions.
                 * @implements IFieldOptions
                 * @constructor
                 * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
                 */
                function FieldOptions(properties) {
                    this.uninterpretedOption = [];
                    this[".google.api.fieldBehavior"] = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FieldOptions ctype.
                 * @member {google.protobuf.FieldOptions.CType} ctype
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.ctype = 0;
    
                /**
                 * FieldOptions packed.
                 * @member {boolean} packed
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.packed = false;
    
                /**
                 * FieldOptions jstype.
                 * @member {google.protobuf.FieldOptions.JSType} jstype
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.jstype = 0;
    
                /**
                 * FieldOptions lazy.
                 * @member {boolean} lazy
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.lazy = false;
    
                /**
                 * FieldOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.deprecated = false;
    
                /**
                 * FieldOptions weak.
                 * @member {boolean} weak
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.weak = false;
    
                /**
                 * FieldOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * FieldOptions .google.api.fieldBehavior.
                 * @member {Array.<google.api.FieldBehavior>} .google.api.fieldBehavior
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype[".google.api.fieldBehavior"] = $util.emptyArray;
    
                /**
                 * FieldOptions .google.api.resourceReference.
                 * @member {google.api.IResourceReference|null|undefined} .google.api.resourceReference
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype[".google.api.resourceReference"] = null;
    
                /**
                 * Creates a new FieldOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
                 * @returns {google.protobuf.FieldOptions} FieldOptions instance
                 */
                FieldOptions.create = function create(properties) {
                    return new FieldOptions(properties);
                };
    
                /**
                 * Encodes the specified FieldOptions message. Does not implicitly {@link google.protobuf.FieldOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {google.protobuf.IFieldOptions} message FieldOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ctype != null && Object.hasOwnProperty.call(message, "ctype"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ctype);
                    if (message.packed != null && Object.hasOwnProperty.call(message, "packed"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.packed);
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.deprecated);
                    if (message.lazy != null && Object.hasOwnProperty.call(message, "lazy"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.lazy);
                    if (message.jstype != null && Object.hasOwnProperty.call(message, "jstype"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.jstype);
                    if (message.weak != null && Object.hasOwnProperty.call(message, "weak"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.weak);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    if (message[".google.api.fieldBehavior"] != null && message[".google.api.fieldBehavior"].length) {
                        writer.uint32(/* id 1052, wireType 2 =*/8418).fork();
                        for (var i = 0; i < message[".google.api.fieldBehavior"].length; ++i)
                            writer.int32(message[".google.api.fieldBehavior"][i]);
                        writer.ldelim();
                    }
                    if (message[".google.api.resourceReference"] != null && Object.hasOwnProperty.call(message, ".google.api.resourceReference"))
                        $root.google.api.ResourceReference.encode(message[".google.api.resourceReference"], writer.uint32(/* id 1055, wireType 2 =*/8442).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified FieldOptions message, length delimited. Does not implicitly {@link google.protobuf.FieldOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {google.protobuf.IFieldOptions} message FieldOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FieldOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FieldOptions} FieldOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ctype = reader.int32();
                            break;
                        case 2:
                            message.packed = reader.bool();
                            break;
                        case 6:
                            message.jstype = reader.int32();
                            break;
                        case 5:
                            message.lazy = reader.bool();
                            break;
                        case 3:
                            message.deprecated = reader.bool();
                            break;
                        case 10:
                            message.weak = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        case 1052:
                            if (!(message[".google.api.fieldBehavior"] && message[".google.api.fieldBehavior"].length))
                                message[".google.api.fieldBehavior"] = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message[".google.api.fieldBehavior"].push(reader.int32());
                            } else
                                message[".google.api.fieldBehavior"].push(reader.int32());
                            break;
                        case 1055:
                            message[".google.api.resourceReference"] = $root.google.api.ResourceReference.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FieldOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FieldOptions} FieldOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FieldOptions message.
                 * @function verify
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ctype != null && message.hasOwnProperty("ctype"))
                        switch (message.ctype) {
                        default:
                            return "ctype: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.packed != null && message.hasOwnProperty("packed"))
                        if (typeof message.packed !== "boolean")
                            return "packed: boolean expected";
                    if (message.jstype != null && message.hasOwnProperty("jstype"))
                        switch (message.jstype) {
                        default:
                            return "jstype: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.lazy != null && message.hasOwnProperty("lazy"))
                        if (typeof message.lazy !== "boolean")
                            return "lazy: boolean expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.weak != null && message.hasOwnProperty("weak"))
                        if (typeof message.weak !== "boolean")
                            return "weak: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    if (message[".google.api.fieldBehavior"] != null && message.hasOwnProperty(".google.api.fieldBehavior")) {
                        if (!Array.isArray(message[".google.api.fieldBehavior"]))
                            return ".google.api.fieldBehavior: array expected";
                        for (var i = 0; i < message[".google.api.fieldBehavior"].length; ++i)
                            switch (message[".google.api.fieldBehavior"][i]) {
                            default:
                                return ".google.api.fieldBehavior: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                    }
                    if (message[".google.api.resourceReference"] != null && message.hasOwnProperty(".google.api.resourceReference")) {
                        var error = $root.google.api.ResourceReference.verify(message[".google.api.resourceReference"]);
                        if (error)
                            return ".google.api.resourceReference." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates a FieldOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FieldOptions} FieldOptions
                 */
                FieldOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FieldOptions)
                        return object;
                    var message = new $root.google.protobuf.FieldOptions();
                    switch (object.ctype) {
                    case "STRING":
                    case 0:
                        message.ctype = 0;
                        break;
                    case "CORD":
                    case 1:
                        message.ctype = 1;
                        break;
                    case "STRING_PIECE":
                    case 2:
                        message.ctype = 2;
                        break;
                    }
                    if (object.packed != null)
                        message.packed = Boolean(object.packed);
                    switch (object.jstype) {
                    case "JS_NORMAL":
                    case 0:
                        message.jstype = 0;
                        break;
                    case "JS_STRING":
                    case 1:
                        message.jstype = 1;
                        break;
                    case "JS_NUMBER":
                    case 2:
                        message.jstype = 2;
                        break;
                    }
                    if (object.lazy != null)
                        message.lazy = Boolean(object.lazy);
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.weak != null)
                        message.weak = Boolean(object.weak);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.FieldOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.FieldOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    if (object[".google.api.fieldBehavior"]) {
                        if (!Array.isArray(object[".google.api.fieldBehavior"]))
                            throw TypeError(".google.protobuf.FieldOptions..google.api.fieldBehavior: array expected");
                        message[".google.api.fieldBehavior"] = [];
                        for (var i = 0; i < object[".google.api.fieldBehavior"].length; ++i)
                            switch (object[".google.api.fieldBehavior"][i]) {
                            default:
                            case "FIELD_BEHAVIOR_UNSPECIFIED":
                            case 0:
                                message[".google.api.fieldBehavior"][i] = 0;
                                break;
                            case "OPTIONAL":
                            case 1:
                                message[".google.api.fieldBehavior"][i] = 1;
                                break;
                            case "REQUIRED":
                            case 2:
                                message[".google.api.fieldBehavior"][i] = 2;
                                break;
                            case "OUTPUT_ONLY":
                            case 3:
                                message[".google.api.fieldBehavior"][i] = 3;
                                break;
                            case "INPUT_ONLY":
                            case 4:
                                message[".google.api.fieldBehavior"][i] = 4;
                                break;
                            case "IMMUTABLE":
                            case 5:
                                message[".google.api.fieldBehavior"][i] = 5;
                                break;
                            case "UNORDERED_LIST":
                            case 6:
                                message[".google.api.fieldBehavior"][i] = 6;
                                break;
                            case "NON_EMPTY_DEFAULT":
                            case 7:
                                message[".google.api.fieldBehavior"][i] = 7;
                                break;
                            }
                    }
                    if (object[".google.api.resourceReference"] != null) {
                        if (typeof object[".google.api.resourceReference"] !== "object")
                            throw TypeError(".google.protobuf.FieldOptions..google.api.resourceReference: object expected");
                        message[".google.api.resourceReference"] = $root.google.api.ResourceReference.fromObject(object[".google.api.resourceReference"]);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a FieldOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {google.protobuf.FieldOptions} message FieldOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.uninterpretedOption = [];
                        object[".google.api.fieldBehavior"] = [];
                    }
                    if (options.defaults) {
                        object.ctype = options.enums === String ? "STRING" : 0;
                        object.packed = false;
                        object.deprecated = false;
                        object.lazy = false;
                        object.jstype = options.enums === String ? "JS_NORMAL" : 0;
                        object.weak = false;
                        object[".google.api.resourceReference"] = null;
                    }
                    if (message.ctype != null && message.hasOwnProperty("ctype"))
                        object.ctype = options.enums === String ? $root.google.protobuf.FieldOptions.CType[message.ctype] : message.ctype;
                    if (message.packed != null && message.hasOwnProperty("packed"))
                        object.packed = message.packed;
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.lazy != null && message.hasOwnProperty("lazy"))
                        object.lazy = message.lazy;
                    if (message.jstype != null && message.hasOwnProperty("jstype"))
                        object.jstype = options.enums === String ? $root.google.protobuf.FieldOptions.JSType[message.jstype] : message.jstype;
                    if (message.weak != null && message.hasOwnProperty("weak"))
                        object.weak = message.weak;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    if (message[".google.api.fieldBehavior"] && message[".google.api.fieldBehavior"].length) {
                        object[".google.api.fieldBehavior"] = [];
                        for (var j = 0; j < message[".google.api.fieldBehavior"].length; ++j)
                            object[".google.api.fieldBehavior"][j] = options.enums === String ? $root.google.api.FieldBehavior[message[".google.api.fieldBehavior"][j]] : message[".google.api.fieldBehavior"][j];
                    }
                    if (message[".google.api.resourceReference"] != null && message.hasOwnProperty(".google.api.resourceReference"))
                        object[".google.api.resourceReference"] = $root.google.api.ResourceReference.toObject(message[".google.api.resourceReference"], options);
                    return object;
                };
    
                /**
                 * Converts this FieldOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * CType enum.
                 * @name google.protobuf.FieldOptions.CType
                 * @enum {number}
                 * @property {number} STRING=0 STRING value
                 * @property {number} CORD=1 CORD value
                 * @property {number} STRING_PIECE=2 STRING_PIECE value
                 */
                FieldOptions.CType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STRING"] = 0;
                    values[valuesById[1] = "CORD"] = 1;
                    values[valuesById[2] = "STRING_PIECE"] = 2;
                    return values;
                })();
    
                /**
                 * JSType enum.
                 * @name google.protobuf.FieldOptions.JSType
                 * @enum {number}
                 * @property {number} JS_NORMAL=0 JS_NORMAL value
                 * @property {number} JS_STRING=1 JS_STRING value
                 * @property {number} JS_NUMBER=2 JS_NUMBER value
                 */
                FieldOptions.JSType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "JS_NORMAL"] = 0;
                    values[valuesById[1] = "JS_STRING"] = 1;
                    values[valuesById[2] = "JS_NUMBER"] = 2;
                    return values;
                })();
    
                return FieldOptions;
            })();
    
            protobuf.OneofOptions = (function() {
    
                /**
                 * Properties of an OneofOptions.
                 * @memberof google.protobuf
                 * @interface IOneofOptions
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] OneofOptions uninterpretedOption
                 */
    
                /**
                 * Constructs a new OneofOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents an OneofOptions.
                 * @implements IOneofOptions
                 * @constructor
                 * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
                 */
                function OneofOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * OneofOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.OneofOptions
                 * @instance
                 */
                OneofOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * Creates a new OneofOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
                 * @returns {google.protobuf.OneofOptions} OneofOptions instance
                 */
                OneofOptions.create = function create(properties) {
                    return new OneofOptions(properties);
                };
    
                /**
                 * Encodes the specified OneofOptions message. Does not implicitly {@link google.protobuf.OneofOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {google.protobuf.IOneofOptions} message OneofOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OneofOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified OneofOptions message, length delimited. Does not implicitly {@link google.protobuf.OneofOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {google.protobuf.IOneofOptions} message OneofOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OneofOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an OneofOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.OneofOptions} OneofOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OneofOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an OneofOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.OneofOptions} OneofOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OneofOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an OneofOptions message.
                 * @function verify
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OneofOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates an OneofOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.OneofOptions} OneofOptions
                 */
                OneofOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.OneofOptions)
                        return object;
                    var message = new $root.google.protobuf.OneofOptions();
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.OneofOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.OneofOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an OneofOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {google.protobuf.OneofOptions} message OneofOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OneofOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this OneofOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.OneofOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OneofOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return OneofOptions;
            })();
    
            protobuf.EnumOptions = (function() {
    
                /**
                 * Properties of an EnumOptions.
                 * @memberof google.protobuf
                 * @interface IEnumOptions
                 * @property {boolean|null} [allowAlias] EnumOptions allowAlias
                 * @property {boolean|null} [deprecated] EnumOptions deprecated
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumOptions uninterpretedOption
                 */
    
                /**
                 * Constructs a new EnumOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents an EnumOptions.
                 * @implements IEnumOptions
                 * @constructor
                 * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
                 */
                function EnumOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * EnumOptions allowAlias.
                 * @member {boolean} allowAlias
                 * @memberof google.protobuf.EnumOptions
                 * @instance
                 */
                EnumOptions.prototype.allowAlias = false;
    
                /**
                 * EnumOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.EnumOptions
                 * @instance
                 */
                EnumOptions.prototype.deprecated = false;
    
                /**
                 * EnumOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.EnumOptions
                 * @instance
                 */
                EnumOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * Creates a new EnumOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
                 * @returns {google.protobuf.EnumOptions} EnumOptions instance
                 */
                EnumOptions.create = function create(properties) {
                    return new EnumOptions(properties);
                };
    
                /**
                 * Encodes the specified EnumOptions message. Does not implicitly {@link google.protobuf.EnumOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {google.protobuf.IEnumOptions} message EnumOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.allowAlias != null && Object.hasOwnProperty.call(message, "allowAlias"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.allowAlias);
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.deprecated);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified EnumOptions message, length delimited. Does not implicitly {@link google.protobuf.EnumOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {google.protobuf.IEnumOptions} message EnumOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an EnumOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.EnumOptions} EnumOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2:
                            message.allowAlias = reader.bool();
                            break;
                        case 3:
                            message.deprecated = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an EnumOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.EnumOptions} EnumOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an EnumOptions message.
                 * @function verify
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EnumOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.allowAlias != null && message.hasOwnProperty("allowAlias"))
                        if (typeof message.allowAlias !== "boolean")
                            return "allowAlias: boolean expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates an EnumOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.EnumOptions} EnumOptions
                 */
                EnumOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.EnumOptions)
                        return object;
                    var message = new $root.google.protobuf.EnumOptions();
                    if (object.allowAlias != null)
                        message.allowAlias = Boolean(object.allowAlias);
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.EnumOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.EnumOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an EnumOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {google.protobuf.EnumOptions} message EnumOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EnumOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults) {
                        object.allowAlias = false;
                        object.deprecated = false;
                    }
                    if (message.allowAlias != null && message.hasOwnProperty("allowAlias"))
                        object.allowAlias = message.allowAlias;
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this EnumOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.EnumOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EnumOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return EnumOptions;
            })();
    
            protobuf.EnumValueOptions = (function() {
    
                /**
                 * Properties of an EnumValueOptions.
                 * @memberof google.protobuf
                 * @interface IEnumValueOptions
                 * @property {boolean|null} [deprecated] EnumValueOptions deprecated
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumValueOptions uninterpretedOption
                 */
    
                /**
                 * Constructs a new EnumValueOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents an EnumValueOptions.
                 * @implements IEnumValueOptions
                 * @constructor
                 * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
                 */
                function EnumValueOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * EnumValueOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.EnumValueOptions
                 * @instance
                 */
                EnumValueOptions.prototype.deprecated = false;
    
                /**
                 * EnumValueOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.EnumValueOptions
                 * @instance
                 */
                EnumValueOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * Creates a new EnumValueOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
                 * @returns {google.protobuf.EnumValueOptions} EnumValueOptions instance
                 */
                EnumValueOptions.create = function create(properties) {
                    return new EnumValueOptions(properties);
                };
    
                /**
                 * Encodes the specified EnumValueOptions message. Does not implicitly {@link google.protobuf.EnumValueOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {google.protobuf.IEnumValueOptions} message EnumValueOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumValueOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.deprecated);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified EnumValueOptions message, length delimited. Does not implicitly {@link google.protobuf.EnumValueOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {google.protobuf.IEnumValueOptions} message EnumValueOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumValueOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an EnumValueOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumValueOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.deprecated = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an EnumValueOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumValueOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an EnumValueOptions message.
                 * @function verify
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EnumValueOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates an EnumValueOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
                 */
                EnumValueOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.EnumValueOptions)
                        return object;
                    var message = new $root.google.protobuf.EnumValueOptions();
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.EnumValueOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.EnumValueOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an EnumValueOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {google.protobuf.EnumValueOptions} message EnumValueOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EnumValueOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults)
                        object.deprecated = false;
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this EnumValueOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.EnumValueOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EnumValueOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return EnumValueOptions;
            })();
    
            protobuf.ServiceOptions = (function() {
    
                /**
                 * Properties of a ServiceOptions.
                 * @memberof google.protobuf
                 * @interface IServiceOptions
                 * @property {boolean|null} [deprecated] ServiceOptions deprecated
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] ServiceOptions uninterpretedOption
                 * @property {string|null} [".google.api.defaultHost"] ServiceOptions .google.api.defaultHost
                 * @property {string|null} [".google.api.oauthScopes"] ServiceOptions .google.api.oauthScopes
                 */
    
                /**
                 * Constructs a new ServiceOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents a ServiceOptions.
                 * @implements IServiceOptions
                 * @constructor
                 * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
                 */
                function ServiceOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ServiceOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.ServiceOptions
                 * @instance
                 */
                ServiceOptions.prototype.deprecated = false;
    
                /**
                 * ServiceOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.ServiceOptions
                 * @instance
                 */
                ServiceOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * ServiceOptions .google.api.defaultHost.
                 * @member {string} .google.api.defaultHost
                 * @memberof google.protobuf.ServiceOptions
                 * @instance
                 */
                ServiceOptions.prototype[".google.api.defaultHost"] = "";
    
                /**
                 * ServiceOptions .google.api.oauthScopes.
                 * @member {string} .google.api.oauthScopes
                 * @memberof google.protobuf.ServiceOptions
                 * @instance
                 */
                ServiceOptions.prototype[".google.api.oauthScopes"] = "";
    
                /**
                 * Creates a new ServiceOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
                 * @returns {google.protobuf.ServiceOptions} ServiceOptions instance
                 */
                ServiceOptions.create = function create(properties) {
                    return new ServiceOptions(properties);
                };
    
                /**
                 * Encodes the specified ServiceOptions message. Does not implicitly {@link google.protobuf.ServiceOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {google.protobuf.IServiceOptions} message ServiceOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 33, wireType 0 =*/264).bool(message.deprecated);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    if (message[".google.api.defaultHost"] != null && Object.hasOwnProperty.call(message, ".google.api.defaultHost"))
                        writer.uint32(/* id 1049, wireType 2 =*/8394).string(message[".google.api.defaultHost"]);
                    if (message[".google.api.oauthScopes"] != null && Object.hasOwnProperty.call(message, ".google.api.oauthScopes"))
                        writer.uint32(/* id 1050, wireType 2 =*/8402).string(message[".google.api.oauthScopes"]);
                    return writer;
                };
    
                /**
                 * Encodes the specified ServiceOptions message, length delimited. Does not implicitly {@link google.protobuf.ServiceOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {google.protobuf.IServiceOptions} message ServiceOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ServiceOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.ServiceOptions} ServiceOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 33:
                            message.deprecated = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        case 1049:
                            message[".google.api.defaultHost"] = reader.string();
                            break;
                        case 1050:
                            message[".google.api.oauthScopes"] = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ServiceOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.ServiceOptions} ServiceOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ServiceOptions message.
                 * @function verify
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ServiceOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    if (message[".google.api.defaultHost"] != null && message.hasOwnProperty(".google.api.defaultHost"))
                        if (!$util.isString(message[".google.api.defaultHost"]))
                            return ".google.api.defaultHost: string expected";
                    if (message[".google.api.oauthScopes"] != null && message.hasOwnProperty(".google.api.oauthScopes"))
                        if (!$util.isString(message[".google.api.oauthScopes"]))
                            return ".google.api.oauthScopes: string expected";
                    return null;
                };
    
                /**
                 * Creates a ServiceOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.ServiceOptions} ServiceOptions
                 */
                ServiceOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.ServiceOptions)
                        return object;
                    var message = new $root.google.protobuf.ServiceOptions();
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.ServiceOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.ServiceOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    if (object[".google.api.defaultHost"] != null)
                        message[".google.api.defaultHost"] = String(object[".google.api.defaultHost"]);
                    if (object[".google.api.oauthScopes"] != null)
                        message[".google.api.oauthScopes"] = String(object[".google.api.oauthScopes"]);
                    return message;
                };
    
                /**
                 * Creates a plain object from a ServiceOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {google.protobuf.ServiceOptions} message ServiceOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ServiceOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults) {
                        object.deprecated = false;
                        object[".google.api.defaultHost"] = "";
                        object[".google.api.oauthScopes"] = "";
                    }
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    if (message[".google.api.defaultHost"] != null && message.hasOwnProperty(".google.api.defaultHost"))
                        object[".google.api.defaultHost"] = message[".google.api.defaultHost"];
                    if (message[".google.api.oauthScopes"] != null && message.hasOwnProperty(".google.api.oauthScopes"))
                        object[".google.api.oauthScopes"] = message[".google.api.oauthScopes"];
                    return object;
                };
    
                /**
                 * Converts this ServiceOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.ServiceOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ServiceOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ServiceOptions;
            })();
    
            protobuf.MethodOptions = (function() {
    
                /**
                 * Properties of a MethodOptions.
                 * @memberof google.protobuf
                 * @interface IMethodOptions
                 * @property {boolean|null} [deprecated] MethodOptions deprecated
                 * @property {google.protobuf.MethodOptions.IdempotencyLevel|null} [idempotencyLevel] MethodOptions idempotencyLevel
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MethodOptions uninterpretedOption
                 * @property {google.api.IHttpRule|null} [".google.api.http"] MethodOptions .google.api.http
                 * @property {Array.<string>|null} [".google.api.methodSignature"] MethodOptions .google.api.methodSignature
                 * @property {google.longrunning.IOperationInfo|null} [".google.longrunning.operationInfo"] MethodOptions .google.longrunning.operationInfo
                 */
    
                /**
                 * Constructs a new MethodOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents a MethodOptions.
                 * @implements IMethodOptions
                 * @constructor
                 * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
                 */
                function MethodOptions(properties) {
                    this.uninterpretedOption = [];
                    this[".google.api.methodSignature"] = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * MethodOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 */
                MethodOptions.prototype.deprecated = false;
    
                /**
                 * MethodOptions idempotencyLevel.
                 * @member {google.protobuf.MethodOptions.IdempotencyLevel} idempotencyLevel
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 */
                MethodOptions.prototype.idempotencyLevel = 0;
    
                /**
                 * MethodOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 */
                MethodOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * MethodOptions .google.api.http.
                 * @member {google.api.IHttpRule|null|undefined} .google.api.http
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 */
                MethodOptions.prototype[".google.api.http"] = null;
    
                /**
                 * MethodOptions .google.api.methodSignature.
                 * @member {Array.<string>} .google.api.methodSignature
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 */
                MethodOptions.prototype[".google.api.methodSignature"] = $util.emptyArray;
    
                /**
                 * MethodOptions .google.longrunning.operationInfo.
                 * @member {google.longrunning.IOperationInfo|null|undefined} .google.longrunning.operationInfo
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 */
                MethodOptions.prototype[".google.longrunning.operationInfo"] = null;
    
                /**
                 * Creates a new MethodOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
                 * @returns {google.protobuf.MethodOptions} MethodOptions instance
                 */
                MethodOptions.create = function create(properties) {
                    return new MethodOptions(properties);
                };
    
                /**
                 * Encodes the specified MethodOptions message. Does not implicitly {@link google.protobuf.MethodOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {google.protobuf.IMethodOptions} message MethodOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MethodOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 33, wireType 0 =*/264).bool(message.deprecated);
                    if (message.idempotencyLevel != null && Object.hasOwnProperty.call(message, "idempotencyLevel"))
                        writer.uint32(/* id 34, wireType 0 =*/272).int32(message.idempotencyLevel);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    if (message[".google.longrunning.operationInfo"] != null && Object.hasOwnProperty.call(message, ".google.longrunning.operationInfo"))
                        $root.google.longrunning.OperationInfo.encode(message[".google.longrunning.operationInfo"], writer.uint32(/* id 1049, wireType 2 =*/8394).fork()).ldelim();
                    if (message[".google.api.methodSignature"] != null && message[".google.api.methodSignature"].length)
                        for (var i = 0; i < message[".google.api.methodSignature"].length; ++i)
                            writer.uint32(/* id 1051, wireType 2 =*/8410).string(message[".google.api.methodSignature"][i]);
                    if (message[".google.api.http"] != null && Object.hasOwnProperty.call(message, ".google.api.http"))
                        $root.google.api.HttpRule.encode(message[".google.api.http"], writer.uint32(/* id 72295728, wireType 2 =*/578365826).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified MethodOptions message, length delimited. Does not implicitly {@link google.protobuf.MethodOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {google.protobuf.IMethodOptions} message MethodOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MethodOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a MethodOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.MethodOptions} MethodOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MethodOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 33:
                            message.deprecated = reader.bool();
                            break;
                        case 34:
                            message.idempotencyLevel = reader.int32();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        case 72295728:
                            message[".google.api.http"] = $root.google.api.HttpRule.decode(reader, reader.uint32());
                            break;
                        case 1051:
                            if (!(message[".google.api.methodSignature"] && message[".google.api.methodSignature"].length))
                                message[".google.api.methodSignature"] = [];
                            message[".google.api.methodSignature"].push(reader.string());
                            break;
                        case 1049:
                            message[".google.longrunning.operationInfo"] = $root.google.longrunning.OperationInfo.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a MethodOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.MethodOptions} MethodOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MethodOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a MethodOptions message.
                 * @function verify
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MethodOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.idempotencyLevel != null && message.hasOwnProperty("idempotencyLevel"))
                        switch (message.idempotencyLevel) {
                        default:
                            return "idempotencyLevel: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    if (message[".google.api.http"] != null && message.hasOwnProperty(".google.api.http")) {
                        var error = $root.google.api.HttpRule.verify(message[".google.api.http"]);
                        if (error)
                            return ".google.api.http." + error;
                    }
                    if (message[".google.api.methodSignature"] != null && message.hasOwnProperty(".google.api.methodSignature")) {
                        if (!Array.isArray(message[".google.api.methodSignature"]))
                            return ".google.api.methodSignature: array expected";
                        for (var i = 0; i < message[".google.api.methodSignature"].length; ++i)
                            if (!$util.isString(message[".google.api.methodSignature"][i]))
                                return ".google.api.methodSignature: string[] expected";
                    }
                    if (message[".google.longrunning.operationInfo"] != null && message.hasOwnProperty(".google.longrunning.operationInfo")) {
                        var error = $root.google.longrunning.OperationInfo.verify(message[".google.longrunning.operationInfo"]);
                        if (error)
                            return ".google.longrunning.operationInfo." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates a MethodOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.MethodOptions} MethodOptions
                 */
                MethodOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.MethodOptions)
                        return object;
                    var message = new $root.google.protobuf.MethodOptions();
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    switch (object.idempotencyLevel) {
                    case "IDEMPOTENCY_UNKNOWN":
                    case 0:
                        message.idempotencyLevel = 0;
                        break;
                    case "NO_SIDE_EFFECTS":
                    case 1:
                        message.idempotencyLevel = 1;
                        break;
                    case "IDEMPOTENT":
                    case 2:
                        message.idempotencyLevel = 2;
                        break;
                    }
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.MethodOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.MethodOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    if (object[".google.api.http"] != null) {
                        if (typeof object[".google.api.http"] !== "object")
                            throw TypeError(".google.protobuf.MethodOptions..google.api.http: object expected");
                        message[".google.api.http"] = $root.google.api.HttpRule.fromObject(object[".google.api.http"]);
                    }
                    if (object[".google.api.methodSignature"]) {
                        if (!Array.isArray(object[".google.api.methodSignature"]))
                            throw TypeError(".google.protobuf.MethodOptions..google.api.methodSignature: array expected");
                        message[".google.api.methodSignature"] = [];
                        for (var i = 0; i < object[".google.api.methodSignature"].length; ++i)
                            message[".google.api.methodSignature"][i] = String(object[".google.api.methodSignature"][i]);
                    }
                    if (object[".google.longrunning.operationInfo"] != null) {
                        if (typeof object[".google.longrunning.operationInfo"] !== "object")
                            throw TypeError(".google.protobuf.MethodOptions..google.longrunning.operationInfo: object expected");
                        message[".google.longrunning.operationInfo"] = $root.google.longrunning.OperationInfo.fromObject(object[".google.longrunning.operationInfo"]);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a MethodOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {google.protobuf.MethodOptions} message MethodOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MethodOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.uninterpretedOption = [];
                        object[".google.api.methodSignature"] = [];
                    }
                    if (options.defaults) {
                        object.deprecated = false;
                        object.idempotencyLevel = options.enums === String ? "IDEMPOTENCY_UNKNOWN" : 0;
                        object[".google.longrunning.operationInfo"] = null;
                        object[".google.api.http"] = null;
                    }
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.idempotencyLevel != null && message.hasOwnProperty("idempotencyLevel"))
                        object.idempotencyLevel = options.enums === String ? $root.google.protobuf.MethodOptions.IdempotencyLevel[message.idempotencyLevel] : message.idempotencyLevel;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    if (message[".google.longrunning.operationInfo"] != null && message.hasOwnProperty(".google.longrunning.operationInfo"))
                        object[".google.longrunning.operationInfo"] = $root.google.longrunning.OperationInfo.toObject(message[".google.longrunning.operationInfo"], options);
                    if (message[".google.api.methodSignature"] && message[".google.api.methodSignature"].length) {
                        object[".google.api.methodSignature"] = [];
                        for (var j = 0; j < message[".google.api.methodSignature"].length; ++j)
                            object[".google.api.methodSignature"][j] = message[".google.api.methodSignature"][j];
                    }
                    if (message[".google.api.http"] != null && message.hasOwnProperty(".google.api.http"))
                        object[".google.api.http"] = $root.google.api.HttpRule.toObject(message[".google.api.http"], options);
                    return object;
                };
    
                /**
                 * Converts this MethodOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MethodOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * IdempotencyLevel enum.
                 * @name google.protobuf.MethodOptions.IdempotencyLevel
                 * @enum {number}
                 * @property {number} IDEMPOTENCY_UNKNOWN=0 IDEMPOTENCY_UNKNOWN value
                 * @property {number} NO_SIDE_EFFECTS=1 NO_SIDE_EFFECTS value
                 * @property {number} IDEMPOTENT=2 IDEMPOTENT value
                 */
                MethodOptions.IdempotencyLevel = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "IDEMPOTENCY_UNKNOWN"] = 0;
                    values[valuesById[1] = "NO_SIDE_EFFECTS"] = 1;
                    values[valuesById[2] = "IDEMPOTENT"] = 2;
                    return values;
                })();
    
                return MethodOptions;
            })();
    
            protobuf.UninterpretedOption = (function() {
    
                /**
                 * Properties of an UninterpretedOption.
                 * @memberof google.protobuf
                 * @interface IUninterpretedOption
                 * @property {Array.<google.protobuf.UninterpretedOption.INamePart>|null} [name] UninterpretedOption name
                 * @property {string|null} [identifierValue] UninterpretedOption identifierValue
                 * @property {number|Long|null} [positiveIntValue] UninterpretedOption positiveIntValue
                 * @property {number|Long|null} [negativeIntValue] UninterpretedOption negativeIntValue
                 * @property {number|null} [doubleValue] UninterpretedOption doubleValue
                 * @property {Uint8Array|null} [stringValue] UninterpretedOption stringValue
                 * @property {string|null} [aggregateValue] UninterpretedOption aggregateValue
                 */
    
                /**
                 * Constructs a new UninterpretedOption.
                 * @memberof google.protobuf
                 * @classdesc Represents an UninterpretedOption.
                 * @implements IUninterpretedOption
                 * @constructor
                 * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
                 */
                function UninterpretedOption(properties) {
                    this.name = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * UninterpretedOption name.
                 * @member {Array.<google.protobuf.UninterpretedOption.INamePart>} name
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.name = $util.emptyArray;
    
                /**
                 * UninterpretedOption identifierValue.
                 * @member {string} identifierValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.identifierValue = "";
    
                /**
                 * UninterpretedOption positiveIntValue.
                 * @member {number|Long} positiveIntValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.positiveIntValue = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    
                /**
                 * UninterpretedOption negativeIntValue.
                 * @member {number|Long} negativeIntValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.negativeIntValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * UninterpretedOption doubleValue.
                 * @member {number} doubleValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.doubleValue = 0;
    
                /**
                 * UninterpretedOption stringValue.
                 * @member {Uint8Array} stringValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.stringValue = $util.newBuffer([]);
    
                /**
                 * UninterpretedOption aggregateValue.
                 * @member {string} aggregateValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.aggregateValue = "";
    
                /**
                 * Creates a new UninterpretedOption instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
                 * @returns {google.protobuf.UninterpretedOption} UninterpretedOption instance
                 */
                UninterpretedOption.create = function create(properties) {
                    return new UninterpretedOption(properties);
                };
    
                /**
                 * Encodes the specified UninterpretedOption message. Does not implicitly {@link google.protobuf.UninterpretedOption.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {google.protobuf.IUninterpretedOption} message UninterpretedOption message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UninterpretedOption.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && message.name.length)
                        for (var i = 0; i < message.name.length; ++i)
                            $root.google.protobuf.UninterpretedOption.NamePart.encode(message.name[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.identifierValue != null && Object.hasOwnProperty.call(message, "identifierValue"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.identifierValue);
                    if (message.positiveIntValue != null && Object.hasOwnProperty.call(message, "positiveIntValue"))
                        writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.positiveIntValue);
                    if (message.negativeIntValue != null && Object.hasOwnProperty.call(message, "negativeIntValue"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.negativeIntValue);
                    if (message.doubleValue != null && Object.hasOwnProperty.call(message, "doubleValue"))
                        writer.uint32(/* id 6, wireType 1 =*/49).double(message.doubleValue);
                    if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
                        writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.stringValue);
                    if (message.aggregateValue != null && Object.hasOwnProperty.call(message, "aggregateValue"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.aggregateValue);
                    return writer;
                };
    
                /**
                 * Encodes the specified UninterpretedOption message, length delimited. Does not implicitly {@link google.protobuf.UninterpretedOption.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {google.protobuf.IUninterpretedOption} message UninterpretedOption message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UninterpretedOption.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an UninterpretedOption message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UninterpretedOption.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2:
                            if (!(message.name && message.name.length))
                                message.name = [];
                            message.name.push($root.google.protobuf.UninterpretedOption.NamePart.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.identifierValue = reader.string();
                            break;
                        case 4:
                            message.positiveIntValue = reader.uint64();
                            break;
                        case 5:
                            message.negativeIntValue = reader.int64();
                            break;
                        case 6:
                            message.doubleValue = reader.double();
                            break;
                        case 7:
                            message.stringValue = reader.bytes();
                            break;
                        case 8:
                            message.aggregateValue = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an UninterpretedOption message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UninterpretedOption.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an UninterpretedOption message.
                 * @function verify
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UninterpretedOption.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        if (!Array.isArray(message.name))
                            return "name: array expected";
                        for (var i = 0; i < message.name.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.NamePart.verify(message.name[i]);
                            if (error)
                                return "name." + error;
                        }
                    }
                    if (message.identifierValue != null && message.hasOwnProperty("identifierValue"))
                        if (!$util.isString(message.identifierValue))
                            return "identifierValue: string expected";
                    if (message.positiveIntValue != null && message.hasOwnProperty("positiveIntValue"))
                        if (!$util.isInteger(message.positiveIntValue) && !(message.positiveIntValue && $util.isInteger(message.positiveIntValue.low) && $util.isInteger(message.positiveIntValue.high)))
                            return "positiveIntValue: integer|Long expected";
                    if (message.negativeIntValue != null && message.hasOwnProperty("negativeIntValue"))
                        if (!$util.isInteger(message.negativeIntValue) && !(message.negativeIntValue && $util.isInteger(message.negativeIntValue.low) && $util.isInteger(message.negativeIntValue.high)))
                            return "negativeIntValue: integer|Long expected";
                    if (message.doubleValue != null && message.hasOwnProperty("doubleValue"))
                        if (typeof message.doubleValue !== "number")
                            return "doubleValue: number expected";
                    if (message.stringValue != null && message.hasOwnProperty("stringValue"))
                        if (!(message.stringValue && typeof message.stringValue.length === "number" || $util.isString(message.stringValue)))
                            return "stringValue: buffer expected";
                    if (message.aggregateValue != null && message.hasOwnProperty("aggregateValue"))
                        if (!$util.isString(message.aggregateValue))
                            return "aggregateValue: string expected";
                    return null;
                };
    
                /**
                 * Creates an UninterpretedOption message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
                 */
                UninterpretedOption.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.UninterpretedOption)
                        return object;
                    var message = new $root.google.protobuf.UninterpretedOption();
                    if (object.name) {
                        if (!Array.isArray(object.name))
                            throw TypeError(".google.protobuf.UninterpretedOption.name: array expected");
                        message.name = [];
                        for (var i = 0; i < object.name.length; ++i) {
                            if (typeof object.name[i] !== "object")
                                throw TypeError(".google.protobuf.UninterpretedOption.name: object expected");
                            message.name[i] = $root.google.protobuf.UninterpretedOption.NamePart.fromObject(object.name[i]);
                        }
                    }
                    if (object.identifierValue != null)
                        message.identifierValue = String(object.identifierValue);
                    if (object.positiveIntValue != null)
                        if ($util.Long)
                            (message.positiveIntValue = $util.Long.fromValue(object.positiveIntValue)).unsigned = true;
                        else if (typeof object.positiveIntValue === "string")
                            message.positiveIntValue = parseInt(object.positiveIntValue, 10);
                        else if (typeof object.positiveIntValue === "number")
                            message.positiveIntValue = object.positiveIntValue;
                        else if (typeof object.positiveIntValue === "object")
                            message.positiveIntValue = new $util.LongBits(object.positiveIntValue.low >>> 0, object.positiveIntValue.high >>> 0).toNumber(true);
                    if (object.negativeIntValue != null)
                        if ($util.Long)
                            (message.negativeIntValue = $util.Long.fromValue(object.negativeIntValue)).unsigned = false;
                        else if (typeof object.negativeIntValue === "string")
                            message.negativeIntValue = parseInt(object.negativeIntValue, 10);
                        else if (typeof object.negativeIntValue === "number")
                            message.negativeIntValue = object.negativeIntValue;
                        else if (typeof object.negativeIntValue === "object")
                            message.negativeIntValue = new $util.LongBits(object.negativeIntValue.low >>> 0, object.negativeIntValue.high >>> 0).toNumber();
                    if (object.doubleValue != null)
                        message.doubleValue = Number(object.doubleValue);
                    if (object.stringValue != null)
                        if (typeof object.stringValue === "string")
                            $util.base64.decode(object.stringValue, message.stringValue = $util.newBuffer($util.base64.length(object.stringValue)), 0);
                        else if (object.stringValue.length)
                            message.stringValue = object.stringValue;
                    if (object.aggregateValue != null)
                        message.aggregateValue = String(object.aggregateValue);
                    return message;
                };
    
                /**
                 * Creates a plain object from an UninterpretedOption message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {google.protobuf.UninterpretedOption} message UninterpretedOption
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UninterpretedOption.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.name = [];
                    if (options.defaults) {
                        object.identifierValue = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, true);
                            object.positiveIntValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.positiveIntValue = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.negativeIntValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.negativeIntValue = options.longs === String ? "0" : 0;
                        object.doubleValue = 0;
                        if (options.bytes === String)
                            object.stringValue = "";
                        else {
                            object.stringValue = [];
                            if (options.bytes !== Array)
                                object.stringValue = $util.newBuffer(object.stringValue);
                        }
                        object.aggregateValue = "";
                    }
                    if (message.name && message.name.length) {
                        object.name = [];
                        for (var j = 0; j < message.name.length; ++j)
                            object.name[j] = $root.google.protobuf.UninterpretedOption.NamePart.toObject(message.name[j], options);
                    }
                    if (message.identifierValue != null && message.hasOwnProperty("identifierValue"))
                        object.identifierValue = message.identifierValue;
                    if (message.positiveIntValue != null && message.hasOwnProperty("positiveIntValue"))
                        if (typeof message.positiveIntValue === "number")
                            object.positiveIntValue = options.longs === String ? String(message.positiveIntValue) : message.positiveIntValue;
                        else
                            object.positiveIntValue = options.longs === String ? $util.Long.prototype.toString.call(message.positiveIntValue) : options.longs === Number ? new $util.LongBits(message.positiveIntValue.low >>> 0, message.positiveIntValue.high >>> 0).toNumber(true) : message.positiveIntValue;
                    if (message.negativeIntValue != null && message.hasOwnProperty("negativeIntValue"))
                        if (typeof message.negativeIntValue === "number")
                            object.negativeIntValue = options.longs === String ? String(message.negativeIntValue) : message.negativeIntValue;
                        else
                            object.negativeIntValue = options.longs === String ? $util.Long.prototype.toString.call(message.negativeIntValue) : options.longs === Number ? new $util.LongBits(message.negativeIntValue.low >>> 0, message.negativeIntValue.high >>> 0).toNumber() : message.negativeIntValue;
                    if (message.doubleValue != null && message.hasOwnProperty("doubleValue"))
                        object.doubleValue = options.json && !isFinite(message.doubleValue) ? String(message.doubleValue) : message.doubleValue;
                    if (message.stringValue != null && message.hasOwnProperty("stringValue"))
                        object.stringValue = options.bytes === String ? $util.base64.encode(message.stringValue, 0, message.stringValue.length) : options.bytes === Array ? Array.prototype.slice.call(message.stringValue) : message.stringValue;
                    if (message.aggregateValue != null && message.hasOwnProperty("aggregateValue"))
                        object.aggregateValue = message.aggregateValue;
                    return object;
                };
    
                /**
                 * Converts this UninterpretedOption to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UninterpretedOption.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                UninterpretedOption.NamePart = (function() {
    
                    /**
                     * Properties of a NamePart.
                     * @memberof google.protobuf.UninterpretedOption
                     * @interface INamePart
                     * @property {string} namePart NamePart namePart
                     * @property {boolean} isExtension NamePart isExtension
                     */
    
                    /**
                     * Constructs a new NamePart.
                     * @memberof google.protobuf.UninterpretedOption
                     * @classdesc Represents a NamePart.
                     * @implements INamePart
                     * @constructor
                     * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
                     */
                    function NamePart(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * NamePart namePart.
                     * @member {string} namePart
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @instance
                     */
                    NamePart.prototype.namePart = "";
    
                    /**
                     * NamePart isExtension.
                     * @member {boolean} isExtension
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @instance
                     */
                    NamePart.prototype.isExtension = false;
    
                    /**
                     * Creates a new NamePart instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
                     * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart instance
                     */
                    NamePart.create = function create(properties) {
                        return new NamePart(properties);
                    };
    
                    /**
                     * Encodes the specified NamePart message. Does not implicitly {@link google.protobuf.UninterpretedOption.NamePart.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {google.protobuf.UninterpretedOption.INamePart} message NamePart message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NamePart.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.namePart);
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isExtension);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified NamePart message, length delimited. Does not implicitly {@link google.protobuf.UninterpretedOption.NamePart.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {google.protobuf.UninterpretedOption.INamePart} message NamePart message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NamePart.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a NamePart message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NamePart.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption.NamePart();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.namePart = reader.string();
                                break;
                            case 2:
                                message.isExtension = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        if (!message.hasOwnProperty("namePart"))
                            throw $util.ProtocolError("missing required 'namePart'", { instance: message });
                        if (!message.hasOwnProperty("isExtension"))
                            throw $util.ProtocolError("missing required 'isExtension'", { instance: message });
                        return message;
                    };
    
                    /**
                     * Decodes a NamePart message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NamePart.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a NamePart message.
                     * @function verify
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NamePart.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (!$util.isString(message.namePart))
                            return "namePart: string expected";
                        if (typeof message.isExtension !== "boolean")
                            return "isExtension: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a NamePart message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                     */
                    NamePart.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.UninterpretedOption.NamePart)
                            return object;
                        var message = new $root.google.protobuf.UninterpretedOption.NamePart();
                        if (object.namePart != null)
                            message.namePart = String(object.namePart);
                        if (object.isExtension != null)
                            message.isExtension = Boolean(object.isExtension);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a NamePart message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {google.protobuf.UninterpretedOption.NamePart} message NamePart
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NamePart.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.namePart = "";
                            object.isExtension = false;
                        }
                        if (message.namePart != null && message.hasOwnProperty("namePart"))
                            object.namePart = message.namePart;
                        if (message.isExtension != null && message.hasOwnProperty("isExtension"))
                            object.isExtension = message.isExtension;
                        return object;
                    };
    
                    /**
                     * Converts this NamePart to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NamePart.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return NamePart;
                })();
    
                return UninterpretedOption;
            })();
    
            protobuf.SourceCodeInfo = (function() {
    
                /**
                 * Properties of a SourceCodeInfo.
                 * @memberof google.protobuf
                 * @interface ISourceCodeInfo
                 * @property {Array.<google.protobuf.SourceCodeInfo.ILocation>|null} [location] SourceCodeInfo location
                 */
    
                /**
                 * Constructs a new SourceCodeInfo.
                 * @memberof google.protobuf
                 * @classdesc Represents a SourceCodeInfo.
                 * @implements ISourceCodeInfo
                 * @constructor
                 * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
                 */
                function SourceCodeInfo(properties) {
                    this.location = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * SourceCodeInfo location.
                 * @member {Array.<google.protobuf.SourceCodeInfo.ILocation>} location
                 * @memberof google.protobuf.SourceCodeInfo
                 * @instance
                 */
                SourceCodeInfo.prototype.location = $util.emptyArray;
    
                /**
                 * Creates a new SourceCodeInfo instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
                 * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo instance
                 */
                SourceCodeInfo.create = function create(properties) {
                    return new SourceCodeInfo(properties);
                };
    
                /**
                 * Encodes the specified SourceCodeInfo message. Does not implicitly {@link google.protobuf.SourceCodeInfo.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {google.protobuf.ISourceCodeInfo} message SourceCodeInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SourceCodeInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.location != null && message.location.length)
                        for (var i = 0; i < message.location.length; ++i)
                            $root.google.protobuf.SourceCodeInfo.Location.encode(message.location[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified SourceCodeInfo message, length delimited. Does not implicitly {@link google.protobuf.SourceCodeInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {google.protobuf.ISourceCodeInfo} message SourceCodeInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SourceCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a SourceCodeInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SourceCodeInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.location && message.location.length))
                                message.location = [];
                            message.location.push($root.google.protobuf.SourceCodeInfo.Location.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a SourceCodeInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SourceCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a SourceCodeInfo message.
                 * @function verify
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SourceCodeInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.location != null && message.hasOwnProperty("location")) {
                        if (!Array.isArray(message.location))
                            return "location: array expected";
                        for (var i = 0; i < message.location.length; ++i) {
                            var error = $root.google.protobuf.SourceCodeInfo.Location.verify(message.location[i]);
                            if (error)
                                return "location." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a SourceCodeInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
                 */
                SourceCodeInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.SourceCodeInfo)
                        return object;
                    var message = new $root.google.protobuf.SourceCodeInfo();
                    if (object.location) {
                        if (!Array.isArray(object.location))
                            throw TypeError(".google.protobuf.SourceCodeInfo.location: array expected");
                        message.location = [];
                        for (var i = 0; i < object.location.length; ++i) {
                            if (typeof object.location[i] !== "object")
                                throw TypeError(".google.protobuf.SourceCodeInfo.location: object expected");
                            message.location[i] = $root.google.protobuf.SourceCodeInfo.Location.fromObject(object.location[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a SourceCodeInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {google.protobuf.SourceCodeInfo} message SourceCodeInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SourceCodeInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.location = [];
                    if (message.location && message.location.length) {
                        object.location = [];
                        for (var j = 0; j < message.location.length; ++j)
                            object.location[j] = $root.google.protobuf.SourceCodeInfo.Location.toObject(message.location[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this SourceCodeInfo to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.SourceCodeInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SourceCodeInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                SourceCodeInfo.Location = (function() {
    
                    /**
                     * Properties of a Location.
                     * @memberof google.protobuf.SourceCodeInfo
                     * @interface ILocation
                     * @property {Array.<number>|null} [path] Location path
                     * @property {Array.<number>|null} [span] Location span
                     * @property {string|null} [leadingComments] Location leadingComments
                     * @property {string|null} [trailingComments] Location trailingComments
                     * @property {Array.<string>|null} [leadingDetachedComments] Location leadingDetachedComments
                     */
    
                    /**
                     * Constructs a new Location.
                     * @memberof google.protobuf.SourceCodeInfo
                     * @classdesc Represents a Location.
                     * @implements ILocation
                     * @constructor
                     * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
                     */
                    function Location(properties) {
                        this.path = [];
                        this.span = [];
                        this.leadingDetachedComments = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Location path.
                     * @member {Array.<number>} path
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     */
                    Location.prototype.path = $util.emptyArray;
    
                    /**
                     * Location span.
                     * @member {Array.<number>} span
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     */
                    Location.prototype.span = $util.emptyArray;
    
                    /**
                     * Location leadingComments.
                     * @member {string} leadingComments
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     */
                    Location.prototype.leadingComments = "";
    
                    /**
                     * Location trailingComments.
                     * @member {string} trailingComments
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     */
                    Location.prototype.trailingComments = "";
    
                    /**
                     * Location leadingDetachedComments.
                     * @member {Array.<string>} leadingDetachedComments
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     */
                    Location.prototype.leadingDetachedComments = $util.emptyArray;
    
                    /**
                     * Creates a new Location instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
                     * @returns {google.protobuf.SourceCodeInfo.Location} Location instance
                     */
                    Location.create = function create(properties) {
                        return new Location(properties);
                    };
    
                    /**
                     * Encodes the specified Location message. Does not implicitly {@link google.protobuf.SourceCodeInfo.Location.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {google.protobuf.SourceCodeInfo.ILocation} message Location message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Location.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.path != null && message.path.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.path.length; ++i)
                                writer.int32(message.path[i]);
                            writer.ldelim();
                        }
                        if (message.span != null && message.span.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.span.length; ++i)
                                writer.int32(message.span[i]);
                            writer.ldelim();
                        }
                        if (message.leadingComments != null && Object.hasOwnProperty.call(message, "leadingComments"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.leadingComments);
                        if (message.trailingComments != null && Object.hasOwnProperty.call(message, "trailingComments"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.trailingComments);
                        if (message.leadingDetachedComments != null && message.leadingDetachedComments.length)
                            for (var i = 0; i < message.leadingDetachedComments.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.leadingDetachedComments[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Location message, length delimited. Does not implicitly {@link google.protobuf.SourceCodeInfo.Location.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {google.protobuf.SourceCodeInfo.ILocation} message Location message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Location.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Location message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.SourceCodeInfo.Location} Location
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Location.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo.Location();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.path && message.path.length))
                                    message.path = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.path.push(reader.int32());
                                } else
                                    message.path.push(reader.int32());
                                break;
                            case 2:
                                if (!(message.span && message.span.length))
                                    message.span = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.span.push(reader.int32());
                                } else
                                    message.span.push(reader.int32());
                                break;
                            case 3:
                                message.leadingComments = reader.string();
                                break;
                            case 4:
                                message.trailingComments = reader.string();
                                break;
                            case 6:
                                if (!(message.leadingDetachedComments && message.leadingDetachedComments.length))
                                    message.leadingDetachedComments = [];
                                message.leadingDetachedComments.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Location message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.SourceCodeInfo.Location} Location
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Location.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Location message.
                     * @function verify
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Location.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.path != null && message.hasOwnProperty("path")) {
                            if (!Array.isArray(message.path))
                                return "path: array expected";
                            for (var i = 0; i < message.path.length; ++i)
                                if (!$util.isInteger(message.path[i]))
                                    return "path: integer[] expected";
                        }
                        if (message.span != null && message.hasOwnProperty("span")) {
                            if (!Array.isArray(message.span))
                                return "span: array expected";
                            for (var i = 0; i < message.span.length; ++i)
                                if (!$util.isInteger(message.span[i]))
                                    return "span: integer[] expected";
                        }
                        if (message.leadingComments != null && message.hasOwnProperty("leadingComments"))
                            if (!$util.isString(message.leadingComments))
                                return "leadingComments: string expected";
                        if (message.trailingComments != null && message.hasOwnProperty("trailingComments"))
                            if (!$util.isString(message.trailingComments))
                                return "trailingComments: string expected";
                        if (message.leadingDetachedComments != null && message.hasOwnProperty("leadingDetachedComments")) {
                            if (!Array.isArray(message.leadingDetachedComments))
                                return "leadingDetachedComments: array expected";
                            for (var i = 0; i < message.leadingDetachedComments.length; ++i)
                                if (!$util.isString(message.leadingDetachedComments[i]))
                                    return "leadingDetachedComments: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Location message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.SourceCodeInfo.Location} Location
                     */
                    Location.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.SourceCodeInfo.Location)
                            return object;
                        var message = new $root.google.protobuf.SourceCodeInfo.Location();
                        if (object.path) {
                            if (!Array.isArray(object.path))
                                throw TypeError(".google.protobuf.SourceCodeInfo.Location.path: array expected");
                            message.path = [];
                            for (var i = 0; i < object.path.length; ++i)
                                message.path[i] = object.path[i] | 0;
                        }
                        if (object.span) {
                            if (!Array.isArray(object.span))
                                throw TypeError(".google.protobuf.SourceCodeInfo.Location.span: array expected");
                            message.span = [];
                            for (var i = 0; i < object.span.length; ++i)
                                message.span[i] = object.span[i] | 0;
                        }
                        if (object.leadingComments != null)
                            message.leadingComments = String(object.leadingComments);
                        if (object.trailingComments != null)
                            message.trailingComments = String(object.trailingComments);
                        if (object.leadingDetachedComments) {
                            if (!Array.isArray(object.leadingDetachedComments))
                                throw TypeError(".google.protobuf.SourceCodeInfo.Location.leadingDetachedComments: array expected");
                            message.leadingDetachedComments = [];
                            for (var i = 0; i < object.leadingDetachedComments.length; ++i)
                                message.leadingDetachedComments[i] = String(object.leadingDetachedComments[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Location message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {google.protobuf.SourceCodeInfo.Location} message Location
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Location.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.path = [];
                            object.span = [];
                            object.leadingDetachedComments = [];
                        }
                        if (options.defaults) {
                            object.leadingComments = "";
                            object.trailingComments = "";
                        }
                        if (message.path && message.path.length) {
                            object.path = [];
                            for (var j = 0; j < message.path.length; ++j)
                                object.path[j] = message.path[j];
                        }
                        if (message.span && message.span.length) {
                            object.span = [];
                            for (var j = 0; j < message.span.length; ++j)
                                object.span[j] = message.span[j];
                        }
                        if (message.leadingComments != null && message.hasOwnProperty("leadingComments"))
                            object.leadingComments = message.leadingComments;
                        if (message.trailingComments != null && message.hasOwnProperty("trailingComments"))
                            object.trailingComments = message.trailingComments;
                        if (message.leadingDetachedComments && message.leadingDetachedComments.length) {
                            object.leadingDetachedComments = [];
                            for (var j = 0; j < message.leadingDetachedComments.length; ++j)
                                object.leadingDetachedComments[j] = message.leadingDetachedComments[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Location to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Location.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Location;
                })();
    
                return SourceCodeInfo;
            })();
    
            protobuf.GeneratedCodeInfo = (function() {
    
                /**
                 * Properties of a GeneratedCodeInfo.
                 * @memberof google.protobuf
                 * @interface IGeneratedCodeInfo
                 * @property {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>|null} [annotation] GeneratedCodeInfo annotation
                 */
    
                /**
                 * Constructs a new GeneratedCodeInfo.
                 * @memberof google.protobuf
                 * @classdesc Represents a GeneratedCodeInfo.
                 * @implements IGeneratedCodeInfo
                 * @constructor
                 * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
                 */
                function GeneratedCodeInfo(properties) {
                    this.annotation = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * GeneratedCodeInfo annotation.
                 * @member {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>} annotation
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @instance
                 */
                GeneratedCodeInfo.prototype.annotation = $util.emptyArray;
    
                /**
                 * Creates a new GeneratedCodeInfo instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
                 * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo instance
                 */
                GeneratedCodeInfo.create = function create(properties) {
                    return new GeneratedCodeInfo(properties);
                };
    
                /**
                 * Encodes the specified GeneratedCodeInfo message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {google.protobuf.IGeneratedCodeInfo} message GeneratedCodeInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneratedCodeInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.annotation != null && message.annotation.length)
                        for (var i = 0; i < message.annotation.length; ++i)
                            $root.google.protobuf.GeneratedCodeInfo.Annotation.encode(message.annotation[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified GeneratedCodeInfo message, length delimited. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {google.protobuf.IGeneratedCodeInfo} message GeneratedCodeInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneratedCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a GeneratedCodeInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneratedCodeInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.annotation && message.annotation.length))
                                message.annotation = [];
                            message.annotation.push($root.google.protobuf.GeneratedCodeInfo.Annotation.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a GeneratedCodeInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneratedCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a GeneratedCodeInfo message.
                 * @function verify
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GeneratedCodeInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.annotation != null && message.hasOwnProperty("annotation")) {
                        if (!Array.isArray(message.annotation))
                            return "annotation: array expected";
                        for (var i = 0; i < message.annotation.length; ++i) {
                            var error = $root.google.protobuf.GeneratedCodeInfo.Annotation.verify(message.annotation[i]);
                            if (error)
                                return "annotation." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a GeneratedCodeInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
                 */
                GeneratedCodeInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.GeneratedCodeInfo)
                        return object;
                    var message = new $root.google.protobuf.GeneratedCodeInfo();
                    if (object.annotation) {
                        if (!Array.isArray(object.annotation))
                            throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: array expected");
                        message.annotation = [];
                        for (var i = 0; i < object.annotation.length; ++i) {
                            if (typeof object.annotation[i] !== "object")
                                throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: object expected");
                            message.annotation[i] = $root.google.protobuf.GeneratedCodeInfo.Annotation.fromObject(object.annotation[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a GeneratedCodeInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {google.protobuf.GeneratedCodeInfo} message GeneratedCodeInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GeneratedCodeInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.annotation = [];
                    if (message.annotation && message.annotation.length) {
                        object.annotation = [];
                        for (var j = 0; j < message.annotation.length; ++j)
                            object.annotation[j] = $root.google.protobuf.GeneratedCodeInfo.Annotation.toObject(message.annotation[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this GeneratedCodeInfo to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GeneratedCodeInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                GeneratedCodeInfo.Annotation = (function() {
    
                    /**
                     * Properties of an Annotation.
                     * @memberof google.protobuf.GeneratedCodeInfo
                     * @interface IAnnotation
                     * @property {Array.<number>|null} [path] Annotation path
                     * @property {string|null} [sourceFile] Annotation sourceFile
                     * @property {number|null} [begin] Annotation begin
                     * @property {number|null} [end] Annotation end
                     */
    
                    /**
                     * Constructs a new Annotation.
                     * @memberof google.protobuf.GeneratedCodeInfo
                     * @classdesc Represents an Annotation.
                     * @implements IAnnotation
                     * @constructor
                     * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
                     */
                    function Annotation(properties) {
                        this.path = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Annotation path.
                     * @member {Array.<number>} path
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @instance
                     */
                    Annotation.prototype.path = $util.emptyArray;
    
                    /**
                     * Annotation sourceFile.
                     * @member {string} sourceFile
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @instance
                     */
                    Annotation.prototype.sourceFile = "";
    
                    /**
                     * Annotation begin.
                     * @member {number} begin
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @instance
                     */
                    Annotation.prototype.begin = 0;
    
                    /**
                     * Annotation end.
                     * @member {number} end
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @instance
                     */
                    Annotation.prototype.end = 0;
    
                    /**
                     * Creates a new Annotation instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
                     * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation instance
                     */
                    Annotation.create = function create(properties) {
                        return new Annotation(properties);
                    };
    
                    /**
                     * Encodes the specified Annotation message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.Annotation.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {google.protobuf.GeneratedCodeInfo.IAnnotation} message Annotation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Annotation.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.path != null && message.path.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.path.length; ++i)
                                writer.int32(message.path[i]);
                            writer.ldelim();
                        }
                        if (message.sourceFile != null && Object.hasOwnProperty.call(message, "sourceFile"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.sourceFile);
                        if (message.begin != null && Object.hasOwnProperty.call(message, "begin"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.begin);
                        if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.end);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Annotation message, length delimited. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.Annotation.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {google.protobuf.GeneratedCodeInfo.IAnnotation} message Annotation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Annotation.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an Annotation message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Annotation.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.path && message.path.length))
                                    message.path = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.path.push(reader.int32());
                                } else
                                    message.path.push(reader.int32());
                                break;
                            case 2:
                                message.sourceFile = reader.string();
                                break;
                            case 3:
                                message.begin = reader.int32();
                                break;
                            case 4:
                                message.end = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an Annotation message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Annotation.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an Annotation message.
                     * @function verify
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Annotation.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.path != null && message.hasOwnProperty("path")) {
                            if (!Array.isArray(message.path))
                                return "path: array expected";
                            for (var i = 0; i < message.path.length; ++i)
                                if (!$util.isInteger(message.path[i]))
                                    return "path: integer[] expected";
                        }
                        if (message.sourceFile != null && message.hasOwnProperty("sourceFile"))
                            if (!$util.isString(message.sourceFile))
                                return "sourceFile: string expected";
                        if (message.begin != null && message.hasOwnProperty("begin"))
                            if (!$util.isInteger(message.begin))
                                return "begin: integer expected";
                        if (message.end != null && message.hasOwnProperty("end"))
                            if (!$util.isInteger(message.end))
                                return "end: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an Annotation message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                     */
                    Annotation.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.GeneratedCodeInfo.Annotation)
                            return object;
                        var message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                        if (object.path) {
                            if (!Array.isArray(object.path))
                                throw TypeError(".google.protobuf.GeneratedCodeInfo.Annotation.path: array expected");
                            message.path = [];
                            for (var i = 0; i < object.path.length; ++i)
                                message.path[i] = object.path[i] | 0;
                        }
                        if (object.sourceFile != null)
                            message.sourceFile = String(object.sourceFile);
                        if (object.begin != null)
                            message.begin = object.begin | 0;
                        if (object.end != null)
                            message.end = object.end | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an Annotation message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {google.protobuf.GeneratedCodeInfo.Annotation} message Annotation
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Annotation.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.path = [];
                        if (options.defaults) {
                            object.sourceFile = "";
                            object.begin = 0;
                            object.end = 0;
                        }
                        if (message.path && message.path.length) {
                            object.path = [];
                            for (var j = 0; j < message.path.length; ++j)
                                object.path[j] = message.path[j];
                        }
                        if (message.sourceFile != null && message.hasOwnProperty("sourceFile"))
                            object.sourceFile = message.sourceFile;
                        if (message.begin != null && message.hasOwnProperty("begin"))
                            object.begin = message.begin;
                        if (message.end != null && message.hasOwnProperty("end"))
                            object.end = message.end;
                        return object;
                    };
    
                    /**
                     * Converts this Annotation to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Annotation.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Annotation;
                })();
    
                return GeneratedCodeInfo;
            })();
    
            protobuf.Any = (function() {
    
                /**
                 * Properties of an Any.
                 * @memberof google.protobuf
                 * @interface IAny
                 * @property {string|null} [type_url] Any type_url
                 * @property {Uint8Array|null} [value] Any value
                 */
    
                /**
                 * Constructs a new Any.
                 * @memberof google.protobuf
                 * @classdesc Represents an Any.
                 * @implements IAny
                 * @constructor
                 * @param {google.protobuf.IAny=} [properties] Properties to set
                 */
                function Any(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Any type_url.
                 * @member {string} type_url
                 * @memberof google.protobuf.Any
                 * @instance
                 */
                Any.prototype.type_url = "";
    
                /**
                 * Any value.
                 * @member {Uint8Array} value
                 * @memberof google.protobuf.Any
                 * @instance
                 */
                Any.prototype.value = $util.newBuffer([]);
    
                /**
                 * Creates a new Any instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.Any
                 * @static
                 * @param {google.protobuf.IAny=} [properties] Properties to set
                 * @returns {google.protobuf.Any} Any instance
                 */
                Any.create = function create(properties) {
                    return new Any(properties);
                };
    
                /**
                 * Encodes the specified Any message. Does not implicitly {@link google.protobuf.Any.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.Any
                 * @static
                 * @param {google.protobuf.IAny} message Any message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Any.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.type_url != null && Object.hasOwnProperty.call(message, "type_url"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.type_url);
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified Any message, length delimited. Does not implicitly {@link google.protobuf.Any.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.Any
                 * @static
                 * @param {google.protobuf.IAny} message Any message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Any.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an Any message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.Any
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.Any} Any
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Any.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Any();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.type_url = reader.string();
                            break;
                        case 2:
                            message.value = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an Any message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.Any
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.Any} Any
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Any.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an Any message.
                 * @function verify
                 * @memberof google.protobuf.Any
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Any.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.type_url != null && message.hasOwnProperty("type_url"))
                        if (!$util.isString(message.type_url))
                            return "type_url: string expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                            return "value: buffer expected";
                    return null;
                };
    
                /**
                 * Creates an Any message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.Any
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.Any} Any
                 */
                Any.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.Any)
                        return object;
                    var message = new $root.google.protobuf.Any();
                    if (object.type_url != null)
                        message.type_url = String(object.type_url);
                    if (object.value != null)
                        if (typeof object.value === "string")
                            $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                        else if (object.value.length)
                            message.value = object.value;
                    return message;
                };
    
                /**
                 * Creates a plain object from an Any message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.Any
                 * @static
                 * @param {google.protobuf.Any} message Any
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Any.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.type_url = "";
                        if (options.bytes === String)
                            object.value = "";
                        else {
                            object.value = [];
                            if (options.bytes !== Array)
                                object.value = $util.newBuffer(object.value);
                        }
                    }
                    if (message.type_url != null && message.hasOwnProperty("type_url"))
                        object.type_url = message.type_url;
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
                    return object;
                };
    
                /**
                 * Converts this Any to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.Any
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Any.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Any;
            })();
    
            protobuf.Duration = (function() {
    
                /**
                 * Properties of a Duration.
                 * @memberof google.protobuf
                 * @interface IDuration
                 * @property {number|Long|null} [seconds] Duration seconds
                 * @property {number|null} [nanos] Duration nanos
                 */
    
                /**
                 * Constructs a new Duration.
                 * @memberof google.protobuf
                 * @classdesc Represents a Duration.
                 * @implements IDuration
                 * @constructor
                 * @param {google.protobuf.IDuration=} [properties] Properties to set
                 */
                function Duration(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Duration seconds.
                 * @member {number|Long} seconds
                 * @memberof google.protobuf.Duration
                 * @instance
                 */
                Duration.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Duration nanos.
                 * @member {number} nanos
                 * @memberof google.protobuf.Duration
                 * @instance
                 */
                Duration.prototype.nanos = 0;
    
                /**
                 * Creates a new Duration instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {google.protobuf.IDuration=} [properties] Properties to set
                 * @returns {google.protobuf.Duration} Duration instance
                 */
                Duration.create = function create(properties) {
                    return new Duration(properties);
                };
    
                /**
                 * Encodes the specified Duration message. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {google.protobuf.IDuration} message Duration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Duration.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                    if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                    return writer;
                };
    
                /**
                 * Encodes the specified Duration message, length delimited. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {google.protobuf.IDuration} message Duration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Duration.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a Duration message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.Duration} Duration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Duration.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Duration();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.seconds = reader.int64();
                            break;
                        case 2:
                            message.nanos = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a Duration message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.Duration} Duration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Duration.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a Duration message.
                 * @function verify
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Duration.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.seconds != null && message.hasOwnProperty("seconds"))
                        if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                            return "seconds: integer|Long expected";
                    if (message.nanos != null && message.hasOwnProperty("nanos"))
                        if (!$util.isInteger(message.nanos))
                            return "nanos: integer expected";
                    return null;
                };
    
                /**
                 * Creates a Duration message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.Duration} Duration
                 */
                Duration.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.Duration)
                        return object;
                    var message = new $root.google.protobuf.Duration();
                    if (object.seconds != null)
                        if ($util.Long)
                            (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                        else if (typeof object.seconds === "string")
                            message.seconds = parseInt(object.seconds, 10);
                        else if (typeof object.seconds === "number")
                            message.seconds = object.seconds;
                        else if (typeof object.seconds === "object")
                            message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                    if (object.nanos != null)
                        message.nanos = object.nanos | 0;
                    return message;
                };
    
                /**
                 * Creates a plain object from a Duration message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {google.protobuf.Duration} message Duration
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Duration.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.seconds = options.longs === String ? "0" : 0;
                        object.nanos = 0;
                    }
                    if (message.seconds != null && message.hasOwnProperty("seconds"))
                        if (typeof message.seconds === "number")
                            object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                        else
                            object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                    if (message.nanos != null && message.hasOwnProperty("nanos"))
                        object.nanos = message.nanos;
                    return object;
                };
    
                /**
                 * Converts this Duration to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.Duration
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Duration.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Duration;
            })();
    
            protobuf.Empty = (function() {
    
                /**
                 * Properties of an Empty.
                 * @memberof google.protobuf
                 * @interface IEmpty
                 */
    
                /**
                 * Constructs a new Empty.
                 * @memberof google.protobuf
                 * @classdesc Represents an Empty.
                 * @implements IEmpty
                 * @constructor
                 * @param {google.protobuf.IEmpty=} [properties] Properties to set
                 */
                function Empty(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Creates a new Empty instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {google.protobuf.IEmpty=} [properties] Properties to set
                 * @returns {google.protobuf.Empty} Empty instance
                 */
                Empty.create = function create(properties) {
                    return new Empty(properties);
                };
    
                /**
                 * Encodes the specified Empty message. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {google.protobuf.IEmpty} message Empty message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Empty.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };
    
                /**
                 * Encodes the specified Empty message, length delimited. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {google.protobuf.IEmpty} message Empty message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Empty.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an Empty message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.Empty} Empty
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Empty.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Empty();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an Empty message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.Empty} Empty
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Empty.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an Empty message.
                 * @function verify
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Empty.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };
    
                /**
                 * Creates an Empty message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.Empty} Empty
                 */
                Empty.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.Empty)
                        return object;
                    return new $root.google.protobuf.Empty();
                };
    
                /**
                 * Creates a plain object from an Empty message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {google.protobuf.Empty} message Empty
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Empty.toObject = function toObject() {
                    return {};
                };
    
                /**
                 * Converts this Empty to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.Empty
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Empty.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Empty;
            })();
    
            protobuf.Timestamp = (function() {
    
                /**
                 * Properties of a Timestamp.
                 * @memberof google.protobuf
                 * @interface ITimestamp
                 * @property {number|Long|null} [seconds] Timestamp seconds
                 * @property {number|null} [nanos] Timestamp nanos
                 */
    
                /**
                 * Constructs a new Timestamp.
                 * @memberof google.protobuf
                 * @classdesc Represents a Timestamp.
                 * @implements ITimestamp
                 * @constructor
                 * @param {google.protobuf.ITimestamp=} [properties] Properties to set
                 */
                function Timestamp(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Timestamp seconds.
                 * @member {number|Long} seconds
                 * @memberof google.protobuf.Timestamp
                 * @instance
                 */
                Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Timestamp nanos.
                 * @member {number} nanos
                 * @memberof google.protobuf.Timestamp
                 * @instance
                 */
                Timestamp.prototype.nanos = 0;
    
                /**
                 * Creates a new Timestamp instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {google.protobuf.ITimestamp=} [properties] Properties to set
                 * @returns {google.protobuf.Timestamp} Timestamp instance
                 */
                Timestamp.create = function create(properties) {
                    return new Timestamp(properties);
                };
    
                /**
                 * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Timestamp.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                    if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                    return writer;
                };
    
                /**
                 * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a Timestamp message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.Timestamp} Timestamp
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Timestamp.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Timestamp();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.seconds = reader.int64();
                            break;
                        case 2:
                            message.nanos = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a Timestamp message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.Timestamp} Timestamp
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Timestamp.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a Timestamp message.
                 * @function verify
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Timestamp.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.seconds != null && message.hasOwnProperty("seconds"))
                        if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                            return "seconds: integer|Long expected";
                    if (message.nanos != null && message.hasOwnProperty("nanos"))
                        if (!$util.isInteger(message.nanos))
                            return "nanos: integer expected";
                    return null;
                };
    
                /**
                 * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.Timestamp} Timestamp
                 */
                Timestamp.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.Timestamp)
                        return object;
                    var message = new $root.google.protobuf.Timestamp();
                    if (object.seconds != null)
                        if ($util.Long)
                            (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                        else if (typeof object.seconds === "string")
                            message.seconds = parseInt(object.seconds, 10);
                        else if (typeof object.seconds === "number")
                            message.seconds = object.seconds;
                        else if (typeof object.seconds === "object")
                            message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                    if (object.nanos != null)
                        message.nanos = object.nanos | 0;
                    return message;
                };
    
                /**
                 * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {google.protobuf.Timestamp} message Timestamp
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Timestamp.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.seconds = options.longs === String ? "0" : 0;
                        object.nanos = 0;
                    }
                    if (message.seconds != null && message.hasOwnProperty("seconds"))
                        if (typeof message.seconds === "number")
                            object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                        else
                            object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                    if (message.nanos != null && message.hasOwnProperty("nanos"))
                        object.nanos = message.nanos;
                    return object;
                };
    
                /**
                 * Converts this Timestamp to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.Timestamp
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Timestamp.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Timestamp;
            })();
    
            return protobuf;
        })();
    
        google.longrunning = (function() {
    
            /**
             * Namespace longrunning.
             * @memberof google
             * @namespace
             */
            var longrunning = {};
    
            longrunning.Operations = (function() {
    
                /**
                 * Constructs a new Operations service.
                 * @memberof google.longrunning
                 * @classdesc Represents an Operations
                 * @extends $protobuf.rpc.Service
                 * @constructor
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 */
                function Operations(rpcImpl, requestDelimited, responseDelimited) {
                    $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }
    
                (Operations.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = Operations;
    
                /**
                 * Creates new Operations service using the specified rpc implementation.
                 * @function create
                 * @memberof google.longrunning.Operations
                 * @static
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 * @returns {Operations} RPC service. Useful where requests and/or responses are streamed.
                 */
                Operations.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };
    
                /**
                 * Callback as used by {@link google.longrunning.Operations#listOperations}.
                 * @memberof google.longrunning.Operations
                 * @typedef ListOperationsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {google.longrunning.ListOperationsResponse} [response] ListOperationsResponse
                 */
    
                /**
                 * Calls ListOperations.
                 * @function listOperations
                 * @memberof google.longrunning.Operations
                 * @instance
                 * @param {google.longrunning.IListOperationsRequest} request ListOperationsRequest message or plain object
                 * @param {google.longrunning.Operations.ListOperationsCallback} callback Node-style callback called with the error, if any, and ListOperationsResponse
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(Operations.prototype.listOperations = function listOperations(request, callback) {
                    return this.rpcCall(listOperations, $root.google.longrunning.ListOperationsRequest, $root.google.longrunning.ListOperationsResponse, request, callback);
                }, "name", { value: "ListOperations" });
    
                /**
                 * Calls ListOperations.
                 * @function listOperations
                 * @memberof google.longrunning.Operations
                 * @instance
                 * @param {google.longrunning.IListOperationsRequest} request ListOperationsRequest message or plain object
                 * @returns {Promise<google.longrunning.ListOperationsResponse>} Promise
                 * @variation 2
                 */
    
                /**
                 * Callback as used by {@link google.longrunning.Operations#getOperation}.
                 * @memberof google.longrunning.Operations
                 * @typedef GetOperationCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {google.longrunning.Operation} [response] Operation
                 */
    
                /**
                 * Calls GetOperation.
                 * @function getOperation
                 * @memberof google.longrunning.Operations
                 * @instance
                 * @param {google.longrunning.IGetOperationRequest} request GetOperationRequest message or plain object
                 * @param {google.longrunning.Operations.GetOperationCallback} callback Node-style callback called with the error, if any, and Operation
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(Operations.prototype.getOperation = function getOperation(request, callback) {
                    return this.rpcCall(getOperation, $root.google.longrunning.GetOperationRequest, $root.google.longrunning.Operation, request, callback);
                }, "name", { value: "GetOperation" });
    
                /**
                 * Calls GetOperation.
                 * @function getOperation
                 * @memberof google.longrunning.Operations
                 * @instance
                 * @param {google.longrunning.IGetOperationRequest} request GetOperationRequest message or plain object
                 * @returns {Promise<google.longrunning.Operation>} Promise
                 * @variation 2
                 */
    
                /**
                 * Callback as used by {@link google.longrunning.Operations#deleteOperation}.
                 * @memberof google.longrunning.Operations
                 * @typedef DeleteOperationCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {google.protobuf.Empty} [response] Empty
                 */
    
                /**
                 * Calls DeleteOperation.
                 * @function deleteOperation
                 * @memberof google.longrunning.Operations
                 * @instance
                 * @param {google.longrunning.IDeleteOperationRequest} request DeleteOperationRequest message or plain object
                 * @param {google.longrunning.Operations.DeleteOperationCallback} callback Node-style callback called with the error, if any, and Empty
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(Operations.prototype.deleteOperation = function deleteOperation(request, callback) {
                    return this.rpcCall(deleteOperation, $root.google.longrunning.DeleteOperationRequest, $root.google.protobuf.Empty, request, callback);
                }, "name", { value: "DeleteOperation" });
    
                /**
                 * Calls DeleteOperation.
                 * @function deleteOperation
                 * @memberof google.longrunning.Operations
                 * @instance
                 * @param {google.longrunning.IDeleteOperationRequest} request DeleteOperationRequest message or plain object
                 * @returns {Promise<google.protobuf.Empty>} Promise
                 * @variation 2
                 */
    
                /**
                 * Callback as used by {@link google.longrunning.Operations#cancelOperation}.
                 * @memberof google.longrunning.Operations
                 * @typedef CancelOperationCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {google.protobuf.Empty} [response] Empty
                 */
    
                /**
                 * Calls CancelOperation.
                 * @function cancelOperation
                 * @memberof google.longrunning.Operations
                 * @instance
                 * @param {google.longrunning.ICancelOperationRequest} request CancelOperationRequest message or plain object
                 * @param {google.longrunning.Operations.CancelOperationCallback} callback Node-style callback called with the error, if any, and Empty
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(Operations.prototype.cancelOperation = function cancelOperation(request, callback) {
                    return this.rpcCall(cancelOperation, $root.google.longrunning.CancelOperationRequest, $root.google.protobuf.Empty, request, callback);
                }, "name", { value: "CancelOperation" });
    
                /**
                 * Calls CancelOperation.
                 * @function cancelOperation
                 * @memberof google.longrunning.Operations
                 * @instance
                 * @param {google.longrunning.ICancelOperationRequest} request CancelOperationRequest message or plain object
                 * @returns {Promise<google.protobuf.Empty>} Promise
                 * @variation 2
                 */
    
                /**
                 * Callback as used by {@link google.longrunning.Operations#waitOperation}.
                 * @memberof google.longrunning.Operations
                 * @typedef WaitOperationCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {google.longrunning.Operation} [response] Operation
                 */
    
                /**
                 * Calls WaitOperation.
                 * @function waitOperation
                 * @memberof google.longrunning.Operations
                 * @instance
                 * @param {google.longrunning.IWaitOperationRequest} request WaitOperationRequest message or plain object
                 * @param {google.longrunning.Operations.WaitOperationCallback} callback Node-style callback called with the error, if any, and Operation
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(Operations.prototype.waitOperation = function waitOperation(request, callback) {
                    return this.rpcCall(waitOperation, $root.google.longrunning.WaitOperationRequest, $root.google.longrunning.Operation, request, callback);
                }, "name", { value: "WaitOperation" });
    
                /**
                 * Calls WaitOperation.
                 * @function waitOperation
                 * @memberof google.longrunning.Operations
                 * @instance
                 * @param {google.longrunning.IWaitOperationRequest} request WaitOperationRequest message or plain object
                 * @returns {Promise<google.longrunning.Operation>} Promise
                 * @variation 2
                 */
    
                return Operations;
            })();
    
            longrunning.Operation = (function() {
    
                /**
                 * Properties of an Operation.
                 * @memberof google.longrunning
                 * @interface IOperation
                 * @property {string|null} [name] Operation name
                 * @property {google.protobuf.IAny|null} [metadata] Operation metadata
                 * @property {boolean|null} [done] Operation done
                 * @property {google.rpc.IStatus|null} [error] Operation error
                 * @property {google.protobuf.IAny|null} [response] Operation response
                 */
    
                /**
                 * Constructs a new Operation.
                 * @memberof google.longrunning
                 * @classdesc Represents an Operation.
                 * @implements IOperation
                 * @constructor
                 * @param {google.longrunning.IOperation=} [properties] Properties to set
                 */
                function Operation(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Operation name.
                 * @member {string} name
                 * @memberof google.longrunning.Operation
                 * @instance
                 */
                Operation.prototype.name = "";
    
                /**
                 * Operation metadata.
                 * @member {google.protobuf.IAny|null|undefined} metadata
                 * @memberof google.longrunning.Operation
                 * @instance
                 */
                Operation.prototype.metadata = null;
    
                /**
                 * Operation done.
                 * @member {boolean} done
                 * @memberof google.longrunning.Operation
                 * @instance
                 */
                Operation.prototype.done = false;
    
                /**
                 * Operation error.
                 * @member {google.rpc.IStatus|null|undefined} error
                 * @memberof google.longrunning.Operation
                 * @instance
                 */
                Operation.prototype.error = null;
    
                /**
                 * Operation response.
                 * @member {google.protobuf.IAny|null|undefined} response
                 * @memberof google.longrunning.Operation
                 * @instance
                 */
                Operation.prototype.response = null;
    
                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;
    
                /**
                 * Operation result.
                 * @member {"error"|"response"|undefined} result
                 * @memberof google.longrunning.Operation
                 * @instance
                 */
                Object.defineProperty(Operation.prototype, "result", {
                    get: $util.oneOfGetter($oneOfFields = ["error", "response"]),
                    set: $util.oneOfSetter($oneOfFields)
                });
    
                /**
                 * Creates a new Operation instance using the specified properties.
                 * @function create
                 * @memberof google.longrunning.Operation
                 * @static
                 * @param {google.longrunning.IOperation=} [properties] Properties to set
                 * @returns {google.longrunning.Operation} Operation instance
                 */
                Operation.create = function create(properties) {
                    return new Operation(properties);
                };
    
                /**
                 * Encodes the specified Operation message. Does not implicitly {@link google.longrunning.Operation.verify|verify} messages.
                 * @function encode
                 * @memberof google.longrunning.Operation
                 * @static
                 * @param {google.longrunning.IOperation} message Operation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Operation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                        $root.google.protobuf.Any.encode(message.metadata, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.done != null && Object.hasOwnProperty.call(message, "done"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.done);
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.google.rpc.Status.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.response != null && Object.hasOwnProperty.call(message, "response"))
                        $root.google.protobuf.Any.encode(message.response, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified Operation message, length delimited. Does not implicitly {@link google.longrunning.Operation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.longrunning.Operation
                 * @static
                 * @param {google.longrunning.IOperation} message Operation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Operation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an Operation message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.longrunning.Operation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.longrunning.Operation} Operation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Operation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.longrunning.Operation();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            message.metadata = $root.google.protobuf.Any.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.done = reader.bool();
                            break;
                        case 4:
                            message.error = $root.google.rpc.Status.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.response = $root.google.protobuf.Any.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an Operation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.longrunning.Operation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.longrunning.Operation} Operation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Operation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an Operation message.
                 * @function verify
                 * @memberof google.longrunning.Operation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Operation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.metadata != null && message.hasOwnProperty("metadata")) {
                        var error = $root.google.protobuf.Any.verify(message.metadata);
                        if (error)
                            return "metadata." + error;
                    }
                    if (message.done != null && message.hasOwnProperty("done"))
                        if (typeof message.done !== "boolean")
                            return "done: boolean expected";
                    if (message.error != null && message.hasOwnProperty("error")) {
                        properties.result = 1;
                        {
                            var error = $root.google.rpc.Status.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    if (message.response != null && message.hasOwnProperty("response")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            var error = $root.google.protobuf.Any.verify(message.response);
                            if (error)
                                return "response." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates an Operation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.longrunning.Operation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.longrunning.Operation} Operation
                 */
                Operation.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.longrunning.Operation)
                        return object;
                    var message = new $root.google.longrunning.Operation();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.metadata != null) {
                        if (typeof object.metadata !== "object")
                            throw TypeError(".google.longrunning.Operation.metadata: object expected");
                        message.metadata = $root.google.protobuf.Any.fromObject(object.metadata);
                    }
                    if (object.done != null)
                        message.done = Boolean(object.done);
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".google.longrunning.Operation.error: object expected");
                        message.error = $root.google.rpc.Status.fromObject(object.error);
                    }
                    if (object.response != null) {
                        if (typeof object.response !== "object")
                            throw TypeError(".google.longrunning.Operation.response: object expected");
                        message.response = $root.google.protobuf.Any.fromObject(object.response);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an Operation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.longrunning.Operation
                 * @static
                 * @param {google.longrunning.Operation} message Operation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Operation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = "";
                        object.metadata = null;
                        object.done = false;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.metadata != null && message.hasOwnProperty("metadata"))
                        object.metadata = $root.google.protobuf.Any.toObject(message.metadata, options);
                    if (message.done != null && message.hasOwnProperty("done"))
                        object.done = message.done;
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.google.rpc.Status.toObject(message.error, options);
                        if (options.oneofs)
                            object.result = "error";
                    }
                    if (message.response != null && message.hasOwnProperty("response")) {
                        object.response = $root.google.protobuf.Any.toObject(message.response, options);
                        if (options.oneofs)
                            object.result = "response";
                    }
                    return object;
                };
    
                /**
                 * Converts this Operation to JSON.
                 * @function toJSON
                 * @memberof google.longrunning.Operation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Operation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Operation;
            })();
    
            longrunning.GetOperationRequest = (function() {
    
                /**
                 * Properties of a GetOperationRequest.
                 * @memberof google.longrunning
                 * @interface IGetOperationRequest
                 * @property {string|null} [name] GetOperationRequest name
                 */
    
                /**
                 * Constructs a new GetOperationRequest.
                 * @memberof google.longrunning
                 * @classdesc Represents a GetOperationRequest.
                 * @implements IGetOperationRequest
                 * @constructor
                 * @param {google.longrunning.IGetOperationRequest=} [properties] Properties to set
                 */
                function GetOperationRequest(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * GetOperationRequest name.
                 * @member {string} name
                 * @memberof google.longrunning.GetOperationRequest
                 * @instance
                 */
                GetOperationRequest.prototype.name = "";
    
                /**
                 * Creates a new GetOperationRequest instance using the specified properties.
                 * @function create
                 * @memberof google.longrunning.GetOperationRequest
                 * @static
                 * @param {google.longrunning.IGetOperationRequest=} [properties] Properties to set
                 * @returns {google.longrunning.GetOperationRequest} GetOperationRequest instance
                 */
                GetOperationRequest.create = function create(properties) {
                    return new GetOperationRequest(properties);
                };
    
                /**
                 * Encodes the specified GetOperationRequest message. Does not implicitly {@link google.longrunning.GetOperationRequest.verify|verify} messages.
                 * @function encode
                 * @memberof google.longrunning.GetOperationRequest
                 * @static
                 * @param {google.longrunning.IGetOperationRequest} message GetOperationRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetOperationRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    return writer;
                };
    
                /**
                 * Encodes the specified GetOperationRequest message, length delimited. Does not implicitly {@link google.longrunning.GetOperationRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.longrunning.GetOperationRequest
                 * @static
                 * @param {google.longrunning.IGetOperationRequest} message GetOperationRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetOperationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a GetOperationRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.longrunning.GetOperationRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.longrunning.GetOperationRequest} GetOperationRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetOperationRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.longrunning.GetOperationRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a GetOperationRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.longrunning.GetOperationRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.longrunning.GetOperationRequest} GetOperationRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetOperationRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a GetOperationRequest message.
                 * @function verify
                 * @memberof google.longrunning.GetOperationRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetOperationRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    return null;
                };
    
                /**
                 * Creates a GetOperationRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.longrunning.GetOperationRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.longrunning.GetOperationRequest} GetOperationRequest
                 */
                GetOperationRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.longrunning.GetOperationRequest)
                        return object;
                    var message = new $root.google.longrunning.GetOperationRequest();
                    if (object.name != null)
                        message.name = String(object.name);
                    return message;
                };
    
                /**
                 * Creates a plain object from a GetOperationRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.longrunning.GetOperationRequest
                 * @static
                 * @param {google.longrunning.GetOperationRequest} message GetOperationRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetOperationRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.name = "";
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    return object;
                };
    
                /**
                 * Converts this GetOperationRequest to JSON.
                 * @function toJSON
                 * @memberof google.longrunning.GetOperationRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetOperationRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return GetOperationRequest;
            })();
    
            longrunning.ListOperationsRequest = (function() {
    
                /**
                 * Properties of a ListOperationsRequest.
                 * @memberof google.longrunning
                 * @interface IListOperationsRequest
                 * @property {string|null} [name] ListOperationsRequest name
                 * @property {string|null} [filter] ListOperationsRequest filter
                 * @property {number|null} [pageSize] ListOperationsRequest pageSize
                 * @property {string|null} [pageToken] ListOperationsRequest pageToken
                 */
    
                /**
                 * Constructs a new ListOperationsRequest.
                 * @memberof google.longrunning
                 * @classdesc Represents a ListOperationsRequest.
                 * @implements IListOperationsRequest
                 * @constructor
                 * @param {google.longrunning.IListOperationsRequest=} [properties] Properties to set
                 */
                function ListOperationsRequest(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ListOperationsRequest name.
                 * @member {string} name
                 * @memberof google.longrunning.ListOperationsRequest
                 * @instance
                 */
                ListOperationsRequest.prototype.name = "";
    
                /**
                 * ListOperationsRequest filter.
                 * @member {string} filter
                 * @memberof google.longrunning.ListOperationsRequest
                 * @instance
                 */
                ListOperationsRequest.prototype.filter = "";
    
                /**
                 * ListOperationsRequest pageSize.
                 * @member {number} pageSize
                 * @memberof google.longrunning.ListOperationsRequest
                 * @instance
                 */
                ListOperationsRequest.prototype.pageSize = 0;
    
                /**
                 * ListOperationsRequest pageToken.
                 * @member {string} pageToken
                 * @memberof google.longrunning.ListOperationsRequest
                 * @instance
                 */
                ListOperationsRequest.prototype.pageToken = "";
    
                /**
                 * Creates a new ListOperationsRequest instance using the specified properties.
                 * @function create
                 * @memberof google.longrunning.ListOperationsRequest
                 * @static
                 * @param {google.longrunning.IListOperationsRequest=} [properties] Properties to set
                 * @returns {google.longrunning.ListOperationsRequest} ListOperationsRequest instance
                 */
                ListOperationsRequest.create = function create(properties) {
                    return new ListOperationsRequest(properties);
                };
    
                /**
                 * Encodes the specified ListOperationsRequest message. Does not implicitly {@link google.longrunning.ListOperationsRequest.verify|verify} messages.
                 * @function encode
                 * @memberof google.longrunning.ListOperationsRequest
                 * @static
                 * @param {google.longrunning.IListOperationsRequest} message ListOperationsRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ListOperationsRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.filter);
                    if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                    if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                    return writer;
                };
    
                /**
                 * Encodes the specified ListOperationsRequest message, length delimited. Does not implicitly {@link google.longrunning.ListOperationsRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.longrunning.ListOperationsRequest
                 * @static
                 * @param {google.longrunning.IListOperationsRequest} message ListOperationsRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ListOperationsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ListOperationsRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.longrunning.ListOperationsRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.longrunning.ListOperationsRequest} ListOperationsRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ListOperationsRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.longrunning.ListOperationsRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 4:
                            message.name = reader.string();
                            break;
                        case 1:
                            message.filter = reader.string();
                            break;
                        case 2:
                            message.pageSize = reader.int32();
                            break;
                        case 3:
                            message.pageToken = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ListOperationsRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.longrunning.ListOperationsRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.longrunning.ListOperationsRequest} ListOperationsRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ListOperationsRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ListOperationsRequest message.
                 * @function verify
                 * @memberof google.longrunning.ListOperationsRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ListOperationsRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.filter != null && message.hasOwnProperty("filter"))
                        if (!$util.isString(message.filter))
                            return "filter: string expected";
                    if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                        if (!$util.isInteger(message.pageSize))
                            return "pageSize: integer expected";
                    if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                        if (!$util.isString(message.pageToken))
                            return "pageToken: string expected";
                    return null;
                };
    
                /**
                 * Creates a ListOperationsRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.longrunning.ListOperationsRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.longrunning.ListOperationsRequest} ListOperationsRequest
                 */
                ListOperationsRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.longrunning.ListOperationsRequest)
                        return object;
                    var message = new $root.google.longrunning.ListOperationsRequest();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.filter != null)
                        message.filter = String(object.filter);
                    if (object.pageSize != null)
                        message.pageSize = object.pageSize | 0;
                    if (object.pageToken != null)
                        message.pageToken = String(object.pageToken);
                    return message;
                };
    
                /**
                 * Creates a plain object from a ListOperationsRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.longrunning.ListOperationsRequest
                 * @static
                 * @param {google.longrunning.ListOperationsRequest} message ListOperationsRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ListOperationsRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.filter = "";
                        object.pageSize = 0;
                        object.pageToken = "";
                        object.name = "";
                    }
                    if (message.filter != null && message.hasOwnProperty("filter"))
                        object.filter = message.filter;
                    if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                        object.pageSize = message.pageSize;
                    if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                        object.pageToken = message.pageToken;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    return object;
                };
    
                /**
                 * Converts this ListOperationsRequest to JSON.
                 * @function toJSON
                 * @memberof google.longrunning.ListOperationsRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ListOperationsRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ListOperationsRequest;
            })();
    
            longrunning.ListOperationsResponse = (function() {
    
                /**
                 * Properties of a ListOperationsResponse.
                 * @memberof google.longrunning
                 * @interface IListOperationsResponse
                 * @property {Array.<google.longrunning.IOperation>|null} [operations] ListOperationsResponse operations
                 * @property {string|null} [nextPageToken] ListOperationsResponse nextPageToken
                 */
    
                /**
                 * Constructs a new ListOperationsResponse.
                 * @memberof google.longrunning
                 * @classdesc Represents a ListOperationsResponse.
                 * @implements IListOperationsResponse
                 * @constructor
                 * @param {google.longrunning.IListOperationsResponse=} [properties] Properties to set
                 */
                function ListOperationsResponse(properties) {
                    this.operations = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ListOperationsResponse operations.
                 * @member {Array.<google.longrunning.IOperation>} operations
                 * @memberof google.longrunning.ListOperationsResponse
                 * @instance
                 */
                ListOperationsResponse.prototype.operations = $util.emptyArray;
    
                /**
                 * ListOperationsResponse nextPageToken.
                 * @member {string} nextPageToken
                 * @memberof google.longrunning.ListOperationsResponse
                 * @instance
                 */
                ListOperationsResponse.prototype.nextPageToken = "";
    
                /**
                 * Creates a new ListOperationsResponse instance using the specified properties.
                 * @function create
                 * @memberof google.longrunning.ListOperationsResponse
                 * @static
                 * @param {google.longrunning.IListOperationsResponse=} [properties] Properties to set
                 * @returns {google.longrunning.ListOperationsResponse} ListOperationsResponse instance
                 */
                ListOperationsResponse.create = function create(properties) {
                    return new ListOperationsResponse(properties);
                };
    
                /**
                 * Encodes the specified ListOperationsResponse message. Does not implicitly {@link google.longrunning.ListOperationsResponse.verify|verify} messages.
                 * @function encode
                 * @memberof google.longrunning.ListOperationsResponse
                 * @static
                 * @param {google.longrunning.IListOperationsResponse} message ListOperationsResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ListOperationsResponse.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operations != null && message.operations.length)
                        for (var i = 0; i < message.operations.length; ++i)
                            $root.google.longrunning.Operation.encode(message.operations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                    return writer;
                };
    
                /**
                 * Encodes the specified ListOperationsResponse message, length delimited. Does not implicitly {@link google.longrunning.ListOperationsResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.longrunning.ListOperationsResponse
                 * @static
                 * @param {google.longrunning.IListOperationsResponse} message ListOperationsResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ListOperationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ListOperationsResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.longrunning.ListOperationsResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.longrunning.ListOperationsResponse} ListOperationsResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ListOperationsResponse.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.longrunning.ListOperationsResponse();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.operations && message.operations.length))
                                message.operations = [];
                            message.operations.push($root.google.longrunning.Operation.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            message.nextPageToken = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ListOperationsResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.longrunning.ListOperationsResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.longrunning.ListOperationsResponse} ListOperationsResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ListOperationsResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ListOperationsResponse message.
                 * @function verify
                 * @memberof google.longrunning.ListOperationsResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ListOperationsResponse.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operations != null && message.hasOwnProperty("operations")) {
                        if (!Array.isArray(message.operations))
                            return "operations: array expected";
                        for (var i = 0; i < message.operations.length; ++i) {
                            var error = $root.google.longrunning.Operation.verify(message.operations[i]);
                            if (error)
                                return "operations." + error;
                        }
                    }
                    if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                        if (!$util.isString(message.nextPageToken))
                            return "nextPageToken: string expected";
                    return null;
                };
    
                /**
                 * Creates a ListOperationsResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.longrunning.ListOperationsResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.longrunning.ListOperationsResponse} ListOperationsResponse
                 */
                ListOperationsResponse.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.longrunning.ListOperationsResponse)
                        return object;
                    var message = new $root.google.longrunning.ListOperationsResponse();
                    if (object.operations) {
                        if (!Array.isArray(object.operations))
                            throw TypeError(".google.longrunning.ListOperationsResponse.operations: array expected");
                        message.operations = [];
                        for (var i = 0; i < object.operations.length; ++i) {
                            if (typeof object.operations[i] !== "object")
                                throw TypeError(".google.longrunning.ListOperationsResponse.operations: object expected");
                            message.operations[i] = $root.google.longrunning.Operation.fromObject(object.operations[i]);
                        }
                    }
                    if (object.nextPageToken != null)
                        message.nextPageToken = String(object.nextPageToken);
                    return message;
                };
    
                /**
                 * Creates a plain object from a ListOperationsResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.longrunning.ListOperationsResponse
                 * @static
                 * @param {google.longrunning.ListOperationsResponse} message ListOperationsResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ListOperationsResponse.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.operations = [];
                    if (options.defaults)
                        object.nextPageToken = "";
                    if (message.operations && message.operations.length) {
                        object.operations = [];
                        for (var j = 0; j < message.operations.length; ++j)
                            object.operations[j] = $root.google.longrunning.Operation.toObject(message.operations[j], options);
                    }
                    if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                        object.nextPageToken = message.nextPageToken;
                    return object;
                };
    
                /**
                 * Converts this ListOperationsResponse to JSON.
                 * @function toJSON
                 * @memberof google.longrunning.ListOperationsResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ListOperationsResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ListOperationsResponse;
            })();
    
            longrunning.CancelOperationRequest = (function() {
    
                /**
                 * Properties of a CancelOperationRequest.
                 * @memberof google.longrunning
                 * @interface ICancelOperationRequest
                 * @property {string|null} [name] CancelOperationRequest name
                 */
    
                /**
                 * Constructs a new CancelOperationRequest.
                 * @memberof google.longrunning
                 * @classdesc Represents a CancelOperationRequest.
                 * @implements ICancelOperationRequest
                 * @constructor
                 * @param {google.longrunning.ICancelOperationRequest=} [properties] Properties to set
                 */
                function CancelOperationRequest(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * CancelOperationRequest name.
                 * @member {string} name
                 * @memberof google.longrunning.CancelOperationRequest
                 * @instance
                 */
                CancelOperationRequest.prototype.name = "";
    
                /**
                 * Creates a new CancelOperationRequest instance using the specified properties.
                 * @function create
                 * @memberof google.longrunning.CancelOperationRequest
                 * @static
                 * @param {google.longrunning.ICancelOperationRequest=} [properties] Properties to set
                 * @returns {google.longrunning.CancelOperationRequest} CancelOperationRequest instance
                 */
                CancelOperationRequest.create = function create(properties) {
                    return new CancelOperationRequest(properties);
                };
    
                /**
                 * Encodes the specified CancelOperationRequest message. Does not implicitly {@link google.longrunning.CancelOperationRequest.verify|verify} messages.
                 * @function encode
                 * @memberof google.longrunning.CancelOperationRequest
                 * @static
                 * @param {google.longrunning.ICancelOperationRequest} message CancelOperationRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CancelOperationRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    return writer;
                };
    
                /**
                 * Encodes the specified CancelOperationRequest message, length delimited. Does not implicitly {@link google.longrunning.CancelOperationRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.longrunning.CancelOperationRequest
                 * @static
                 * @param {google.longrunning.ICancelOperationRequest} message CancelOperationRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CancelOperationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a CancelOperationRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.longrunning.CancelOperationRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.longrunning.CancelOperationRequest} CancelOperationRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CancelOperationRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.longrunning.CancelOperationRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a CancelOperationRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.longrunning.CancelOperationRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.longrunning.CancelOperationRequest} CancelOperationRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CancelOperationRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a CancelOperationRequest message.
                 * @function verify
                 * @memberof google.longrunning.CancelOperationRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CancelOperationRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    return null;
                };
    
                /**
                 * Creates a CancelOperationRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.longrunning.CancelOperationRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.longrunning.CancelOperationRequest} CancelOperationRequest
                 */
                CancelOperationRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.longrunning.CancelOperationRequest)
                        return object;
                    var message = new $root.google.longrunning.CancelOperationRequest();
                    if (object.name != null)
                        message.name = String(object.name);
                    return message;
                };
    
                /**
                 * Creates a plain object from a CancelOperationRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.longrunning.CancelOperationRequest
                 * @static
                 * @param {google.longrunning.CancelOperationRequest} message CancelOperationRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CancelOperationRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.name = "";
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    return object;
                };
    
                /**
                 * Converts this CancelOperationRequest to JSON.
                 * @function toJSON
                 * @memberof google.longrunning.CancelOperationRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CancelOperationRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return CancelOperationRequest;
            })();
    
            longrunning.DeleteOperationRequest = (function() {
    
                /**
                 * Properties of a DeleteOperationRequest.
                 * @memberof google.longrunning
                 * @interface IDeleteOperationRequest
                 * @property {string|null} [name] DeleteOperationRequest name
                 */
    
                /**
                 * Constructs a new DeleteOperationRequest.
                 * @memberof google.longrunning
                 * @classdesc Represents a DeleteOperationRequest.
                 * @implements IDeleteOperationRequest
                 * @constructor
                 * @param {google.longrunning.IDeleteOperationRequest=} [properties] Properties to set
                 */
                function DeleteOperationRequest(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * DeleteOperationRequest name.
                 * @member {string} name
                 * @memberof google.longrunning.DeleteOperationRequest
                 * @instance
                 */
                DeleteOperationRequest.prototype.name = "";
    
                /**
                 * Creates a new DeleteOperationRequest instance using the specified properties.
                 * @function create
                 * @memberof google.longrunning.DeleteOperationRequest
                 * @static
                 * @param {google.longrunning.IDeleteOperationRequest=} [properties] Properties to set
                 * @returns {google.longrunning.DeleteOperationRequest} DeleteOperationRequest instance
                 */
                DeleteOperationRequest.create = function create(properties) {
                    return new DeleteOperationRequest(properties);
                };
    
                /**
                 * Encodes the specified DeleteOperationRequest message. Does not implicitly {@link google.longrunning.DeleteOperationRequest.verify|verify} messages.
                 * @function encode
                 * @memberof google.longrunning.DeleteOperationRequest
                 * @static
                 * @param {google.longrunning.IDeleteOperationRequest} message DeleteOperationRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeleteOperationRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    return writer;
                };
    
                /**
                 * Encodes the specified DeleteOperationRequest message, length delimited. Does not implicitly {@link google.longrunning.DeleteOperationRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.longrunning.DeleteOperationRequest
                 * @static
                 * @param {google.longrunning.IDeleteOperationRequest} message DeleteOperationRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeleteOperationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a DeleteOperationRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.longrunning.DeleteOperationRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.longrunning.DeleteOperationRequest} DeleteOperationRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeleteOperationRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.longrunning.DeleteOperationRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a DeleteOperationRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.longrunning.DeleteOperationRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.longrunning.DeleteOperationRequest} DeleteOperationRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeleteOperationRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a DeleteOperationRequest message.
                 * @function verify
                 * @memberof google.longrunning.DeleteOperationRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeleteOperationRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    return null;
                };
    
                /**
                 * Creates a DeleteOperationRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.longrunning.DeleteOperationRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.longrunning.DeleteOperationRequest} DeleteOperationRequest
                 */
                DeleteOperationRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.longrunning.DeleteOperationRequest)
                        return object;
                    var message = new $root.google.longrunning.DeleteOperationRequest();
                    if (object.name != null)
                        message.name = String(object.name);
                    return message;
                };
    
                /**
                 * Creates a plain object from a DeleteOperationRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.longrunning.DeleteOperationRequest
                 * @static
                 * @param {google.longrunning.DeleteOperationRequest} message DeleteOperationRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeleteOperationRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.name = "";
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    return object;
                };
    
                /**
                 * Converts this DeleteOperationRequest to JSON.
                 * @function toJSON
                 * @memberof google.longrunning.DeleteOperationRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeleteOperationRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return DeleteOperationRequest;
            })();
    
            longrunning.WaitOperationRequest = (function() {
    
                /**
                 * Properties of a WaitOperationRequest.
                 * @memberof google.longrunning
                 * @interface IWaitOperationRequest
                 * @property {string|null} [name] WaitOperationRequest name
                 * @property {google.protobuf.IDuration|null} [timeout] WaitOperationRequest timeout
                 */
    
                /**
                 * Constructs a new WaitOperationRequest.
                 * @memberof google.longrunning
                 * @classdesc Represents a WaitOperationRequest.
                 * @implements IWaitOperationRequest
                 * @constructor
                 * @param {google.longrunning.IWaitOperationRequest=} [properties] Properties to set
                 */
                function WaitOperationRequest(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * WaitOperationRequest name.
                 * @member {string} name
                 * @memberof google.longrunning.WaitOperationRequest
                 * @instance
                 */
                WaitOperationRequest.prototype.name = "";
    
                /**
                 * WaitOperationRequest timeout.
                 * @member {google.protobuf.IDuration|null|undefined} timeout
                 * @memberof google.longrunning.WaitOperationRequest
                 * @instance
                 */
                WaitOperationRequest.prototype.timeout = null;
    
                /**
                 * Creates a new WaitOperationRequest instance using the specified properties.
                 * @function create
                 * @memberof google.longrunning.WaitOperationRequest
                 * @static
                 * @param {google.longrunning.IWaitOperationRequest=} [properties] Properties to set
                 * @returns {google.longrunning.WaitOperationRequest} WaitOperationRequest instance
                 */
                WaitOperationRequest.create = function create(properties) {
                    return new WaitOperationRequest(properties);
                };
    
                /**
                 * Encodes the specified WaitOperationRequest message. Does not implicitly {@link google.longrunning.WaitOperationRequest.verify|verify} messages.
                 * @function encode
                 * @memberof google.longrunning.WaitOperationRequest
                 * @static
                 * @param {google.longrunning.IWaitOperationRequest} message WaitOperationRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WaitOperationRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.timeout != null && Object.hasOwnProperty.call(message, "timeout"))
                        $root.google.protobuf.Duration.encode(message.timeout, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified WaitOperationRequest message, length delimited. Does not implicitly {@link google.longrunning.WaitOperationRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.longrunning.WaitOperationRequest
                 * @static
                 * @param {google.longrunning.IWaitOperationRequest} message WaitOperationRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WaitOperationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a WaitOperationRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.longrunning.WaitOperationRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.longrunning.WaitOperationRequest} WaitOperationRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WaitOperationRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.longrunning.WaitOperationRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            message.timeout = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a WaitOperationRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.longrunning.WaitOperationRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.longrunning.WaitOperationRequest} WaitOperationRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WaitOperationRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a WaitOperationRequest message.
                 * @function verify
                 * @memberof google.longrunning.WaitOperationRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                WaitOperationRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.timeout != null && message.hasOwnProperty("timeout")) {
                        var error = $root.google.protobuf.Duration.verify(message.timeout);
                        if (error)
                            return "timeout." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates a WaitOperationRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.longrunning.WaitOperationRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.longrunning.WaitOperationRequest} WaitOperationRequest
                 */
                WaitOperationRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.longrunning.WaitOperationRequest)
                        return object;
                    var message = new $root.google.longrunning.WaitOperationRequest();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.timeout != null) {
                        if (typeof object.timeout !== "object")
                            throw TypeError(".google.longrunning.WaitOperationRequest.timeout: object expected");
                        message.timeout = $root.google.protobuf.Duration.fromObject(object.timeout);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a WaitOperationRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.longrunning.WaitOperationRequest
                 * @static
                 * @param {google.longrunning.WaitOperationRequest} message WaitOperationRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                WaitOperationRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = "";
                        object.timeout = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.timeout != null && message.hasOwnProperty("timeout"))
                        object.timeout = $root.google.protobuf.Duration.toObject(message.timeout, options);
                    return object;
                };
    
                /**
                 * Converts this WaitOperationRequest to JSON.
                 * @function toJSON
                 * @memberof google.longrunning.WaitOperationRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                WaitOperationRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return WaitOperationRequest;
            })();
    
            longrunning.OperationInfo = (function() {
    
                /**
                 * Properties of an OperationInfo.
                 * @memberof google.longrunning
                 * @interface IOperationInfo
                 * @property {string|null} [responseType] OperationInfo responseType
                 * @property {string|null} [metadataType] OperationInfo metadataType
                 */
    
                /**
                 * Constructs a new OperationInfo.
                 * @memberof google.longrunning
                 * @classdesc Represents an OperationInfo.
                 * @implements IOperationInfo
                 * @constructor
                 * @param {google.longrunning.IOperationInfo=} [properties] Properties to set
                 */
                function OperationInfo(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * OperationInfo responseType.
                 * @member {string} responseType
                 * @memberof google.longrunning.OperationInfo
                 * @instance
                 */
                OperationInfo.prototype.responseType = "";
    
                /**
                 * OperationInfo metadataType.
                 * @member {string} metadataType
                 * @memberof google.longrunning.OperationInfo
                 * @instance
                 */
                OperationInfo.prototype.metadataType = "";
    
                /**
                 * Creates a new OperationInfo instance using the specified properties.
                 * @function create
                 * @memberof google.longrunning.OperationInfo
                 * @static
                 * @param {google.longrunning.IOperationInfo=} [properties] Properties to set
                 * @returns {google.longrunning.OperationInfo} OperationInfo instance
                 */
                OperationInfo.create = function create(properties) {
                    return new OperationInfo(properties);
                };
    
                /**
                 * Encodes the specified OperationInfo message. Does not implicitly {@link google.longrunning.OperationInfo.verify|verify} messages.
                 * @function encode
                 * @memberof google.longrunning.OperationInfo
                 * @static
                 * @param {google.longrunning.IOperationInfo} message OperationInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OperationInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.responseType != null && Object.hasOwnProperty.call(message, "responseType"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.responseType);
                    if (message.metadataType != null && Object.hasOwnProperty.call(message, "metadataType"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.metadataType);
                    return writer;
                };
    
                /**
                 * Encodes the specified OperationInfo message, length delimited. Does not implicitly {@link google.longrunning.OperationInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.longrunning.OperationInfo
                 * @static
                 * @param {google.longrunning.IOperationInfo} message OperationInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OperationInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an OperationInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.longrunning.OperationInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.longrunning.OperationInfo} OperationInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OperationInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.longrunning.OperationInfo();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.responseType = reader.string();
                            break;
                        case 2:
                            message.metadataType = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an OperationInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.longrunning.OperationInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.longrunning.OperationInfo} OperationInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OperationInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an OperationInfo message.
                 * @function verify
                 * @memberof google.longrunning.OperationInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OperationInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.responseType != null && message.hasOwnProperty("responseType"))
                        if (!$util.isString(message.responseType))
                            return "responseType: string expected";
                    if (message.metadataType != null && message.hasOwnProperty("metadataType"))
                        if (!$util.isString(message.metadataType))
                            return "metadataType: string expected";
                    return null;
                };
    
                /**
                 * Creates an OperationInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.longrunning.OperationInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.longrunning.OperationInfo} OperationInfo
                 */
                OperationInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.longrunning.OperationInfo)
                        return object;
                    var message = new $root.google.longrunning.OperationInfo();
                    if (object.responseType != null)
                        message.responseType = String(object.responseType);
                    if (object.metadataType != null)
                        message.metadataType = String(object.metadataType);
                    return message;
                };
    
                /**
                 * Creates a plain object from an OperationInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.longrunning.OperationInfo
                 * @static
                 * @param {google.longrunning.OperationInfo} message OperationInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OperationInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.responseType = "";
                        object.metadataType = "";
                    }
                    if (message.responseType != null && message.hasOwnProperty("responseType"))
                        object.responseType = message.responseType;
                    if (message.metadataType != null && message.hasOwnProperty("metadataType"))
                        object.metadataType = message.metadataType;
                    return object;
                };
    
                /**
                 * Converts this OperationInfo to JSON.
                 * @function toJSON
                 * @memberof google.longrunning.OperationInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OperationInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return OperationInfo;
            })();
    
            return longrunning;
        })();
    
        google.rpc = (function() {
    
            /**
             * Namespace rpc.
             * @memberof google
             * @namespace
             */
            var rpc = {};
    
            rpc.Status = (function() {
    
                /**
                 * Properties of a Status.
                 * @memberof google.rpc
                 * @interface IStatus
                 * @property {number|null} [code] Status code
                 * @property {string|null} [message] Status message
                 * @property {Array.<google.protobuf.IAny>|null} [details] Status details
                 */
    
                /**
                 * Constructs a new Status.
                 * @memberof google.rpc
                 * @classdesc Represents a Status.
                 * @implements IStatus
                 * @constructor
                 * @param {google.rpc.IStatus=} [properties] Properties to set
                 */
                function Status(properties) {
                    this.details = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Status code.
                 * @member {number} code
                 * @memberof google.rpc.Status
                 * @instance
                 */
                Status.prototype.code = 0;
    
                /**
                 * Status message.
                 * @member {string} message
                 * @memberof google.rpc.Status
                 * @instance
                 */
                Status.prototype.message = "";
    
                /**
                 * Status details.
                 * @member {Array.<google.protobuf.IAny>} details
                 * @memberof google.rpc.Status
                 * @instance
                 */
                Status.prototype.details = $util.emptyArray;
    
                /**
                 * Creates a new Status instance using the specified properties.
                 * @function create
                 * @memberof google.rpc.Status
                 * @static
                 * @param {google.rpc.IStatus=} [properties] Properties to set
                 * @returns {google.rpc.Status} Status instance
                 */
                Status.create = function create(properties) {
                    return new Status(properties);
                };
    
                /**
                 * Encodes the specified Status message. Does not implicitly {@link google.rpc.Status.verify|verify} messages.
                 * @function encode
                 * @memberof google.rpc.Status
                 * @static
                 * @param {google.rpc.IStatus} message Status message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Status.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                    if (message.details != null && message.details.length)
                        for (var i = 0; i < message.details.length; ++i)
                            $root.google.protobuf.Any.encode(message.details[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified Status message, length delimited. Does not implicitly {@link google.rpc.Status.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.rpc.Status
                 * @static
                 * @param {google.rpc.IStatus} message Status message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Status.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a Status message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.rpc.Status
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.rpc.Status} Status
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Status.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.rpc.Status();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.code = reader.int32();
                            break;
                        case 2:
                            message.message = reader.string();
                            break;
                        case 3:
                            if (!(message.details && message.details.length))
                                message.details = [];
                            message.details.push($root.google.protobuf.Any.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a Status message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.rpc.Status
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.rpc.Status} Status
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Status.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a Status message.
                 * @function verify
                 * @memberof google.rpc.Status
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Status.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.code != null && message.hasOwnProperty("code"))
                        if (!$util.isInteger(message.code))
                            return "code: integer expected";
                    if (message.message != null && message.hasOwnProperty("message"))
                        if (!$util.isString(message.message))
                            return "message: string expected";
                    if (message.details != null && message.hasOwnProperty("details")) {
                        if (!Array.isArray(message.details))
                            return "details: array expected";
                        for (var i = 0; i < message.details.length; ++i) {
                            var error = $root.google.protobuf.Any.verify(message.details[i]);
                            if (error)
                                return "details." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a Status message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.rpc.Status
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.rpc.Status} Status
                 */
                Status.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.rpc.Status)
                        return object;
                    var message = new $root.google.rpc.Status();
                    if (object.code != null)
                        message.code = object.code | 0;
                    if (object.message != null)
                        message.message = String(object.message);
                    if (object.details) {
                        if (!Array.isArray(object.details))
                            throw TypeError(".google.rpc.Status.details: array expected");
                        message.details = [];
                        for (var i = 0; i < object.details.length; ++i) {
                            if (typeof object.details[i] !== "object")
                                throw TypeError(".google.rpc.Status.details: object expected");
                            message.details[i] = $root.google.protobuf.Any.fromObject(object.details[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a Status message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.rpc.Status
                 * @static
                 * @param {google.rpc.Status} message Status
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Status.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.details = [];
                    if (options.defaults) {
                        object.code = 0;
                        object.message = "";
                    }
                    if (message.code != null && message.hasOwnProperty("code"))
                        object.code = message.code;
                    if (message.message != null && message.hasOwnProperty("message"))
                        object.message = message.message;
                    if (message.details && message.details.length) {
                        object.details = [];
                        for (var j = 0; j < message.details.length; ++j)
                            object.details[j] = $root.google.protobuf.Any.toObject(message.details[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this Status to JSON.
                 * @function toJSON
                 * @memberof google.rpc.Status
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Status.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Status;
            })();
    
            return rpc;
        })();
    
        return google;
    })();

    return $root;
});
